import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { useFetchData } from './use-fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AttachmentUrl: { input: string; output: string; }
  BaseUrl: { input: string; output: string; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
  FloatPercentage: { input: number; output: number; }
  NonEmptyString: { input: string; output: string; }
  NonNegativeInt: { input: number; output: number; }
  PositiveInt: { input: number; output: number; }
  SupportAttachmentMimeType: { input: any; output: any; }
  URL: { input: string; output: string; }
  Void: { input: any; output: any; }
};

/** Actor bot user */
export type ActorBotUser = {
  __typename?: 'ActorBotUser';
  /** Bot user of the actor */
  botUser: BotUser;
  /** Identifier of the actor */
  id: Scalars['ID']['output'];
};

/** Actor internal user */
export type ActorInternalUser = {
  __typename?: 'ActorInternalUser';
  /** Identifier of the actor */
  id: Scalars['ID']['output'];
  /** Internal user of the actor */
  internalUser: InternalUser;
};

/** Actor platform user */
export type ActorPlatformUser = ActorInternalUser | ActorSupplierUser;

/** Actor acting on behalf of Choose, either an internal user or a bot standing in for one */
export type ActorStaffUser = ActorBotUser | ActorInternalUser;

/** Actor supplier user */
export type ActorSupplierUser = {
  __typename?: 'ActorSupplierUser';
  /** Identifier of the actor */
  id: Scalars['ID']['output'];
  /** Supplier user of the actor */
  supplierUser: SupplierUser;
};

/** Actor user */
export type ActorUser = ActorBotUser | ActorInternalUser | ActorSupplierUser;

export type AddSaleNoteInput = {
  /** The attachments of the note */
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  /** The content of the note */
  content: Scalars['String']['input'];
  /** The ID of the sale to add the note to */
  saleId: Scalars['ID']['input'];
};

/** Add support actor app contact credit input */
export type AddSupportActorAppContactCreditInput = {
  /** Actor app contact id */
  actorAppContactId: Scalars['ID']['input'];
  /** Amount in cents */
  amountInCents: Scalars['PositiveInt']['input'];
  /** Description */
  description: Scalars['String']['input'];
  /** Store */
  store: Store;
};

export type AddSupportAppContactNoteInput = {
  /** The ID of the app contact to add the note to */
  actorAppContactId: Scalars['ID']['input'];
  /** The attachments of the note */
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  /** The content of the note */
  content: Scalars['String']['input'];
};

/** Input used to add an email to a support ticket. */
export type AddSupportTicketEmailInput = {
  /** A list of attachment urls to attach to the email. */
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  /** The email HTML body. */
  contentHtml: Scalars['String']['input'];
  /** The email text body. */
  contentText: Scalars['String']['input'];
  /** The ID of the ticket related to the email. */
  ticketId: Scalars['ID']['input'];
};

/** Address */
export type Address = {
  __typename?: 'Address';
  /** City */
  city: Scalars['String']['output'];
  /** Country */
  country: Scalars['String']['output'];
  /** Country code */
  countryCode: Scalars['String']['output'];
  /** County */
  county?: Maybe<Scalars['String']['output']>;
  /** Letters indicating which state the address is from */
  state?: Maybe<Scalars['String']['output']>;
  /** Street */
  street: Scalars['String']['output'];
  /** Street additional */
  streetAdditional?: Maybe<Scalars['String']['output']>;
  /** Zip code */
  zipCode: Scalars['String']['output'];
};

/** App contact support ticket unread */
export type AppContact_SupportTicketUnread = {
  __typename?: 'AppContact_SupportTicketUnread';
  /** Ticket id that has been unread */
  ticketId: Scalars['ID']['output'];
};

/** Apply support app contact referral input */
export type ApplySupportAppContactReferralInput = {
  /** Actor app contact id */
  actorAppContactId: Scalars['ID']['input'];
  /** Referrer code */
  referrerCode: Scalars['String']['input'];
};

/** Billing address - Input */
export type BillingAddress_Input = {
  /** City */
  city: Scalars['String']['input'];
  /** Country code */
  countryCode: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street */
  street: Scalars['String']['input'];
  /** Street additional */
  streetAdditional?: InputMaybe<Scalars['String']['input']>;
  /** Zip code */
  zipCode: Scalars['String']['input'];
};

/** Output type for boolean filter. */
export type BooleanFilter = {
  __typename?: 'BooleanFilter';
  equals?: Maybe<Scalars['Boolean']['output']>;
  not?: Maybe<Scalars['Boolean']['output']>;
};

/** Filter for boolean fields with inclusion and exclusion logic. */
export type BooleanFilterInput = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Bot user */
export type BotUser = {
  __typename?: 'BotUser';
  /** Identifier of the actor */
  id: Scalars['ID']['output'];
  /** Name of the bot user */
  name: Scalars['String']['output'];
};

/** Brand */
export type Brand = {
  __typename?: 'Brand';
  /** Contact email */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Contact phone */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** HubSpot ID */
  hubspotId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Instagram URL */
  instagram?: Maybe<Scalars['String']['output']>;
  /** Language */
  language: LanguageIso6391;
  /** Name */
  name: Scalars['String']['output'];
  /** Return address */
  returnAddress?: Maybe<ReturnAddress>;
  /** Sale responsible for this brand */
  saleManager?: Maybe<Scalars['String']['output']>;
  /** Shopify URL */
  shopifyUrl?: Maybe<Scalars['String']['output']>;
  /** Store */
  storeId: Store;
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
  /** Website URL */
  website?: Maybe<Scalars['String']['output']>;
};

/** The buyer is the person who has been billed for the order */
export type Buyer = {
  __typename?: 'Buyer';
  /** Address */
  address: Address;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Full name ("first_name last_name") */
  fullName: Scalars['String']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Previous buyer if it has been updated */
  previous?: Maybe<Buyer>;
};

/** Cancel order items reason */
export enum CancelOrderItemsReason {
  /** Not wanted anymore */
  NotWantedAnymore = 'NotWantedAnymore',
  /** Out of stock */
  OutOfStock = 'OutOfStock'
}

/** Cancel order reason */
export enum CancelOrderReason {
  /** Not wanted anymore */
  NotWantedAnymore = 'NotWantedAnymore',
  /** Out of stock */
  OutOfStock = 'OutOfStock'
}

/** Cashback */
export type Cashback = {
  __typename?: 'Cashback';
  /** Amount */
  amount: Scalars['Int']['output'];
  /** Date of last amount update (null if amount has never been updated) */
  amountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Currency */
  currency: CurrencyIso;
  /** Transformation into credit date (can be past value depending on status) */
  dueDate: Scalars['DateTime']['output'];
  /** Status */
  status: CashbackStatus;
};

/** Cashback status */
export enum CashbackStatus {
  /** Cashback cancelled because of post purchase action */
  Cancelled = 'cancelled',
  /** Cashback transformed into credit */
  Fulfilled = 'fulfilled',
  /** Cashback not yet transformed into credit */
  Pending = 'pending'
}

/** Claim */
export type Claim = {
  __typename?: 'Claim';
  /** Action chosen by the supplier when the claim has been accepted */
  acceptedAction?: Maybe<ClaimAcceptedAction>;
  /** Date when the claim has been accepted */
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Actor who accepted the claim */
  acceptedBy?: Maybe<ActorUser>;
  /** Note written by the supplier when the claim has been accepted */
  acceptedNote?: Maybe<Scalars['String']['output']>;
  /** Date when the claim has been canceled */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Actor who canceled the claim */
  canceledBy?: Maybe<ActorUser>;
  /** Date of the creation */
  createdAt: Scalars['DateTime']['output'];
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  /** Whether the claim has been opened by a bot */
  isOpenedByBot: Scalars['Boolean']['output'];
  /** Items */
  items: Array<Item>;
  /** Preferred solution */
  preferredSolution: ClaimPreferredSolution;
  /** Date when the claim processing deadline has been reached */
  processingDeadline: Scalars['DateTime']['output'];
  /** Proof URLs */
  proofUrls: Array<Scalars['String']['output']>;
  /** Reason */
  reason: ClaimReason;
  /** Reship action error reasons if the action is not available */
  reshipActionErrorReasons: Array<ClaimReshipActionErrorReason>;
  /** Support ticket id */
  supportTicketId?: Maybe<Scalars['ID']['output']>;
  /** Sworn statement URLs */
  swornStatementUrls: Array<Scalars['String']['output']>;
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
};

/** Claim accepted action (action chose by the supplier when it has accepted the claim) */
export enum ClaimAcceptedAction {
  /** The supplier has directy handled the claim with the customer */
  DirectlyHandledWithTheCustomer = 'DIRECTLY_HANDLED_WITH_THE_CUSTOMER',
  /** The supplier decided to resend a new digital coupon code for the items */
  ItemsDigitalCouponCodesResent = 'ITEMS_DIGITAL_COUPON_CODES_RESENT',
  /** The supplier decided to refund the items */
  ItemsRefunded = 'ITEMS_REFUNDED',
  /** The supplier decided to reship the items */
  ItemsReshipped = 'ITEMS_RESHIPPED'
}

/** Claim preferred solution */
export enum ClaimPreferredSolution {
  /** No preference */
  NoPreference = 'NoPreference',
  /** Refund */
  Refund = 'Refund',
  /** Reship */
  Reship = 'Reship'
}

/** Claim Reason */
export enum ClaimReason {
  /** The customer has received the parcel but is damaged */
  DeliveredButDamaged = 'DELIVERED_BUT_DAMAGED',
  /** The customer has received the parcel but is incomplete */
  DeliveredButIncomplete = 'DELIVERED_BUT_INCOMPLETE',
  /** The customer has received the parcel but is wrong (wrong or missing items) */
  DeliveredButWrong = 'DELIVERED_BUT_WRONG',
  /** The customer has received a digital coupon code but is not working */
  DigitalCouponCodeNotWorking = 'DIGITAL_COUPON_CODE_NOT_WORKING',
  /** The customer has not received the parcel and has been returned to the sender */
  NotDeliveredAndReturnedToSender = 'NOT_DELIVERED_AND_RETURNED_TO_SENDER',
  /** The customer has not received the parcel and the tracking is blocked */
  NotDeliveredAndTrackingBlocked = 'NOT_DELIVERED_AND_TRACKING_BLOCKED',
  /** The customer has not received the parcel and the tracking is delivered */
  NotDeliveredAndTrackingDelivered = 'NOT_DELIVERED_AND_TRACKING_DELIVERED',
  /** Other */
  Other = 'OTHER'
}

/** Claim reship action error reason */
export enum ClaimReshipActionErrorReason {
  /** There is no items to reship */
  NoItems = 'NO_ITEMS',
  /** The order has already been reshipped */
  OrderAlreadyReshipped = 'ORDER_ALREADY_RESHIPPED',
  /** The order is cancelled */
  OrderCancelled = 'ORDER_CANCELLED',
  /** Some of the items to reship are digital */
  SomeItemsDigital = 'SOME_ITEMS_DIGITAL'
}

/** Claim reship recipient - Input */
export type ClaimReshipRecipient_Input = {
  /** City */
  city: Scalars['String']['input'];
  /** Country code */
  countryCode: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Phone number */
  phoneNumber: Scalars['String']['input'];
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street */
  street: Scalars['String']['input'];
  /** Street additional */
  streetAdditional?: InputMaybe<Scalars['String']['input']>;
  /** Zip code */
  zipCode: Scalars['String']['input'];
};

/** Output type for context derived properties filter. */
export type ContextDerivedFilter = {
  __typename?: 'ContextDerivedFilter';
  /** Filter by the identifier of the related order. */
  orderId?: Maybe<IdFilterNullable>;
  /** Filter by the identifier of the related product. */
  productId?: Maybe<IdFilterNullable>;
  /** Filter by sale properties. */
  sale?: Maybe<ContextDerivedSaleFilter>;
  /** Filter by the identifier of the related sale. */
  saleId?: Maybe<IdFilterNullable>;
  /** Filter by the identifier of the related store. */
  storeId?: Maybe<StoreFilterNullable>;
  /** Filter by the identifier of the related brand. */
  supplierId?: Maybe<IdFilterNullable>;
  /** Filter by the identifier of the related variant. */
  variantId?: Maybe<IdFilterNullable>;
};

/** Filter for context derived properties of support tickets. */
export type ContextDerivedFilterInput = {
  /** Filter by the identifier of the related order. */
  orderId?: InputMaybe<IdFilterNullableInput>;
  /** Filter by the identifier of the related product. */
  productId?: InputMaybe<IdFilterNullableInput>;
  /** Filter by sale properties. */
  sale?: InputMaybe<ContextDerivedSaleFilterInput>;
  /** Filter by the identifier of the related sale. */
  saleId?: InputMaybe<IdFilterNullableInput>;
  /** Filter by the identifier of the related store. */
  storeId?: InputMaybe<StoreFilterNullableInput>;
  /** Filter by the identifier of the related brand. */
  supplierId?: InputMaybe<IdFilterNullableInput>;
  /** Filter by the identifier of the related variant. */
  variantId?: InputMaybe<IdFilterNullableInput>;
};

/** Output type for context derived sale filter. */
export type ContextDerivedSaleFilter = {
  __typename?: 'ContextDerivedSaleFilter';
  salesTeamName?: Maybe<SaleSalesTeamNameFilter>;
  type?: Maybe<SaleTypeFilter>;
};

/** Filter for context derived sale filter. */
export type ContextDerivedSaleFilterInput = {
  salesTeamName?: InputMaybe<SaleSalesTeamNameFilterInput>;
  type?: InputMaybe<SaleTypeFilterInput>;
};

/** Courier */
export type Courier = {
  __typename?: 'Courier';
  /** Alternative name */
  alternativeName?: Maybe<Scalars['String']['output']>;
  /** Contact phone number */
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Default language */
  defaultLanguage: Scalars['String']['output'];
  /** Logo url */
  logoUrl: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Slug */
  slug: Scalars['String']['output'];
  /** Supported countries */
  supportedCountries: Array<Scalars['String']['output']>;
  /** Supported languages */
  supportedLanguages: Array<Scalars['String']['output']>;
  /** Web url */
  webUrl?: Maybe<Scalars['String']['output']>;
};

/** Courier - By slug - Input */
export type Courier_BySlug_Input = {
  /** Slug */
  slug: Scalars['String']['input'];
};

/** Couriers - Detect - Input */
export type Couriers_Detect_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Tracking number */
  trackingNumber: Scalars['String']['input'];
};

/** Couriers - Search - Input */
export type Couriers_Search_Input = {
  /** Name */
  name: Scalars['String']['input'];
};

export type CreateSupportSnippetInput = {
  /** The store id of the snippet. */
  storeId: Store;
  /** The tag ids of the snippet. */
  tagIds: Array<Scalars['ID']['input']>;
  /** The templates of the snippet. */
  templates: Array<SupportSnippetTemplateInput>;
  /** The title of the snippet. */
  title: Scalars['String']['input'];
};

export type CreateSupportSnippetTagInput = {
  /** The background color of the snippet tag. */
  backgroundColor: Scalars['String']['input'];
  /** The description of the snippet tag. */
  description: Scalars['String']['input'];
  /** The label of the snippet tag. */
  label: Scalars['String']['input'];
  /** The text color of the snippet tag. */
  textColor: Scalars['String']['input'];
};

export type CreateSupportSnippetTemplateInput = {
  /** The language of the snippet template. */
  language: LanguageIso6391;
  /** The snippet id. */
  snippetId: Scalars['ID']['input'];
  /** The template of the snippet template. */
  template: Scalars['String']['input'];
};

/** Creates a support ticket for an order with other issue */
export type CreateSupportTicketByOrderIdInput = {
  /** If the ticket is only for information */
  isOnlyInformation: Scalars['Boolean']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Title of the ticket */
  title: Scalars['String']['input'];
};

/** A support ticket representing an issue or request submitted by a contact. */
export type CreateSupportTicketInput = {
  /** The ticket’s associated contact */
  actorContactId: Scalars['ID']['input'];
  /** If the ticket is only for information */
  isOnlyInformation: Scalars['Boolean']['input'];
  /** The main title or subject of the ticket */
  title: Scalars['String']['input'];
};

/** Create support ticket flow order cancelation v1 */
export type CreateSupportTicket_FlowOrderCancelationV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order delayed v1 */
export type CreateSupportTicket_FlowOrderDelayedV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order delivered but items damaged v1 */
export type CreateSupportTicket_FlowOrderDeliveredButItemsDamagedV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Items ids damaged */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution: SupportTicketActivityInitialRequestOrderPreferredSolution;
  /** Proofs attached */
  proofs: Array<Scalars['AttachmentUrl']['input']>;
};

/** Create support ticket flow order delivered but items missing v1 */
export type CreateSupportTicket_FlowOrderDeliveredButItemsMissingV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Items ids missing */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution?: InputMaybe<SupportTicketActivityInitialRequestOrderPreferredSolution>;
  /** Proofs attached */
  proofs: Array<Scalars['AttachmentUrl']['input']>;
};

/** Create support ticket flow order delivered but items not working anymore v1 */
export type CreateSupportTicket_FlowOrderDeliveredButItemsNotWorkingAnymoreV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Items ids not working anymore */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Proofs attached */
  proofs: Array<Scalars['AttachmentUrl']['input']>;
};

/** Create support ticket flow order delivered but items size issue v1 */
export type CreateSupportTicket_FlowOrderDeliveredButItemsSizeIssueV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Items ids with size issue */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order delivered but items vouchers not working v1 */
export type CreateSupportTicket_FlowOrderDeliveredButItemsVouchersNotWorkingV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Items ids concerned */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Proofs attached */
  proofs: Array<Scalars['AttachmentUrl']['input']>;
};

/** Create support ticket flow order delivered but items wrong v1 */
export type CreateSupportTicket_FlowOrderDeliveredButItemsWrongV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Items ids wrong */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution: SupportTicketActivityInitialRequestOrderPreferredSolution;
  /** Proofs attached */
  proofs: Array<Scalars['AttachmentUrl']['input']>;
};

/** Create support ticket flow order invoice issue v1 */
export type CreateSupportTicket_FlowOrderInvoiceIssueV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order other issue v1 */
export type CreateSupportTicket_FlowOrderOtherIssueV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order payment method wrong v1 */
export type CreateSupportTicket_FlowOrderPaymentMethodWrongV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order pickup point issue v1 */
export type CreateSupportTicket_FlowOrderPickupPointIssueV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order promo code not set v1 */
export type CreateSupportTicket_FlowOrderPromoCodeNotSetV1Input = {
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Promo code */
  promoCode: Scalars['String']['input'];
  /** Proofs attached */
  proofs: Array<Scalars['AttachmentUrl']['input']>;
};

/** Create support ticket flow order refund incomplete v1 */
export type CreateSupportTicket_FlowOrderRefundIncompleteV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Proofs attached */
  proofs: Array<Scalars['AttachmentUrl']['input']>;
};

/** Create support ticket flow order refund not received v1 */
export type CreateSupportTicket_FlowOrderRefundNotReceivedV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order return info v1 */
export type CreateSupportTicket_FlowOrderReturnInfoV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order return international v1 */
export type CreateSupportTicket_FlowOrderReturnInternationalV1Input = {
  /** Whether the refund is applied with withheld or not */
  applyWithheld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Preferred refund method */
  preferredRefundMethod?: InputMaybe<PreferredRefundMethod>;
  /** Return lines */
  returnLines: Array<SupportTicketActivityInitialRequestOrderReturnLineInput>;
};

/** Create support ticket flow order return not available info v1 */
export type CreateSupportTicket_FlowOrderReturnNotAvailableInfoV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order return not eligible info v1 */
export type CreateSupportTicket_FlowOrderReturnNotEligibleInfoV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order returned to sender v1 */
export type CreateSupportTicket_FlowOrderReturnedToSenderV1Input = {
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Shipping address */
  shippingAddress: ShippingAddress_Input;
};

/** Create support ticket flow order shipping address wrong v1 */
export type CreateSupportTicket_FlowOrderShippingAddressWrongV1Input = {
  /** Content to explain the issue */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Shipping address */
  shippingAddress?: InputMaybe<ShippingAddress_Input>;
};

/** Create support ticket flow order tracking blocked v1 */
export type CreateSupportTicket_FlowOrderTrackingBlockedV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
};

/** Create support ticket flow order tracking delivered but not received v1 */
export type CreateSupportTicket_FlowOrderTrackingDeliveredButNotReceivedV1Input = {
  /** Content to explain the issue */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Order id concerned */
  orderId: Scalars['ID']['input'];
  /** Sworn statements */
  swornStatements: Array<Scalars['AttachmentUrl']['input']>;
};

/** Create support ticket flow other account v1 */
export type CreateSupportTicket_FlowOtherAccountV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
};

/** Create support ticket flow other after sale policy v1 */
export type CreateSupportTicket_FlowOtherAfterSalePolicyV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
};

/** Create support ticket flow other bug v1 */
export type CreateSupportTicket_FlowOtherBugV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
};

/** Create support ticket flow other checkout v1 */
export type CreateSupportTicket_FlowOtherCheckoutV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
};

/** Create support ticket flow other referral v1 */
export type CreateSupportTicket_FlowOtherReferralV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
};

/** Create support ticket flow other request v1 */
export type CreateSupportTicket_FlowOtherRequestV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
};

/** Create support ticket flow other sale v1 */
export type CreateSupportTicket_FlowOtherSaleV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
};

/** Create support ticket flow sale info v1 */
export type CreateSupportTicket_FlowSaleInfoV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Sale id */
  saleId: Scalars['ID']['input'];
};

/** Create support ticket flow variant info v1 */
export type CreateSupportTicket_FlowVariantInfoV1Input = {
  /** Content to explain the issue */
  content: Scalars['String']['input'];
  /** Variant id */
  variantId: Scalars['ID']['input'];
};

export type CreateSupportViewInput = {
  /** The columns to display in the support view. */
  displayedProperties: SupportViewDisplayedPropertyInput;
  /** The filters to apply to the support tickets in this view. */
  filters: SupportTicketsFilterInput;
  /** The columns to group by in the support view. */
  groupBy: SupportViewGroupByProperty;
  /** The icon for the new support view. */
  icon: Scalars['String']['input'];
  /** The color of the icon for the new support view. */
  iconColor: Scalars['String']['input'];
  /** The sorting to apply to the support tickets in this view. */
  sortBy: SupportTicketsSortInput;
  /** The title of the new support view. */
  title: Scalars['String']['input'];
};

/** Credit */
export type Credit = {
  __typename?: 'Credit';
  /** Balance amount in cents */
  balanceAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Lines */
  lines: Array<CreditLine>;
  /** Store */
  store: Store;
  /** Transactions */
  transactions: Array<CreditTransaction>;
};

/** Credit history line */
export type CreditHistoryLine = {
  __typename?: 'CreditHistoryLine';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Operator */
  operator?: Maybe<Scalars['String']['output']>;
  /** Store */
  store: Store;
  /** Value in cents */
  valueInCents: Scalars['Int']['output'];
};

/** Credit line */
export type CreditLine = {
  __typename?: 'CreditLine';
  /** Amount in cents */
  amountInCents: Scalars['PositiveInt']['output'];
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Expires at */
  expiresAt: Scalars['DateTime']['output'];
  /** Has expired remaining amount ? */
  hasExpiredRemainingAmount: Scalars['Boolean']['output'];
  /** Id */
  id: Scalars['ID']['output'];
  /** Is expired ? */
  isExpired: Scalars['Boolean']['output'];
  /** Operator */
  operator?: Maybe<Scalars['String']['output']>;
  /** Remaining amount in cents */
  remainingAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Spent amount in cents */
  spentAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Store */
  store: Store;
};

/** Credit transaction */
export type CreditTransaction = {
  __typename?: 'CreditTransaction';
  /** Amount in cents */
  amountInCents: Scalars['PositiveInt']['output'];
  /** Billing id */
  billingId?: Maybe<Scalars['ID']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  /** Operator */
  operator?: Maybe<Scalars['String']['output']>;
  /** Order id */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** Referee user id */
  refereeUserId?: Maybe<Scalars['ID']['output']>;
  /** Store */
  store: Store;
  /** Type */
  type: CreditTransactionType;
};

/** Credit transaction type */
export enum CreditTransactionType {
  /** Credit transaction */
  Credit = 'Credit',
  /** Debit transaction */
  Debit = 'Debit'
}

/** Currency ISO code */
export enum CurrencyIso {
  /** Euro */
  Eur = 'eur',
  /** US Dollar */
  Usd = 'usd'
}

/** Current user - Edit first day of the week - Input */
export type CurrentUser_EditFirstDayOfTheWeek_Input = {
  /** First day of the week */
  firstDayOfTheWeek: FirstDayOfTheWeek;
};

/** Current user - Edit language - Input */
export type CurrentUser_EditLanguage_Input = {
  /** Language */
  language: LanguageIso6391;
};

/** Current user - Edit name - Input */
export type CurrentUser_EditName_Input = {
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
};

/** Current user - Edit picture - Input */
export type CurrentUser_EditPicture_Input = {
  /** Picture */
  picture: Scalars['BaseUrl']['input'];
};

/** Current user - Edit timezone - Input */
export type CurrentUser_EditTimezone_Input = {
  /** Timezone */
  timezone: Scalars['String']['input'];
};

/** Output type for date range filter. */
export type DateRangeFilter = {
  __typename?: 'DateRangeFilter';
  gt?: Maybe<Scalars['DateTime']['output']>;
  gte?: Maybe<Scalars['DateTime']['output']>;
  lt?: Maybe<Scalars['DateTime']['output']>;
  lte?: Maybe<Scalars['DateTime']['output']>;
};

/** Generic range filter for date fields. */
export type DateRangeFilterInput = {
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Represents a range of date and time when the parcel is expected to arrive at the customer's location */
export type DeliveryDateRange = {
  __typename?: 'DeliveryDateRange';
  /** The creation date */
  createdAt: Scalars['DateTime']['output'];
  /** The latest delivery date and time when the parcel is expected to arrive at the customer's location */
  end: Scalars['Date']['output'];
  /** The earliest delivery date and time when the parcel is expected to arrive at the customer's location */
  start: Scalars['Date']['output'];
};

/** Delivery date range input */
export type DeliveryDateRangeInput = {
  /** The latest delivery date and time when the parcel is expected to arrive at the customer's location */
  end: Scalars['Date']['input'];
  /** The earliest delivery date and time when the parcel is expected to arrive at the customer's location */
  start: Scalars['Date']['input'];
};

/** Edit support actor app contact referral code input */
export type EditSupportActorAppContactReferralCodeInput = {
  /** Actor app contact id */
  actorAppContactId: Scalars['ID']['input'];
  /** Referral code */
  referralCode: Scalars['String']['input'];
};

/** File extension */
export enum FileExtension {
  /** CSV */
  Csv = 'CSV',
  /** XLSX */
  Xlsx = 'XLSX'
}

/** First day of the week */
export enum FirstDayOfTheWeek {
  /** Monday */
  Monday = 'Monday',
  /** Saturday */
  Saturday = 'Saturday',
  /** Sunday */
  Sunday = 'Sunday'
}

/** Output type for ID filter. */
export type IdFilter = {
  __typename?: 'IDFilter';
  in?: Maybe<Array<Scalars['ID']['output']>>;
  notIn?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Generic filter for ID fields with inclusion and exclusion logic. */
export type IdFilterInput = {
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Output type for ID filter with nullable values. */
export type IdFilterNullable = {
  __typename?: 'IDFilterNullable';
  in?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

/** Generic filter for ID fields with inclusion and exclusion logic (null value allowed). */
export type IdFilterNullableInput = {
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Output type for initial request properties filter. */
export type InitialRequestFilter = {
  __typename?: 'InitialRequestFilter';
  flow?: Maybe<SupportTicketActivityInitialRequestFlowFilter>;
};

/** Filter for initial request properties of support tickets. */
export type InitialRequestFilterInput = {
  /** Filter by the flow of the initial request. */
  flow?: InputMaybe<SupportTicketActivityInitialRequestFlowFilterInput>;
};

/** Internal user */
export type InternalUser = {
  __typename?: 'InternalUser';
  /** Email of the internal user */
  email: Scalars['EmailAddress']['output'];
  /** First day of the week of the internal user */
  firstDayOfTheWeek: FirstDayOfTheWeek;
  /** First name of the internal user */
  firstName: Scalars['String']['output'];
  /** Identifier of the actor */
  id: Scalars['ID']['output'];
  /** Language of the internal user */
  language: LanguageIso6391;
  /** Last name of the internal user */
  lastName: Scalars['String']['output'];
  /** Picture URL of the internal user */
  picture: Scalars['URL']['output'];
  /** Scopes of the internal user */
  scopes: Array<Scalars['String']['output']>;
  /** Support role of the internal user */
  supportRole: SupportRole;
  /** Timezone of the internal user */
  timezone: Scalars['String']['output'];
};

/** Filter object for querying support internal users with various criteria. */
export type InternalUsersFilterInput = {
  /** Filter by user support role. */
  role?: InputMaybe<SupportRoleFilterInput>;
};

/** Invoice for customs */
export type InvoiceForCustoms = {
  __typename?: 'InvoiceForCustoms';
  /** Url */
  url: Scalars['URL']['output'];
};

/** Item */
export type Item = {
  __typename?: 'Item';
  /** Digital coupon code */
  digitalCouponCode?: Maybe<Scalars['String']['output']>;
  /** GTIN */
  gtin?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Image URL */
  imageUrl: Scalars['String']['output'];
  /** Is cancellable ? */
  isCancellable: Scalars['Boolean']['output'];
  /** Is cancelled ? */
  isCancelled: Scalars['Boolean']['output'];
  /** Is digital ? */
  isDigital: Scalars['Boolean']['output'];
  /** Is offered ? */
  isOffered: Scalars['Boolean']['output'];
  /** Is reshipped ? */
  isReshipped: Scalars['Boolean']['output'];
  /** Is returnable ? */
  isReturnable: Scalars['Boolean']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** New digital coupon code */
  newDigitalCouponCode?: Maybe<Scalars['String']['output']>;
  /** Price bought by Choose */
  priceBoughtByChoose: Price;
  /** Price sold by Choose to the customer (in cents) */
  priceSold: Price;
  /** Product ID */
  productId: Scalars['String']['output'];
  /** Product variant ID */
  productVariantId: Scalars['String']['output'];
  /** Refund summary */
  refundSummary: OrderLineRefundSummary;
  /** Notifications sent to the customer about the item */
  sentNotifications: Array<ItemSentNotification>;
  /** Size */
  size?: Maybe<Scalars['String']['output']>;
  /** SKU */
  sku?: Maybe<Scalars['String']['output']>;
  /** Voucher expiration date if the item is digital */
  voucherExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Voucher marked as used date if the item is digital */
  voucherMarkedAsUsedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Item return reason code */
export enum ItemReturnReasonCode {
  /** Better price */
  BetterPrice = 'BETTER_PRICE',
  /** Claim */
  Claim = 'CLAIM',
  /** Damaged product (not used anymore) */
  DamagedProduct = 'DAMAGED_PRODUCT',
  /** Damaged shipping (not used anymore) */
  DamagedShipping = 'DAMAGED_SHIPPING',
  /** Delay */
  Delay = 'DELAY',
  /** Description */
  Description = 'DESCRIPTION',
  /** Other */
  Other = 'OTHER',
  /** Picture */
  Picture = 'PICTURE',
  /** Quality */
  Quality = 'QUALITY',
  /** Size */
  Size = 'SIZE',
  /** Wrong article (not used anymore) */
  WrongArticle = 'WRONG_ARTICLE'
}

/** Item return sub reason code */
export enum ItemReturnSubReasonCode {
  /** bad shape */
  BadShape = 'BAD_SHAPE',
  /** multi size bought */
  MultiSize = 'MULTI_SIZE',
  /** Other */
  Other = 'OTHER',
  /** too large */
  TooLarge = 'TOO_LARGE',
  /** too long */
  TooLong = 'TOO_LONG',
  /** too short */
  TooShort = 'TOO_SHORT',
  /** too tight */
  TooTight = 'TOO_TIGHT'
}

/** Item sent notification */
export enum ItemSentNotification {
  /** Voucher expires in 7 days */
  VoucherExpiresIn_7Days = 'VOUCHER_EXPIRES_IN_7_DAYS',
  /** Voucher expires in 30 days */
  VoucherExpiresIn_30Days = 'VOUCHER_EXPIRES_IN_30_DAYS'
}

/** Language (ISO 639-1) */
export enum LanguageIso6391 {
  /** English (US) */
  EnUs = 'en_US',
  /** Spanish (Spain) */
  EsEs = 'es_ES',
  /** French (France) */
  FrFr = 'fr_FR',
  /** Dutch (Belgium / Netherlands) */
  NlNl = 'nl_NL'
}

/** Logistician */
export enum Logistician {
  /** Bigblue */
  Bigblue = 'BIGBLUE',
  /** Boxtal */
  Boxtal = 'BOXTAL',
  /** Coliship */
  Coliship = 'COLISHIP',
  /** Cubyn */
  Cubyn = 'CUBYN',
  /** Generic all items on same row */
  GenericColumn = 'GENERIC_COLUMN',
  /** Generic by item row */
  GenericRow = 'GENERIC_ROW',
  /** Sendcloud */
  Sendcloud = 'SENDCLOUD',
  /** Shipping bo */
  Shippingbo = 'SHIPPINGBO',
  /** Stockaz */
  Stockaz = 'STOCKAZ',
  /** Transporterapp */
  Transporterapp = 'TRANSPORTERAPP'
}

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Adds a note to the specified sale.
   *
   * Arguments:
   * - input: The input for adding a note to a sale.
   *
   * Returns:
   * - The updated sale, including the newly added note.
   */
  addSaleNote: Sale;
  /** Adds some credit to the support actor app contact */
  addSupportActorAppContactCredit?: Maybe<Scalars['Void']['output']>;
  /**
   * Adds a note to the specified app contact.
   *
   * Arguments:
   * - input: The input for adding a note to an app contact.
   *
   * Returns:
   * - The updated app contact, including the newly added note.
   */
  addSupportAppContactNote: SupportActorAppContact;
  /** Add a reaction on a ticket activity. If already exists for this actor and type, no-op. */
  addSupportTicketActivityReaction: SupportTicketActivityReaction;
  /**
   * Sends an email to the contact in the context of the specified ticket.
   *
   * Arguments:
   * - input: The input used to add an email to a support ticket.
   *
   * Returns:
   * - The updated Ticket, including the new email activity.
   */
  addSupportTicketEmail: SupportTicket;
  /**
   * Sends a message to the contact within the context of the specified ticket.
   *
   * Arguments:
   * - ticketId: The ID of the ticket where the message will be added.
   * - content: The message body.
   * - attachments: (Optional) A list of attachment urls to attach to the message.
   *
   * Returns:
   * - The updated Ticket, including the newly added message.
   */
  addSupportTicketMessage: SupportTicket;
  /**
   * Adds an internal note to the specified ticket. Notes are visible only to support agents.
   *
   * Arguments:
   * - ticketId: The ID of the ticket to update.
   * - content: The content of the note.
   * - attachments: (Optional) A list of attachment urls to attach to the note.
   *
   * Returns:
   * - The updated Ticket, including the new note.
   */
  addSupportTicketNote: SupportTicket;
  /** Adds a support view to the current user's favorites. */
  addSupportViewFavorite?: Maybe<Scalars['Void']['output']>;
  /**
   * Sends a message to the internal user within the context of the specified ticket.
   *
   * Arguments:
   * - ticketId: The ID of the ticket where the message will be added.
   * - content: The message body.
   * - attachments: (Optional) A list of attachment urls to attach to the message.
   *
   * Returns:
   * - The updated Ticket, including the newly added message.
   */
  appContact_addSupportTicketMessage: SupportTicket;
  /** Creates a support ticket for an order cancelation */
  appContact_createSupportTicket_flowOrderCancelationV1: SupportTicket;
  /** Creates a support ticket for an order delayed */
  appContact_createSupportTicket_flowOrderDelayedV1: SupportTicket;
  /** Creates a support ticket for an order delivered but items damaged */
  appContact_createSupportTicket_flowOrderDeliveredButItemsDamagedV1: SupportTicket;
  /** Creates a support ticket for an order delivered but items missing */
  appContact_createSupportTicket_flowOrderDeliveredButItemsMissingV1: SupportTicket;
  /** Creates a support ticket for an order delivered but items not working anymore */
  appContact_createSupportTicket_flowOrderDeliveredButItemsNotWorkingAnymoreV1: SupportTicket;
  /** Creates a support ticket for an order delivered but items size issue */
  appContact_createSupportTicket_flowOrderDeliveredButItemsSizeIssueV1: SupportTicket;
  /** Creates a support ticket for an order delivered but items vouchers not working */
  appContact_createSupportTicket_flowOrderDeliveredButItemsVouchersNotWorkingV1: SupportTicket;
  /** Creates a support ticket for an order delivered but items wrong */
  appContact_createSupportTicket_flowOrderDeliveredButItemsWrongV1: SupportTicket;
  /** Creates a support ticket for an order with invoice issue */
  appContact_createSupportTicket_flowOrderInvoiceIssueV1: SupportTicket;
  /** Creates a support ticket for an order with other issue */
  appContact_createSupportTicket_flowOrderOtherIssueV1: SupportTicket;
  /** Creates a support ticket for an order with payment method wrong */
  appContact_createSupportTicket_flowOrderPaymentMethodWrongV1: SupportTicket;
  /** Creates a support ticket for an order with pickup point issue */
  appContact_createSupportTicket_flowOrderPickupPointIssueV1: SupportTicket;
  /** Creates a support ticket for an order with promo code not set */
  appContact_createSupportTicket_flowOrderPromoCodeNotSetV1: SupportTicket;
  /** Creates a support ticket for an order with refund incomplete */
  appContact_createSupportTicket_flowOrderRefundIncompleteV1: SupportTicket;
  /** Creates a support ticket for an order with refund not received */
  appContact_createSupportTicket_flowOrderRefundNotReceivedV1: SupportTicket;
  /** Creates a support ticket for an order return information */
  appContact_createSupportTicket_flowOrderReturnInfoV1: SupportTicket;
  /** Creates a support ticket for an order return international */
  appContact_createSupportTicket_flowOrderReturnInternationalV1: SupportTicket;
  /** Creates a support ticket for an order return not available information */
  appContact_createSupportTicket_flowOrderReturnNotAvailableInfoV1: SupportTicket;
  /** Creates a support ticket for an order return not eligible information */
  appContact_createSupportTicket_flowOrderReturnNotEligibleInfoV1: SupportTicket;
  /** Creates a support ticket for an order returned to sender */
  appContact_createSupportTicket_flowOrderReturnedToSenderV1: SupportTicket;
  /** Creates a support ticket for an order with shipping address wrong */
  appContact_createSupportTicket_flowOrderShippingAddressWrongV1: SupportTicket;
  /** Creates a support ticket for an order with tracking blocked */
  appContact_createSupportTicket_flowOrderTrackingBlockedV1: SupportTicket;
  /** Creates a support ticket for an order with tracking delivered but not received */
  appContact_createSupportTicket_flowOrderTrackingDeliveredButNotReceivedV1: SupportTicket;
  /** Creates a support ticket for other account */
  appContact_createSupportTicket_flowOtherAccountV1: SupportTicket;
  /** Creates a support ticket for other after sale policy */
  appContact_createSupportTicket_flowOtherAfterSalePolicyV1: SupportTicket;
  /** Creates a support ticket for other bug */
  appContact_createSupportTicket_flowOtherBugV1: SupportTicket;
  /** Creates a support ticket for other checkout */
  appContact_createSupportTicket_flowOtherCheckoutV1: SupportTicket;
  /** Creates a support ticket for other referral */
  appContact_createSupportTicket_flowOtherReferralV1: SupportTicket;
  /** Creates a support ticket for other request */
  appContact_createSupportTicket_flowOtherRequestV1: SupportTicket;
  /** Creates a support ticket for other sale */
  appContact_createSupportTicket_flowOtherSaleV1: SupportTicket;
  /** Creates a support ticket for sale info */
  appContact_createSupportTicket_flowSaleInfoV1: SupportTicket;
  /** Creates a support ticket for variant info */
  appContact_createSupportTicket_flowVariantInfoV1: SupportTicket;
  /**
   * Generate a secure, pre-signed URL for uploading a support attachment file.
   *
   * This mutation returns a signed URL that allows direct upload to google storage bucket.
   * The file must match the specified name, MIME type, and size.
   */
  appContact_generateSupportAttachmentUploadUrl: Upload;
  /** Submits the support ticket resolution survey */
  appContact_submitSupportTicketResolutionSurvey: SupportTicket;
  /** Applies a referral to the support app contact */
  applySupportAppContactReferral?: Maybe<Scalars['Void']['output']>;
  /** Applies a referral to the support app contact (dry run) */
  applySupportAppContactReferralDryRun?: Maybe<ReferralPlanResult>;
  /** Assign support role to internal user */
  assignSupportRoleToInternalUser?: Maybe<Scalars['Void']['output']>;
  /**
   * Attaches a tag to a specified snippet.
   *
   * Arguments:
   * - snippetId: The ID of the snippet.
   * - snippetTagId: The ID of the snippet tag.
   *
   * Returns:
   * - The updated Snippet, including the newly attached tag.
   */
  attachSupportSnippetTagToSupportSnippet: SupportSnippet;
  /**
   * Attaches a business context to a support ticket.
   * This will enrich the ticket with relevant custom fields
   * derived from the specified context type and ID.
   */
  attachSupportTicketContext: SupportTicket;
  /**
   * Creates a new snippet.
   *
   * Arguments:
   * - input: The input for creating a snippet.
   *
   * Returns:
   * - The created snippet.
   */
  createSupportSnippet: SupportSnippet;
  /**
   * Creates a new snippet tag.
   *
   * Arguments:
   * - input: The input for creating a snippet tag.
   *
   * Returns:
   * - The created snippet tag.
   */
  createSupportSnippetTag: SupportSnippetTag;
  /**
   * Creates a new snippet template.
   *
   * Arguments:
   * - input: The input for creating a snippet template.
   *
   * Returns:
   * - The created snippet template.
   */
  createSupportSnippetTemplate: SupportSnippetTemplate;
  createSupportTicket: SupportTicket;
  /** Creates a support ticket for an order with other issue */
  createSupportTicketByOrderId: SupportTicket;
  /** Creates a new support view with the specified properties. */
  createSupportView: SupportView;
  /** Edits the first day of the week of the current user */
  currentUser_editFirstDayOfTheWeek?: Maybe<Scalars['Void']['output']>;
  /** Edits the language of the current user */
  currentUser_editLanguage?: Maybe<Scalars['Void']['output']>;
  /** Edits the name of the current user */
  currentUser_editName?: Maybe<Scalars['Void']['output']>;
  /** Edits the picture of the current user */
  currentUser_editPicture?: Maybe<Scalars['Void']['output']>;
  /** Edits the timezone of the current user */
  currentUser_editTimezone?: Maybe<Scalars['Void']['output']>;
  /** Generates the upload URL for the picture of the current user */
  currentUser_generatePictureUploadUrl: Upload;
  /** Deletes the support attachment */
  deleteSupportAttachment?: Maybe<Scalars['Void']['output']>;
  /** Deletes the support ticket */
  deleteSupportTicket?: Maybe<Scalars['Void']['output']>;
  /** Deletes a support view by its unique identifier. */
  deleteSupportView?: Maybe<Scalars['Void']['output']>;
  /**
   * Detaches a tag from a specified snippet.
   *
   * Arguments:
   * - snippetId: The ID of the snippet.
   * - snippetTagId: The ID of the snippet tag.
   *
   * Returns:
   * - The updated Snippet, excluding the detached tag.
   */
  detachSupportSnippetTagToSupportSnippet: SupportSnippet;
  /**
   * Detaches any previously linked business context from the support ticket.
   * This will remove associated custom fields derived from the context.
   */
  detachSupportTicketContext: SupportTicket;
  /** Edits the referral code of the support actor app contact */
  editSupportActorAppContactReferralCode?: Maybe<Scalars['Void']['output']>;
  /**
   * Generate a secure, pre-signed URL for uploading a support attachment file.
   *
   * This mutation returns a signed URL that allows direct upload to google storage bucket.
   * The file must match the specified name, MIME type, and size.
   */
  generateSupportAttachmentUploadUrl: Upload;
  /** Mark all notifications as read for the current internal user */
  markAllSupportNotificationsAsRead: Scalars['Boolean']['output'];
  /** Mark a notification as read */
  markSupportNotificationAsRead?: Maybe<SupportNotification>;
  /** Accepts the operation supplier workspace assignment */
  operationSupplierWorkspaceAssignment_accept?: Maybe<Scalars['Void']['output']>;
  /** Expires all the pending expired operation supplier workspace assignments */
  operationSupplierWorkspaceAssignment_expireAllPendingExpired?: Maybe<Scalars['Void']['output']>;
  /** Assigns the operation to the supplier workspace */
  operation_assignToSupplierWorkspace?: Maybe<Scalars['Void']['output']>;
  /** Updates whether the supplier charges VAT on its supplier billing */
  operation_updateSupplierChargesVat: Operation;
  /** Cancels the order */
  order_cancel?: Maybe<Scalars['Void']['output']>;
  /** Cancels the order - Dry run */
  order_cancel_dryRun: RefundSummary;
  /** Accepts the order claim with refund */
  order_claim_acceptWithRefund?: Maybe<Scalars['Void']['output']>;
  /** Accepts the order claim with reship */
  order_claim_acceptWithReship?: Maybe<Scalars['Void']['output']>;
  /** Accepts the order claim with voucher replacement codes */
  order_claim_acceptWithVoucherReplacementCodes?: Maybe<Scalars['Void']['output']>;
  /** Accepts the order claim with voucher replacement message */
  order_claim_acceptWithVoucherReplacementMessage?: Maybe<Scalars['Void']['output']>;
  /** Cancels the order claim */
  order_claim_cancel?: Maybe<Scalars['Void']['output']>;
  /** Opens an order claim for delivered but damaged */
  order_claim_openForDeliveredButDamaged?: Maybe<Scalars['Void']['output']>;
  /** Opens an order claim for delivered but incomplete */
  order_claim_openForDeliveredButIncomplete?: Maybe<Scalars['Void']['output']>;
  /** Opens an order claim for delivered but wrong */
  order_claim_openForDeliveredButWrong?: Maybe<Scalars['Void']['output']>;
  /** Opens an order claim for not delivered and returned to sender */
  order_claim_openForNotDeliveredAndReturnedToSender?: Maybe<Scalars['Void']['output']>;
  /** Opens an order claim for not delivered and tracking blocked */
  order_claim_openForNotDeliveredAndTrackingBlocked?: Maybe<Scalars['Void']['output']>;
  /** Opens an order claim for not delivered and tracking delivered */
  order_claim_openForNotDeliveredAndTrackingDelivered?: Maybe<Scalars['Void']['output']>;
  /** Opens an order claim for other */
  order_claim_openForOther?: Maybe<Scalars['Void']['output']>;
  /** Opens an order claim for voucher not working */
  order_claim_openForVoucherNotWorking?: Maybe<Scalars['Void']['output']>;
  /** Edits the order billing address */
  order_editBillingAddress?: Maybe<Scalars['Void']['output']>;
  /** Generates an invoice for customs */
  order_generateInvoiceForCustoms: InvoiceForCustoms;
  /** Generates a purchase order */
  order_generatePurchaseOrder: PurchaseOrder;
  /** Cancels the order items */
  order_items_cancel?: Maybe<Scalars['Void']['output']>;
  /** Cancels the order items - Dry run */
  order_items_cancel_dryRun: RefundSummary;
  /** Refunds the order items */
  order_items_refund?: Maybe<Scalars['Void']['output']>;
  /** Refunds the order items - Dry run */
  order_items_refund_dryRun: RefundSummary;
  /** Creates an order parcel */
  order_parcel_create?: Maybe<Scalars['Void']['output']>;
  /** Edits an order parcel */
  order_parcel_edit?: Maybe<Scalars['Void']['output']>;
  /** Groups an order parcel */
  order_parcel_group?: Maybe<Scalars['Void']['output']>;
  /** Swaps an order parcel */
  order_parcel_swap?: Maybe<Scalars['Void']['output']>;
  /** Marks the order parcels as delivered */
  order_parcels_markAsDelivered?: Maybe<Scalars['Void']['output']>;
  /** Cancels the order return */
  order_return_cancel?: Maybe<Scalars['Void']['output']>;
  /** Creates an order return */
  order_return_create?: Maybe<Scalars['Void']['output']>;
  /** Creates an order return with a label */
  order_return_createWithLabel?: Maybe<Scalars['Void']['output']>;
  /** Creates an order return with a label for a claim */
  order_return_createWithLabelForClaim?: Maybe<Scalars['Void']['output']>;
  /** Edits the order return preferred refund method */
  order_return_editPreferredRefundMethod?: Maybe<Scalars['Void']['output']>;
  /** Edits the order return tracking info */
  order_return_editTrackingInfo?: Maybe<Scalars['Void']['output']>;
  /** Generates a label upload url for an order return */
  order_return_generateLabelUploadUrl: Upload;
  /** Locks the order return validation */
  order_return_lockValidation?: Maybe<Scalars['Void']['output']>;
  /** Unlocks the order return validation */
  order_return_unlockValidation?: Maybe<Scalars['Void']['output']>;
  /** Validates the order return */
  order_return_validate?: Maybe<Scalars['Void']['output']>;
  /** Validates the order return - Dry run */
  order_return_validate_dryRun: Array<OrderRefundPlan>;
  /** Refunds the order shipping fees */
  order_shippingFees_refund?: Maybe<Scalars['Void']['output']>;
  /** Refunds the order shipping fees - Dry run */
  order_shippingFees_refund_dryRun: RefundSummary;
  /** Synchronizes the order with Shopify */
  order_shopify_synchronize?: Maybe<Scalars['Void']['output']>;
  /** Splits the order in multiple orders */
  order_split?: Maybe<Scalars['Void']['output']>;
  /** Generates an orders parcels upload url */
  orders_parcels_generateUploadUrl: Upload;
  /** Submits the orders parcels */
  orders_parcels_submit?: Maybe<Scalars['Void']['output']>;
  /** Synchronizes the orders with Shopify */
  orders_shopify_synchronize?: Maybe<Scalars['Void']['output']>;
  /** Synchronizes the products stocks with Shopify */
  products_stocks_shopify_synchronize?: Maybe<Scalars['Void']['output']>;
  /** Removes some credit from the support actor app contact */
  removeSupportActorAppContactCredit?: Maybe<Scalars['Void']['output']>;
  /**
   * Removes a snippet.
   *
   * Arguments:
   * - snippetId: The ID of the snippet to remove.
   *
   * Returns:
   * - The removed snippet.
   */
  removeSupportSnippet: SupportSnippet;
  /**
   * Removes a snippet tag.
   *
   * Arguments:
   * - snippetTagId: The ID of the snippet tag to remove.
   *
   * Returns:
   * - The removed snippet tag.
   */
  removeSupportSnippetTag: SupportSnippetTag;
  /**
   * Removes a snippet template.
   *
   * Arguments:
   * - snippetTemplateId: The ID of the snippet template to remove.
   *
   * Returns:
   * - The removed snippet template.
   */
  removeSupportSnippetTemplate: SupportSnippetTemplate;
  /** Remove a reaction from a ticket activity. If not exists, no-op. */
  removeSupportTicketActivityReaction: Scalars['Boolean']['output'];
  /** Removes a support view from the current user's favorites. */
  removeSupportViewFavorite?: Maybe<Scalars['Void']['output']>;
  /**
   * Assigns or unassigns an internal user or bot to a specific ticket.
   *
   * - If `actorUserId` is provided, the specified user will be assigned to the ticket.
   * - If `actorUserId` is null, the current assignee (if any) will be removed.
   *
   * Arguments:
   * - ticketId: The ID of the ticket to update.
   * - actorUserId: (Optional) The ID of the internal user or bot to assign. If omitted or null, the ticket will be unassigned.
   *
   * Returns:
   * - The updated Ticket.
   */
  setSupportTicketAssignee: SupportTicket;
  /**
   * Updates the sub-status of a given ticket. Optionally, the ticket can be snoozed until a specified date.
   *
   * Arguments:
   * - ticketId: The ID of the ticket to update.
   * - subStatus: The new sub-status to apply to the ticket.
   * - snoozedUntil: (Optional) A date until which the ticket will be snoozed. Useful for deferring action on the ticket.
   *
   * Returns:
   * - The updated Ticket.
   */
  setSupportTicketSubStatus: SupportTicket;
  /**
   * Set a new title for the specified support ticket.
   *
   * Arguments:
   * - ticketId: The ID of the support ticket to update.
   * - title: The new title.
   *
   * Returns:
   * - The updated support ticket.
   */
  setSupportTicketTitle: SupportTicket;
  /** Creates a new supplier billing adjustment note */
  supplierBillingAdjustmentNote_create: SupplierBillingAdjustmentNote;
  /** Deletes the supplier billing adjustment note */
  supplierBillingAdjustmentNote_delete?: Maybe<Scalars['Void']['output']>;
  /** Updates the supplier billing adjustment note */
  supplierBillingAdjustmentNote_update?: Maybe<Scalars['Void']['output']>;
  /** Creates a new supplier billing adjustment */
  supplierBillingAdjustment_create: SupplierBillingAdjustment;
  /** Deletes the supplier billing adjustment */
  supplierBillingAdjustment_delete?: Maybe<Scalars['Void']['output']>;
  /** Generates a new supplier billing adjustment document upload url */
  supplierBillingAdjustment_generateDocumentUploadUrl: Upload;
  /** Updates the supplier billing adjustment */
  supplierBillingAdjustment_update?: Maybe<Scalars['Void']['output']>;
  /** Validates the supplier billing adjustment */
  supplierBillingAdjustment_validate?: Maybe<Scalars['Void']['output']>;
  /** Submits a supplier down payment */
  supplierDownPayment_submit?: Maybe<Scalars['Void']['output']>;
  /** Generates a supplier invoice upload url */
  supplierInvoice_generateUploadUrl: Upload;
  /** Submits a supplier invoice */
  supplierInvoice_submit?: Maybe<Scalars['Void']['output']>;
  /** Creates a new supplier workspace */
  supplierWorkspace_create: SupplierWorkspace;
  /** Accepts the invitation to the supplier workspace */
  supplierWorkspace_invitation_accept?: Maybe<Scalars['Void']['output']>;
  /** Cancels the invitation to the supplier workspace */
  supplierWorkspace_invitation_cancel?: Maybe<Scalars['Void']['output']>;
  /** Edits the role of the invitation to the supplier workspace */
  supplierWorkspace_invitation_editRole?: Maybe<Scalars['Void']['output']>;
  /** Expires all the pending expired supplier workspace invitations */
  supplierWorkspace_invitation_expireAllPendingExpired?: Maybe<Scalars['Void']['output']>;
  /** Sends an invitation to the supplier workspace */
  supplierWorkspace_invitation_send?: Maybe<Scalars['Void']['output']>;
  /** Triggers the email of the invitation to the supplier workspace */
  supplierWorkspace_invitation_triggerEmail?: Maybe<Scalars['Void']['output']>;
  /** Edits the role of the member in the supplier workspace */
  supplierWorkspace_member_editRole?: Maybe<Scalars['Void']['output']>;
  /** Removes the member from the supplier workspace */
  supplierWorkspace_member_remove?: Maybe<Scalars['Void']['output']>;
  /** Accepts the AI suggestion */
  supportTicket_aiSuggestion_accept: SupportTicket;
  /** Edits the AI suggestion email */
  supportTicket_aiSuggestion_editEmail: SupportTicket;
  /** Edits the AI suggestion message */
  supportTicket_aiSuggestion_editMessage: SupportTicket;
  /** Support ticket - Archive all */
  supportTicket_archiveAll?: Maybe<Scalars['Void']['output']>;
  /** Closes a support ticket as a duplicate of another ticket. The ticket is archived. */
  supportTicket_closeAsDuplicate: SupportTicket;
  /** Closes a support ticket as junk (e.g. marketing email). The ticket is ignored. */
  supportTicket_closeAsJunk: SupportTicket;
  /** Closes a support ticket as unresolvable (e.g. ongoing conflict with the customer). The ticket is archived. */
  supportTicket_closeAsUnresolvable: SupportTicket;
  /**
   * Records the agent verdict on the flow a ticket initial request belongs to.
   * Needs no AI classification, and overwrites any previous verdict
   */
  supportTicket_initialRequest_reviewFlow: SupportTicketActivityInitialRequestFlowReview;
  /** Support ticket - Order - Declares items as out of stock */
  supportTicket_order_declareItemsAsOutOfStock: SupportTicket;
  /** Support ticket - Order - Declares items as out of stock - dry run */
  supportTicket_order_declareItemsAsOutOfStock_dryRun: SupportTicket_Order_DeclareItemsAsOutOfStock_Output;
  /** Support ticket - Order - Postpone delivery date range */
  supportTicket_order_postponeDeliveryDateRange: SupportTicket;
  /** Support ticket - Order - Update delivery date range */
  supportTicket_order_updateDeliveryDateRange: SupportTicket;
  /**
   * Sends an email to the contact in the context of the specified ticket.
   *
   * Arguments:
   * - input: The input used to add an email to a support ticket.
   * - scheduleAt: The date and time when the email should be sent.
   * Returns:
   * - The new email schedule action.
   */
  supportTicket_scheduleAction_addEmail: SupportTicket;
  /**
   * Schedules a message to be sent to the contact in the context of the specified ticket.
   *
   * Arguments:
   * - input: The input used to add a message to a support ticket.
   * - scheduleAt: The date and time when the message should be sent.
   * Returns:
   * - The new message schedule action.
   */
  supportTicket_scheduleAction_addMessage: SupportTicket;
  /**
   * Schedules a note to be added to the specified ticket.
   *
   * Arguments:
   * - input: The input used to add a note to a support ticket.
   * - scheduleAt: The date and time when the note should be added.
   * Returns:
   * - The new note schedule action.
   */
  supportTicket_scheduleAction_addNote: SupportTicket;
  /** Executes the schedule actions of all tickets with a pending status and a schedule at in the past. */
  supportTicket_scheduleAction_executeAll?: Maybe<Scalars['Void']['output']>;
  /**
   * Marks the specified schedule action as canceled.
   *
   * Arguments:
   * - input: The input used to mark a schedule action as canceled.
   * Returns:
   * - The updated ticket.
   */
  supportTicket_scheduleAction_markAsCanceled: SupportTicket;
  /**
   * Marks the specified schedule action as paused.
   *
   * Arguments:
   * - input: The input used to mark a schedule action as paused.
   * Returns:
   * - The updated ticket.
   */
  supportTicket_scheduleAction_markAsPaused: SupportTicket;
  /**
   * Reschedules the specified schedule action.
   *
   * Arguments:
   * - input: The input used to reschedule a schedule action.
   * Returns:
   * - The updated ticket.
   */
  supportTicket_scheduleAction_reschedule: SupportTicket;
  /**
   * Schedules the sub-status of a given ticket.
   *
   * Arguments:
   * - input: The input used to set the sub-status of a support ticket.
   * - scheduleAt: The date and time when the sub-status should be set.
   * Returns:
   * - The new sub-status schedule action.
   */
  supportTicket_scheduleAction_setSubStatus: SupportTicket;
  /**
   * Updates an email schedule action.
   *
   * Arguments:
   * - input: The input used to update an email to a support ticket.
   * Returns:
   * - The updated schedule action.
   */
  supportTicket_scheduleAction_updateEmail: SupportTicket;
  /**
   * Updates a message schedule action.
   *
   * Arguments:
   * - input: The input used to update a message to a support ticket.
   * Returns:
   * - The updated schedule action.
   */
  supportTicket_scheduleAction_updateMessage: SupportTicket;
  /**
   * Updates a note schedule action.
   *
   * Arguments:
   * - input: The input used to update a note to a support ticket.
   * Returns:
   * - The updated schedule action.
   */
  supportTicket_scheduleAction_updateNote: SupportTicket;
  /**
   * Updates a sub-status schedule action.
   *
   * Arguments:
   * - input: The input used to update the sub-status of a support ticket.
   * Returns:
   * - The updated schedule action.
   */
  supportTicket_scheduleAction_updateSubStatus: SupportTicket;
  /** Flags the support actor app contact as a frauder */
  support_actorAppContact_flagAsFrauder: SupportActorAppContact;
  /** Flags the support actor app contact as an influencer */
  support_actorAppContact_flagAsInfluencer: SupportActorAppContact;
  /** Unflags the support actor app contact as a frauder */
  support_actorAppContact_unflagAsFrauder: SupportActorAppContact;
  /** Unflags the support actor app contact as an influencer */
  support_actorAppContact_unflagAsInfluencer: SupportActorAppContact;
  /**
   * Support - Order Flow - Communication App Users
   *
   * Creates OnlyInformation tickets with a message for a list of app users.
   */
  support_orderFlow_communicationAppUsers?: Maybe<Scalars['Void']['output']>;
  /**
   * Support - Order Flow - Credit compensation supplier charged
   *
   * filters mandatory
   * - saleIds => one
   */
  support_orderFlow_creditCompensationSupplierCharged?: Maybe<Scalars['Void']['output']>;
  /**
   * Support - Order Flow - Delivery delay V2
   *
   * filters mandatory
   * - saleIds => one
   * - tagging.shipment => NONE, PENDING, INFO_RECEIVED
   */
  support_orderFlow_deliveryDelayV2?: Maybe<Scalars['Void']['output']>;
  /**
   * Support - Order Flow - Order cancellation
   *
   * filters mandatory
   * - saleIds => one
   */
  support_orderFlow_orderCancellation?: Maybe<Scalars['Void']['output']>;
  /**
   * Support - Order Flow - Order optimization packaging
   *
   * filters mandatory
   * - saleIds => one
   */
  support_orderFlow_orderOptimizationPackaging?: Maybe<Scalars['Void']['output']>;
  /**
   * Support - Order Flow - Other
   *
   * filters mandatory
   * - saleIds => one
   */
  support_orderFlow_other?: Maybe<Scalars['Void']['output']>;
  /**
   * Support - Order Flow - Product out of stock
   *
   * filters mandatory
   * - saleIds => one
   * - productReferences => one or more
   */
  support_orderFlow_productOutOfStock?: Maybe<Scalars['Void']['output']>;
  /**
   * Support - Order Flow - Product out of stock Shopify
   *
   * filters mandatory
   * - saleIds => one
   */
  support_orderFlow_productOutOfStockShopify?: Maybe<Scalars['Void']['output']>;
  /**
   * Support - Order Flow - Product wrong description
   *
   * filters mandatory
   * - saleIds => one
   * - productReferences => one or more
   */
  support_orderFlow_productWrongDescription?: Maybe<Scalars['Void']['output']>;
  /** Translates the text to the given language */
  translate: Translation;
  /**
   * Updates a snippet.
   *
   * Arguments:
   * - snippetId: The ID of the snippet to update.
   * - input: The input for updating a snippet.
   *
   * Returns:
   * - The updated snippet.
   */
  updateSupportSnippet: SupportSnippet;
  /**
   * Updates a snippet tag.
   *
   * Arguments:
   * - snippetTagId: The ID of the snippet tag to update.
   * - input: The input for updating a snippet tag.
   *
   * Returns:
   * - The updated snippet tag.
   */
  updateSupportSnippetTag: SupportSnippetTag;
  /**
   * Updates a snippet template.
   *
   * Arguments:
   * - snippetTemplateId: The ID of the snippet template to update.
   * - input: The input for updating a snippet template.
   *
   * Returns:
   * - The updated snippet template.
   */
  updateSupportSnippetTemplate: SupportSnippetTemplate;
  /** Updates an existing support view with the specified properties. */
  updateSupportView: SupportView;
  /** Edits the variant stock quantity */
  variant_editStockQuantity?: Maybe<Scalars['Void']['output']>;
};


export type MutationAddSaleNoteArgs = {
  input: AddSaleNoteInput;
};


export type MutationAddSupportActorAppContactCreditArgs = {
  input: AddSupportActorAppContactCreditInput;
};


export type MutationAddSupportAppContactNoteArgs = {
  input: AddSupportAppContactNoteInput;
};


export type MutationAddSupportTicketActivityReactionArgs = {
  activityId: Scalars['ID']['input'];
  type: SupportTicketActivityReactionType;
};


export type MutationAddSupportTicketEmailArgs = {
  input: AddSupportTicketEmailInput;
};


export type MutationAddSupportTicketMessageArgs = {
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  content: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationAddSupportTicketNoteArgs = {
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  content: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationAddSupportViewFavoriteArgs = {
  viewId: Scalars['ID']['input'];
};


export type MutationAppContact_AddSupportTicketMessageArgs = {
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  content: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationAppContact_CreateSupportTicket_FlowOrderCancelationV1Args = {
  input: CreateSupportTicket_FlowOrderCancelationV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderDelayedV1Args = {
  input: CreateSupportTicket_FlowOrderDelayedV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderDeliveredButItemsDamagedV1Args = {
  input: CreateSupportTicket_FlowOrderDeliveredButItemsDamagedV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderDeliveredButItemsMissingV1Args = {
  input: CreateSupportTicket_FlowOrderDeliveredButItemsMissingV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderDeliveredButItemsNotWorkingAnymoreV1Args = {
  input: CreateSupportTicket_FlowOrderDeliveredButItemsNotWorkingAnymoreV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderDeliveredButItemsSizeIssueV1Args = {
  input: CreateSupportTicket_FlowOrderDeliveredButItemsSizeIssueV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderDeliveredButItemsVouchersNotWorkingV1Args = {
  input: CreateSupportTicket_FlowOrderDeliveredButItemsVouchersNotWorkingV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderDeliveredButItemsWrongV1Args = {
  input: CreateSupportTicket_FlowOrderDeliveredButItemsWrongV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderInvoiceIssueV1Args = {
  input: CreateSupportTicket_FlowOrderInvoiceIssueV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderOtherIssueV1Args = {
  input: CreateSupportTicket_FlowOrderOtherIssueV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderPaymentMethodWrongV1Args = {
  input: CreateSupportTicket_FlowOrderPaymentMethodWrongV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderPickupPointIssueV1Args = {
  input: CreateSupportTicket_FlowOrderPickupPointIssueV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderPromoCodeNotSetV1Args = {
  input: CreateSupportTicket_FlowOrderPromoCodeNotSetV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderRefundIncompleteV1Args = {
  input: CreateSupportTicket_FlowOrderRefundIncompleteV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderRefundNotReceivedV1Args = {
  input: CreateSupportTicket_FlowOrderRefundNotReceivedV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderReturnInfoV1Args = {
  input: CreateSupportTicket_FlowOrderReturnInfoV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderReturnInternationalV1Args = {
  input: CreateSupportTicket_FlowOrderReturnInternationalV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderReturnNotAvailableInfoV1Args = {
  input: CreateSupportTicket_FlowOrderReturnNotAvailableInfoV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderReturnNotEligibleInfoV1Args = {
  input: CreateSupportTicket_FlowOrderReturnNotEligibleInfoV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderReturnedToSenderV1Args = {
  input: CreateSupportTicket_FlowOrderReturnedToSenderV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderShippingAddressWrongV1Args = {
  input: CreateSupportTicket_FlowOrderShippingAddressWrongV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderTrackingBlockedV1Args = {
  input: CreateSupportTicket_FlowOrderTrackingBlockedV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOrderTrackingDeliveredButNotReceivedV1Args = {
  input: CreateSupportTicket_FlowOrderTrackingDeliveredButNotReceivedV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOtherAccountV1Args = {
  input: CreateSupportTicket_FlowOtherAccountV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOtherAfterSalePolicyV1Args = {
  input: CreateSupportTicket_FlowOtherAfterSalePolicyV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOtherBugV1Args = {
  input: CreateSupportTicket_FlowOtherBugV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOtherCheckoutV1Args = {
  input: CreateSupportTicket_FlowOtherCheckoutV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOtherReferralV1Args = {
  input: CreateSupportTicket_FlowOtherReferralV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOtherRequestV1Args = {
  input: CreateSupportTicket_FlowOtherRequestV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowOtherSaleV1Args = {
  input: CreateSupportTicket_FlowOtherSaleV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowSaleInfoV1Args = {
  input: CreateSupportTicket_FlowSaleInfoV1Input;
};


export type MutationAppContact_CreateSupportTicket_FlowVariantInfoV1Args = {
  input: CreateSupportTicket_FlowVariantInfoV1Input;
};


export type MutationAppContact_GenerateSupportAttachmentUploadUrlArgs = {
  upload: SupportAttachmentUploadUrlInput;
};


export type MutationAppContact_SubmitSupportTicketResolutionSurveyArgs = {
  input: SubmitSupportTicketResolutionSurveyInput;
};


export type MutationApplySupportAppContactReferralArgs = {
  input: ApplySupportAppContactReferralInput;
};


export type MutationApplySupportAppContactReferralDryRunArgs = {
  input: ApplySupportAppContactReferralInput;
};


export type MutationAssignSupportRoleToInternalUserArgs = {
  actorId: Scalars['ID']['input'];
  role: SupportRole;
};


export type MutationAttachSupportSnippetTagToSupportSnippetArgs = {
  snippetId: Scalars['ID']['input'];
  snippetTagId: Scalars['ID']['input'];
};


export type MutationAttachSupportTicketContextArgs = {
  context: SupportTicketContextInput;
  ticketId: Scalars['ID']['input'];
};


export type MutationCreateSupportSnippetArgs = {
  input: CreateSupportSnippetInput;
};


export type MutationCreateSupportSnippetTagArgs = {
  input: CreateSupportSnippetTagInput;
};


export type MutationCreateSupportSnippetTemplateArgs = {
  input: CreateSupportSnippetTemplateInput;
};


export type MutationCreateSupportTicketArgs = {
  input: CreateSupportTicketInput;
};


export type MutationCreateSupportTicketByOrderIdArgs = {
  input: CreateSupportTicketByOrderIdInput;
};


export type MutationCreateSupportViewArgs = {
  input: CreateSupportViewInput;
};


export type MutationCurrentUser_EditFirstDayOfTheWeekArgs = {
  input: CurrentUser_EditFirstDayOfTheWeek_Input;
};


export type MutationCurrentUser_EditLanguageArgs = {
  input: CurrentUser_EditLanguage_Input;
};


export type MutationCurrentUser_EditNameArgs = {
  input: CurrentUser_EditName_Input;
};


export type MutationCurrentUser_EditPictureArgs = {
  input: CurrentUser_EditPicture_Input;
};


export type MutationCurrentUser_EditTimezoneArgs = {
  input: CurrentUser_EditTimezone_Input;
};


export type MutationCurrentUser_GeneratePictureUploadUrlArgs = {
  input: UploadInput;
};


export type MutationDeleteSupportAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupportTicketArgs = {
  ticketId: Scalars['ID']['input'];
};


export type MutationDeleteSupportViewArgs = {
  viewId: Scalars['ID']['input'];
};


export type MutationDetachSupportSnippetTagToSupportSnippetArgs = {
  snippetId: Scalars['ID']['input'];
  snippetTagId: Scalars['ID']['input'];
};


export type MutationDetachSupportTicketContextArgs = {
  ticketId: Scalars['ID']['input'];
};


export type MutationEditSupportActorAppContactReferralCodeArgs = {
  input: EditSupportActorAppContactReferralCodeInput;
};


export type MutationGenerateSupportAttachmentUploadUrlArgs = {
  upload: SupportAttachmentUploadUrlInput;
};


export type MutationMarkSupportNotificationAsReadArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationOperationSupplierWorkspaceAssignment_AcceptArgs = {
  input: OperationSupplierWorkspaceAssignment_Accept_Input;
};


export type MutationOperation_AssignToSupplierWorkspaceArgs = {
  input: Operation_AssignToSupplierWorkspace_Input;
};


export type MutationOperation_UpdateSupplierChargesVatArgs = {
  input: Operation_UpdateSupplierChargesVat_Input;
};


export type MutationOrder_CancelArgs = {
  input: Order_Cancel_Input;
};


export type MutationOrder_Cancel_DryRunArgs = {
  input: Order_Cancel_Input;
};


export type MutationOrder_Claim_AcceptWithRefundArgs = {
  input: Order_Claim_AcceptWithRefund_Input;
};


export type MutationOrder_Claim_AcceptWithReshipArgs = {
  input: Order_Claim_AcceptWithReship_Input;
};


export type MutationOrder_Claim_AcceptWithVoucherReplacementCodesArgs = {
  input: Order_Claim_AcceptWithVoucherReplacementCodes_Input;
};


export type MutationOrder_Claim_AcceptWithVoucherReplacementMessageArgs = {
  input: Order_Claim_AcceptWithVoucherReplacementMessage_Input;
};


export type MutationOrder_Claim_CancelArgs = {
  input: Order_Claim_Cancel_Input;
};


export type MutationOrder_Claim_OpenForDeliveredButDamagedArgs = {
  input: Order_Claim_OpenForDeliveredButDamaged_Input;
};


export type MutationOrder_Claim_OpenForDeliveredButIncompleteArgs = {
  input: Order_Claim_OpenForDeliveredButIncomplete_Input;
};


export type MutationOrder_Claim_OpenForDeliveredButWrongArgs = {
  input: Order_Claim_OpenForDeliveredButWrong_Input;
};


export type MutationOrder_Claim_OpenForNotDeliveredAndReturnedToSenderArgs = {
  input: Order_Claim_OpenForNotDeliveredAndReturnedToSender_Input;
};


export type MutationOrder_Claim_OpenForNotDeliveredAndTrackingBlockedArgs = {
  input: Order_Claim_OpenForNotDeliveredAndTrackingBlocked_Input;
};


export type MutationOrder_Claim_OpenForNotDeliveredAndTrackingDeliveredArgs = {
  input: Order_Claim_OpenForNotDeliveredAndTrackingDelivered_Input;
};


export type MutationOrder_Claim_OpenForOtherArgs = {
  input: Order_Claim_OpenForOther_Input;
};


export type MutationOrder_Claim_OpenForVoucherNotWorkingArgs = {
  input: Order_Claim_OpenForVoucherNotWorking_Input;
};


export type MutationOrder_EditBillingAddressArgs = {
  input: Order_EditBillingAddress_Input;
};


export type MutationOrder_GenerateInvoiceForCustomsArgs = {
  input: Order_GenerateInvoiceForCustoms_Input;
};


export type MutationOrder_GeneratePurchaseOrderArgs = {
  input: Order_GeneratePurchaseOrder_Input;
};


export type MutationOrder_Items_CancelArgs = {
  input: Order_Items_Cancel_Input;
};


export type MutationOrder_Items_Cancel_DryRunArgs = {
  input: Order_Items_Cancel_Input;
};


export type MutationOrder_Items_RefundArgs = {
  input: Order_Items_Refund_Input;
};


export type MutationOrder_Items_Refund_DryRunArgs = {
  input: Order_Items_Refund_Input;
};


export type MutationOrder_Parcel_CreateArgs = {
  input: Order_Parcel_Create_Input;
};


export type MutationOrder_Parcel_EditArgs = {
  input: Order_Parcel_Edit_Input;
};


export type MutationOrder_Parcel_GroupArgs = {
  input: Order_Parcel_Group_Input;
};


export type MutationOrder_Parcel_SwapArgs = {
  input: Order_Parcel_Swap_Input;
};


export type MutationOrder_Parcels_MarkAsDeliveredArgs = {
  input: Order_Parcels_MarkAsDelivered_Input;
};


export type MutationOrder_Return_CancelArgs = {
  input: Order_Return_Cancel_Input;
};


export type MutationOrder_Return_CreateArgs = {
  input: Order_Return_Create_Input;
};


export type MutationOrder_Return_CreateWithLabelArgs = {
  input: Order_Return_CreateWithLabel_Input;
};


export type MutationOrder_Return_CreateWithLabelForClaimArgs = {
  input: Order_Return_CreateWithLabelForClaim_Input;
};


export type MutationOrder_Return_EditPreferredRefundMethodArgs = {
  input: Order_Return_EditPreferredRefundMethod_Input;
};


export type MutationOrder_Return_EditTrackingInfoArgs = {
  input: Order_Return_EditTrackingInfo_Input;
};


export type MutationOrder_Return_GenerateLabelUploadUrlArgs = {
  input: Order_Return_GenerateLabelUploadUrl_Input;
};


export type MutationOrder_Return_LockValidationArgs = {
  input: Order_Return_LockValidation_Input;
};


export type MutationOrder_Return_UnlockValidationArgs = {
  input: Order_Return_UnlockValidation_Input;
};


export type MutationOrder_Return_ValidateArgs = {
  input: Order_Return_Validate_Input;
};


export type MutationOrder_Return_Validate_DryRunArgs = {
  input: Order_Return_Validate_Input;
};


export type MutationOrder_ShippingFees_RefundArgs = {
  input: Order_ShippingFees_Refund_Input;
};


export type MutationOrder_ShippingFees_Refund_DryRunArgs = {
  input: Order_ShippingFees_Refund_Input;
};


export type MutationOrder_Shopify_SynchronizeArgs = {
  input: Order_Shopify_Synchronize_Input;
};


export type MutationOrder_SplitArgs = {
  input: Order_Split_Input;
};


export type MutationOrders_Parcels_GenerateUploadUrlArgs = {
  input: Orders_Parcels_GenerateUploadUrl_Input;
};


export type MutationOrders_Parcels_SubmitArgs = {
  input: Orders_Parcels_Submit_Input;
};


export type MutationOrders_Shopify_SynchronizeArgs = {
  input: Orders_Shopify_Synchronize_Input;
};


export type MutationProducts_Stocks_Shopify_SynchronizeArgs = {
  input: Products_Stocks_Shopify_Synchronize_Input;
};


export type MutationRemoveSupportActorAppContactCreditArgs = {
  input: RemoveSupportActorAppContactCreditInput;
};


export type MutationRemoveSupportSnippetArgs = {
  snippetId: Scalars['ID']['input'];
};


export type MutationRemoveSupportSnippetTagArgs = {
  snippetTagId: Scalars['ID']['input'];
};


export type MutationRemoveSupportSnippetTemplateArgs = {
  snippetTemplateId: Scalars['ID']['input'];
};


export type MutationRemoveSupportTicketActivityReactionArgs = {
  activityId: Scalars['ID']['input'];
  type: SupportTicketActivityReactionType;
};


export type MutationRemoveSupportViewFavoriteArgs = {
  viewId: Scalars['ID']['input'];
};


export type MutationSetSupportTicketAssigneeArgs = {
  actorUserId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};


export type MutationSetSupportTicketSubStatusArgs = {
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  subStatus: SupportTicketSubStatus;
  ticketId: Scalars['ID']['input'];
};


export type MutationSetSupportTicketTitleArgs = {
  ticketId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationSupplierBillingAdjustmentNote_CreateArgs = {
  input: SupplierBillingAdjustmentNote_Create_Input;
};


export type MutationSupplierBillingAdjustmentNote_DeleteArgs = {
  input: SupplierBillingAdjustmentNote_Delete_Input;
};


export type MutationSupplierBillingAdjustmentNote_UpdateArgs = {
  input: SupplierBillingAdjustmentNote_Update_Input;
};


export type MutationSupplierBillingAdjustment_CreateArgs = {
  input: SupplierBillingAdjustment_Create_Input;
};


export type MutationSupplierBillingAdjustment_DeleteArgs = {
  input: SupplierBillingAdjustment_Delete_Input;
};


export type MutationSupplierBillingAdjustment_GenerateDocumentUploadUrlArgs = {
  input: SupplierBillingAdjustment_GenerateDocumentUploadUrl_Input;
};


export type MutationSupplierBillingAdjustment_UpdateArgs = {
  input: SupplierBillingAdjustment_Update_Input;
};


export type MutationSupplierBillingAdjustment_ValidateArgs = {
  input: SupplierBillingAdjustment_Validate_Input;
};


export type MutationSupplierDownPayment_SubmitArgs = {
  input: SupplierDownPayment_Submit_Input;
};


export type MutationSupplierInvoice_GenerateUploadUrlArgs = {
  input: SupplierInvoice_GenerateUploadUrl_Input;
};


export type MutationSupplierInvoice_SubmitArgs = {
  input: SupplierInvoice_Submit_Input;
};


export type MutationSupplierWorkspace_CreateArgs = {
  input: SupplierWorkspace_Create_Input;
};


export type MutationSupplierWorkspace_Invitation_AcceptArgs = {
  input: SupplierWorkspace_Invitation_Accept_Input;
};


export type MutationSupplierWorkspace_Invitation_CancelArgs = {
  input: SupplierWorkspace_Invitation_Cancel_Input;
};


export type MutationSupplierWorkspace_Invitation_EditRoleArgs = {
  input: SupplierWorkspace_Invitation_EditRole_Input;
};


export type MutationSupplierWorkspace_Invitation_SendArgs = {
  input: SupplierWorkspace_Invitation_Send_Input;
};


export type MutationSupplierWorkspace_Invitation_TriggerEmailArgs = {
  input: SupplierWorkspace_Invitation_TriggerEmail_Input;
};


export type MutationSupplierWorkspace_Member_EditRoleArgs = {
  input: SupplierWorkspace_Member_EditRole_Input;
};


export type MutationSupplierWorkspace_Member_RemoveArgs = {
  input: SupplierWorkspace_Member_Remove_Input;
};


export type MutationSupportTicket_AiSuggestion_AcceptArgs = {
  input: SupportTicketAiSuggestionAcceptInput;
};


export type MutationSupportTicket_AiSuggestion_EditEmailArgs = {
  input: SupportTicketAiSuggestionEditEmailInput;
};


export type MutationSupportTicket_AiSuggestion_EditMessageArgs = {
  input: SupportTicketAiSuggestionEditMessageInput;
};


export type MutationSupportTicket_CloseAsDuplicateArgs = {
  input: SupportTicket_CloseAsDuplicate_Input;
};


export type MutationSupportTicket_CloseAsJunkArgs = {
  input: SupportTicket_CloseAsJunk_Input;
};


export type MutationSupportTicket_CloseAsUnresolvableArgs = {
  input: SupportTicket_CloseAsUnresolvable_Input;
};


export type MutationSupportTicket_InitialRequest_ReviewFlowArgs = {
  input: SupportTicketInitialRequestReviewFlowInput;
};


export type MutationSupportTicket_Order_DeclareItemsAsOutOfStockArgs = {
  input: SupportTicket_Order_DeclareItemsAsOutOfStock_Input;
};


export type MutationSupportTicket_Order_DeclareItemsAsOutOfStock_DryRunArgs = {
  input: SupportTicket_Order_DeclareItemsAsOutOfStock_Input;
};


export type MutationSupportTicket_Order_PostponeDeliveryDateRangeArgs = {
  input: SupportTicket_Order_PostponeDeliveryDateRange_Input;
};


export type MutationSupportTicket_Order_UpdateDeliveryDateRangeArgs = {
  input: SupportTicket_Order_UpdateDeliveryDateRange_Input;
};


export type MutationSupportTicket_ScheduleAction_AddEmailArgs = {
  input: SupportTicketScheduleActionAddEmailInput;
  scheduleAt: Scalars['DateTime']['input'];
};


export type MutationSupportTicket_ScheduleAction_AddMessageArgs = {
  input: SupportTicketScheduleActionAddMessageInput;
  scheduleAt: Scalars['DateTime']['input'];
};


export type MutationSupportTicket_ScheduleAction_AddNoteArgs = {
  input: SupportTicketScheduleActionAddNoteInput;
  scheduleAt: Scalars['DateTime']['input'];
};


export type MutationSupportTicket_ScheduleAction_MarkAsCanceledArgs = {
  input: SupportTicketScheduleActionMarkAsCanceledInput;
};


export type MutationSupportTicket_ScheduleAction_MarkAsPausedArgs = {
  input: SupportTicketScheduleActionMarkAsPausedInput;
};


export type MutationSupportTicket_ScheduleAction_RescheduleArgs = {
  input: SupportTicketScheduleActionRescheduleInput;
};


export type MutationSupportTicket_ScheduleAction_SetSubStatusArgs = {
  input: SupportTicketScheduleActionSetSubStatusInput;
  scheduleAt: Scalars['DateTime']['input'];
};


export type MutationSupportTicket_ScheduleAction_UpdateEmailArgs = {
  input: SupportTicketScheduleActionUpdateEmailInput;
};


export type MutationSupportTicket_ScheduleAction_UpdateMessageArgs = {
  input: SupportTicketScheduleActionUpdateMessageInput;
};


export type MutationSupportTicket_ScheduleAction_UpdateNoteArgs = {
  input: SupportTicketScheduleActionUpdateNoteInput;
};


export type MutationSupportTicket_ScheduleAction_UpdateSubStatusArgs = {
  input: SupportTicketScheduleActionUpdateSubStatusInput;
};


export type MutationSupport_ActorAppContact_FlagAsFrauderArgs = {
  input: Support_ActorAppContact_FlagAsFrauder_Input;
};


export type MutationSupport_ActorAppContact_FlagAsInfluencerArgs = {
  input: Support_ActorAppContact_FlagAsInfluencer_Input;
};


export type MutationSupport_ActorAppContact_UnflagAsFrauderArgs = {
  input: Support_ActorAppContact_UnflagAsFrauder_Input;
};


export type MutationSupport_ActorAppContact_UnflagAsInfluencerArgs = {
  input: Support_ActorAppContact_UnflagAsInfluencer_Input;
};


export type MutationSupport_OrderFlow_CommunicationAppUsersArgs = {
  input: Support_OrderFlow_CommunicationAppUsers_Input;
};


export type MutationSupport_OrderFlow_CreditCompensationSupplierChargedArgs = {
  input: Support_OrderFlow_CreditCompensationSupplierCharged_Input;
};


export type MutationSupport_OrderFlow_DeliveryDelayV2Args = {
  input: Support_OrderFlow_DeliveryDelayV2_Input;
};


export type MutationSupport_OrderFlow_OrderCancellationArgs = {
  input: Support_OrderFlow_OrderCancellation_Input;
};


export type MutationSupport_OrderFlow_OrderOptimizationPackagingArgs = {
  input: Support_OrderFlow_OrderOptimizationPackaging_Input;
};


export type MutationSupport_OrderFlow_OtherArgs = {
  input: Support_OrderFlow_Other_Input;
};


export type MutationSupport_OrderFlow_ProductOutOfStockArgs = {
  input: Support_OrderFlow_ProductOutOfStock_Input;
};


export type MutationSupport_OrderFlow_ProductOutOfStockShopifyArgs = {
  input: Support_OrderFlow_ProductOutOfStockShopify_Input;
};


export type MutationSupport_OrderFlow_ProductWrongDescriptionArgs = {
  input: Support_OrderFlow_ProductWrongDescription_Input;
};


export type MutationTranslateArgs = {
  input: Translate_Input;
};


export type MutationUpdateSupportSnippetArgs = {
  input: UpdateSupportSnippetInput;
  snippetId: Scalars['ID']['input'];
};


export type MutationUpdateSupportSnippetTagArgs = {
  input: UpdateSupportSnippetTagInput;
  snippetTagId: Scalars['ID']['input'];
};


export type MutationUpdateSupportSnippetTemplateArgs = {
  input: UpdateSupportSnippetTemplateInput;
  snippetTemplateId: Scalars['ID']['input'];
};


export type MutationUpdateSupportViewArgs = {
  input: UpdateSupportViewInput;
  viewId: Scalars['ID']['input'];
};


export type MutationVariant_EditStockQuantityArgs = {
  input: Variant_EditStockQuantity_Input;
};

/** Operation */
export type Operation = {
  __typename?: 'Operation';
  /** Brand id */
  brandId: Scalars['ID']['output'];
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** ISO 4217 code (e.g. EUR) of the currency in which the operation prices are expressed */
  currency: Scalars['String']['output'];
  /** Delivery courier slugs */
  deliveryCourierSlugs: Array<Scalars['String']['output']>;
  /** Delivery couriers */
  deliveryCouriers: Array<Courier>;
  /** Id */
  id: Scalars['ID']['output'];
  /** Gets the order product stats */
  orderProductStats: OrderProductStats;
  /** Gets the order ratings */
  orderRatings: OrderRatingsConnection;
  /** Gets the order stats */
  orderStats: OrderStats;
  /** Gets the orders */
  orders: OrdersConnection;
  /** Gets the orders counters */
  ordersCounters: OrdersCounters;
  /** Gets the orders by tracking */
  orders_byTracking: Array<Order>;
  /** Gets the orders export */
  orders_export?: Maybe<OrdersExport>;
  /** Gets the orders unfulfilled export */
  orders_export_unfulfilled?: Maybe<OrdersExport>;
  /** Gets the products */
  products: Array<Product>;
  /** Gets the products stocks export */
  products_stocks_export: ProductsStocksExport;
  /** Sale */
  sale: Sale;
  /** Sale id */
  saleId: Scalars['ID']['output'];
  /** Shopify */
  shopify?: Maybe<Shopify>;
  /** Supplier */
  supplier: Supplier;
  /** Gets the supplier billing */
  supplierBilling: SupplierBilling;
  /** Gets the supplier billing adjustments */
  supplierBillingAdjustments: Array<SupplierBillingAdjustment>;
  /** Gets the supplier billing state */
  supplierBillingState: SupplierBillingState;
  /** Gets the supplier billing export */
  supplierBilling_export: SupplierBillingExport;
  /** Whether the supplier charges VAT on its supplier billing (null when not determined yet) */
  supplierChargesVat?: Maybe<Scalars['Boolean']['output']>;
  /** Supplier id */
  supplierId: Scalars['ID']['output'];
  /** Gets the supplier invoices */
  supplierInvoices: Array<SupplierInvoice>;
  /** Supplier workspace */
  supplierWorkspace?: Maybe<SupplierWorkspace>;
  /** Supplier workspace id */
  supplierWorkspaceId?: Maybe<Scalars['ID']['output']>;
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
};


/** Operation */
export type OperationOrderProductStatsArgs = {
  input: Operation_OrderProductStats_Input;
};


/** Operation */
export type OperationOrderRatingsArgs = {
  input: Operation_OrderRatings_Input;
};


/** Operation */
export type OperationOrdersArgs = {
  input: Operation_Orders_Input;
};


/** Operation */
export type OperationOrders_ByTrackingArgs = {
  input: Operation_Orders_ByTracking_Input;
};


/** Operation */
export type OperationOrders_ExportArgs = {
  input: Operation_Orders_Export_Input;
};


/** Operation */
export type OperationOrders_Export_UnfulfilledArgs = {
  input: Operation_Orders_Export_Unfulfilled_Input;
};


/** Operation */
export type OperationProducts_Stocks_ExportArgs = {
  input: Operation_Products_Stocks_Export_Input;
};


/** Operation */
export type OperationSupplierBilling_ExportArgs = {
  input: Operation_SupplierBilling_Export_Input;
};

/** Operation supplier workspace assignment */
export type OperationSupplierWorkspaceAssignment = {
  __typename?: 'OperationSupplierWorkspaceAssignment';
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Email */
  email: Scalars['EmailAddress']['output'];
  /** Whether the email has been sent */
  emailSent: Scalars['Boolean']['output'];
  /** Date when the assignment expires */
  expiresAt: Scalars['DateTime']['output'];
  /** Id */
  id: Scalars['ID']['output'];
  /** Operation */
  operation: Operation;
  /** Operation id */
  operationId: Scalars['ID']['output'];
  /** Status */
  status: OperationSupplierWorkspaceAssignmentStatus;
  /** Supplier workspace */
  supplierWorkspace?: Maybe<SupplierWorkspace>;
  /** Supplier workspace id */
  supplierWorkspaceId?: Maybe<Scalars['ID']['output']>;
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
};

/** Operation supplier workspace assignment status */
export enum OperationSupplierWorkspaceAssignmentStatus {
  /** Accepted */
  Accepted = 'Accepted',
  /** Expired */
  Expired = 'Expired',
  /** Pending */
  Pending = 'Pending'
}

/** Operation supplier workspace assignment - Accept - Input */
export type OperationSupplierWorkspaceAssignment_Accept_Input = {
  /** Operation supplier workspace assignment id */
  operationSupplierWorkspaceAssignmentId: Scalars['ID']['input'];
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Operation type */
export enum OperationType {
  /** Choose with StockAZ clears its stock */
  Clearance = 'CLEARANCE',
  /** The supplier sell its products and ship on its own */
  DropShipping = 'DROP_SHIPPING',
  /** Choose has ordered the products before the operation and ship on its own */
  FirmPurchase = 'FIRM_PURCHASE',
  /** Choose order the products sold after the operation and ship it on its own */
  PostOperationPurchase = 'POST_OPERATION_PURCHASE',
  /** The reseller sell products from another supplier => Not used anymore */
  Reseller = 'RESELLER'
}

/** Operation - Assign to supplier workspace - Input */
export type Operation_AssignToSupplierWorkspace_Input = {
  /** Operation id */
  operationId: Scalars['ID']['input'];
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Operation - Input */
export type Operation_Input = {
  /** Operation id */
  operationId: Scalars['ID']['input'];
};

/** Operation - Order product stats - Input */
export type Operation_OrderProductStats_Input = {
  /** Option key */
  optionKey?: InputMaybe<Scalars['String']['input']>;
};

/** Operation - Order ratings - Filter - Input */
export type Operation_OrderRatings_Filter_Input = {
  /** Filter by rate */
  rate?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Filter with a comment */
  withComment?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Operation - Order ratings - Input */
export type Operation_OrderRatings_Input = {
  /** Filter */
  filter?: InputMaybe<Operation_OrderRatings_Filter_Input>;
  /** Page info */
  pageInfo: PageInfo_Input;
};

/** Operation - Orders - By Tracking - Input */
export type Operation_Orders_ByTracking_Input = {
  /** Tracking courier slug */
  trackingCourierSlug: Scalars['String']['input'];
  /** Tracking number */
  trackingNumber: Scalars['String']['input'];
};

/** Operation - Orders - Export - Input */
export type Operation_Orders_Export_Input = {
  /** File extension */
  fileExtension: FileExtension;
  /** File format */
  fileFormat?: InputMaybe<Logistician>;
  /** Filter */
  filter?: InputMaybe<Operation_Orders_Filter_Input>;
  /** Search */
  search?: InputMaybe<Operation_Orders_Search_Input>;
  /** Sort */
  sort: Operation_Orders_Sort_Input;
};

/** Operation - Orders - Export - Unfulfilled - Input */
export type Operation_Orders_Export_Unfulfilled_Input = {
  /** File extension */
  fileExtension: FileExtension;
  /** File format */
  fileFormat?: InputMaybe<Logistician>;
};

/** Operation - Orders - Filter - Creation Date - Input */
export type Operation_Orders_Filter_Creation_Date_Input = {
  /** Filter from this creation date */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter to this creation date */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Operation - Orders - Filter - Input */
export type Operation_Orders_Filter_Input = {
  /** Filter on creation date */
  creationDate?: InputMaybe<Operation_Orders_Filter_Creation_Date_Input>;
  /** Filter on customer identifiers */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on item references */
  itemReferences?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on order identifiers */
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on tagging */
  tagging?: InputMaybe<Operation_Orders_Filter_Tagging_Input>;
};

/** Operation - Orders - Filter - Tagging - Input */
export type Operation_Orders_Filter_Tagging_Input = {
  /** Filter on brand tags */
  brand?: InputMaybe<Array<OrderTagBrand>>;
  /** Filter on claim tags */
  claim?: InputMaybe<Array<OrderTagClaim>>;
  /** Filter on claim reason tags */
  claimReason?: InputMaybe<Array<OrderTagClaimReason>>;
  /** Filter on fulfillment tags */
  fulfillment?: InputMaybe<Array<OrderTagFulfillment>>;
  /** Filter on refund tags */
  refund?: InputMaybe<Array<OrderTagRefund>>;
  /** Filter on reship tags */
  reship?: InputMaybe<Array<OrderTagReship>>;
  /** Filter on return tags */
  return?: InputMaybe<Array<OrderTagReturn>>;
  /** Filter on shipment tags */
  shipment?: InputMaybe<Array<OrderTagShipment>>;
  /** Filter on shipping mode tags */
  shippingMode?: InputMaybe<Array<OrderTagShippingMode>>;
  /** Filter on shopify tags */
  shopify?: InputMaybe<Array<OrderTagShopify>>;
  /** Filter on status tags */
  status?: InputMaybe<Array<OrderTagStatus>>;
  /** Filter on type tags */
  type?: InputMaybe<Array<OrderTagType>>;
};

/** Operation - Orders - Input */
export type Operation_Orders_Input = {
  /** Filter */
  filter?: InputMaybe<Operation_Orders_Filter_Input>;
  /** Page info */
  pageInfo: PageInfo_Input;
  /** Search */
  search?: InputMaybe<Operation_Orders_Search_Input>;
  /** Sort */
  sort: Operation_Orders_Sort_Input;
};

/** Operation - Orders - Search - Field - Input */
export enum Operation_Orders_Search_Field_Input {
  /** Search in all available fields */
  All = 'ALL'
}

/** Operation - Orders - Search - Input */
export type Operation_Orders_Search_Input = {
  /** Field to search into */
  field: Operation_Orders_Search_Field_Input;
  /** Term to search */
  term: Scalars['String']['input'];
};

/** Operation - Orders - Sort - Field - Input */
export enum Operation_Orders_Sort_Field_Input {
  /** Sort on claim creation date */
  ClaimCreationDate = 'CLAIM_CREATION_DATE',
  /** Sort on creation date */
  CreationDate = 'CREATION_DATE',
  /** Sort on recipient full name */
  RecipientFullName = 'RECIPIENT_FULL_NAME',
  /** Sort on brand tag */
  TagBrand = 'TAG_BRAND',
  /** Sort on claim tag */
  TagClaim = 'TAG_CLAIM',
  /** Sort on claim reason tag */
  TagClaimReason = 'TAG_CLAIM_REASON',
  /** Sort on fulfillment tag */
  TagFulfillment = 'TAG_FULFILLMENT',
  /** Sort on refund tag */
  TagRefund = 'TAG_REFUND',
  /** Sort on reship tag */
  TagReship = 'TAG_RESHIP',
  /** Sort on return tag */
  TagReturn = 'TAG_RETURN',
  /** Sort on shipment tag */
  TagShipment = 'TAG_SHIPMENT',
  /** Sort on shipping mode tag */
  TagShippingMode = 'TAG_SHIPPING_MODE',
  /** Sort on shopify tag */
  TagShopify = 'TAG_SHOPIFY',
  /** Sort on status tag */
  TagStatus = 'TAG_STATUS',
  /** Sort on type tag */
  TagType = 'TAG_TYPE',
  /** Sort on total price sold */
  TotalPriceSold = 'TOTAL_PRICE_SOLD'
}

/** Operation - Orders - Sort - Input */
export type Operation_Orders_Sort_Input = {
  /** Field to sort */
  field: Operation_Orders_Sort_Field_Input;
  /** Order to sort */
  order: Operation_Orders_Sort_Order_Input;
};

/** Operation - Orders - Sort - Order - Input */
export enum Operation_Orders_Sort_Order_Input {
  /** Sort in ascending order */
  Ascending = 'ASCENDING',
  /** Sort in descending order */
  Descending = 'DESCENDING'
}

/** Operation - Products - Stocks - Export - Input */
export type Operation_Products_Stocks_Export_Input = {
  /** File extension */
  fileExtension: FileExtension;
};

/** Operation - Supplier Billing - Export - Input */
export type Operation_SupplierBilling_Export_Input = {
  /** File extension */
  fileExtension: FileExtension;
};

/** Operation - Update supplier charges VAT - Input */
export type Operation_UpdateSupplierChargesVat_Input = {
  /** Operation id */
  operationId: Scalars['ID']['input'];
  /** Whether the supplier charges VAT on its supplier billing */
  supplierChargesVat: Scalars['Boolean']['input'];
};

/** Order */
export type Order = {
  __typename?: 'Order';
  /** Billing ID */
  billingId: Scalars['ID']['output'];
  /** Brand */
  brand: Brand;
  /** Brand ID */
  brandId: Scalars['ID']['output'];
  /** The buyer is the person who has been billed for the order */
  buyer: Buyer;
  /** Cashback */
  cashback?: Maybe<Cashback>;
  /** Claims */
  claims: Array<Claim>;
  /** Date of the creation */
  createdAt: Scalars['DateTime']['output'];
  /** Customer ID */
  customerId: Scalars['ID']['output'];
  /** Has been exported by the supplier ?  (using a CSV from the dashboard in order to not process it twice) */
  hasBeenExported: Scalars['Boolean']['output'];
  /** Has supplier error ? */
  hasSupplierError: Scalars['Boolean']['output'];
  /** Has synchronization error ? */
  hasSynchronizationError: Scalars['Boolean']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Initial order if this is a reship order */
  initialOrder?: Maybe<Order>;
  /** ID of the initial order if this is a reship order */
  initialOrderId?: Maybe<Scalars['ID']['output']>;
  /** Integration */
  integration: OrderIntegration;
  /** Is cancelled ? */
  isCancelled: Scalars['Boolean']['output'];
  /** Does the order include only digital items ? */
  isFullDigital: Scalars['Boolean']['output'];
  /** Is shipping estimated time exceeded ? */
  isShippingEstimatedTimeExceeded: Scalars['Boolean']['output'];
  /** Items ordered by the customer */
  items: Array<Item>;
  /** Lines refunds */
  linesRefunds: Array<OrderLineRefund>;
  /** Operation */
  operation?: Maybe<Operation>;
  /** Operation ID */
  operationId?: Maybe<Scalars['ID']['output']>;
  /** Operation type */
  operationType: OperationType;
  /** Parcels */
  parcels: Array<Parcel>;
  /** Parent orders */
  parentOrders: Array<Order>;
  /** Payment infos */
  payment: OrderPayment;
  /** Rating */
  rating?: Maybe<OrderRating>;
  /** The recipient is the person who will receive the order */
  recipient: Recipient;
  /** Reship order if this is an initial order reshipped */
  reshipOrder?: Maybe<Order>;
  /** ID of the reship order if this is an initial order reshipped */
  reshipOrderId?: Maybe<Scalars['ID']['output']>;
  /** Returns */
  returns: Array<Return>;
  /** Sale */
  sale: Sale;
  /** Sale ID */
  saleId: Scalars['ID']['output'];
  /** Shipping infos */
  shipping: OrderShipping;
  /** Split action error reasons if the action is not available */
  splitActionErrorReasons: Array<OrderSplitActionErrorReason>;
  /** Support actor app contact */
  supportActorAppContact: SupportActorAppContact;
  /** Tags */
  tags: OrderTags;
  /** Total price sold (items) by Choose to the customer (in cents) */
  totalPriceSold: Price;
};

/** Order edge */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** Cursor */
  cursor: Scalars['ID']['output'];
  /** Node */
  node: Order;
};

/** Order integration */
export type OrderIntegration = {
  __typename?: 'OrderIntegration';
  /** Error message from the integration (Shopify, StockAZ) */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** ID of the order from the integration (Shopify, StockAZ) */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** Shopify integration */
  shopify?: Maybe<ShopifyOrderIntegration>;
};

/** Order item refund plan */
export type OrderItemRefundPlan = {
  __typename?: 'OrderItemRefundPlan';
  /** Breakdown */
  breakdown: OrderRefundPlanBreakdown;
  /** Item id */
  itemId: Scalars['ID']['output'];
  /** Order id */
  orderId: Scalars['ID']['output'];
  /** Withheld */
  withheld?: Maybe<OrderRefundPlanWithheld>;
};

/** Order item taxes refund plan */
export type OrderItemTaxesRefundPlan = {
  __typename?: 'OrderItemTaxesRefundPlan';
  /** Breakdown */
  breakdown: OrderRefundPlanBreakdown;
  /** Item id */
  itemId: Scalars['ID']['output'];
  /** Order id */
  orderId: Scalars['ID']['output'];
  /** Withheld */
  withheld?: Maybe<OrderRefundPlanWithheld>;
};

/** Order line refund */
export type OrderLineRefund = {
  __typename?: 'OrderLineRefund';
  /** Amount in cents of the refund */
  amountInCents: Scalars['NonNegativeInt']['output'];
  /** Cover party that has covered the refund */
  coveredBy: OrderLineRefundCover;
  /** Creation date of the refund */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the refund */
  id: Scalars['ID']['output'];
  /** Internal note associated to the refund */
  internalNote?: Maybe<Scalars['String']['output']>;
  /** Identifier of the line (item id for "ITEM" and order id for "SHIPPING" and "LEGACY") */
  lineId: Scalars['ID']['output'];
  /** Line type ("ITEM" or "SHIPPING") */
  lineType: OrderLineType;
  /** Identifier of the plan (refunds made at the same time have the same plan id) */
  planId: Scalars['ID']['output'];
  /** Reason of the refund */
  reason: OrderLineRefundReason;
};

/** Order line refund cover */
export enum OrderLineRefundCover {
  /** Choose has covered the refund */
  Choose = 'CHOOSE',
  /** The supplier has covered the refund */
  Supplier = 'SUPPLIER'
}

/** Order line refund reason */
export enum OrderLineRefundReason {
  /** A claim has been accepted */
  ClaimAccepted = 'CLAIM_ACCEPTED',
  /** A claim has been accepted because the parcel has not been delivered and has been returned to the sender */
  ClaimAcceptedNotDeliveredAndReturnedToSender = 'CLAIM_ACCEPTED_NOT_DELIVERED_AND_RETURNED_TO_SENDER',
  /** A refund has been done directly */
  Direct = 'DIRECT',
  /** A refund has been done directly because a claim has the deadline exceeded */
  DirectClaimDeadlineExceeded = 'DIRECT_CLAIM_DEADLINE_EXCEEDED',
  /** A refund has been done directly because a claim has been refused */
  DirectClaimRefused = 'DIRECT_CLAIM_REFUSED',
  /** A refund has been done directly to make a commercial gesture */
  DirectCommercialGesture = 'DIRECT_COMMERCIAL_GESTURE',
  /** A refund has been done directly because an item has a wrong image */
  DirectItemWrongImage = 'DIRECT_ITEM_WRONG_IMAGE',
  /** A refund has been done directly because an item has a wrong price */
  DirectItemWrongPrice = 'DIRECT_ITEM_WRONG_PRICE',
  /** A legal conformity guarantee has been accepted by Choose - not the brand */
  DirectLegalConformityGuarantee = 'DIRECT_LEGAL_CONFORMITY_GUARANTEE',
  /** A refund has been done directly because a return has the deadline exceeded */
  DirectReturnDeadlineExceeded = 'DIRECT_RETURN_DEADLINE_EXCEEDED',
  /** A refund has been done directly because a return has been locked */
  DirectReturnLocked = 'DIRECT_RETURN_LOCKED',
  /** A refund has been done directly because a return has been refused */
  DirectReturnRefused = 'DIRECT_RETURN_REFUSED',
  /** An item has been canceled */
  ItemCanceled = 'ITEM_CANCELED',
  /** An item has been canceled because of out of stock */
  ItemCanceledOutOfStock = 'ITEM_CANCELED_OUT_OF_STOCK',
  /** An order has been canceled */
  OrderCanceled = 'ORDER_CANCELED',
  /** A return has been accepted */
  ReturnAccepted = 'RETURN_ACCEPTED',
  /** An unknown reason (legacy) */
  Unknown = 'UNKNOWN'
}

/** Order line refund summary */
export type OrderLineRefundSummary = {
  __typename?: 'OrderLineRefundSummary';
  /**
   * Is refundable ?
   *
   * Is not offered and not removed and has a price greater than 0
   */
  isRefundable: Scalars['Boolean']['output'];
  /**
   * Is totally refunded ?
   *
   * Has at least one refund and the refunded amount is equal to the price
   */
  isTotallyRefunded: Scalars['Boolean']['output'];
  /** Refunded amount of the price in cents */
  refundedAmountInCents: Scalars['NonNegativeInt']['output'];
  /**
   * Refunded amount of the price in percentage
   *
   * Is between `0` and `100`
   */
  refundedAmountInPercentage: Scalars['FloatPercentage']['output'];
  /**
   * Refunded amount of the price in percentage covered by Choose
   *
   * Is between `0` and `100`
   */
  refundedAmountInPercentageCoveredByChoose: Scalars['FloatPercentage']['output'];
  /**
   * Refunded amount of the price in percentage covered by the supplier
   *
   * Is between `0` and `100`
   */
  refundedAmountInPercentageCoveredBySupplier: Scalars['FloatPercentage']['output'];
  /** Remaining to refund amount of the price in cents */
  remainingToRefundAmountInCents: Scalars['NonNegativeInt']['output'];
  /**
   * Remaining to refund amount of the price in percentage
   *
   * Is between `0` and `100`
   */
  remainingToRefundAmountInPercentage: Scalars['FloatPercentage']['output'];
};

/** Order line type */
export enum OrderLineType {
  /** Item */
  Item = 'ITEM',
  /** Legacy (not associated to an item or a shipping) */
  Legacy = 'LEGACY',
  /** Shipping */
  Shipping = 'SHIPPING'
}

/** Order payment */
export type OrderPayment = {
  __typename?: 'OrderPayment';
  /** Processor used for the payment */
  processor: PaymentProcessor;
  /** Processor detailed (eg: "stripe (ios Apple Pay)") */
  processorDetailed: Scalars['String']['output'];
  /** Processor transaction id */
  processorTransactionId: Scalars['String']['output'];
  /** Url of the transaction in the processor dashboard */
  processorTransactionUrl: Scalars['String']['output'];
  /** Sub processor used for the payment */
  subProcessor?: Maybe<PaymentSubProcessor>;
  /** Currency used for the payment transaction */
  transactionCurrency: CurrencyIso;
  /** Transaction plan */
  transactionPlan: OrderPaymentPlan;
};

/** Order payment plan */
export type OrderPaymentPlan = {
  __typename?: 'OrderPaymentPlan';
  /** Number of transactions already paid */
  paidTransactionsCount: Scalars['NonNegativeInt']['output'];
  /** List of transactions waiting for payment */
  pendingTransactions: Array<PendingPaymentTransaction>;
  /** Number of transactions waiting for payment */
  pendingTransactionsCount: Scalars['NonNegativeInt']['output'];
};

/** Order product stats */
export type OrderProductStats = {
  __typename?: 'OrderProductStats';
  /** Available option keys */
  availableOptionKeys: Array<Scalars['String']['output']>;
  /** Current option key */
  currentOptionKey?: Maybe<Scalars['String']['output']>;
  /** Products */
  products: Array<ProductStats>;
};

/** Order rating */
export type OrderRating = {
  __typename?: 'OrderRating';
  /** Comment */
  comment?: Maybe<Scalars['String']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Id */
  id: Scalars['ID']['output'];
  /** Order */
  order: Order;
  /** Order id */
  orderId: Scalars['ID']['output'];
  /** Rate */
  rate: Scalars['PositiveInt']['output'];
  /** User */
  user: OrderRatingUser;
};

/** Order rating count by rate */
export type OrderRatingCountByRate = {
  __typename?: 'OrderRatingCountByRate';
  /** Count */
  count: Scalars['NonNegativeInt']['output'];
  /** Rate */
  rate: Scalars['PositiveInt']['output'];
};

/** Order rating edge */
export type OrderRatingEdge = {
  __typename?: 'OrderRatingEdge';
  /** Cursor */
  cursor: Scalars['ID']['output'];
  /** Node */
  node: OrderRating;
};

/** Order rating stats */
export type OrderRatingStats = {
  __typename?: 'OrderRatingStats';
  /** Average rate */
  averageRate: Scalars['Float']['output'];
  /** Count by rate */
  countByRate: Array<OrderRatingCountByRate>;
  /** Total count */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** Order rating user */
export type OrderRatingUser = {
  __typename?: 'OrderRatingUser';
  /** Id */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Profile picture url */
  profilePictureUrl?: Maybe<Scalars['URL']['output']>;
};

/** Order ratings connection */
export type OrderRatingsConnection = {
  __typename?: 'OrderRatingsConnection';
  /** Edges */
  edges: Array<OrderRatingEdge>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** Union of all possible order refund plans */
export type OrderRefundPlan = OrderItemRefundPlan | OrderItemTaxesRefundPlan | OrderShippingFeesRefundPlan;

/** Order refund plan breakdown */
export type OrderRefundPlanBreakdown = {
  __typename?: 'OrderRefundPlanBreakdown';
  /** Amount of cash in cents */
  cashAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Amount of credit in cents */
  creditAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Amount of discount in cents */
  discountAmountInCents: Scalars['NonNegativeInt']['output'];
};

export type OrderRefundPlanWithheld = {
  __typename?: 'OrderRefundPlanWithheld';
  /** Amount of cash in cents */
  cashAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Reason */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Order return item count by reason */
export type OrderReturnItemCountByReason = {
  __typename?: 'OrderReturnItemCountByReason';
  /** Item count */
  itemCount: Scalars['NonNegativeInt']['output'];
  /** Reason */
  reason: ReturnLineReason;
  /** Sub reason */
  subReason?: Maybe<ReturnLineSubReason>;
};

/** Order return item count by variant */
export type OrderReturnItemCountByVariant = {
  __typename?: 'OrderReturnItemCountByVariant';
  /** Item count */
  itemCount: Scalars['NonNegativeInt']['output'];
  /** Variant */
  variant: OrderReturnVariant;
};

/** Order return stats */
export type OrderReturnStats = {
  __typename?: 'OrderReturnStats';
  /** Item count by reasons */
  itemCountByReasons: Array<OrderReturnItemCountByReason>;
  /** Item count by variants */
  itemCountByVariants: Array<OrderReturnItemCountByVariant>;
  /** Rate */
  rate: Scalars['FloatPercentage']['output'];
  /** Total amount in cents */
  totalAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Total item count */
  totalItemCount: Scalars['NonNegativeInt']['output'];
};

/** Order return variant */
export type OrderReturnVariant = {
  __typename?: 'OrderReturnVariant';
  /** Id */
  id: Scalars['ID']['output'];
  /** Image */
  image: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Options */
  options: Array<Scalars['String']['output']>;
};

/** Order shipping */
export type OrderShipping = {
  __typename?: 'OrderShipping';
  /** Delivery date range history (ordered by createdAt desc) */
  deliveryDateRangeHistory: Array<DeliveryDateRange>;
  /** Estimated time in days */
  estimatedTime: Scalars['Int']['output'];
  /** Fees (in cents) */
  fees: Scalars['Int']['output'];
  /** Fees sold by Choose to the customer (in cents) */
  feesSold: Scalars['Int']['output'];
  /** Pickup point */
  pickupPoint?: Maybe<PickupPoint>;
  /** Policy ID */
  policyId?: Maybe<Scalars['ID']['output']>;
  /** Refund summary */
  refundSummary: OrderLineRefundSummary;
};

/** Order shipping fees refund plan */
export type OrderShippingFeesRefundPlan = {
  __typename?: 'OrderShippingFeesRefundPlan';
  /** Breakdown */
  breakdown: OrderRefundPlanBreakdown;
  /** Order id */
  orderId: Scalars['ID']['output'];
  /** Withheld */
  withheld?: Maybe<OrderRefundPlanWithheld>;
};

/** Order split action error reason */
export enum OrderSplitActionErrorReason {
  /** The order has all the items digital */
  AllItemsDigital = 'ALL_ITEMS_DIGITAL',
  /** The order is cancelled */
  OrderCancelled = 'ORDER_CANCELLED',
  /** The order has been reshipped */
  OrderReshipped = 'ORDER_RESHIPPED',
  /** The order has some claims pending */
  SomeClaimsPending = 'SOME_CLAIMS_PENDING',
  /** The order has some refunds */
  SomeRefunds = 'SOME_REFUNDS',
  /** The order has some returns */
  SomeReturns = 'SOME_RETURNS'
}

/** Order stats */
export type OrderStats = {
  __typename?: 'OrderStats';
  /** Rating */
  rating: OrderRatingStats;
  /** Return */
  return: OrderReturnStats;
  /** Total count */
  totalCount: Scalars['NonNegativeInt']['output'];
  /** Total item count */
  totalItemCount: Scalars['NonNegativeInt']['output'];
};

/** Order tag brand */
export enum OrderTagBrand {
  /** The order is available for the brand and requires an action */
  ActionRequired = 'ACTION_REQUIRED',
  /** The order is available for the brand and requires an action because claim */
  ActionRequiredClaim = 'ACTION_REQUIRED_CLAIM',
  /** The order is available for the brand and requires an action because return */
  ActionRequiredReturn = 'ACTION_REQUIRED_RETURN',
  /** The order is available for the brand and requires an action because shipment incident */
  ActionRequiredShipmentIncident = 'ACTION_REQUIRED_SHIPMENT_INCIDENT',
  /** The order is available for the brand and requires an action because unfulfilled */
  ActionRequiredUnfulfilled = 'ACTION_REQUIRED_UNFULFILLED',
  /** The order is available for the brand */
  Available = 'AVAILABLE'
}

/** Order tag claim */
export enum OrderTagClaim {
  /** The order has some closed claims */
  Closed = 'CLOSED',
  /** The order has no claim */
  None = 'NONE',
  /** The order has some opened claims */
  Opened = 'OPENED'
}

/** Order tag claim reason */
export enum OrderTagClaimReason {
  /** The order has some claims with delivered but damaged reason */
  DeliveredButDamaged = 'DELIVERED_BUT_DAMAGED',
  /** The order has some claims with delivered but incomplete reason */
  DeliveredButIncomplete = 'DELIVERED_BUT_INCOMPLETE',
  /** The order has some claims with delivered but wrong reason */
  DeliveredButWrong = 'DELIVERED_BUT_WRONG',
  /** The order has no claim */
  None = 'NONE',
  /** The order has some claims with not delivered and returned to sender reason */
  NotDeliveredAndReturnedToSender = 'NOT_DELIVERED_AND_RETURNED_TO_SENDER',
  /** The order has some claims with not delivered and tracking blocked reason */
  NotDeliveredAndTrackingBlocked = 'NOT_DELIVERED_AND_TRACKING_BLOCKED',
  /** The order has some claims with not delivered and tracking delivered reason */
  NotDeliveredAndTrackingDelivered = 'NOT_DELIVERED_AND_TRACKING_DELIVERED',
  /** The order has some claims with other reason */
  Other = 'OTHER',
  /** The order has some claims with voucher not working reason */
  VoucherNotWorking = 'VOUCHER_NOT_WORKING'
}

/** Order tag fulfillment */
export enum OrderTagFulfillment {
  /** The order has all the items that are eligible to shipment in a shipment */
  Fulfilled = 'FULFILLED',
  /** The order has none of the items that are eligible to shipment in a shipment */
  Unfulfilled = 'UNFULFILLED'
}

/** Order tag refund */
export enum OrderTagRefund {
  /** The order has no refund */
  None = 'NONE',
  /** The order has some refunds but not totally refunded */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The order has some refunds and totally refunded */
  TotallyRefunded = 'TOTALLY_REFUNDED'
}

/** Order tag reship */
export enum OrderTagReship {
  /** The order has no reship */
  None = 'NONE',
  /** The order has some reships */
  Reshipped = 'RESHIPPED'
}

/** Order tag return */
export enum OrderTagReturn {
  /** The order has some canceled returns */
  Canceled = 'CANCELED',
  /** The order has some delivered returns */
  Delivered = 'DELIVERED',
  /** The order has some in progress returns */
  InProgress = 'IN_PROGRESS',
  /** The order has no return */
  None = 'NONE',
  /** The order has some requested returns */
  Requested = 'REQUESTED',
  /** The order has some validated returns */
  Validated = 'VALIDATED'
}

/** Order tag shipment */
export enum OrderTagShipment {
  /** The order has some attempt fail shipments */
  AttemptFail = 'ATTEMPT_FAIL',
  /** The order has some available for pickup shipments */
  AvailableForPickup = 'AVAILABLE_FOR_PICKUP',
  /** The order has some delivered shipments */
  Delivered = 'DELIVERED',
  /** The order has some exception shipments */
  Exception = 'EXCEPTION',
  /** The order has some expired shipments */
  Expired = 'EXPIRED',
  /** The order has some info received shipments */
  InfoReceived = 'INFO_RECEIVED',
  /** The order has some in transit shipments */
  InTransit = 'IN_TRANSIT',
  /** The order has no shipment */
  None = 'NONE',
  /** The order has some out for delivery shipments */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** The order has some pending shipments */
  Pending = 'PENDING'
}

/** Order tag shipping mode */
export enum OrderTagShippingMode {
  /** The shipments will be shipped at the recipient's home */
  Home = 'HOME',
  /** The order will not be shipped (digital items) */
  None = 'NONE',
  /** The shipments will be shipped at a pickup point */
  PickupPoint = 'PICKUP_POINT'
}

/** Order tag shopify */
export enum OrderTagShopify {
  /** The order has no shopify */
  None = 'NONE',
  /** The order has a shopify and is synchronized */
  Synchronized = 'SYNCHRONIZED',
  /** The order has a shopify and is not synchronized */
  Unsynchronized = 'UNSYNCHRONIZED'
}

/** Order tag status */
export enum OrderTagStatus {
  /** The order has been canceled by the customer or by a member of the support team */
  Canceled = 'CANCELED',
  /** The order has been placed less than 10 minutes ago */
  PendingValidation = 'PENDING_VALIDATION',
  /** The order has been placed more than 10 minutes ago */
  Validated = 'VALIDATED'
}

/** Order tag type */
export enum OrderTagType {
  /** The order has only digital items */
  Digital = 'DIGITAL',
  /** The order has only physical items */
  Physical = 'PHYSICAL'
}

/** Order tags */
export type OrderTags = {
  __typename?: 'OrderTags';
  /** Brand tags */
  brand: Array<OrderTagBrand>;
  /** Claim tags */
  claim: Array<OrderTagClaim>;
  /** Claim reason tags */
  claimReason: Array<OrderTagClaimReason>;
  /** Fulfillment tag */
  fulfillment: OrderTagFulfillment;
  /** Refund tag */
  refund: OrderTagRefund;
  /** Reship tag */
  reship: OrderTagReship;
  /** Return tags */
  return: Array<OrderTagReturn>;
  /** Shipment tags */
  shipment: Array<OrderTagShipment>;
  /** Shipping mode tag */
  shippingMode: OrderTagShippingMode;
  /** Shopify tag */
  shopify: OrderTagShopify;
  /** Status tag */
  status: OrderTagStatus;
  /** Type tag */
  type: OrderTagType;
};

/** Order - Cancel - Input */
export type Order_Cancel_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Put back in stock */
  putBackInStock: Scalars['Boolean']['input'];
  /** Reason */
  reason: CancelOrderReason;
  /** Support ticket id */
  supportTicketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Order - Claim - Accept with refund - Input */
export type Order_Claim_AcceptWithRefund_Input = {
  /** Claim id */
  claimId: Scalars['ID']['input'];
  /** Order id */
  orderId: Scalars['ID']['input'];
};

/** Order - Claim - Accept with reship - Input */
export type Order_Claim_AcceptWithReship_Input = {
  /** Claim id */
  claimId: Scalars['ID']['input'];
  /** Order id */
  orderId: Scalars['ID']['input'];
};

/** Order - Claim - Accept with voucher replacement codes - Input */
export type Order_Claim_AcceptWithVoucherReplacementCodes_Input = {
  /** Claim id */
  claimId: Scalars['ID']['input'];
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Voucher replacement codes */
  voucherReplacementCodes: Array<VoucherReplacementCode_Input>;
};

/** Order - Claim - Accept with voucher replacement message - Input */
export type Order_Claim_AcceptWithVoucherReplacementMessage_Input = {
  /** Claim id */
  claimId: Scalars['ID']['input'];
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Voucher replacement message */
  voucherReplacementMessage: Scalars['String']['input'];
};

/** Order - Claim - Cancel - Input */
export type Order_Claim_Cancel_Input = {
  /** Claim id */
  claimId: Scalars['ID']['input'];
  /** Order id */
  orderId: Scalars['ID']['input'];
};

/** Order - Claim - Open for delivered but damaged - Input */
export type Order_Claim_OpenForDeliveredButDamaged_Input = {
  /** Description */
  description: Scalars['String']['input'];
  /** Image urls */
  imageUrls: Array<Scalars['String']['input']>;
  /** Item ids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution?: InputMaybe<ClaimPreferredSolution>;
  /** Reship recipient */
  reshipRecipient?: InputMaybe<ClaimReshipRecipient_Input>;
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Order - Claim - Open for delivered but incomplete - Input */
export type Order_Claim_OpenForDeliveredButIncomplete_Input = {
  /** Description */
  description: Scalars['String']['input'];
  /** Image urls */
  imageUrls: Array<Scalars['String']['input']>;
  /** Item ids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution?: InputMaybe<ClaimPreferredSolution>;
  /** Reship recipient */
  reshipRecipient?: InputMaybe<ClaimReshipRecipient_Input>;
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Order - Claim - Open for delivered but wrong - Input */
export type Order_Claim_OpenForDeliveredButWrong_Input = {
  /** Description */
  description: Scalars['String']['input'];
  /** Image urls */
  imageUrls: Array<Scalars['String']['input']>;
  /** Item ids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution?: InputMaybe<ClaimPreferredSolution>;
  /** Reship recipient */
  reshipRecipient?: InputMaybe<ClaimReshipRecipient_Input>;
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Order - Claim - Open for not delivered and returned to sender - Input */
export type Order_Claim_OpenForNotDeliveredAndReturnedToSender_Input = {
  /** Description */
  description: Scalars['String']['input'];
  /** Item ids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution?: InputMaybe<ClaimPreferredSolution>;
  /** Reship recipient */
  reshipRecipient?: InputMaybe<ClaimReshipRecipient_Input>;
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Order - Claim - Open for not delivered and tracking blocked - Input */
export type Order_Claim_OpenForNotDeliveredAndTrackingBlocked_Input = {
  /** Description */
  description: Scalars['String']['input'];
  /** Item ids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution?: InputMaybe<ClaimPreferredSolution>;
  /** Reship recipient */
  reshipRecipient?: InputMaybe<ClaimReshipRecipient_Input>;
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Order - Claim - Open for not delivered and tracking delivered - Input */
export type Order_Claim_OpenForNotDeliveredAndTrackingDelivered_Input = {
  /** Description */
  description: Scalars['String']['input'];
  /** Item ids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution?: InputMaybe<ClaimPreferredSolution>;
  /** Reship recipient */
  reshipRecipient?: InputMaybe<ClaimReshipRecipient_Input>;
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
  /** Sworn statement file urls */
  swornStatementFileUrls: Array<Scalars['String']['input']>;
};

/** Order - Claim - Open for other - Input */
export type Order_Claim_OpenForOther_Input = {
  /** Description */
  description: Scalars['String']['input'];
  /** Image urls */
  imageUrls: Array<Scalars['String']['input']>;
  /** Item ids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution?: InputMaybe<ClaimPreferredSolution>;
  /** Reship recipient */
  reshipRecipient?: InputMaybe<ClaimReshipRecipient_Input>;
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Order - Claim - Open for voucher not working - Input */
export type Order_Claim_OpenForVoucherNotWorking_Input = {
  /** Description */
  description: Scalars['String']['input'];
  /** Image urls */
  imageUrls: Array<Scalars['String']['input']>;
  /** Item ids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred solution */
  preferredSolution?: InputMaybe<ClaimPreferredSolution>;
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Order - Edit Billing Address - Input */
export type Order_EditBillingAddress_Input = {
  /** Billing address */
  billingAddress: BillingAddress_Input;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Support ticket id */
  supportTicketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Order - Generate invoice for customs - Input */
export type Order_GenerateInvoiceForCustoms_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
};

/** Order - Generate purchase order - Input */
export type Order_GeneratePurchaseOrder_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
};

/** Order - Input */
export type Order_Input = {
  /** Order ID */
  orderId: Scalars['ID']['input'];
};

/** Order - Items - Cancel - Input */
export type Order_Items_Cancel_Input = {
  /** Item ids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Put back in stock */
  putBackInStock: Scalars['Boolean']['input'];
  /** Reason */
  reason: CancelOrderItemsReason;
  /** Support ticket id */
  supportTicketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Order - Items - Refund - Input */
export type Order_Items_Refund_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Refund info */
  refundInfo: RefundInfo_Input;
  /** Refund intents */
  refundIntents: Array<Order_Items_Refund_Intent_Item_Input>;
  /** Support ticket id */
  supportTicketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Order - Items - Refund - Intent - Item - Input */
export type Order_Items_Refund_Intent_Item_Input = {
  /** Amount in cents of the item price to refund */
  amountInCents?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Item id */
  itemId: Scalars['ID']['input'];
  /** Percentage of the item price to refund (between `0.00` and `100.00`) */
  percentage?: InputMaybe<Scalars['FloatPercentage']['input']>;
};

/** Order - Parcel - Create - Input */
export type Order_Parcel_Create_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Tracking info */
  trackingInfo: TrackingInfo_Input;
};

/** Order - Parcel - Edit - Input */
export type Order_Parcel_Edit_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Order ids excluded */
  orderIdsExcluded?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Tracking info */
  trackingInfo: TrackingInfo_Input;
};

/** Order - Parcel - Group - Input */
export type Order_Parcel_Group_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Order ids excluded */
  orderIdsExcluded?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Tracking info */
  trackingInfo: TrackingInfo_Input;
};

/** Order - Parcel - Swap - Input */
export type Order_Parcel_Swap_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Tracking info */
  trackingInfo: TrackingInfo_Input;
};

/** Order - Parcels - Mark as delivered - Input */
export type Order_Parcels_MarkAsDelivered_Input = {
  /** Delivery date */
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Support ticket id */
  supportTicketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Order - Refund plan - Input */
export type Order_RefundPlan_Input = {
  /** Apply withheld refund */
  applyWithheld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Force refund in credit */
  forceRefundInCredit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Item refunds */
  itemRefunds?: InputMaybe<Array<Order_RefundPlan_Item_Input>>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Shipping fees refund */
  shippingFeesRefund?: InputMaybe<Order_RefundPlan_ShippingFees_Input>;
};

/** Order - Refund plan - Item - Input */
export type Order_RefundPlan_Item_Input = {
  /** Amount in cents of the item price to refund */
  amountInCents?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Item id */
  itemId: Scalars['ID']['input'];
  /** Percentage of the item price to refund (between `0.00` and `100.00`) */
  percentage?: InputMaybe<Scalars['FloatPercentage']['input']>;
};

/** Order - Refund plan - Shipping fees - Input */
export type Order_RefundPlan_ShippingFees_Input = {
  /** Amount in cents of the shipping fees to refund */
  amountInCents?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Percentage of the shipping fees to refund (between `0.00` and `100.00`) */
  percentage?: InputMaybe<Scalars['FloatPercentage']['input']>;
};

/** Order - Return - Cancel - Input */
export type Order_Return_Cancel_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Return id */
  returnId: Scalars['ID']['input'];
};

/** Order - Return - Create with label for claim - Input */
export type Order_Return_CreateWithLabelForClaim_Input = {
  /** Claim id */
  claimId: Scalars['ID']['input'];
  /** Item ids */
  itemIds: Array<Scalars['ID']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Tracking carrier slug */
  trackingCourierSlug: Scalars['String']['input'];
  /** Tracking number */
  trackingNumber: Scalars['String']['input'];
};

/** Order - Return - Create with label - Input */
export type Order_Return_CreateWithLabel_Input = {
  /** Apply withheld on the refund */
  applyWithheld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred refund method */
  preferredRefundMethod?: InputMaybe<PreferredRefundMethod>;
  /** Return lines */
  returnLines: Array<ReturnLine_Input>;
  /** Support ticket id */
  supportTicketId?: InputMaybe<Scalars['ID']['input']>;
  /** Tracking courier slug */
  trackingCourierSlug: Scalars['String']['input'];
  /** Tracking number */
  trackingNumber: Scalars['String']['input'];
};

/** Order - Return - Create - Input */
export type Order_Return_Create_Input = {
  /** Apply withheld on the refund */
  applyWithheld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred refund method */
  preferredRefundMethod?: InputMaybe<PreferredRefundMethod>;
  /** Return lines */
  returnLines: Array<ReturnLine_Input>;
  /** Return to choose office */
  returnToChooseOffice: Scalars['Boolean']['input'];
  /** Support ticket id */
  supportTicketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Order - Return - Edit Preferred Refund Method - Input */
export type Order_Return_EditPreferredRefundMethod_Input = {
  /** Apply withheld on the refund */
  applyWithheld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Preferred refund method */
  preferredRefundMethod: PreferredRefundMethod;
  /** Return id */
  returnId: Scalars['ID']['input'];
};

/** Order - Return - Edit Tracking Info - Input */
export type Order_Return_EditTrackingInfo_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Return id */
  returnId: Scalars['ID']['input'];
  /** Tracking courier slug */
  trackingCourierSlug: Scalars['String']['input'];
  /** Tracking number */
  trackingNumber: Scalars['String']['input'];
};

/** Order - Return - Generate label upload url - Input */
export type Order_Return_GenerateLabelUploadUrl_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
};

/** Order - Return - Lock validation - Input */
export type Order_Return_LockValidation_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Return id */
  returnId: Scalars['ID']['input'];
};

/** Order - Return - Unlock validation - Input */
export type Order_Return_UnlockValidation_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Return id */
  returnId: Scalars['ID']['input'];
};

/** Order - Return - Validate - Input */
export type Order_Return_Validate_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Return id */
  returnId: Scalars['ID']['input'];
  /** Support ticket id */
  supportTicketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Order - Shipping Fees - Refund - Input */
export type Order_ShippingFees_Refund_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Refund info */
  refundInfo: RefundInfo_Input;
  /** Refund intent */
  refundIntent: Order_ShippingFees_Refund_Intent_Input;
  /** Support ticket id */
  supportTicketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Order - Shipping Fees - Refund - Intent - Input */
export type Order_ShippingFees_Refund_Intent_Input = {
  /** Amount in cents of the shipping price to refund */
  amountInCents?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Percentage of the shipping price to refund (between `0.00` and `100.00`) */
  percentage?: InputMaybe<Scalars['FloatPercentage']['input']>;
};

/** Order - Shopify - Synchronize - Input */
export type Order_Shopify_Synchronize_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
};

/** Order - Split - Input */
export type Order_Split_Input = {
  /** New orders item ids */
  newOrdersItemIds: Array<Array<Scalars['ID']['input']>>;
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Support ticket id */
  supportTicketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Orders connection */
export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  /** Edges */
  edges: Array<OrderEdge>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** Orders counters */
export type OrdersCounters = {
  __typename?: 'OrdersCounters';
  /** Tagging counters */
  tagging: OrdersTaggingCounters;
};

/** Orders export */
export type OrdersExport = {
  __typename?: 'OrdersExport';
  /** File url */
  fileUrl: Scalars['URL']['output'];
};

/** Orders tag brand counters */
export type OrdersTagBrandCounters = {
  __typename?: 'OrdersTagBrandCounters';
  /** Action required counters */
  actionRequired: Scalars['NonNegativeInt']['output'];
  /** Action required claim counters */
  actionRequiredClaim: Scalars['NonNegativeInt']['output'];
  /** Action required return counters */
  actionRequiredReturn: Scalars['NonNegativeInt']['output'];
  /** Action required shipment incident counters */
  actionRequiredShipmentIncident: Scalars['NonNegativeInt']['output'];
  /** Action required unfulfilled counters */
  actionRequiredUnfulfilled: Scalars['NonNegativeInt']['output'];
  /** Available counters */
  available: Scalars['NonNegativeInt']['output'];
};

/** Orders tag claim counters */
export type OrdersTagClaimCounters = {
  __typename?: 'OrdersTagClaimCounters';
  /** Closed counters */
  closed: Scalars['NonNegativeInt']['output'];
  /** None counters */
  none: Scalars['NonNegativeInt']['output'];
  /** Opened counters */
  opened: Scalars['NonNegativeInt']['output'];
};

/** Orders tag claim reason counters */
export type OrdersTagClaimReasonCounters = {
  __typename?: 'OrdersTagClaimReasonCounters';
  /** Delivered but damaged counters */
  deliveredButDamaged: Scalars['NonNegativeInt']['output'];
  /** Delivered but incomplete counters */
  deliveredButIncomplete: Scalars['NonNegativeInt']['output'];
  /** Delivered but wrong counters */
  deliveredButWrong: Scalars['NonNegativeInt']['output'];
  /** None counters */
  none: Scalars['NonNegativeInt']['output'];
  /** Not delivered and returned to sender counters */
  notDeliveredAndReturnedToSender: Scalars['NonNegativeInt']['output'];
  /** Not delivered and tracking blocked counters */
  notDeliveredAndTrackingBlocked: Scalars['NonNegativeInt']['output'];
  /** Not delivered and tracking delivered counters */
  notDeliveredAndTrackingDelivered: Scalars['NonNegativeInt']['output'];
  /** Other counters */
  other: Scalars['NonNegativeInt']['output'];
  /** Voucher not working counters */
  voucherNotWorking: Scalars['NonNegativeInt']['output'];
};

/** Orders tag fulfillment counters */
export type OrdersTagFulfillmentCounters = {
  __typename?: 'OrdersTagFulfillmentCounters';
  /** Fulfilled counters */
  fulfilled: Scalars['NonNegativeInt']['output'];
  /** Unfulfilled counters */
  unfulfilled: Scalars['NonNegativeInt']['output'];
};

/** Orders tag refund counters */
export type OrdersTagRefundCounters = {
  __typename?: 'OrdersTagRefundCounters';
  /** None counters */
  none: Scalars['NonNegativeInt']['output'];
  /** Partially refunded counters */
  partiallyRefunded: Scalars['NonNegativeInt']['output'];
  /** Totally refunded counters */
  totallyRefunded: Scalars['NonNegativeInt']['output'];
};

/** Orders tag reship counters */
export type OrdersTagReshipCounters = {
  __typename?: 'OrdersTagReshipCounters';
  /** None counters */
  none: Scalars['NonNegativeInt']['output'];
  /** Reshipped counters */
  reshipped: Scalars['NonNegativeInt']['output'];
};

/** Orders tag return counters */
export type OrdersTagReturnCounters = {
  __typename?: 'OrdersTagReturnCounters';
  /** Canceled counters */
  canceled: Scalars['NonNegativeInt']['output'];
  /** Delivered counters */
  delivered: Scalars['NonNegativeInt']['output'];
  /** In progress counters */
  inProgress: Scalars['NonNegativeInt']['output'];
  /** None counters */
  none: Scalars['NonNegativeInt']['output'];
  /** Requested counters */
  requested: Scalars['NonNegativeInt']['output'];
  /** Validated counters */
  validated: Scalars['NonNegativeInt']['output'];
};

/** Orders tag shipment counters */
export type OrdersTagShipmentCounters = {
  __typename?: 'OrdersTagShipmentCounters';
  /** Attempt fail counters */
  attemptFail: Scalars['NonNegativeInt']['output'];
  /** Available for pickup counters */
  availableForPickup: Scalars['NonNegativeInt']['output'];
  /** Delivered counters */
  delivered: Scalars['NonNegativeInt']['output'];
  /** Exception counters */
  exception: Scalars['NonNegativeInt']['output'];
  /** Expired counters */
  expired: Scalars['NonNegativeInt']['output'];
  /** In transit counters */
  inTransit: Scalars['NonNegativeInt']['output'];
  /** Info received counters */
  infoReceived: Scalars['NonNegativeInt']['output'];
  /** None counters */
  none: Scalars['NonNegativeInt']['output'];
  /** Out for delivery counters */
  outForDelivery: Scalars['NonNegativeInt']['output'];
  /** Pending counters */
  pending: Scalars['NonNegativeInt']['output'];
};

/** Orders tag shipping mode counters */
export type OrdersTagShippingModeCounters = {
  __typename?: 'OrdersTagShippingModeCounters';
  /** Home counters */
  home: Scalars['NonNegativeInt']['output'];
  /** None counters */
  none: Scalars['NonNegativeInt']['output'];
  /** Pickup point counters */
  pickupPoint: Scalars['NonNegativeInt']['output'];
};

/** Orders tag shopify counters */
export type OrdersTagShopifyCounters = {
  __typename?: 'OrdersTagShopifyCounters';
  /** None counters */
  none: Scalars['NonNegativeInt']['output'];
  /** Synchronized counters */
  synchronized: Scalars['NonNegativeInt']['output'];
  /** Unsynchronized counters */
  unsynchronized: Scalars['NonNegativeInt']['output'];
};

/** Orders tag status counters */
export type OrdersTagStatusCounters = {
  __typename?: 'OrdersTagStatusCounters';
  /** Canceled counters */
  canceled: Scalars['NonNegativeInt']['output'];
  /** Pending validation counters */
  pendingValidation: Scalars['NonNegativeInt']['output'];
  /** Validated counters */
  validated: Scalars['NonNegativeInt']['output'];
};

/** Orders tag type counters */
export type OrdersTagTypeCounters = {
  __typename?: 'OrdersTagTypeCounters';
  /** Digital counters */
  digital: Scalars['NonNegativeInt']['output'];
  /** Physical counters */
  physical: Scalars['NonNegativeInt']['output'];
};

/** Orders tagging counters */
export type OrdersTaggingCounters = {
  __typename?: 'OrdersTaggingCounters';
  /** Tag brand counters */
  brand: OrdersTagBrandCounters;
  /** Tag claim counters */
  claim: OrdersTagClaimCounters;
  /** Tag claim reason counters */
  claimReason: OrdersTagClaimReasonCounters;
  /** Tag fulfillment counters */
  fulfillment: OrdersTagFulfillmentCounters;
  /** Tag refund counters */
  refund: OrdersTagRefundCounters;
  /** Tag reship counters */
  reship: OrdersTagReshipCounters;
  /** Tag return counters */
  return: OrdersTagReturnCounters;
  /** Tag shipment counters */
  shipment: OrdersTagShipmentCounters;
  /** Tag shipping mode counters */
  shippingMode: OrdersTagShippingModeCounters;
  /** Tag shopify counters */
  shopify: OrdersTagShopifyCounters;
  /** Tag status counters */
  status: OrdersTagStatusCounters;
  /** Tag type counters */
  type: OrdersTagTypeCounters;
};

/** Orders - Input */
export type Orders_Input = {
  /** Order ids */
  orderIds: Array<Scalars['ID']['input']>;
};

/** Orders - Parcels - Generate upload url - Input */
export type Orders_Parcels_GenerateUploadUrl_Input = {
  /** Operation id */
  operationId: Scalars['ID']['input'];
  /** Upload */
  upload: UploadInput;
};

/** Orders - Parcels - Submit - Input */
export type Orders_Parcels_Submit_Input = {
  /** File key */
  fileKey: Scalars['String']['input'];
  /** Operation id */
  operationId: Scalars['ID']['input'];
};

/** Orders - Search - Filter - Creation Date - Input */
export type Orders_Search_Filter_CreationDate_Input = {
  /** Filter from this creation date */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter to this creation date */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Orders - Search - Filter - Input */
export type Orders_Search_Filter_Input = {
  /** Filter on brand identifier */
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on creation date */
  creationDate?: InputMaybe<Orders_Search_Filter_CreationDate_Input>;
  /** Filter on customer identifiers */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on item references */
  itemReferences?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on operation identifiers */
  operationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter on order identifiers */
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on sale identifiers */
  saleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on tagging */
  tagging?: InputMaybe<Orders_Search_Filter_Tagging_Input>;
};

/** Orders - Search - Filter - Search - Field - Input */
export enum Orders_Search_Filter_Search_Field_Input {
  /** Search in all available fields */
  All = 'ALL'
}

/** Orders - Search - Filter - Search - Input */
export type Orders_Search_Filter_Search_Input = {
  /** Field to search into */
  field: Orders_Search_Filter_Search_Field_Input;
  /** Term to search */
  term: Scalars['String']['input'];
};

/** Orders - Search - Filter - Tagging - Input */
export type Orders_Search_Filter_Tagging_Input = {
  /** Filter on brand tags */
  brand?: InputMaybe<Array<OrderTagBrand>>;
  /** Filter on claim tags */
  claim?: InputMaybe<Array<OrderTagClaim>>;
  /** Filter on claim reason tags */
  claimReason?: InputMaybe<Array<OrderTagClaimReason>>;
  /** Filter on fulfillment tags */
  fulfillment?: InputMaybe<Array<OrderTagFulfillment>>;
  /** Filter on refund tags */
  refund?: InputMaybe<Array<OrderTagRefund>>;
  /** Filter on reship tags */
  reship?: InputMaybe<Array<OrderTagReship>>;
  /** Filter on return tags */
  return?: InputMaybe<Array<OrderTagReturn>>;
  /** Filter on shipment tags */
  shipment?: InputMaybe<Array<OrderTagShipment>>;
  /** Filter on shipping mode tags */
  shippingMode?: InputMaybe<Array<OrderTagShippingMode>>;
  /** Filter on shopify tags */
  shopify?: InputMaybe<Array<OrderTagShopify>>;
  /** Filter on status tags */
  status?: InputMaybe<Array<OrderTagStatus>>;
  /** Filter on type tags */
  type?: InputMaybe<Array<OrderTagType>>;
};

/** Orders - Search - Input */
export type Orders_Search_Input = {
  /** Filter */
  filter?: InputMaybe<Orders_Search_Filter_Input>;
  /** Page info */
  pageInfo: PageInfo_Input;
  /** Search */
  search?: InputMaybe<Orders_Search_Filter_Search_Input>;
  /** Sort */
  sort: Orders_Search_Sort_Input;
};

/** Orders - Search - Sort - Field - Input */
export enum Orders_Search_Sort_Field_Input {
  /** Sort on claim creation date */
  ClaimCreationDate = 'CLAIM_CREATION_DATE',
  /** Sort on creation date */
  CreationDate = 'CREATION_DATE',
  /** Sort on recipient full name */
  RecipientFullName = 'RECIPIENT_FULL_NAME',
  /** Sort on brand tag */
  TagBrand = 'TAG_BRAND',
  /** Sort on claim tag */
  TagClaim = 'TAG_CLAIM',
  /** Sort on claim reason tag */
  TagClaimReason = 'TAG_CLAIM_REASON',
  /** Sort on fulfillment tag */
  TagFulfillment = 'TAG_FULFILLMENT',
  /** Sort on refund tag */
  TagRefund = 'TAG_REFUND',
  /** Sort on reship tag */
  TagReship = 'TAG_RESHIP',
  /** Sort on return tag */
  TagReturn = 'TAG_RETURN',
  /** Sort on shipment tag */
  TagShipment = 'TAG_SHIPMENT',
  /** Sort on shipping mode tag */
  TagShippingMode = 'TAG_SHIPPING_MODE',
  /** Sort on shopify tag */
  TagShopify = 'TAG_SHOPIFY',
  /** Sort on status tag */
  TagStatus = 'TAG_STATUS',
  /** Sort on type tag */
  TagType = 'TAG_TYPE',
  /** Sort on total price sold */
  TotalPriceSold = 'TOTAL_PRICE_SOLD'
}

/** Orders - Search - Sort - Input */
export type Orders_Search_Sort_Input = {
  /** Field to sort */
  field: Orders_Search_Sort_Field_Input;
  /** Order to sort */
  order: Orders_Search_Sort_Order_Input;
};

/** Orders - Search - Sort - Order - Input */
export enum Orders_Search_Sort_Order_Input {
  /** Sort in ascending order */
  Ascending = 'ASCENDING',
  /** Sort in descending order */
  Descending = 'DESCENDING'
}

/** Orders - Shopify - Synchronize - Input */
export type Orders_Shopify_Synchronize_Input = {
  /** Operation id */
  operationId: Scalars['ID']['input'];
};

/** Page info */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor for the last element of the page */
  endCursor?: Maybe<Scalars['ID']['output']>;
  /** Whether there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor for the first element of the page */
  startCursor?: Maybe<Scalars['ID']['output']>;
};

/** Page info - Input */
export type PageInfo_Input = {
  /** Cursor to get the next page after this one */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Cursor to get the previous page before this one */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Number of first elements to get */
  first?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Number of last elements to get */
  last?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/** Parcel */
export type Parcel = {
  __typename?: 'Parcel';
  /** Estimated delivery date range */
  estimatedDeliveryDateRange?: Maybe<ParcelEstimatedDeliveryDateRange>;
  /**
   * Does the parcel has its tracking stucked or not ?
   *
   * - only if more than 3 days in 'pending' for now
   */
  hasTrackingStucked: Scalars['Boolean']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Items */
  items: Array<Item>;
  /** Recipient */
  recipient: Recipient;
  /** Tracking */
  tracking: Tracking;
  /** Date when the parcel was delivered */
  trackingDeliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Tracking id */
  trackingId: Scalars['ID']['output'];
  /** Tracking sub status */
  trackingSubStatus?: Maybe<TrackingSubStatus>;
};

/** Parcel estimated delivery date range */
export type ParcelEstimatedDeliveryDateRange = {
  __typename?: 'ParcelEstimatedDeliveryDateRange';
  /** Max */
  max: Scalars['DateTime']['output'];
  /** Min */
  min: Scalars['DateTime']['output'];
};

/** Payment processor */
export enum PaymentProcessor {
  /** Alma */
  Alma = 'Alma',
  /** Braintree */
  Braintree = 'Braintree',
  /** Choose */
  Choose = 'Choose',
  /** Primer */
  Primer = 'Primer',
  /** Stripe */
  Stripe = 'Stripe'
}

/** Payment Sub-processor - Stripe Specific */
export enum PaymentSubProcessor {
  /** Bancontact */
  Bancontact = 'Bancontact',
  /** Klarna */
  Klarna = 'Klarna',
  /** PayPal */
  PayPal = 'PayPal',
  /** RevolutPay */
  RevolutPay = 'RevolutPay'
}

/** Pending payment transaction */
export type PendingPaymentTransaction = {
  __typename?: 'PendingPaymentTransaction';
  /** Transaction amount in cents */
  amount: Scalars['NonNegativeInt']['output'];
  /** Currency ISO code */
  currency: CurrencyIso;
  /** Date where transaction will be process */
  dueDate: Scalars['DateTime']['output'];
};

/** Pickup point address */
export type PickupAddress = {
  __typename?: 'PickupAddress';
  /** city */
  city: Scalars['String']['output'];
  /** Country code */
  countryCode: Scalars['String']['output'];
  /** name */
  name: Scalars['String']['output'];
  /** street */
  street: Scalars['String']['output'];
  /** streetAdditional */
  streetAdditional?: Maybe<Scalars['String']['output']>;
  /** zipCode */
  zipCode: Scalars['String']['output'];
};

/** Pickup opening days */
export type PickupOpeningDays = {
  __typename?: 'PickupOpeningDays';
  /** Friday */
  friday?: Maybe<Array<PickupOpeningHours>>;
  /** Monday */
  monday?: Maybe<Array<PickupOpeningHours>>;
  /** Saturday */
  saturday?: Maybe<Array<PickupOpeningHours>>;
  /** Sunday */
  sunday?: Maybe<Array<PickupOpeningHours>>;
  /** Thursday */
  thursday?: Maybe<Array<PickupOpeningHours>>;
  /** Tuesday */
  tuesday?: Maybe<Array<PickupOpeningHours>>;
  /** Wednesday */
  wednesday?: Maybe<Array<PickupOpeningHours>>;
};

/** Pickup opening hours */
export type PickupOpeningHours = {
  __typename?: 'PickupOpeningHours';
  /** Close */
  close: Scalars['String']['output'];
  /** Open */
  open: Scalars['String']['output'];
};

/** Pickup point */
export type PickupPoint = {
  __typename?: 'PickupPoint';
  /** Address */
  address?: Maybe<PickupAddress>;
  /** Country code */
  countryCode: Scalars['String']['output'];
  /** Id */
  id: Scalars['ID']['output'];
  /** Network */
  network: PickupPointNetwork;
  /** Opening days */
  openingDays?: Maybe<PickupOpeningDays>;
};

/** Pickup point network */
export enum PickupPointNetwork {
  /** Colissimo */
  Colissimo = 'COLISSIMO',
  /** Mondial relay */
  MondialRelay = 'MONDIAL_RELAY',
  /** Shop2Shop */
  Shop2Shop = 'SHOP2SHOP'
}

/** Preferred refund method */
export enum PreferredRefundMethod {
  /** User want to be refunded with Choose credit */
  ChooseCredit = 'ChooseCredit',
  /** User want to be refunded with the initial payment method */
  InitialPaymentMethod = 'InitialPaymentMethod'
}

/** Price */
export type Price = {
  __typename?: 'Price';
  /** Currency ISO code */
  currency: CurrencyIso;
  /** Value with VAT (in cents) */
  valueWithVat: Scalars['Int']['output'];
  /** Value without VAT (in cents) */
  valueWithoutVat: Scalars['Int']['output'];
};

/** A product, which can be either a physical or digital type. */
export type Product = ProductDigital | ProductPhysical;

/** A badge associated with a product, used for highlighting features or promotions. */
export type ProductBadge = {
  __typename?: 'ProductBadge';
  /** Icon representing the badge. */
  icon: ProductBadgeIcon;
  /** Unique identifier of the badge. */
  id: Scalars['String']['output'];
  /** Indicates if the badge is special (e.g. for limited offers). */
  isSpecial: Scalars['Boolean']['output'];
  /** Text label of the badge. */
  text: Scalars['String']['output'];
};

/** Represents the icon assets for a badge, typically provided in multiple formats. */
export type ProductBadgeIcon = {
  __typename?: 'ProductBadgeIcon';
  /** PNG format of the badge icon. */
  png: Scalars['String']['output'];
  /** SVG format of the badge icon. */
  svg: Scalars['String']['output'];
};

/** Currency ISO code */
export enum ProductCurrencyIso {
  /** Euro */
  Eur = 'eur',
  /** US Dollar */
  Usd = 'usd'
}

/** A custom field attached to a product, for extensible metadata. */
export type ProductCustomField = {
  __typename?: 'ProductCustomField';
  /** Key of the custom field. */
  key: Scalars['String']['output'];
  /** Value of the custom field (string or number as string). */
  value: Scalars['String']['output'];
  /** View configuration for the custom field. */
  view: ProductCustomFieldView;
};

/** View configuration for a custom field. */
export type ProductCustomFieldView = {
  __typename?: 'ProductCustomFieldView';
  /** Type of view for the custom field (e.g. text, number, select). */
  type?: Maybe<Scalars['String']['output']>;
};

/** A digital product (coupon) with offer and usage information. */
export type ProductDigital = {
  __typename?: 'ProductDigital';
  /** List of badges associated with the product. */
  badges: Array<ProductBadge>;
  /** Brand */
  brand: Brand;
  /** Brand ID */
  brandId: Scalars['ID']['output'];
  /** Expiration date for the coupon, if any. */
  couponExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Custom fields for extensible product metadata. */
  customFields: Array<ProductCustomField>;
  /** Description of the product. */
  description: Scalars['String']['output'];
  /** Frequently asked questions for the digital product. */
  faq: ProductDigitalFaq;
  /** Financial information for the product. */
  financial: ProductFinancial;
  /** Gender for which the product is intended. */
  gender: ProductGender;
  /** Instructions on how to use the digital product, if any. */
  howToUse?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique identifier of the product. */
  id: Scalars['ID']['output'];
  /** Indicates if the product contains alcohol. */
  isAlcohol: Scalars['Boolean']['output'];
  /** Indicates if the product is a cobrand. */
  isCobrand: Scalars['Boolean']['output'];
  /** Indicates if the product is the featured cobrand for its sale. */
  isCobrandFeatured: Scalars['Boolean']['output'];
  /** Indicates if the product is a gift on purchase. */
  isGiftOnPurchase: Scalars['Boolean']['output'];
  /** Name of the product. */
  name: Scalars['String']['output'];
  /** Offer associated with the digital product, if any. */
  offer?: Maybe<Scalars['String']['output']>;
  /** List of configurable options for the product. */
  options: Array<ProductOption>;
  /** Sale for the product. */
  sale: Sale;
  /** Identifier of the sale associated with the product. */
  saleId: Scalars['ID']['output'];
  /** Setup information for the product. */
  setup: ProductSetup;
  /** Slug (URL-friendly identifier) for the product. */
  slug: Scalars['String']['output'];
  /** Store where the product is available. */
  storeId: Store;
  /** List of terms for the digital product, if any. */
  terms?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of the product (should be "coupon"). */
  type: Scalars['String']['output'];
  /** List of variants for the product. */
  variants: Array<Variant>;
  /** View configuration for the product. */
  view: ProductView;
  /** Visibility status of the product. */
  visibility: ProductVisibility;
  /** Visials media for the product. */
  visuals: ProductVisuals;
};

/** Frequently asked questions for a digital product. */
export type ProductDigitalFaq = {
  __typename?: 'ProductDigitalFaq';
  /** FAQ after purchase. */
  afterPurchase?: Maybe<Scalars['String']['output']>;
  /** FAQ before purchase. */
  beforePurchase?: Maybe<Scalars['String']['output']>;
};

/** Financial information for a product. */
export type ProductFinancial = {
  __typename?: 'ProductFinancial';
  /** Category identifier for the product. */
  categoryId: Scalars['String']['output'];
  /** French VAT rate for the product. */
  frenchTaxRate: Scalars['Float']['output'];
  /** Indicates if the product uses VAT margin. */
  hasVatMargin: Scalars['Boolean']['output'];
  /** Human-readable category name. */
  readableCategory: Scalars['String']['output'];
};

/** Gender for which the product is intended. */
export enum ProductGender {
  /** Female. */
  Female = 'female',
  /** Male. */
  Male = 'male',
  /** Unisex. */
  Unisex = 'unisex'
}

/** Represents an image associated with a product. */
export type ProductImage = {
  __typename?: 'ProductImage';
  /** Storage key for the image base. */
  baseKey: Scalars['String']['output'];
  /** Unique identifier of the image. */
  id: Scalars['String']['output'];
  /** Public URL of the image. */
  url: Scalars['String']['output'];
  /** Version number of the image (for cache busting). */
  version: Scalars['Int']['output'];
};

/** A configurable option for a product (e.g. color, size). */
export type ProductOption = {
  __typename?: 'ProductOption';
  /** Unique identifier of the option. */
  id: Scalars['String']['output'];
  /** Name of the option (e.g. "Color"). */
  name: Scalars['String']['output'];
  /** Type of the option (e.g. "select"). */
  type: Scalars['String']['output'];
  /** Possible values for the option. */
  values: Array<ProductOptionValue>;
  /** View configuration for the option. */
  view: ProductOptionView;
};

/** Represents a possible value for a product option (e.g. color, size). */
export type ProductOptionValue = {
  __typename?: 'ProductOptionValue';
  /** Unique identifier of the option value. */
  id: Scalars['String']['output'];
  /** Value (e.g. "Red", "XL"). */
  value: Scalars['String']['output'];
  /** View configuration for the option value. */
  view: ProductOptionValueView;
};

/** View configuration for an option value. */
export type ProductOptionValueView = {
  __typename?: 'ProductOptionValueView';
  /** Position of the option value in the list. */
  position: Scalars['Int']['output'];
};

/** View configuration for a product option. */
export type ProductOptionView = {
  __typename?: 'ProductOptionView';
  /** Position of the option in the list. */
  position: Scalars['Int']['output'];
};

/** A physical product (object) with shipping and return policy information. */
export type ProductPhysical = {
  __typename?: 'ProductPhysical';
  /** List of badges associated with the product. */
  badges: Array<ProductBadge>;
  /** Brand */
  brand: Brand;
  /** Brand ID */
  brandId: Scalars['ID']['output'];
  /** Custom fields for extensible product metadata. */
  customFields: Array<ProductCustomField>;
  /** Description of the product. */
  description: Scalars['String']['output'];
  /** Financial information for the product. */
  financial: ProductFinancial;
  /** Gender for which the product is intended. */
  gender: ProductGender;
  /** Unique identifier of the product. */
  id: Scalars['ID']['output'];
  /** Indicates if the product contains alcohol. */
  isAlcohol: Scalars['Boolean']['output'];
  /** Indicates if the product is a cobrand. */
  isCobrand: Scalars['Boolean']['output'];
  /** Indicates if the product is the featured cobrand for its sale. */
  isCobrandFeatured: Scalars['Boolean']['output'];
  /** Indicates if the product is a gift on purchase. */
  isGiftOnPurchase: Scalars['Boolean']['output'];
  /** Name of the product. */
  name: Scalars['String']['output'];
  /** List of configurable options for the product. */
  options: Array<ProductOption>;
  /** Return policy for the product. */
  returnPolicy: ProductPhysicalReturnPolicy;
  /** Sale for the product. */
  sale: Sale;
  /** Identifier of the sale associated with the product. */
  saleId: Scalars['ID']['output'];
  /** Setup information for the product. */
  setup: ProductSetup;
  /** Shipping information for the product. */
  shipping: ProductPhysicalShipping;
  /** Slug (URL-friendly identifier) for the product. */
  slug: Scalars['String']['output'];
  /** Store where the product is available. */
  storeId: Store;
  /** Type of the product (should be "object"). */
  type: Scalars['String']['output'];
  /** List of variants for the product. */
  variants: Array<Variant>;
  /** View configuration for the product. */
  view: ProductView;
  /** Visibility status of the product. */
  visibility: ProductVisibility;
  /** Cover media for the product. */
  visuals: ProductVisuals;
};

/** Return policy for a physical product. */
export type ProductPhysicalReturnPolicy = {
  __typename?: 'ProductPhysicalReturnPolicy';
  /** Indicates if the product is returnable. */
  isReturnable: Scalars['Boolean']['output'];
};

/** Shipping information for a physical product. */
export type ProductPhysicalShipping = {
  __typename?: 'ProductPhysicalShipping';
  /** Indicates if the product is shipped by Choose. */
  isShippedByChoose: Scalars['Boolean']['output'];
  /** Maximum delivery date for any variant, if any. */
  maxVariantDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Country code from which the product is shipped, if any. */
  shippedFromCountryCode?: Maybe<Scalars['String']['output']>;
};

/** Setup information for a product (import, source, etc). */
export type ProductSetup = {
  __typename?: 'ProductSetup';
  /** Position in the import CSV, if imported. */
  importCsvPosition?: Maybe<Scalars['Int']['output']>;
  /** Source URL for the product, if imported. */
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

/** Product stats */
export type ProductStats = {
  __typename?: 'ProductStats';
  /** Group id */
  groupId: Scalars['ID']['output'];
  /** Id */
  id: Scalars['ID']['output'];
  /** Image url */
  imageUrl: Scalars['URL']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Options */
  options: Array<Scalars['String']['output']>;
  /** Total amount in cents */
  totalAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Total count */
  totalCount: Scalars['NonNegativeInt']['output'];
  /** Variants */
  variants: Array<VariantStats>;
};

/** View configuration for a product (e.g. position in a list). */
export type ProductView = {
  __typename?: 'ProductView';
  /** Position of the product in a list or collection. */
  position: Scalars['Int']['output'];
};

/** Visibility status of a product. */
export type ProductVisibility = {
  __typename?: 'ProductVisibility';
  /** Timestamp when the product was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates if the product is available for sale. */
  isAvailableForSale: Scalars['Boolean']['output'];
  /** Indicates if the product is deleted. */
  isDeleted: Scalars['Boolean']['output'];
  /** Indicates if the product is a draft. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates if the product is hidden for sale. */
  isHidden: Scalars['Boolean']['output'];
};

/** Cover media for a product, including images and optional video. */
export type ProductVisuals = {
  __typename?: 'ProductVisuals';
  /** Cover image. */
  cover: ProductImage;
  /** List of cover images. */
  images: Array<ProductImage>;
  /** URL of the cover video, if any. */
  video?: Maybe<Scalars['String']['output']>;
};

/** Products stocks export */
export type ProductsStocksExport = {
  __typename?: 'ProductsStocksExport';
  /** File url */
  fileUrl: Scalars['URL']['output'];
};

/** Products - Stocks - Shopify - Synchronize - Input */
export type Products_Stocks_Shopify_Synchronize_Input = {
  /** Operation id */
  operationId: Scalars['ID']['input'];
};

/** Purchase order */
export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  /** Url */
  url: Scalars['URL']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Gets the current actor */
  appContact_currentActor: SupportActorAppContact;
  /** Gets ticket by unique identifier of the ticket */
  appContact_supportTicket: SupportTicket;
  /**
   * Suggests the initial request flow matching the customer message, among the flows the app
   * supports. Returns null when the classifier is not confident enough, lands on a flow the app
   * does not support, or cannot answer.
   */
  appContact_supportTicket_suggestInitialRequestFlow?: Maybe<SupportTicketActivityInitialRequestFlow>;
  /** Gets tickets by cursor pagination with filters (filters are not supported for contactId field) */
  appContact_supportTickets: SupportTicketConnection;
  /** Gets the number of tickets for the app contact */
  appContact_supportTicketsCount: Scalars['Int']['output'];
  /** Gets the brand */
  brand: Brand;
  /** Gets the brands by ids */
  brandsByIds: Array<Brand>;
  /** Gets the courier by slug */
  courier_bySlug: Courier;
  /** Detects the couriers using the order id and tracking number */
  couriers_detect: Array<Courier>;
  /** Searches the couriers */
  couriers_search: Array<Courier>;
  /** Gets the current user */
  currentUser: ActorPlatformUser;
  /** Returns the list of favorite support views for the current user. */
  currentUserFavoriteSupportViews: Array<SupportView>;
  /** Gets the pending operation supplier workspace assignments for the current user */
  currentUser_pendingOperationSupplierWorkspaceAssignments: Array<OperationSupplierWorkspaceAssignment>;
  /** Gets the pending supplier workspace invitations for the current user */
  currentUser_pendingSupplierWorkspaceInvitations: Array<SupplierWorkspaceInvitation>;
  /** Gets the supplier workspaces for the current user */
  currentUser_supplierWorkspaces: Array<SupplierWorkspace>;
  /** Gets the system information */
  info: SystemInfo;
  /** Gets internal users with filters */
  internalUsers: Array<ActorInternalUser>;
  /** Gets the operation by id */
  operation: Operation;
  /** Gets the order by id */
  order: Order;
  /** Gets the order refund plan */
  order_refundPlan: Array<OrderRefundPlan>;
  /** Gets the orders by ids */
  orders: Array<Order>;
  /** Searches the orders */
  orders_search: OrdersConnection;
  /** Gets the product */
  product: Product;
  /** Gets the products by ids */
  productsByIds: Array<Product>;
  /** Gets the sale */
  sale: Sale;
  /** Gets the sales by ids */
  salesByIds: Array<Sale>;
  /** Search for brands */
  searchBrands: Array<Brand>;
  /** Search for sales */
  searchSales: Array<Sale>;
  /** Search for app contacts */
  searchSupportActorAppContact: Array<SupportActorAppContact>;
  /** Search for email contacts */
  searchSupportActorEmailContacts: Array<SupportActorEmailContact>;
  /** Gets the supplier by id */
  supplier: Supplier;
  /** Gets the supplier billing adjustment */
  supplierBillingAdjustment: SupplierBillingAdjustment;
  /** Gets the supplier workspace by id */
  supplierWorkspace: SupplierWorkspace;
  /** Gets the support actor app contact by app user id */
  supportActorAppContactByAppUserId: SupportActorAppContact;
  /** Gets the support actor app contacts by ids */
  supportActorAppContactsByIds: Array<SupportActorAppContact>;
  /** Gets the support actor by id */
  supportActorById: SupportActor;
  /** List of notifications for the current internal user (paginated, most recent first) */
  supportNotifications: SupportNotificationConnection;
  /** Count of unread notifications for the current internal user */
  supportNotificationsUnreadCount: Scalars['Int']['output'];
  /** Get the support snippet by id */
  supportSnippet: SupportSnippet;
  /** Get the support snippet tag by id */
  supportSnippetTag: SupportSnippetTag;
  /** Gets support snippet tags by cursor pagination with filters */
  supportSnippetTags: SupportSnippetTagConnection;
  /** Get the support snippet template by id */
  supportSnippetTemplate: SupportSnippetTemplate;
  /** Gets support snippets by cursor pagination with filters */
  supportSnippets: SupportSnippetConnection;
  /** Gets ticket by unique identifier of the ticket */
  supportTicket: SupportTicket;
  /** Gets tickets by cursor pagination with filters */
  supportTickets: SupportTicketConnection;
  /** Gets a support view by its unique identifier. */
  supportView: SupportView;
  /** Gets support views by cursor pagination with filters. */
  supportViews: SupportViewConnection;
  /** Gets the order flow by its id */
  support_orderFlow: SupportOrderFlow;
  /** Searches for order flows */
  support_orderFlow_search: SupportOrderFlowConnection;
  /** Gets the order flows by their ids */
  support_orderFlows: Array<SupportOrderFlow>;
  /** Gets the variant */
  variant: Variant;
  /** Gets the variants by ids */
  variantsByIds: Array<Variant>;
};


export type QueryAppContact_SupportTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppContact_SupportTicket_SuggestInitialRequestFlowArgs = {
  content: Scalars['NonEmptyString']['input'];
  supportedFlows: Array<SupportTicketActivityInitialRequestFlow>;
};


export type QueryAppContact_SupportTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportTicketsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportTicketsSortInput>;
};


export type QueryAppContact_SupportTicketsCountArgs = {
  filters?: InputMaybe<SupportTicketsFilterInput>;
};


export type QueryBrandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCourier_BySlugArgs = {
  input: Courier_BySlug_Input;
};


export type QueryCouriers_DetectArgs = {
  input: Couriers_Detect_Input;
};


export type QueryCouriers_SearchArgs = {
  input: Couriers_Search_Input;
};


export type QueryInternalUsersArgs = {
  filters?: InputMaybe<InternalUsersFilterInput>;
};


export type QueryOperationArgs = {
  input: Operation_Input;
};


export type QueryOrderArgs = {
  input: Order_Input;
};


export type QueryOrder_RefundPlanArgs = {
  input: Order_RefundPlan_Input;
};


export type QueryOrdersArgs = {
  input: Orders_Input;
};


export type QueryOrders_SearchArgs = {
  input: Orders_Search_Input;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySaleArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySalesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySearchBrandsArgs = {
  input: SearchBrandsInput;
};


export type QuerySearchSalesArgs = {
  input: SearchSalesInput;
};


export type QuerySearchSupportActorAppContactArgs = {
  input: SearchSupportActorAppContactInput;
};


export type QuerySearchSupportActorEmailContactsArgs = {
  input: SearchSupportActorEmailContactsInput;
};


export type QuerySupplierArgs = {
  input: Supplier_Input;
};


export type QuerySupplierBillingAdjustmentArgs = {
  input: SupplierBillingAdjustment_Input;
};


export type QuerySupplierWorkspaceArgs = {
  input: SupplierWorkspace_Input;
};


export type QuerySupportActorAppContactByAppUserIdArgs = {
  appUserId: Scalars['ID']['input'];
};


export type QuerySupportActorAppContactsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySupportActorByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupportNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportNotificationsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportNotificationsSortInput>;
};


export type QuerySupportSnippetArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupportSnippetTagArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupportSnippetTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportSnippetTagsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportSnippetTagsSortInput>;
};


export type QuerySupportSnippetTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupportSnippetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportSnippetsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportSnippetsSortInput>;
};


export type QuerySupportTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupportTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportTicketsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportTicketsSortInput>;
};


export type QuerySupportViewArgs = {
  viewId: Scalars['ID']['input'];
};


export type QuerySupportViewsArgs = {
  input: SearchSupportViewsInput;
};


export type QuerySupport_OrderFlowArgs = {
  input: Support_OrderFlow_Input;
};


export type QuerySupport_OrderFlow_SearchArgs = {
  input: Support_OrderFlow_Search_Input;
};


export type QuerySupport_OrderFlowsArgs = {
  input: Support_OrderFlows_Input;
};


export type QueryVariantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVariantsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The recipient is the person who will receive the order */
export type Recipient = {
  __typename?: 'Recipient';
  /** Address */
  address: Address;
  /** Email */
  email: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Full name ("first_name last_name") */
  fullName: Scalars['String']['output'];
  /** Identifier */
  id: Scalars['ID']['output'];
  /** Is editable ? */
  isEditable: Scalars['Boolean']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Phone number */
  phoneNumber: Scalars['String']['output'];
  /** Previous recipient if it has been updated */
  previous?: Maybe<Recipient>;
};

/** Referee */
export type Referee = {
  __typename?: 'Referee';
  /** App user id */
  appUserId: Scalars['ID']['output'];
  /** Credit */
  credit: ReferralCredit;
  /** Name */
  name: Scalars['String']['output'];
};

/** Referral credit */
export type ReferralCredit = {
  __typename?: 'ReferralCredit';
  /** Amount in cents */
  amountInCents: Scalars['PositiveInt']['output'];
  /** Currency */
  currency: CurrencyIso;
};

/** Referral plan */
export type ReferralPlan = {
  __typename?: 'ReferralPlan';
  /** Referee */
  referee: Referee;
  /** Referrer */
  referrer: Referrer;
};

/** Referral plan error */
export type ReferralPlanError = {
  __typename?: 'ReferralPlanError';
  /** Code */
  code: ReferralPlanErrorCode;
};

/** Referral plan error code */
export enum ReferralPlanErrorCode {
  /** Referee already has a referrer */
  RefereeAlreadyHasAReferrer = 'RefereeAlreadyHasAReferrer',
  /** Referee not found */
  RefereeNotFound = 'RefereeNotFound',
  /** Referral already applied */
  ReferralAlreadyApplied = 'ReferralAlreadyApplied',
  /** Referrer not found */
  ReferrerNotFound = 'ReferrerNotFound'
}

/** Referral plan result */
export type ReferralPlanResult = ReferralPlan | ReferralPlanError;

/** Referrer */
export type Referrer = {
  __typename?: 'Referrer';
  /** App user id */
  appUserId: Scalars['ID']['output'];
  /** Credit */
  credit: ReferralCredit;
  /** Is mass referrer */
  isMassReferrer: Scalars['Boolean']['output'];
  /** Name */
  name: Scalars['String']['output'];
};

/** Refund cover - Input */
export enum RefundCover_Input {
  /** Choose covers the refund */
  Choose = 'Choose',
  /** The supplier covers the refund */
  Supplier = 'Supplier'
}

/** Refund info - Input */
export type RefundInfo_Input = {
  /** Party that covers the refund */
  coveredBy: RefundCover_Input;
  /** Internal note about the refund */
  internalNote?: InputMaybe<Scalars['String']['input']>;
  /** Reason of the refund */
  reason?: InputMaybe<RefundReason_Input>;
};

/** Refund reason - Input */
export enum RefundReason_Input {
  /** A claim has the deadline exceeded */
  ClaimDeadlineExceeded = 'ClaimDeadlineExceeded',
  /** A claim has been refused */
  ClaimRefused = 'ClaimRefused',
  /** Commercial gesture */
  CommercialGesture = 'CommercialGesture',
  /** An item has a wrong image */
  ItemWrongImage = 'ItemWrongImage',
  /** An item has a wrong price */
  ItemWrongPrice = 'ItemWrongPrice',
  /** A legal conformity guarantee has been accepted by Choose - not the brand */
  LegalConformityGuarantee = 'LegalConformityGuarantee',
  /** A return has the deadline exceeded */
  ReturnDeadlineExceeded = 'ReturnDeadlineExceeded',
  /** A return has been locked */
  ReturnLocked = 'ReturnLocked',
  /** A return has been refused */
  ReturnRefused = 'ReturnRefused'
}

/** Refund summary */
export type RefundSummary = {
  __typename?: 'RefundSummary';
  /** Amount of cash in cents simulated or applied */
  cashAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Amount of credit in cents simulated or applied */
  creditAmountInCents: Scalars['NonNegativeInt']['output'];
};

/** Remove support actor app contact credit input */
export type RemoveSupportActorAppContactCreditInput = {
  /** Actor app contact id */
  actorAppContactId: Scalars['ID']['input'];
  /** Amount in cents */
  amountInCents: Scalars['PositiveInt']['input'];
  /** Description */
  description: Scalars['String']['input'];
  /** Store */
  store: Store;
};

/** Return */
export type Return = {
  __typename?: 'Return';
  /** Whether the refund is applied with withheld or not */
  applyWithheld: Scalars['Boolean']['output'];
  /** Cancelation date */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Claim id */
  claimId?: Maybe<Scalars['ID']['output']>;
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier */
  id: Scalars['ID']['output'];
  /** Whether the validation is locked */
  isValidationLocked: Scalars['Boolean']['output'];
  /** Label file URL */
  labelFileUrl: Scalars['String']['output'];
  /** Lines */
  lines: Array<ReturnLine>;
  /** Order id */
  orderId: Scalars['ID']['output'];
  /** Preferred refund method */
  preferredRefundMethod: PreferredRefundMethod;
  /** Requester */
  requestedBy: ReturnRequester;
  /** Status */
  status: ReturnStatus;
  /** Tracking */
  tracking: Tracking;
  /** Tracking id */
  trackingId: Scalars['ID']['output'];
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
  /** Validation date */
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Return Address
 *
 * Contains return information including the contact name and full address.
 */
export type ReturnAddress = {
  __typename?: 'ReturnAddress';
  /**
   * Address
   *
   * The structured address information for the return location.
   */
  address: Address;
  /**
   * Name
   *
   * Full name or company name for the return address.
   */
  name: Scalars['String']['output'];
};

/** Return line */
export type ReturnLine = {
  __typename?: 'ReturnLine';
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier */
  id: Scalars['ID']['output'];
  /** Item */
  item: Item;
  /** Item id */
  itemId: Scalars['ID']['output'];
  /** Reason */
  reason: ReturnLineReason;
  /** Return id */
  returnId: Scalars['ID']['output'];
  /** Sub reason */
  subReason?: Maybe<ReturnLineSubReason>;
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
};

/** Return line reason */
export enum ReturnLineReason {
  /** The item is of bad quality */
  BadQuality = 'BadQuality',
  /** A better price is available elsewhere */
  BetterPriceAvailableElsewhere = 'BetterPriceAvailableElsewhere',
  /** The supplier has requested a return in response to a claim */
  Claim = 'Claim',
  /** The item is damaged */
  DamagedItem = 'DamagedItem',
  /** The shipping is damaged */
  DamagedShipping = 'DamagedShipping',
  /** The item was delivered too late */
  DeliveredTooLate = 'DeliveredTooLate',
  /** The item does not match the description */
  DoNotMatchDescription = 'DoNotMatchDescription',
  /** The item does not match the picture */
  DoNotMatchPicture = 'DoNotMatchPicture',
  /** Other reason */
  Other = 'Other',
  /** The size is not correct */
  Size = 'Size',
  /** The item is wrong */
  WrongItem = 'WrongItem'
}

/** Return line sub reason */
export enum ReturnLineSubReason {
  /** The size does not fit */
  SizeDoesNotFit = 'SizeDoesNotFit',
  /** The size is other */
  SizeOther = 'SizeOther',
  /** The customer has ordered several sizes */
  SizeSeveralSizesOrdered = 'SizeSeveralSizesOrdered',
  /** The size is too long */
  SizeTooLong = 'SizeTooLong',
  /** The size is too short */
  SizeTooShort = 'SizeTooShort',
  /** The size is too tight */
  SizeTooTight = 'SizeTooTight',
  /** The size is too wide */
  SizeTooWide = 'SizeTooWide'
}

/** Return line - Input */
export type ReturnLine_Input = {
  /** Item id */
  itemId: Scalars['ID']['input'];
  /** Reason */
  reason: ReturnLineReason;
  /** Sub reason */
  subReason?: InputMaybe<ReturnLineSubReason>;
};

/** Return requester */
export enum ReturnRequester {
  /** A member of the Choose team has requested the return */
  Choose = 'Choose',
  /** The customer has requested the return */
  Customer = 'Customer',
  /** The supplier has requested the return */
  Supplier = 'Supplier'
}

/** Return status */
export enum ReturnStatus {
  /** Canceled */
  Canceled = 'Canceled',
  /** Delivered */
  Delivered = 'Delivered',
  /** In progress */
  InProgress = 'InProgress',
  /** Requested */
  Requested = 'Requested',
  /** Validated */
  Validated = 'Validated'
}

/** Represents a sale. */
export type Sale = {
  __typename?: 'Sale';
  /** Internal user responsible for this sale in contact with the supplier. */
  accountManager?: Maybe<Scalars['String']['output']>;
  /** Gets sale activities by cursor pagination with filters */
  activities: SaleActivityConnection;
  /** Brand ID */
  brandId?: Maybe<Scalars['ID']['output']>;
  /** Cover image of the sale. */
  coverImage?: Maybe<Scalars['String']['output']>;
  /** Date the sale was created. */
  createdAt: Scalars['DateTime']['output'];
  /** End date of the sale. */
  endsAt: Scalars['DateTime']['output'];
  /** Unique identifier of the sale. */
  id: Scalars['ID']['output'];
  /** True if this sale is a selection and not associated with a specific brand. */
  isSelection: Scalars['Boolean']['output'];
  /** Name of the sale (can be brand name or selection name). */
  name: Scalars['String']['output'];
  /** The list of products for the sale. */
  products: Array<Product>;
  /** Sales Team responsible for the sale. */
  salesTeamName?: Maybe<SalesTeamName>;
  /** Internal user responsible for setting up this sale. */
  setupManager?: Maybe<Scalars['String']['output']>;
  /** Start date of the sale. */
  startsAt: Scalars['DateTime']['output'];
  /** State of the sale. */
  status: SaleStatus;
  /** Store where the sale is available. */
  storeId: Store;
  /** Type of sale operation (e.g., Flash Sale, Preorder). */
  type: SaleType;
  /** Date the sale was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents a sale. */
export type SaleActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SaleActivitiesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleActivitiesSortInput>;
};

/** Filter object for querying sales with various criteria. */
export type SaleActivitiesFilterInput = {
  /** Filter by activity ID. */
  id?: InputMaybe<IdFilterInput>;
  /** Filter by sale ID. */
  saleId?: InputMaybe<IdFilterInput>;
  /** Filter by activity type. */
  type?: InputMaybe<SaleActivityTypeFilterInput>;
};

/** Input for sorting sale activities by specific fields. */
export type SaleActivitiesSortInput = {
  /** The sorting direction, either ASC for ascending or DESC for descending. */
  direction: SaleActivitiesSortableDirection;
  /** The field by which activities should be sorted (e.g., createdAt). */
  field: SaleActivitiesSortableFields;
};

export enum SaleActivitiesSortableDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SaleActivitiesSortableFields {
  CreatedAt = 'createdAt'
}

/** Union of all possible sale activities */
export type SaleActivity = SaleActivityNote;

/** Sale activity connection */
export type SaleActivityConnection = {
  __typename?: 'SaleActivityConnection';
  /** Edges of the activity connection */
  edges: Array<SaleActivityEdge>;
  /** Page info of the activity connection */
  pageInfo: PageInfo;
};

/** Sale activity edge */
export type SaleActivityEdge = {
  __typename?: 'SaleActivityEdge';
  /** Cursor of the activity edge */
  cursor: Scalars['String']['output'];
  /** Node of the activity edge */
  node: SaleActivity;
};

/** Sale activity note (when a note is added to a sale) */
export type SaleActivityNote = {
  __typename?: 'SaleActivityNote';
  /** Actor who performed the sale activity note */
  actor: SupportActor;
  /** Actor identifier who performed the sale activity note */
  actorId: Scalars['ID']['output'];
  /** Attachments of the sale activity note */
  attachments: Array<SupportAttachment>;
  /** Content of the note added to the sale */
  content: Scalars['String']['output'];
  /** Identifier of the sale activity note */
  id: Scalars['ID']['output'];
  /** Date and time when the sale a ctivity note occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Types of activities that can be performed on a sale. */
export enum SaleActivityType {
  /** Sale note added */
  SaleActivityNote = 'SaleActivityNote'
}

/** Input for filtering sale activities by type. */
export type SaleActivityTypeFilterInput = {
  in?: InputMaybe<Array<SaleActivityType>>;
  notIn?: InputMaybe<Array<SaleActivityType>>;
};

/** Output type for sale sales team name filter. */
export type SaleSalesTeamNameFilter = {
  __typename?: 'SaleSalesTeamNameFilter';
  in?: Maybe<Array<SalesTeamName>>;
  notIn?: Maybe<Array<SalesTeamName>>;
};

/** Filter for sale sales team name filter. */
export type SaleSalesTeamNameFilterInput = {
  in?: InputMaybe<Array<SalesTeamName>>;
  notIn?: InputMaybe<Array<SalesTeamName>>;
};

/** Represents the current state of the sale. */
export enum SaleStatus {
  /** Sale has ended. */
  Closed = 'Closed',
  /** Next sale to be activated. */
  Next = 'Next',
  /** Sale is currently active. */
  Public = 'Public',
  /** Sale is not published. */
  Unpublished = 'Unpublished'
}

/** Describes the type of operation associated with a sale. */
export enum SaleType {
  /** Clearance sales, typically involving returned or unsold stock (e.g. braderie). */
  Clearance = 'Clearance',
  /** Products are shipped by the brand directly to customers. */
  Dropshipping = 'Dropshipping',
  /** Products are purchased by Choose before the sale and shipped from our warehouses. */
  FirmPurchase = 'FirmPurchase',
  /** Products are purchased after the sale ends. */
  PostOperationPurchase = 'PostOperationPurchase',
  /** Legacy type used in 2022: products resold from other sources. */
  Reseller = 'Reseller'
}

/** Output type for sale operation type filter. */
export type SaleTypeFilter = {
  __typename?: 'SaleTypeFilter';
  in?: Maybe<Array<SaleType>>;
  notIn?: Maybe<Array<SaleType>>;
};

/** Filter for sale operation type filter. */
export type SaleTypeFilterInput = {
  in?: InputMaybe<Array<SaleType>>;
  notIn?: InputMaybe<Array<SaleType>>;
};

/** Describes the team name associated with a sale. */
export enum SalesTeamName {
  /** Cosmetiques */
  Cosmetiques = 'Cosmetiques',
  /** Kids */
  Kids = 'Kids',
  /** Maison */
  Maison = 'Maison',
  /** Mode */
  Mode = 'Mode'
}

/** Search brands input */
export type SearchBrandsInput = {
  /** Limit */
  limit: Scalars['Int']['input'];
  /** Term */
  term: Scalars['String']['input'];
};

/** Search sales input */
export type SearchSalesInput = {
  /** Limit of the search */
  limit: Scalars['Int']['input'];
  /** Term of the search */
  term: Scalars['String']['input'];
};

/** Search support actor app contact input */
export type SearchSupportActorAppContactInput = {
  /** Limit of the search */
  limit: Scalars['Int']['input'];
  /** Term of the search */
  term: Scalars['String']['input'];
};

/** Search support actor email contacts input */
export type SearchSupportActorEmailContactsInput = {
  /** Limit of the search */
  limit: Scalars['Int']['input'];
  /** Term of the search */
  term: Scalars['String']['input'];
};

export type SearchSupportViewsInput = {
  /** The cursor after which to fetch support views (pagination). */
  after?: InputMaybe<Scalars['String']['input']>;
  /** The cursor before which to fetch support views (pagination). */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Optional filters to narrow down the support views. */
  filters?: InputMaybe<SupportViewsFilterInput>;
  /** The number of support views to return starting from the first item (pagination). */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** The number of support views to return starting from the last item (pagination). */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Optional sorting instructions to specify how the results should be ordered. */
  sortBy?: InputMaybe<SupportViewsSortInput>;
};

/** Shipping address */
export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  /** City */
  city: Scalars['String']['output'];
  /** Country code */
  countryCode: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Phone number */
  phoneNumber: Scalars['String']['output'];
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** Street */
  street: Scalars['String']['output'];
  /** Street additional */
  streetAdditional?: Maybe<Scalars['String']['output']>;
  /** Zip code */
  zipCode: Scalars['String']['output'];
};

/** Shipping address - Input */
export type ShippingAddress_Input = {
  /** City */
  city: Scalars['String']['input'];
  /** Country code */
  countryCode: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Phone number */
  phoneNumber: Scalars['String']['input'];
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street */
  street: Scalars['String']['input'];
  /** Street additional */
  streetAdditional?: InputMaybe<Scalars['String']['input']>;
  /** Zip code */
  zipCode: Scalars['String']['input'];
};

/** Shopify */
export type Shopify = {
  __typename?: 'Shopify';
  /** Whether the stock is live synchronized */
  isStockLiveSynchronized: Scalars['Boolean']['output'];
  /** Latest stock synchronization date and time */
  latestStockSynchronizationAt?: Maybe<Scalars['DateTime']['output']>;
  /** Shop url */
  shopUrl: Scalars['URL']['output'];
};

/** Shopify order integration */
export type ShopifyOrderIntegration = {
  __typename?: 'ShopifyOrderIntegration';
  /** Count ID of the order from Shopify */
  orderCountId?: Maybe<Scalars['ID']['output']>;
  /** ID of the order from Shopify */
  orderId: Scalars['ID']['output'];
  /** URL of the order from Shopify */
  orderUrl: Scalars['String']['output'];
};

/** Store */
export enum Store {
  /** European store. */
  Eu = 'eu',
  /** US store. */
  Us = 'us'
}

/** Generic filter for store fields with inclusion and exclusion logic. */
export type StoreFilterInput = {
  in?: InputMaybe<Array<Store>>;
  notIn?: InputMaybe<Array<Store>>;
};

/** Output type for store id filter with nullable values. */
export type StoreFilterNullable = {
  __typename?: 'StoreFilterNullable';
  in?: Maybe<Array<Maybe<Store>>>;
  notIn?: Maybe<Array<Maybe<Store>>>;
};

/** Filter for store id filter with nullable values. */
export type StoreFilterNullableInput = {
  in?: InputMaybe<Array<InputMaybe<Store>>>;
  notIn?: InputMaybe<Array<InputMaybe<Store>>>;
};

/** Generic filter for string fields with inclusion and exclusion logic. */
export type StringFilterInput = {
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Submit support ticket resolution survey input */
export type SubmitSupportTicketResolutionSurveyInput = {
  /** Content */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Whether the ticket is resolved */
  isResolved: Scalars['Boolean']['input'];
  /** Ticket id */
  ticketId: Scalars['ID']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribes to ticket unread */
  appContact_supportTicketUnread: AppContact_SupportTicketUnread;
  /** Subscribes to supplier workspace order created events */
  supplierWorkspace_order_created: Order;
  /** Subscribes to supplier workspace order updated events */
  supplierWorkspace_order_updated: Order;
  /** Subscribes to supplier workspace order validated events */
  supplierWorkspace_order_validated: Order;
  /** Subscribes to supplier workspace supplier invoice created events */
  supplierWorkspace_supplierInvoice_created: SupplierInvoice;
  /** Subscribes to supplier workspace supplier invoice updated events */
  supplierWorkspace_supplierInvoice_updated: SupplierInvoice;
  /** Real-time notification for the current internal user */
  supportNotificationCreated: SupportNotification;
  /** Subscribes to snippet creation */
  supportSnippetCreated: SupportSnippet;
  /** Subscribes to snippet tag creation */
  supportSnippetTagCreated: SupportSnippetTag;
  /** Subscribes to snippet tag updates */
  supportSnippetTagUpdated: SupportSnippetTag;
  /** Subscribes to snippet updates */
  supportSnippetUpdated: SupportSnippet;
  /** Subscribes to ticket creation */
  supportTicketCreated: SupportTicket;
  /** Subscribes to ticket deletion */
  supportTicketDeleted: Scalars['ID']['output'];
  /** Subscribes to ticket updates */
  supportTicketUpdated: SupportTicket;
};


export type SubscriptionSupplierWorkspace_Order_CreatedArgs = {
  input: SupplierWorkspace_Order_Created_Input;
};


export type SubscriptionSupplierWorkspace_Order_UpdatedArgs = {
  input: SupplierWorkspace_Order_Updated_Input;
};


export type SubscriptionSupplierWorkspace_Order_ValidatedArgs = {
  input: SupplierWorkspace_Order_Validated_Input;
};


export type SubscriptionSupplierWorkspace_SupplierInvoice_CreatedArgs = {
  input: SupplierWorkspace_SupplierInvoice_Created_Input;
};


export type SubscriptionSupplierWorkspace_SupplierInvoice_UpdatedArgs = {
  input: SupplierWorkspace_SupplierInvoice_Updated_Input;
};

/** Supplier */
export type Supplier = {
  __typename?: 'Supplier';
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Hubspot supplier id */
  hubspotSupplierId: Scalars['String']['output'];
  /** Id */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** OSS number */
  ossNumber?: Maybe<Scalars['String']['output']>;
  /** SIREN */
  siren?: Maybe<Scalars['String']['output']>;
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
  /** VAT number */
  vatNumber?: Maybe<Scalars['String']['output']>;
  /** Workspaces */
  workspaces: Array<SupplierWorkspace>;
};

export type SupplierBilling = {
  __typename?: 'SupplierBilling';
  adjustments: Array<SupplierBillingAdjustment>;
  downPayment?: Maybe<SupplierDownPayment>;
  errors: Array<SupplierBillingProductSoldError>;
  financialDetail: SupplierBillingFinancialDetail;
  hasError: Scalars['Boolean']['output'];
  isFullPaid: Scalars['Boolean']['output'];
  isSubjectToVat: Scalars['Boolean']['output'];
  payments: Array<SupplierPayment>;
};

export type SupplierBillingAdjustment = SupplierBillingAdjustmentDraft | SupplierBillingAdjustmentValidated;

/** Supplier billing adjustment charge to */
export enum SupplierBillingAdjustmentChargeTo {
  Choose = 'Choose',
  Supplier = 'Supplier'
}

/** Supplier billing adjustment document */
export type SupplierBillingAdjustmentDocument = {
  __typename?: 'SupplierBillingAdjustmentDocument';
  /** Extension */
  extension: Scalars['String']['output'];
  /** Mime type */
  mimeType: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Size */
  size: Scalars['NonNegativeInt']['output'];
  /** Url */
  url: Scalars['URL']['output'];
};

/** Supplier billing adjustment draft */
export type SupplierBillingAdjustmentDraft = {
  __typename?: 'SupplierBillingAdjustmentDraft';
  amountVatExcludedInCents?: Maybe<Scalars['NonNegativeInt']['output']>;
  amountVatIncludedInCents?: Maybe<Scalars['NonNegativeInt']['output']>;
  chargedTo: SupplierBillingAdjustmentChargeTo;
  createdAt: Scalars['DateTime']['output'];
  createdBy: ActorInternalUser;
  createdById: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<SupplierBillingAdjustmentDocument>;
  id: Scalars['ID']['output'];
  notes: Array<SupplierBillingAdjustmentNote>;
  operationId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vatRate?: Maybe<Scalars['FloatPercentage']['output']>;
};

/** Supplier billing adjustment note */
export type SupplierBillingAdjustmentNote = {
  __typename?: 'SupplierBillingAdjustmentNote';
  /** Content */
  content: Scalars['String']['output'];
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorInternalUser;
  /** Created by id */
  createdById: Scalars['ID']['output'];
  /** Deleted at */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  /** Supplier billing adjustment id */
  supplierBillingAdjustmentId: Scalars['ID']['output'];
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Supplier billing adjustment note - Create - Input */
export type SupplierBillingAdjustmentNote_Create_Input = {
  /** Content */
  content: Scalars['String']['input'];
  /** Supplier billing adjustment id */
  supplierBillingAdjustmentId: Scalars['ID']['input'];
};

/** Supplier billing adjustment note - Delete - Input */
export type SupplierBillingAdjustmentNote_Delete_Input = {
  /** Supplier billing adjustment note id */
  supplierBillingAdjustmentNoteId: Scalars['ID']['input'];
};

/** Supplier billing adjustment note - Update - Input */
export type SupplierBillingAdjustmentNote_Update_Input = {
  /** Content */
  content: Scalars['String']['input'];
  /** Supplier billing adjustment note id */
  supplierBillingAdjustmentNoteId: Scalars['ID']['input'];
};

/** Supplier billing adjustment validated */
export type SupplierBillingAdjustmentValidated = {
  __typename?: 'SupplierBillingAdjustmentValidated';
  amountVatExcludedInCents: Scalars['NonNegativeInt']['output'];
  amountVatIncludedInCents: Scalars['NonNegativeInt']['output'];
  chargedTo: SupplierBillingAdjustmentChargeTo;
  createdAt: Scalars['DateTime']['output'];
  createdBy: ActorInternalUser;
  createdById: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documents: Array<SupplierBillingAdjustmentDocument>;
  id: Scalars['ID']['output'];
  notes: Array<SupplierBillingAdjustmentNote>;
  operationId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validatedAt: Scalars['DateTime']['output'];
  validatedBy: ActorInternalUser;
  validatedById: Scalars['ID']['output'];
  vatRate: Scalars['FloatPercentage']['output'];
};

/** Supplier billing adjustment - Create - Input */
export type SupplierBillingAdjustment_Create_Input = {
  /** Amount vat excluded in cents */
  amountVatExcludedInCents?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /** Charged to */
  chargedTo: SupplierBillingAdjustmentChargeTo;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Document urls */
  documentUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Operation id */
  operationId: Scalars['ID']['input'];
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Vat rate */
  vatRate?: InputMaybe<Scalars['FloatPercentage']['input']>;
};

/** Supplier billing adjustment - Delete - Input */
export type SupplierBillingAdjustment_Delete_Input = {
  /** Supplier billing adjustment id */
  supplierBillingAdjustmentId: Scalars['ID']['input'];
};

/** Supplier billing adjustment - Generate document upload url - Input */
export type SupplierBillingAdjustment_GenerateDocumentUploadUrl_Input = {
  /** Operation id */
  operationId: Scalars['ID']['input'];
  /** Upload */
  upload: UploadInput;
};

/** Gets the supplier billing adjustment */
export type SupplierBillingAdjustment_Input = {
  /** Supplier billing adjustment id */
  supplierBillingAdjustmentId: Scalars['ID']['input'];
};

/** Supplier billing adjustment - Update - Input */
export type SupplierBillingAdjustment_Update_Input = {
  /** Amount vat excluded in cents */
  amountVatExcludedInCents?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /** Charged to */
  chargedTo?: InputMaybe<SupplierBillingAdjustmentChargeTo>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Document urls */
  documentUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier billing adjustment id */
  supplierBillingAdjustmentId: Scalars['ID']['input'];
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Vat rate */
  vatRate?: InputMaybe<Scalars['FloatPercentage']['input']>;
};

/** Supplier billing adjustment - Validate - Input */
export type SupplierBillingAdjustment_Validate_Input = {
  /** Supplier billing adjustment id */
  supplierBillingAdjustmentId: Scalars['ID']['input'];
};

export type SupplierBillingByDate = {
  __typename?: 'SupplierBillingByDate';
  date: Scalars['Date']['output'];
  orderCount: Scalars['Int']['output'];
  totalBillingHt: Scalars['Int']['output'];
  totalBillingTtc: Scalars['Int']['output'];
  totalCommissionHt: Scalars['Int']['output'];
  totalCommissionTtc: Scalars['Int']['output'];
  totalOperationHt: Scalars['Int']['output'];
  totalOperationTtc: Scalars['Int']['output'];
  totalVat: Scalars['Int']['output'];
};

export type SupplierBillingByVatRate = {
  __typename?: 'SupplierBillingByVatRate';
  totalBillingHt: Scalars['Int']['output'];
  totalBillingTtc: Scalars['Int']['output'];
  totalCommissionHt: Scalars['Int']['output'];
  totalCommissionTtc: Scalars['Int']['output'];
  totalOperationHt: Scalars['Int']['output'];
  totalOperationTtc: Scalars['Int']['output'];
  totalVat: Scalars['Int']['output'];
  vatRate: Scalars['String']['output'];
};

/** Supplier Billing Export */
export type SupplierBillingExport = {
  __typename?: 'SupplierBillingExport';
  /** File url */
  fileUrl: Scalars['URL']['output'];
};

export type SupplierBillingFinancialDetail = {
  __typename?: 'SupplierBillingFinancialDetail';
  aggByDate: Array<SupplierBillingByDate>;
  aggByVatRate: Array<SupplierBillingByVatRate>;
  totalAdjustmentHt: Scalars['Int']['output'];
  totalAdjustmentTtc: Scalars['Int']['output'];
  totalBillingHt: Scalars['Int']['output'];
  totalBillingTtc: Scalars['Int']['output'];
  totalCommissionHt: Scalars['Int']['output'];
  totalCommissionTtc: Scalars['Int']['output'];
  totalDeliveryHt: Scalars['Int']['output'];
  totalDeliveryTtc: Scalars['Int']['output'];
  totalOperationHt: Scalars['Int']['output'];
  totalOperationTtc: Scalars['Int']['output'];
  totalRefundHt: Scalars['Int']['output'];
  totalRefundTtc: Scalars['Int']['output'];
  totalRemainingHt: Scalars['Int']['output'];
  totalRemainingTtc: Scalars['Int']['output'];
  totalTurnoverHt: Scalars['Int']['output'];
  totalTurnoverTtc: Scalars['Int']['output'];
};

export type SupplierBillingProductSoldError = {
  __typename?: 'SupplierBillingProductSoldError';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

/** Supplier billing state */
export type SupplierBillingState = {
  __typename?: 'SupplierBillingState';
  /** Whether the user can access the supplier billing */
  canAccess: Scalars['Boolean']['output'];
  /** Whether the user can access the supplier billing bypassed */
  canAccessBypassed: Scalars['Boolean']['output'];
  /** Whether the operation is pending claim closing */
  isPendingClaimClosing: Scalars['Boolean']['output'];
  /** Whether the operation is pending order delivery */
  isPendingOrderDelivery: Scalars['Boolean']['output'];
  /** Whether the operation is pending return validation */
  isPendingReturnValidation: Scalars['Boolean']['output'];
  /** Whether the operation is pending withdrawal period */
  isPendingWithdrawalPeriod: Scalars['Boolean']['output'];
  /** The pending claim closing order ids */
  pendingClaimClosingOrderIds: Array<Scalars['ID']['output']>;
  /** The pending order delivery order ids */
  pendingOrderDeliveryOrderIds: Array<Scalars['ID']['output']>;
  /** The pending return validation order ids */
  pendingReturnValidationOrderIds: Array<Scalars['ID']['output']>;
  /** The sale status */
  saleStatus: SupplierBillingStateSaleStatus;
  /** The withdrawal period end date */
  withdrawalPeriodEndDate: Scalars['DateTime']['output'];
  /** The withdrawal period in days */
  withdrawalPeriodInDays: Scalars['NonNegativeInt']['output'];
};

/** Supplier billing state sale status */
export enum SupplierBillingStateSaleStatus {
  /** The sale has ended */
  Ended = 'Ended',
  /** The sale is ongoing */
  Ongoing = 'Ongoing',
  /** The sale is upcoming */
  Upcoming = 'Upcoming'
}

export type SupplierDownPayment = SupplierDownPaymentClassic | SupplierDownPaymentExceptional;

export type SupplierDownPaymentActivationDateRule = {
  __typename?: 'SupplierDownPaymentActivationDateRule';
  activationDate: Scalars['DateTime']['output'];
  isValidated: Scalars['Boolean']['output'];
};

export type SupplierDownPaymentClassic = {
  __typename?: 'SupplierDownPaymentClassic';
  financialDetail: SupplierBillingFinancialDetail;
  preset: SupplierDownPaymentPreset;
  rate: Scalars['Int']['output'];
  rules: Array<SupplierDownPaymentRule>;
};

export type SupplierDownPaymentExceptional = {
  __typename?: 'SupplierDownPaymentExceptional';
  preset: SupplierDownPaymentPreset;
};

export type SupplierDownPaymentFulfilledOrderPercentageRule = {
  __typename?: 'SupplierDownPaymentFulfilledOrderPercentageRule';
  currentValue: Scalars['Int']['output'];
  isValidated: Scalars['Boolean']['output'];
  targetValue: Scalars['Int']['output'];
};

export type SupplierDownPaymentMinimumAmountInCentsRule = {
  __typename?: 'SupplierDownPaymentMinimumAmountInCentsRule';
  currentValue: Scalars['Int']['output'];
  isValidated: Scalars['Boolean']['output'];
  targetValue: Scalars['Int']['output'];
};

export enum SupplierDownPaymentPreset {
  Classic = 'Classic',
  Exceptional = 'Exceptional'
}

export type SupplierDownPaymentRule = SupplierDownPaymentActivationDateRule | SupplierDownPaymentFulfilledOrderPercentageRule | SupplierDownPaymentMinimumAmountInCentsRule;

/** Supplier down payment - Submit - Input */
export type SupplierDownPayment_Submit_Input = {
  /** File key */
  fileKey: Scalars['String']['input'];
  /** Operation id */
  operationId: Scalars['ID']['input'];
};

/** Supplier invoice */
export type SupplierInvoice = {
  __typename?: 'SupplierInvoice';
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** File name */
  fileName: Scalars['String']['output'];
  /** File url */
  fileUrl: Scalars['URL']['output'];
  /** Identifier */
  id: Scalars['ID']['output'];
  /** Operation name */
  operation: Operation;
  /** Operation id */
  operationId: Scalars['ID']['output'];
  /** Status */
  status: SupplierInvoiceStatus;
  /** Type */
  type: SupplierInvoiceType;
};

/** Supplier invoice status */
export enum SupplierInvoiceStatus {
  /** Bot error */
  BotError = 'bot_error',
  /** Bot processing */
  BotProcessing = 'bot_processing',
  /** Paid */
  Paid = 'paid',
  /** Received */
  Received = 'received',
  /** Rejected */
  Rejected = 'rejected',
  /** To be paid */
  ToBePaid = 'to_be_paid',
  /** Validated */
  Validated = 'validated'
}

/** Supplier invoice type */
export enum SupplierInvoiceType {
  /** Credit note */
  CreditNote = 'credit_note',
  /** Down payment */
  DownPayment = 'down_payment',
  /** Final balance */
  FinalBalance = 'final_balance',
  /** Invoice */
  Invoice = 'invoice',
  /** Proforma */
  Proforma = 'proforma',
  /** Statement of account */
  StatementOfAccount = 'statement_of_account'
}

/** Supplier invoice - Generate upload url - Input */
export type SupplierInvoice_GenerateUploadUrl_Input = {
  /** Operation id */
  operationId: Scalars['ID']['input'];
  /** Upload */
  upload: UploadInput;
};

/** Supplier invoice - Submit - Input */
export type SupplierInvoice_Submit_Input = {
  /** File key */
  fileKey: Scalars['String']['input'];
  /** Operation id */
  operationId: Scalars['ID']['input'];
};

export type SupplierPayment = {
  __typename?: 'SupplierPayment';
  amountVatExcludedInCents: Scalars['Int']['output'];
  amountVatInCents: Scalars['Int']['output'];
  amountVatIncludedInCents: Scalars['Int']['output'];
  invoiceId: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Supplier user */
export type SupplierUser = {
  __typename?: 'SupplierUser';
  /** Email of the supplier user */
  email: Scalars['EmailAddress']['output'];
  /** First day of the week of the supplier user */
  firstDayOfTheWeek: FirstDayOfTheWeek;
  /** First name of the supplier user */
  firstName: Scalars['String']['output'];
  /** Identifier of the actor */
  id: Scalars['ID']['output'];
  /** Language of the supplier user */
  language: LanguageIso6391;
  /** Last name of the supplier user */
  lastName: Scalars['String']['output'];
  /** Picture URL of the supplier user */
  picture: Scalars['URL']['output'];
  /** Timezone of the supplier user */
  timezone: Scalars['String']['output'];
};

/** Supplier workspace */
export type SupplierWorkspace = {
  __typename?: 'SupplierWorkspace';
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Creator */
  createdBy: ActorPlatformUser;
  /** Deletion date */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  /** Invitations */
  invitations: Array<SupplierWorkspaceInvitation>;
  /** Members */
  members: Array<SupplierWorkspaceMember>;
  /** Name */
  name: Scalars['String']['output'];
  /** Operations */
  operations: Array<Operation>;
  /** Supplier */
  supplier: Supplier;
  /** Supplier id */
  supplierId: Scalars['ID']['output'];
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
};

/** Supplier workspace invitation */
export type SupplierWorkspaceInvitation = {
  __typename?: 'SupplierWorkspaceInvitation';
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Actor who created the supplier workspace invitation */
  createdBy: ActorPlatformUser;
  /** Deletion date */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Email */
  email: Scalars['EmailAddress']['output'];
  /** Whether the email has been sent */
  emailSent: Scalars['Boolean']['output'];
  /** Date when the invitation expires */
  expiresAt: Scalars['DateTime']['output'];
  /** Id */
  id: Scalars['ID']['output'];
  /** Role */
  role: SupplierWorkspaceRole;
  /** Status */
  status: SupplierWorkspaceInvitationStatus;
  /** Supplier workspace */
  supplierWorkspace: SupplierWorkspace;
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['output'];
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
};

/** Supplier workspace invitation status */
export enum SupplierWorkspaceInvitationStatus {
  /** Accepted */
  Accepted = 'Accepted',
  /** Canceled */
  Canceled = 'Canceled',
  /** Expired */
  Expired = 'Expired',
  /** Pending */
  Pending = 'Pending'
}

/** Supplier workspace member */
export type SupplierWorkspaceMember = {
  __typename?: 'SupplierWorkspaceMember';
  /** Actor */
  actor: ActorPlatformUser;
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Deletion date */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  /** Role */
  role: SupplierWorkspaceRole;
  /** Supplier workspace */
  supplierWorkspace: SupplierWorkspace;
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['output'];
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
};

/** Supplier workspace role */
export enum SupplierWorkspaceRole {
  /** Admin */
  Admin = 'Admin',
  /** Member */
  Member = 'Member'
}

/** Supplier workspace - Create - Input */
export type SupplierWorkspace_Create_Input = {
  /** Name */
  name: Scalars['String']['input'];
  /** Supplier id */
  supplierId: Scalars['ID']['input'];
};

/** Supplier workspace - Input */
export type SupplierWorkspace_Input = {
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Invitation - Accept - Input */
export type SupplierWorkspace_Invitation_Accept_Input = {
  /** Invitation id */
  invitationId: Scalars['ID']['input'];
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Invitation - Cancel - Input */
export type SupplierWorkspace_Invitation_Cancel_Input = {
  /** Invitation id */
  invitationId: Scalars['ID']['input'];
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Invitation - Edit Role - Input */
export type SupplierWorkspace_Invitation_EditRole_Input = {
  /** Invitation id */
  invitationId: Scalars['ID']['input'];
  /** Role */
  role: SupplierWorkspaceRole;
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Invitation - Send - Input */
export type SupplierWorkspace_Invitation_Send_Input = {
  /** Email */
  email: Scalars['EmailAddress']['input'];
  /** Role */
  role: SupplierWorkspaceRole;
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Invitation - Trigger Email - Input */
export type SupplierWorkspace_Invitation_TriggerEmail_Input = {
  /** Invitation id */
  invitationId: Scalars['ID']['input'];
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Member - Edit Role - Input */
export type SupplierWorkspace_Member_EditRole_Input = {
  /** Member id */
  memberId: Scalars['ID']['input'];
  /** Role */
  role: SupplierWorkspaceRole;
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Member - Remove - Input */
export type SupplierWorkspace_Member_Remove_Input = {
  /** Member id */
  memberId: Scalars['ID']['input'];
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Order - Created - Input */
export type SupplierWorkspace_Order_Created_Input = {
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Order - Updated - Input */
export type SupplierWorkspace_Order_Updated_Input = {
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Order - Validated - Input */
export type SupplierWorkspace_Order_Validated_Input = {
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Supplier invoice - Created - Input */
export type SupplierWorkspace_SupplierInvoice_Created_Input = {
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier workspace - Supplier invoice - Updated - Input */
export type SupplierWorkspace_SupplierInvoice_Updated_Input = {
  /** Supplier workspace id */
  supplierWorkspaceId: Scalars['ID']['input'];
};

/** Supplier - Input */
export type Supplier_Input = {
  /** Supplier id */
  supplierId: Scalars['ID']['input'];
};

/** Union of all possible support actors */
export type SupportActor = ActorBotUser | ActorInternalUser | ActorSupplierUser | SupportActorAppContact | SupportActorEmailContact;

/** Filter object for querying support actors with various criteria. */
export type SupportActorActivitiesFilterInput = {
  /** Filter by activity ID. */
  id?: InputMaybe<IdFilterInput>;
  /** Filter by actor ID. */
  subjectActorId?: InputMaybe<IdFilterInput>;
  /** Filter by activity type. */
  type?: InputMaybe<SupportActorActivityTypeFilterInput>;
};

/** Input for sorting actor activities by specific fields. */
export type SupportActorActivitiesSortInput = {
  /** The sorting direction, either ASC for ascending or DESC for descending. */
  direction: SupportActorActivitiesSortableDirection;
  /** The field by which activities should be sorted (e.g., createdAt). */
  field: SupportActorActivitiesSortableFields;
};

export enum SupportActorActivitiesSortableDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SupportActorActivitiesSortableFields {
  CreatedAt = 'createdAt'
}

/** Union of all possible support actor activities */
export type SupportActorActivity = SupportActorActivityCredit | SupportActorActivityFrauder | SupportActorActivityInfluencer | SupportActorActivityNote | SupportActorActivityReferralCode;

/** Support actor activity connection */
export type SupportActorActivityConnection = {
  __typename?: 'SupportActorActivityConnection';
  /** Edges of the activity connection */
  edges: Array<SupportActorActivityEdge>;
  /** Page info of the activity connection */
  pageInfo: PageInfo;
};

/** Support actor activity credit (when some credit is added or removed) */
export type SupportActorActivityCredit = {
  __typename?: 'SupportActorActivityCredit';
  /** Action of the actor activity credit */
  action: SupportActorActivityCreditAction;
  /** Actor who performed the actor activity credit */
  actor: SupportActor;
  /** Actor identifier who performed the actor activity credit */
  actorId: Scalars['ID']['output'];
  /** Amount in cents of the actor activity credit */
  amountInCents: Scalars['Int']['output'];
  /** Currency of the actor activity credit */
  currency: CurrencyIso;
  /** Identifier of the actor activity credit */
  id: Scalars['ID']['output'];
  /** Date and time when the actor activity credit occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Enum of the different actions of credit actor activities */
export enum SupportActorActivityCreditAction {
  /** Add credit */
  Add = 'Add',
  /** Remove credit */
  Remove = 'Remove'
}

/** Support actor activity edge */
export type SupportActorActivityEdge = {
  __typename?: 'SupportActorActivityEdge';
  /** Cursor of the activity edge */
  cursor: Scalars['String']['output'];
  /** Node of the activity edge */
  node: SupportActorActivity;
};

/** Support actor activity frauder (when a frauder is flagged or unflagged) */
export type SupportActorActivityFrauder = {
  __typename?: 'SupportActorActivityFrauder';
  /** Actor who performed the actor activity frauder */
  actor: SupportActor;
  /** Actor identifier who performed the actor activity frauder */
  actorId: Scalars['ID']['output'];
  /** Identifier of the actor activity frauder */
  id: Scalars['ID']['output'];
  /** Whether the actor is a frauder */
  isFrauder: Scalars['Boolean']['output'];
  /** Date and time when the actor activity frauder occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support actor activity influencer (when an influencer is flagged or unflagged) */
export type SupportActorActivityInfluencer = {
  __typename?: 'SupportActorActivityInfluencer';
  /** Actor who performed the actor activity influencer */
  actor: SupportActor;
  /** Actor identifier who performed the actor activity influencer */
  actorId: Scalars['ID']['output'];
  /** Identifier of the actor activity influencer */
  id: Scalars['ID']['output'];
  /** Whether the actor is an influencer */
  isInfluencer: Scalars['Boolean']['output'];
  /** Date and time when the actor activity influencer occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support actor activity note (when a note is added to an actor) */
export type SupportActorActivityNote = {
  __typename?: 'SupportActorActivityNote';
  /** Actor who performed the actor activity note */
  actor: SupportActor;
  /** Actor identifier who performed the actor activity note */
  actorId: Scalars['ID']['output'];
  /** Attachments of the actor activity note */
  attachments: Array<SupportAttachment>;
  /** Content of the note added to the actor */
  content: Scalars['String']['output'];
  /** Identifier of the actor activity note */
  id: Scalars['ID']['output'];
  /** Date and time when the actor activity note occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support actor activity referral code (when an actor referral code is edited) */
export type SupportActorActivityReferralCode = {
  __typename?: 'SupportActorActivityReferralCode';
  /** Actor who performed the actor activity referral code */
  actor: SupportActor;
  /** Actor identifier who performed the actor activity referral code */
  actorId: Scalars['ID']['output'];
  /** Identifier of the actor activity referral code */
  id: Scalars['ID']['output'];
  /** New referral code of the actor activity referral code */
  newReferralCode: Scalars['String']['output'];
  /** Date and time when the actor activity referral code occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Old referral code of the actor activity referral code */
  oldReferralCode?: Maybe<Scalars['String']['output']>;
};

/** Types of activities that can be performed on an actor. */
export enum SupportActorActivityType {
  /** Support actor activity credit */
  SupportActorActivityCredit = 'SupportActorActivityCredit',
  /** Support actor activity frauder */
  SupportActorActivityFrauder = 'SupportActorActivityFrauder',
  /** Support actor activity influencer */
  SupportActorActivityInfluencer = 'SupportActorActivityInfluencer',
  /** Support actor activity note */
  SupportActorActivityNote = 'SupportActorActivityNote',
  /** Support actor activity referral code */
  SupportActorActivityReferralCode = 'SupportActorActivityReferralCode'
}

/** Input for filtering actor activities by type. */
export type SupportActorActivityTypeFilterInput = {
  in?: InputMaybe<Array<SupportActorActivityType>>;
  notIn?: InputMaybe<Array<SupportActorActivityType>>;
};

/** Support actor app contact */
export type SupportActorAppContact = {
  __typename?: 'SupportActorAppContact';
  /** Gets actor activities by cursor pagination with filters */
  activities: SupportActorActivityConnection;
  /** App contact of the actor */
  appContact: SupportAppContact;
  /** Identifier of the actor */
  id: Scalars['ID']['output'];
  /** Gets tickets associated with the app contact using cursor-based pagination and optional filters. */
  tickets: SupportTicketConnection;
};


/** Support actor app contact */
export type SupportActorAppContactActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportActorActivitiesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportActorActivitiesSortInput>;
};


/** Support actor app contact */
export type SupportActorAppContactTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportTicketsSortInput>;
};

/** Support actor bot user */
export type SupportActorBotUser = {
  __typename?: 'SupportActorBotUser';
  /** Bot user of the actor */
  botUser: BotUser;
  /** Identifier of the actor */
  id: Scalars['ID']['output'];
};

/** Union of all possible support actor contacts */
export type SupportActorContact = SupportActorAppContact | SupportActorEmailContact;

/** Support actor email contact */
export type SupportActorEmailContact = {
  __typename?: 'SupportActorEmailContact';
  /** Email contact of the actor */
  emailContact: SupportEmailContact;
  /** Identifier of the actor */
  id: Scalars['ID']['output'];
  /** Gets tickets associated with the email contact using cursor-based pagination. */
  tickets: SupportTicketConnection;
};


/** Support actor email contact */
export type SupportActorEmailContactTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportTicketsSortInput>;
};

/** Support actor internal user */
export type SupportActorInternalUser = {
  __typename?: 'SupportActorInternalUser';
  /** Identifier of the actor */
  id: Scalars['ID']['output'];
  /** Internal user of the actor */
  internalUser: InternalUser;
};

/** Union of all possible support actors (legacy) */
export type SupportActorLegacy = ActorBotUser | ActorInternalUser | ActorSupplierUser | SupportActorAppContact | SupportActorBotUser | SupportActorEmailContact | SupportActorInternalUser;

/** Support app contact */
export type SupportAppContact = {
  __typename?: 'SupportAppContact';
  /** App user identifier of the app contact */
  appUserId: Scalars['ID']['output'];
  /** Credits of the app contact */
  credits: Array<Credit>;
  /** Email of the app contact */
  email?: Maybe<Scalars['String']['output']>;
  /** First name of the app contact */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Full name of the app contact */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Identifier of the app contact */
  id: Scalars['ID']['output'];
  /** Whether the app contact is a frauder */
  isFrauder: Scalars['Boolean']['output'];
  /** Whether the app contact is an influencer */
  isInfluencer: Scalars['Boolean']['output'];
  /** Language of the app contact (ISO 639-1) */
  language: LanguageIso6391;
  /** Last name of the app contact */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Latest activity date and time of the app contact */
  latestActivityAt: Scalars['DateTime']['output'];
  /** Gets recent orders associated with the contact */
  latestOrders: Array<Order>;
  /** Latest shipping address of the app contact */
  latestShippingAddress?: Maybe<ShippingAddress>;
  /** Mobile of the app contact */
  mobile: SupportAppContactMobile;
  /** Total number of orders made by the app contact */
  ordersCount: Scalars['Int']['output'];
  /** Phone number of the app contact */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Referral code of the app contact */
  referralCode?: Maybe<Scalars['String']['output']>;
  /** Referral godfather of the app contact */
  referralGodfather?: Maybe<SupportActorAppContact>;
  /** Referral godfather app user id of the app contact */
  referralGodfatherAppUserId?: Maybe<Scalars['String']['output']>;
  /** Store of the app contact */
  store: Store;
  /** Timezone of the app contact */
  timezone: Scalars['String']['output'];
};


/** Support app contact */
export type SupportAppContactLatestOrdersArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/** Support app contact mobile */
export type SupportAppContactMobile = {
  __typename?: 'SupportAppContactMobile';
  /** App of the app contact mobile */
  app: SupportAppContactMobileApp;
  /** Device of the app contact mobile */
  device?: Maybe<SupportAppContactMobileDevice>;
};

/** Support app contact mobile app */
export type SupportAppContactMobileApp = {
  __typename?: 'SupportAppContactMobileApp';
  /** Whether the version of the mobile app is the latest version */
  isLatestVersion: Scalars['Boolean']['output'];
  /** Version of the mobile app */
  version: Scalars['String']['output'];
};

/** Support app contact mobile device */
export type SupportAppContactMobileDevice = {
  __typename?: 'SupportAppContactMobileDevice';
  /** Brand of the mobile device */
  brand: Scalars['String']['output'];
  /** Operating system of the mobile device */
  os: SupportAppContactMobileDeviceOs;
  /** Operating system version of the mobile device */
  osVersion: Scalars['String']['output'];
};

export enum SupportAppContactMobileDeviceOs {
  /** Android */
  Android = 'Android',
  /** iOS */
  IOs = 'iOS'
}

/** Represents a file attachment in a ticket activity */
export type SupportAttachment = {
  __typename?: 'SupportAttachment';
  /** Date and time the attachment was created */
  createdAt: Scalars['DateTime']['output'];
  /** Actor who uploaded the attachment */
  createdBy: SupportActor;
  /** Date and time the attachment was deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Actor who deleted the attachment */
  deletedBy?: Maybe<SupportActor>;
  /** File extension (e.g. 'png', 'pdf') */
  fileExtension: Scalars['String']['output'];
  /** MIME type of the file (e.g. 'image/png') */
  fileMimeType: Scalars['String']['output'];
  /** File name, including extension */
  fileName: Scalars['String']['output'];
  /** File size in bytes */
  fileSize: Scalars['Int']['output'];
  /** Public or secured URL of the attachment */
  fileUrl: Scalars['String']['output'];
  /** Unique identifier of the attachment */
  id: Scalars['ID']['output'];
  /** Type of the attachment */
  type?: Maybe<SupportAttachmentType>;
  /** Date and time the attachment was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support attachment input */
export type SupportAttachmentPayload = {
  __typename?: 'SupportAttachmentPayload';
  /** File extension (e.g. 'png', 'pdf') */
  fileExtension: Scalars['String']['output'];
  /** MIME type of the file (e.g. 'image/png') */
  fileMimeType: Scalars['String']['output'];
  /** File name, including extension */
  fileName: Scalars['String']['output'];
  /** File size in bytes */
  fileSize: Scalars['Int']['output'];
  /** Public or secured URL of the attachment */
  fileUrl: Scalars['String']['output'];
  /** Type of the attachment */
  type?: Maybe<SupportAttachmentType>;
};

/** Support attachment type */
export enum SupportAttachmentType {
  /** Initial request attachment */
  InitialRequestAttachment = 'InitialRequestAttachment',
  /** Initial request proof */
  InitialRequestProof = 'InitialRequestProof',
  /** Initial request sworn statement */
  InitialRequestSwornStatement = 'InitialRequestSwornStatement'
}

/** Input for uploading a support attachment. */
export type SupportAttachmentUploadUrlInput = {
  fileMimeType: Scalars['SupportAttachmentMimeType']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
};

/** Support email contact */
export type SupportEmailContact = {
  __typename?: 'SupportEmailContact';
  /** Email of the email contact */
  email: Scalars['String']['output'];
  /** Identifier of the email contact */
  id: Scalars['ID']['output'];
  /** Name of the email contact */
  name?: Maybe<Scalars['String']['output']>;
};

/** Union of all notification types */
export type SupportNotification = SupportNotificationMention | SupportNotificationReaction;

/** Connection type for notification pagination */
export type SupportNotificationConnection = {
  __typename?: 'SupportNotificationConnection';
  edges: Array<SupportNotificationEdge>;
  pageInfo: PageInfo;
};

/** Edge type for notification pagination */
export type SupportNotificationEdge = {
  __typename?: 'SupportNotificationEdge';
  cursor: Scalars['String']['output'];
  node: SupportNotification;
};

/** Notification triggered by a mention in a note */
export type SupportNotificationMention = {
  __typename?: 'SupportNotificationMention';
  /** Activity that triggered the notification */
  activity: SupportTicketActivity;
  /** Activity that triggered the notification */
  activityId: Scalars['ID']['output'];
  /** Date when the notification was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the notification */
  id: Scalars['ID']['output'];
  /** Date when the notification was read (null if unread) */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** Actor who received the notification */
  recipient: SupportActor;
  /** Actor who received the notification */
  recipientId: Scalars['ID']['output'];
  /** Actor who triggered the notification */
  sender: SupportActor;
  /** Actor who triggered the notification */
  senderId: Scalars['ID']['output'];
  /** Ticket associated with the activity */
  ticket: SupportTicket;
};

/** Notification triggered by a reaction on an activity */
export type SupportNotificationReaction = {
  __typename?: 'SupportNotificationReaction';
  /** Activity that triggered the notification */
  activity: SupportTicketActivity;
  /** Activity that triggered the notification */
  activityId: Scalars['ID']['output'];
  /** Date when the notification was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the notification */
  id: Scalars['ID']['output'];
  /** Type of reaction */
  reactionType: SupportTicketActivityReactionType;
  /** Date when the notification was read (null if unread) */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** Actor who received the notification */
  recipient: SupportActor;
  /** Actor who received the notification */
  recipientId: Scalars['ID']['output'];
  /** Actor who triggered the notification */
  sender: SupportActor;
  /** Actor who triggered the notification */
  senderId: Scalars['ID']['output'];
  /** Ticket associated with the activity */
  ticket: SupportTicket;
};

/** Notification type */
export enum SupportNotificationType {
  Mention = 'Mention',
  Reaction = 'Reaction'
}

export type SupportNotificationsFilterInput = {
  read?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupportNotificationsSortInput = {
  direction: SupportNotificationsSortableDirection;
  field: SupportNotificationsSortableFields;
};

export enum SupportNotificationsSortableDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SupportNotificationsSortableFields {
  CreatedAt = 'createdAt'
}

/** Support - Order flow */
export type SupportOrderFlow = SupportOrderFlowCommunicationAppUsers | SupportOrderFlowCreditCompensationSupplierCharged | SupportOrderFlowDeliveryDelay | SupportOrderFlowDeliveryDelayV2 | SupportOrderFlowOrderCancellation | SupportOrderFlowOrderOptimizationPackaging | SupportOrderFlowOther | SupportOrderFlowProductOutOfStock | SupportOrderFlowProductOutOfStockShopify | SupportOrderFlowProductWrongDescription;

/** Support - Order Flow - Cancel order reason */
export enum SupportOrderFlowCancelOrderReason {
  /** Delivery impossible in destination country */
  DeliveryImpossibleInDestinationCountry = 'DeliveryImpossibleInDestinationCountry',
  /** Supplier refuses to ship */
  SupplierRefusesToShip = 'SupplierRefusesToShip'
}

/** Support - Order flow - Communication App Users */
export type SupportOrderFlowCommunicationAppUsers = {
  __typename?: 'SupportOrderFlowCommunicationAppUsers';
  /** App user ids */
  appUserIds: Array<Scalars['ID']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorUser;
  /** Errors */
  errors: Array<SupportOrderFlowError>;
  /** Flow */
  flow: SupportOrderFlowType;
  /** Id */
  id: Scalars['ID']['output'];
  /** Status */
  status: SupportOrderFlowStatus;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support order flow connection */
export type SupportOrderFlowConnection = {
  __typename?: 'SupportOrderFlowConnection';
  /** Edges of the order flow connection */
  edges: Array<SupportOrderFlowEdge>;
  /** Page info of the order flow connection */
  pageInfo: PageInfo;
};

/** Support - Order flow - Credit compensation supplier charged */
export type SupportOrderFlowCreditCompensationSupplierCharged = {
  __typename?: 'SupportOrderFlowCreditCompensationSupplierCharged';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorUser;
  /** Errors */
  errors: Array<SupportOrderFlowError>;
  /** Filters */
  filters: SupportOrderFlowFiltersCreditCompensationSupplierCharged;
  /** Flow */
  flow: SupportOrderFlowType;
  /** Id */
  id: Scalars['ID']['output'];
  /** Order ids */
  orderIds: Array<Scalars['ID']['output']>;
  /** Status */
  status: SupportOrderFlowStatus;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support - Order flow - Delivery delay */
export type SupportOrderFlowDeliveryDelay = {
  __typename?: 'SupportOrderFlowDeliveryDelay';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorUser;
  /** Errors */
  errors: Array<SupportOrderFlowError>;
  /** Filters */
  filters: SupportOrderFlowFiltersDeliveryDelay;
  /** Flow */
  flow: SupportOrderFlowType;
  /** Id */
  id: Scalars['ID']['output'];
  /** Order ids */
  orderIds: Array<Scalars['ID']['output']>;
  /** Status */
  status: SupportOrderFlowStatus;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support - Order flow - Delivery delay V2 */
export type SupportOrderFlowDeliveryDelayV2 = {
  __typename?: 'SupportOrderFlowDeliveryDelayV2';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorUser;
  /** Errors */
  errors: Array<SupportOrderFlowError>;
  /** Filters */
  filters: SupportOrderFlowFiltersDeliveryDelayV2;
  /** Flow */
  flow: SupportOrderFlowType;
  /** Id */
  id: Scalars['ID']['output'];
  /** Order ids */
  orderIds: Array<Scalars['ID']['output']>;
  /** Status */
  status: SupportOrderFlowStatus;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support order flow edge */
export type SupportOrderFlowEdge = {
  __typename?: 'SupportOrderFlowEdge';
  /** Cursor of the order flow edge */
  cursor: Scalars['String']['output'];
  /** Node of the order flow edge */
  node: SupportOrderFlow;
};

/** Support - Order flow - Error */
export type SupportOrderFlowError = {
  __typename?: 'SupportOrderFlowError';
  /** Error code */
  errorCode: SupportOrderFlowErrorCode;
  /** Order id */
  orderId: Scalars['ID']['output'];
};

/** Support - Order flow - Error code */
export enum SupportOrderFlowErrorCode {
  /** App user not found */
  AppUserNotFound = 'AppUserNotFound',
  /** App user unknown */
  AppUserUnknown = 'AppUserUnknown',
  /** Order already canceled */
  OrderAlreadyCanceled = 'OrderAlreadyCanceled',
  /** Order fulfillment not unfulfilled */
  OrderFulfillmentNotUnfulfilled = 'OrderFulfillmentNotUnfulfilled',
  /** Order items not found */
  OrderItemsNotFound = 'OrderItemsNotFound',
  /** Order sale id mismatch */
  OrderSaleIdMismatch = 'OrderSaleIdMismatch',
  /** Order shipment not none pending info received */
  OrderShipmentNotNonePendingInfoReceived = 'OrderShipmentNotNonePendingInfoReceived',
  /** Order unknown */
  OrderUnknown = 'OrderUnknown'
}

/** Support - Order flow - Filters - Credit compensation supplier charged */
export type SupportOrderFlowFiltersCreditCompensationSupplierCharged = {
  __typename?: 'SupportOrderFlowFiltersCreditCompensationSupplierCharged';
  /** Sale */
  sale: Sale;
  /** Sale id */
  saleId: Scalars['ID']['output'];
};

/** Support - Order flow - Filters - Delivery delay */
export type SupportOrderFlowFiltersDeliveryDelay = {
  __typename?: 'SupportOrderFlowFiltersDeliveryDelay';
  /** Sale */
  sale: Sale;
  /** Sale id */
  saleId: Scalars['ID']['output'];
  /** Tagging */
  tagging: SupportOrderFlowFiltersDeliveryDelayTagging;
};

/** Support - Order flow - Filters - Delivery delay - Tagging */
export type SupportOrderFlowFiltersDeliveryDelayTagging = {
  __typename?: 'SupportOrderFlowFiltersDeliveryDelayTagging';
  /** Fulfillment */
  fulfillment: SupportOrderFlowFiltersDeliveryDelayTaggingFulfillment;
};

/** Support - Order flow - Filters - Delivery delay - Tagging - Fulfillment */
export enum SupportOrderFlowFiltersDeliveryDelayTaggingFulfillment {
  /** Unfulfilled */
  Unfulfilled = 'UNFULFILLED'
}

/** Support - Order flow - Filters - Delivery delay V2 */
export type SupportOrderFlowFiltersDeliveryDelayV2 = {
  __typename?: 'SupportOrderFlowFiltersDeliveryDelayV2';
  /** Sale */
  sale: Sale;
  /** Sale id */
  saleId: Scalars['ID']['output'];
  /** Tagging */
  tagging: SupportOrderFlowFiltersDeliveryDelayV2Tagging;
};

/** Support - Order flow - Filters - Delivery delay V2 - Tagging */
export type SupportOrderFlowFiltersDeliveryDelayV2Tagging = {
  __typename?: 'SupportOrderFlowFiltersDeliveryDelayV2Tagging';
  /** Shipment */
  shipment: Array<SupportOrderFlowFiltersDeliveryDelayV2TaggingShipment>;
};

/** Support - Order flow - Filters - Delivery delay V2 - Tagging - Shipment */
export enum SupportOrderFlowFiltersDeliveryDelayV2TaggingShipment {
  /** INFO_RECEIVED */
  InfoReceived = 'INFO_RECEIVED',
  /** NONE */
  None = 'NONE',
  /** PENDING */
  Pending = 'PENDING'
}

/** Support - Order flow - Filters - Order cancellation */
export type SupportOrderFlowFiltersOrderCancellation = {
  __typename?: 'SupportOrderFlowFiltersOrderCancellation';
  /** Sale */
  sale: Sale;
  /** Sale id */
  saleId: Scalars['ID']['output'];
};

/** Support - Order flow - Filters - Order optimization packaging */
export type SupportOrderFlowFiltersOrderOptimizationPackaging = {
  __typename?: 'SupportOrderFlowFiltersOrderOptimizationPackaging';
  /** Sale */
  sale: Sale;
  /** Sale id */
  saleId: Scalars['ID']['output'];
};

/** Support - Order flow - Filters - Other */
export type SupportOrderFlowFiltersOther = {
  __typename?: 'SupportOrderFlowFiltersOther';
  /** Sale */
  sale: Sale;
  /** Sale id */
  saleId: Scalars['ID']['output'];
};

/** Support - Order flow - Filters - Product out of stock */
export type SupportOrderFlowFiltersProductOutOfStock = {
  __typename?: 'SupportOrderFlowFiltersProductOutOfStock';
  /** Product references */
  productReferences: Array<Scalars['ID']['output']>;
  /** Sale */
  sale: Sale;
  /** Sale id */
  saleId: Scalars['ID']['output'];
};

/** Support - Order flow - Filters - Product out of stock Shopify */
export type SupportOrderFlowFiltersProductOutOfStockShopify = {
  __typename?: 'SupportOrderFlowFiltersProductOutOfStockShopify';
  /** Sale */
  sale: Sale;
  /** Sale id */
  saleId: Scalars['ID']['output'];
};

/** Support - Order flow - Filters - Product wrong description */
export type SupportOrderFlowFiltersProductWrongDescription = {
  __typename?: 'SupportOrderFlowFiltersProductWrongDescription';
  /** Product references */
  productReferences: Array<Scalars['ID']['output']>;
  /** Sale */
  sale: Sale;
  /** Sale id */
  saleId: Scalars['ID']['output'];
};

/** Support - Order flow - Order cancellation */
export type SupportOrderFlowOrderCancellation = {
  __typename?: 'SupportOrderFlowOrderCancellation';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorUser;
  /** Errors */
  errors: Array<SupportOrderFlowError>;
  /** Filters */
  filters: SupportOrderFlowFiltersOrderCancellation;
  /** Flow */
  flow: SupportOrderFlowType;
  /** Id */
  id: Scalars['ID']['output'];
  /** Order ids */
  orderIds: Array<Scalars['ID']['output']>;
  /** Status */
  status: SupportOrderFlowStatus;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support - Order flow - Order optimization packaging */
export type SupportOrderFlowOrderOptimizationPackaging = {
  __typename?: 'SupportOrderFlowOrderOptimizationPackaging';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorUser;
  /** Errors */
  errors: Array<SupportOrderFlowError>;
  /** Filters */
  filters: SupportOrderFlowFiltersOrderOptimizationPackaging;
  /** Flow */
  flow: SupportOrderFlowType;
  /** Id */
  id: Scalars['ID']['output'];
  /** Order ids */
  orderIds: Array<Scalars['ID']['output']>;
  /** Status */
  status: SupportOrderFlowStatus;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support - Order flow - Other */
export type SupportOrderFlowOther = {
  __typename?: 'SupportOrderFlowOther';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorUser;
  /** Errors */
  errors: Array<SupportOrderFlowError>;
  /** Filters */
  filters: SupportOrderFlowFiltersOther;
  /** Flow */
  flow: SupportOrderFlowType;
  /** Id */
  id: Scalars['ID']['output'];
  /** Order ids */
  orderIds: Array<Scalars['ID']['output']>;
  /** Status */
  status: SupportOrderFlowStatus;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support - Order flow - Product out of stock */
export type SupportOrderFlowProductOutOfStock = {
  __typename?: 'SupportOrderFlowProductOutOfStock';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorUser;
  /** Errors */
  errors: Array<SupportOrderFlowError>;
  /** Filters */
  filters: SupportOrderFlowFiltersProductOutOfStock;
  /** Flow */
  flow: SupportOrderFlowType;
  /** Id */
  id: Scalars['ID']['output'];
  /** Order ids */
  orderIds: Array<Scalars['ID']['output']>;
  /** Status */
  status: SupportOrderFlowStatus;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support - Order flow - Product out of stock Shopify */
export type SupportOrderFlowProductOutOfStockShopify = {
  __typename?: 'SupportOrderFlowProductOutOfStockShopify';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorUser;
  /** Errors */
  errors: Array<SupportOrderFlowError>;
  /** Filters */
  filters: SupportOrderFlowFiltersProductOutOfStockShopify;
  /** Flow */
  flow: SupportOrderFlowType;
  /** Id */
  id: Scalars['ID']['output'];
  /** Order ids */
  orderIds: Array<Scalars['ID']['output']>;
  /** Status */
  status: SupportOrderFlowStatus;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support - Order flow - Product wrong description */
export type SupportOrderFlowProductWrongDescription = {
  __typename?: 'SupportOrderFlowProductWrongDescription';
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: ActorUser;
  /** Errors */
  errors: Array<SupportOrderFlowError>;
  /** Filters */
  filters: SupportOrderFlowFiltersProductWrongDescription;
  /** Flow */
  flow: SupportOrderFlowType;
  /** Id */
  id: Scalars['ID']['output'];
  /** Order ids */
  orderIds: Array<Scalars['ID']['output']>;
  /** Status */
  status: SupportOrderFlowStatus;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Support - Order flow - Status */
export enum SupportOrderFlowStatus {
  /** Completed */
  Completed = 'Completed',
  /** In progress */
  InProgress = 'InProgress',
  /** Pending */
  Pending = 'Pending'
}

/** Support - Order flow - Type */
export enum SupportOrderFlowType {
  /** Communication to app users */
  CommunicationAppUsers = 'CommunicationAppUsers',
  /** Credit compensation supplier charged */
  CreditCompensationSupplierCharged = 'CreditCompensationSupplierCharged',
  /** Delivery delay */
  DeliveryDelay = 'DeliveryDelay',
  /** Delivery delay V2 */
  DeliveryDelayV2 = 'DeliveryDelayV2',
  /** Order cancellation */
  OrderCancellation = 'OrderCancellation',
  /** Order optimization packaging */
  OrderOptimizationPackaging = 'OrderOptimizationPackaging',
  /** Other */
  Other = 'Other',
  /** Product out of stock */
  ProductOutOfStock = 'ProductOutOfStock',
  /** Product out of stock Shopify */
  ProductOutOfStockShopify = 'ProductOutOfStockShopify',
  /** Product wrong description */
  ProductWrongDescription = 'ProductWrongDescription'
}

export enum SupportRole {
  Admin = 'ADMIN',
  Agent = 'AGENT',
  Emerch = 'EMERCH',
  Market = 'MARKET',
  OperatorManager = 'OPERATOR_MANAGER',
  SuperAdmin = 'SUPER_ADMIN',
  Viewer = 'VIEWER'
}

/** Filter for enum field: SupportRoles. */
export type SupportRoleFilterInput = {
  in?: InputMaybe<Array<SupportRole>>;
  notIn?: InputMaybe<Array<SupportRole>>;
};

/**
 * A support snippet.
 * A snippet is a template that can be used to generate a message.
 * It can be used in a ticket or a ticket reply.
 */
export type SupportSnippet = {
  __typename?: 'SupportSnippet';
  /** The date and time when the snippet was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor (e.g., user, bot) who created the snippet. */
  createdBy: ActorInternalUser;
  /** The date and time when the snippet was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The actor (e.g., user, bot) who deleted the snippet. */
  deletedBy?: Maybe<ActorInternalUser>;
  /** The unique identifier of the snippet. */
  id: Scalars['ID']['output'];
  /** The store of the snippet. */
  storeId: Store;
  /** The tag IDs associated with the snippet. */
  tagIds: Array<Scalars['ID']['output']>;
  /** The tags associated with the snippet. */
  tags: Array<SupportSnippetTag>;
  /** The templates of the snippet. */
  templates: Array<SupportSnippetTemplate>;
  /**
   * The title of the snippet.
   * It is used to identify the snippet in the UI.
   * It is not used for the snippet content.
   */
  title: Scalars['String']['output'];
  /** The date and time when the snippet was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection to a paginated list of snippets, containing edges and pagination info. */
export type SupportSnippetConnection = {
  __typename?: 'SupportSnippetConnection';
  /** A list of edges, each containing a snippet and its cursor. */
  edges: Array<SupportSnippetEdge>;
  /** Pagination information (whether there are more pages of snippets). */
  pageInfo: PageInfo;
};

/** Represents an edge in the paginated list of snippets, containing the snippet data and a cursor. */
export type SupportSnippetEdge = {
  __typename?: 'SupportSnippetEdge';
  /** A unique cursor identifying this snippet, used for pagination. */
  cursor: Scalars['String']['output'];
  /** The actual snippet data. */
  node: SupportSnippet;
};

/** A support snippet tag. */
export type SupportSnippetTag = {
  __typename?: 'SupportSnippetTag';
  /** The background color of the tag */
  backgroundColor: Scalars['String']['output'];
  /** The date and time when the tag was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actor (e.g., user, bot) who created the tag */
  createdBy: ActorInternalUser;
  /** The date and time when the tag was deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The actor (e.g., user, bot) who deleted the tag */
  deletedBy?: Maybe<ActorInternalUser>;
  /** A detailed description of the tag */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the tag */
  id: Scalars['ID']['output'];
  /** The main label of the tag */
  label: Scalars['String']['output'];
  /** The text color of the tag */
  textColor: Scalars['String']['output'];
  /** The date and time when the tag was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection to a paginated list of snippet tags, containing edges and pagination info. */
export type SupportSnippetTagConnection = {
  __typename?: 'SupportSnippetTagConnection';
  /** A list of edges, each containing a snippet tag and its cursor. */
  edges: Array<SupportSnippetTagEdge>;
  /** Pagination information (whether there are more pages of snippet tags). */
  pageInfo: PageInfo;
};

/** Represents an edge in the paginated list of snippet tags, containing the snippet tag data and a cursor. */
export type SupportSnippetTagEdge = {
  __typename?: 'SupportSnippetTagEdge';
  /** A unique cursor identifying this snippet tag, used for pagination. */
  cursor: Scalars['String']['output'];
  /** The actual snippet tag data. */
  node: SupportSnippetTag;
};

/** Filter object for querying support snippet tags with various criteria. */
export type SupportSnippetTagsFilterInput = {
  /** Filter by the date the snippet tag was created. */
  createdAt?: InputMaybe<DateRangeFilterInput>;
  /** Filter by the ID of the user who created the snippet tag. */
  createdById?: InputMaybe<IdFilterInput>;
  /** Filter by the date the snippet tag was deleted. */
  deletedAt?: InputMaybe<DateRangeFilterInput>;
  /** Filter by the ID of the user who deleted the snippet tag. */
  deletedById?: InputMaybe<IdFilterNullableInput>;
  /** Filter by snippet tag ID. */
  id?: InputMaybe<IdFilterInput>;
  /** Filter by the date the snippet tag was updated. */
  updatedAt?: InputMaybe<DateRangeFilterInput>;
};

/** Input for sorting snippet tags by specific fields. */
export type SupportSnippetTagsSortInput = {
  /** The sorting direction, either ASC for ascending or DESC for descending. */
  direction: SupportSnippetTagsSortableDirection;
  /** The field by which snippet tags should be sorted (e.g., createdAt, priority). */
  field: SupportSnippetTagsSortableFields;
};

export enum SupportSnippetTagsSortableDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SupportSnippetTagsSortableFields {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

/** A support snippet template. */
export type SupportSnippetTemplate = {
  __typename?: 'SupportSnippetTemplate';
  /** The date and time when the snippet template was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actor (e.g., user, bot) who created the snippet template */
  createdBy: ActorInternalUser;
  /** The unique identifier of the snippet template */
  id: Scalars['ID']['output'];
  /** The language of the snippet language. */
  language: LanguageIso6391;
  /** The snippet associated with the snippet template */
  snippet: SupportSnippet;
  /** The snippet id */
  snippetId: Scalars['ID']['output'];
  /** The template of the snippet in the language. */
  template: Scalars['String']['output'];
  /** The date and time when the snippet template was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type SupportSnippetTemplateInput = {
  /** The language of the snippet template. */
  language: LanguageIso6391;
  /** The template of the snippet in the language. */
  template: Scalars['String']['input'];
};

/** Filter object for querying support snippets with various criteria. */
export type SupportSnippetsFilterInput = {
  /** Filter by the date the snippet was created. */
  createdAt?: InputMaybe<DateRangeFilterInput>;
  /** Filter by the ID of the user who created the snippet. */
  createdById?: InputMaybe<IdFilterInput>;
  /** Filter by the date the snippet was deleted. */
  deletedAt?: InputMaybe<DateRangeFilterInput>;
  /** Filter by the ID of the user who deleted the snippet. */
  deletedById?: InputMaybe<IdFilterNullableInput>;
  /** Filter by snippet ID. */
  id?: InputMaybe<IdFilterInput>;
  /** Filter by snippet store id. */
  storeId?: InputMaybe<StoreFilterInput>;
  /** Filter by the date the snippet was updated. */
  updatedAt?: InputMaybe<DateRangeFilterInput>;
};

/** Input for sorting snippets by specific fields. */
export type SupportSnippetsSortInput = {
  /** The sorting direction, either ASC for ascending or DESC for descending. */
  direction: SupportSnippetsSortableDirection;
  /** The field by which snippets should be sorted (e.g., createdAt, updatedAt). */
  field: SupportSnippetsSortableFields;
};

export enum SupportSnippetsSortableDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SupportSnippetsSortableFields {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

/** A support ticket representing an issue or request submitted by a contact. */
export type SupportTicket = {
  __typename?: 'SupportTicket';
  /** Gets activities by cursor pagination with filters */
  activities: SupportTicketActivityConnection;
  /** Gets AI suggestions by cursor pagination with filters */
  aiSuggestions: SupportTicketAiSuggestionConnection;
  /** The date and time the ticket was assigned */
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user currently assigned to handle the ticket */
  assignedTo?: Maybe<ActorUser>;
  /** Attachments */
  attachments: Array<SupportAttachment>;
  /** The channel through which the ticket was submitted (e.g., email, chat) */
  channel: SupportTicketChannel;
  /** Claim ids */
  claimIds: Array<Scalars['ID']['output']>;
  /** claims */
  claims: Array<Claim>;
  /** The contact who submitted the ticket */
  contact: SupportActorContact;
  /** Whether the contact can reply to the ticket */
  contactCanReply: Scalars['Boolean']['output'];
  /** Whether the contact can submit the resolution survey */
  contactCanSubmitResolutionSurvey: Scalars['Boolean']['output'];
  /**
   * A structure containing all fields derived from the selected context (denormalized for performance).
   * These values are computed once at creation/update time and persisted for faster reads.
   */
  contextDerived?: Maybe<SupportTicketContextDerived>;
  /**
   * Identifier of the reference entity used as the base context.
   * Used in combination with `contextType` to resolve and persist derived fields.
   */
  contextRefId?: Maybe<Scalars['ID']['output']>;
  /**
   * Defines the type of context entity (e.g., ORDER, PRODUCT, SUPPLIER)
   * that the ticket refers to for deriving computed fields.
   */
  contextType?: Maybe<SupportTicketContextType>;
  /** Timestamp when the ticket was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actor (e.g., user, bot) who created the ticket */
  createdBy: SupportActor;
  /** A detailed description of the issue or request */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the ticket has an opened claim */
  hasOpenedClaim: Scalars['Boolean']['output'];
  /** Whether the ticket has pending schedule actions */
  hasPendingScheduleActions: Scalars['Boolean']['output'];
  /** The unique identifier of the ticket */
  id: Scalars['ID']['output'];
  /** Initial request activity of the ticket */
  initialRequest?: Maybe<SupportTicketActivityInitialRequest>;
  /** Whether the ticket is a draft */
  isDraft: Scalars['Boolean']['output'];
  /** Whether the ticket has been read by the contact */
  isReadByContact: Scalars['Boolean']['output'];
  /** The order flow from which the ticket was issued */
  orderFlow?: Maybe<SupportOrderFlow>;
  /** The order flow identifier from which the ticket was issued */
  orderFlowId?: Maybe<Scalars['ID']['output']>;
  /** Short preview text summarizing the content */
  previewText?: Maybe<Scalars['String']['output']>;
  /** Gets schedule actions by cursor pagination with filters */
  scheduleActions: SupportTicketScheduleActionConnection;
  /** The current status of the ticket (e.g., TODO, SNOOZED, DONE) */
  status: SupportTicketStatus;
  /** The date and time when the status was last updated */
  statusUpdatedAt: Scalars['DateTime']['output'];
  /** The sub-status of the ticket, providing more detailed progress tracking */
  subStatus: SupportTicketSubStatus;
  /** The main title or subject of the ticket */
  title: Scalars['String']['output'];
  /** Timestamp of the most recent update to the ticket */
  updatedAt: Scalars['DateTime']['output'];
};


/** A support ticket representing an issue or request submitted by a contact. */
export type SupportTicketActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportTicketActivitiesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportTicketActivitiesSortInput>;
};


/** A support ticket representing an issue or request submitted by a contact. */
export type SupportTicketAiSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportTicketAiSuggestionsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportTicketAiSuggestionsSortInput>;
};


/** A support ticket representing an issue or request submitted by a contact. */
export type SupportTicketScheduleActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportTicketScheduleActionsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportTicketScheduleActionsSortInput>;
};

/** Filter object for querying support tickets with various criteria. */
export type SupportTicketActivitiesFilterInput = {
  /** Filter by activity ID. */
  id?: InputMaybe<IdFilterInput>;
  /** Filter by ticket ID. */
  ticketId?: InputMaybe<IdFilterInput>;
  /** Filter by activity type. */
  type?: InputMaybe<SupportTicketActivityTypeFilterInput>;
};

/** Input for sorting activities by specific fields. */
export type SupportTicketActivitiesSortInput = {
  /** The sorting direction, either ASC for ascending or DESC for descending. */
  direction: SupportTicketActivitiesSortableDirection;
  /** The field by which activities should be sorted (e.g., createdAt, priority). */
  field: SupportTicketActivitiesSortableFields;
};

export enum SupportTicketActivitiesSortableDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SupportTicketActivitiesSortableFields {
  CreatedAt = 'createdAt'
}

/** Union of all possible support ticket activities */
export type SupportTicketActivity = SupportTicketActivityAiSuggestion | SupportTicketActivityAiSuggestionSetup | SupportTicketActivityAiSuggestionStatus | SupportTicketActivityAssignment | SupportTicketActivityClosureDuplicate | SupportTicketActivityClosureJunk | SupportTicketActivityClosureUnresolvable | SupportTicketActivityContext | SupportTicketActivityContextDerived | SupportTicketActivityEmail | SupportTicketActivityInitialRequestMigration | SupportTicketActivityInitialRequestOrder | SupportTicketActivityInitialRequestOther | SupportTicketActivityInitialRequestSale | SupportTicketActivityInitialRequestVariant | SupportTicketActivityMessage | SupportTicketActivityNote | SupportTicketActivityPublish | SupportTicketActivityResolutionSurvey | SupportTicketActivityScheduleAction | SupportTicketActivityScheduleActionSetup | SupportTicketActivityScheduleActionStatus | SupportTicketActivityStatus | SupportTicketActivityTitle;

/** Support ticket activity AI suggestion (when an AI suggestion is created) */
export type SupportTicketActivityAiSuggestion = {
  __typename?: 'SupportTicketActivityAiSuggestion';
  /** Actor who performed the activity AI suggestion */
  actor: SupportActor;
  /** Actor identifier who performed the activity AI suggestion */
  actorId: Scalars['ID']['output'];
  /** AI suggestion */
  aiSuggestion: SupportTicketAiSuggestion;
  /** AI suggestion identifier */
  aiSuggestionId: Scalars['ID']['output'];
  /** AI suggestion payload */
  aiSuggestionPayload: SupportTicketAiSuggestionPayload;
  /** AI suggestion reasoning */
  aiSuggestionReasoning: Scalars['String']['output'];
  /** AI suggestion reasoning summary */
  aiSuggestionReasoningSummary: Scalars['String']['output'];
  /** AI suggestion status */
  aiSuggestionStatus: SupportTicketAiSuggestionStatus;
  /** AI suggestion trace identifier */
  aiSuggestionTraceId: Scalars['String']['output'];
  /** AI suggestion type */
  aiSuggestionType: SupportTicketAiSuggestionType;
  /** Identifier of the activity AI suggestion */
  id: Scalars['ID']['output'];
  /** Date and time when the activity AI suggestion occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support ticket activity AI suggestion setup (when an AI suggestion payload is updated) */
export type SupportTicketActivityAiSuggestionSetup = {
  __typename?: 'SupportTicketActivityAiSuggestionSetup';
  /** Actor who performed the activity AI suggestion setup */
  actor: SupportActor;
  /** Actor identifier who performed the activity AI suggestion setup */
  actorId: Scalars['ID']['output'];
  /** AI suggestion */
  aiSuggestion: SupportTicketAiSuggestion;
  /** AI suggestion edit reason */
  aiSuggestionEditReason: SupportTicketAiSuggestionEditReason;
  /** AI suggestion identifier */
  aiSuggestionId: Scalars['ID']['output'];
  /** AI suggestion type */
  aiSuggestionType: SupportTicketAiSuggestionType;
  /** Identifier of the activity AI suggestion setup */
  id: Scalars['ID']['output'];
  /** Next AI suggestion payload */
  nextAiSuggestionPayload: SupportTicketAiSuggestionPayload;
  /** Date and time when the activity AI suggestion setup occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Previous AI suggestion payload */
  previousAiSuggestionPayload: SupportTicketAiSuggestionPayload;
};

/** Support ticket activity AI suggestion status (when an AI suggestion status is updated) */
export type SupportTicketActivityAiSuggestionStatus = {
  __typename?: 'SupportTicketActivityAiSuggestionStatus';
  /** Actor who performed the activity AI suggestion status */
  actor: SupportActor;
  /** Actor identifier who performed the activity AI suggestion status */
  actorId: Scalars['ID']['output'];
  /** AI suggestion */
  aiSuggestion: SupportTicketAiSuggestion;
  /** AI suggestion identifier */
  aiSuggestionId: Scalars['ID']['output'];
  /** AI suggestion type */
  aiSuggestionType: SupportTicketAiSuggestionType;
  /** Identifier of the activity AI suggestion status */
  id: Scalars['ID']['output'];
  /** Next AI suggestion status */
  nextAiSuggestionStatus: SupportTicketAiSuggestionStatus;
  /** Date and time when the activity AI suggestion status occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Previous AI suggestion status */
  previousAiSuggestionStatus: SupportTicketAiSuggestionStatus;
};

/** Support ticket activity assignment (when a new assignee is set on a ticket) */
export type SupportTicketActivityAssignment = {
  __typename?: 'SupportTicketActivityAssignment';
  /** Actor who performed the activity assignment */
  actor: SupportActor;
  /** Actor identifier who performed the activity assignment */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity assignment */
  id: Scalars['ID']['output'];
  /** New assignee set on the ticket (`null` if the assignee has been unset) */
  newAssignee?: Maybe<ActorUser>;
  /** New assignee identifier set on the ticket (`null` if the assignee identifier has been unset) */
  newAssigneeId?: Maybe<Scalars['ID']['output']>;
  /** Date and time when the activity assignment occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support ticket activity closure (when a ticket is closed for a specific reason) */
export type SupportTicketActivityClosure = SupportTicketActivityClosureDuplicate | SupportTicketActivityClosureJunk | SupportTicketActivityClosureUnresolvable;

/** Support ticket activity closure as duplicate (ticket is a duplicate of another ticket) */
export type SupportTicketActivityClosureDuplicate = {
  __typename?: 'SupportTicketActivityClosureDuplicate';
  /** Actor who performed the activity closure */
  actor: SupportActor;
  /** Actor identifier who performed the activity closure */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity closure */
  id: Scalars['ID']['output'];
  /** Date and time when the activity closure occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support ticket activity closure as junk (e.g. marketing email) */
export type SupportTicketActivityClosureJunk = {
  __typename?: 'SupportTicketActivityClosureJunk';
  /** Actor who performed the activity closure */
  actor: SupportActor;
  /** Actor identifier who performed the activity closure */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity closure */
  id: Scalars['ID']['output'];
  /** Date and time when the activity closure occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support ticket activity closure as unresolvable (e.g. ongoing conflict with the customer) */
export type SupportTicketActivityClosureUnresolvable = {
  __typename?: 'SupportTicketActivityClosureUnresolvable';
  /** Actor who performed the activity closure */
  actor: SupportActor;
  /** Actor identifier who performed the activity closure */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity closure */
  id: Scalars['ID']['output'];
  /** Date and time when the activity closure occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support ticket activity connection */
export type SupportTicketActivityConnection = {
  __typename?: 'SupportTicketActivityConnection';
  /** Edges of the activity connection */
  edges: Array<SupportTicketActivityEdge>;
  /** Page info of the activity connection */
  pageInfo: PageInfo;
};

/** Support ticket activity context (when a new context is set on a ticket) */
export type SupportTicketActivityContext = {
  __typename?: 'SupportTicketActivityContext';
  /** Actor who performed the activity context */
  actor: SupportActor;
  /** Actor identifier who performed the activity context */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity context */
  id: Scalars['ID']['output'];
  /** New context ref id set on the ticket */
  newContextRefId?: Maybe<Scalars['ID']['output']>;
  /** New context type set on the ticket */
  newContextType?: Maybe<SupportTicketContextType>;
  /** Date and time when the activity context occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support ticket activity context derived (when a new context derived is set on a ticket) */
export type SupportTicketActivityContextDerived = {
  __typename?: 'SupportTicketActivityContextDerived';
  /** Actor who performed the activity context derived */
  actor: SupportActor;
  /** Actor identifier who performed the activity context derived */
  actorId: Scalars['ID']['output'];
  /** Context derived key updated on the ticket */
  contextDerivedKey: SupportTicketContextDerivedKey;
  /** Identifier of the activity context derived */
  id: Scalars['ID']['output'];
  /** New context derived value set on the ticket */
  newContextDerivedValue?: Maybe<Scalars['ID']['output']>;
  /** Date and time when the activity context derived occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support ticket activity edge */
export type SupportTicketActivityEdge = {
  __typename?: 'SupportTicketActivityEdge';
  /** Cursor of the activity edge */
  cursor: Scalars['String']['output'];
  /** Node of the activity edge */
  node: SupportTicketActivity;
};

/** Support ticket activity email (when an email is added to a ticket) */
export type SupportTicketActivityEmail = {
  __typename?: 'SupportTicketActivityEmail';
  /** Actor who performed the activity email */
  actor: SupportActor;
  /** Actor identifier who performed the activity email */
  actorId: Scalars['ID']['output'];
  /** AI suggestion that added the email to the ticket (null if the email was added manually) */
  aiSuggestion?: Maybe<SupportTicketAiSuggestion>;
  /** Identifier of the AI suggestion that added the email to the ticket (null if the email was added manually) */
  aiSuggestionId?: Maybe<Scalars['ID']['output']>;
  /** Attachments of the email added to the ticket */
  attachments: Array<SupportAttachment>;
  /** BCC emails of the email added to the ticket */
  bcc: Scalars['String']['output'];
  /** CC emails of the email added to the ticket */
  cc: Scalars['String']['output'];
  /** HTML content of the email added to the ticket */
  contentHtml: Scalars['String']['output'];
  /** Text content of the email added to the ticket */
  contentText: Scalars['String']['output'];
  /** From email of the email added to the ticket */
  from: Scalars['String']['output'];
  /** Identifier of the activity email */
  id: Scalars['ID']['output'];
  /** Message ID of the email added to the ticket */
  messageId: Scalars['String']['output'];
  /** Date and time when the activity email occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** References of the email added to the ticket */
  references: Array<Scalars['String']['output']>;
  /** Reply to of the email added to the ticket */
  replyTo: Scalars['String']['output'];
  /** Planned action that added the email to the ticket (null if the email was added manually) */
  scheduleAction?: Maybe<SupportTicketScheduleAction>;
  /** Identifier of the planned action that added the email to the ticket (null if the email was added manually) */
  scheduleActionId?: Maybe<Scalars['ID']['output']>;
  /** Subject of the email added to the ticket */
  subject: Scalars['String']['output'];
  /** To emails of the email added to the ticket */
  to: Scalars['String']['output'];
};

export type SupportTicketActivityInitialRequest = SupportTicketActivityInitialRequestMigration | SupportTicketActivityInitialRequestOrder | SupportTicketActivityInitialRequestOther | SupportTicketActivityInitialRequestSale | SupportTicketActivityInitialRequestVariant;

/** AI classification of the initial request message against the candidate flows */
export type SupportTicketActivityInitialRequestAiClassification = {
  __typename?: 'SupportTicketActivityInitialRequestAiClassification';
  /** How confident the classifier is in flowSuggested, between 0 and 1 */
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Flow the classifier picked, null when it answered that none matches or when it did not answer */
  flowSuggested?: Maybe<SupportTicketActivityInitialRequestFlow>;
  id: Scalars['ID']['output'];
  status: SupportTicketActivityInitialRequestAiClassificationStatus;
};

/** Status of the AI classification of an initial request */
export enum SupportTicketActivityInitialRequestAiClassificationStatus {
  Done = 'Done',
  Error = 'Error',
  InProgress = 'InProgress',
  Pending = 'Pending'
}

/** Flow used to submit the initial request */
export enum SupportTicketActivityInitialRequestFlow {
  MigrationV1 = 'MigrationV1',
  OrderCancelationV1 = 'OrderCancelationV1',
  OrderDelayedV1 = 'OrderDelayedV1',
  OrderDeliveredButItemsDamagedV1 = 'OrderDeliveredButItemsDamagedV1',
  OrderDeliveredButItemsMissingV1 = 'OrderDeliveredButItemsMissingV1',
  OrderDeliveredButItemsNotWorkingAnymoreV1 = 'OrderDeliveredButItemsNotWorkingAnymoreV1',
  OrderDeliveredButItemsSizeIssueV1 = 'OrderDeliveredButItemsSizeIssueV1',
  OrderDeliveredButItemsVouchersNotWorkingV1 = 'OrderDeliveredButItemsVouchersNotWorkingV1',
  OrderDeliveredButItemsWrongV1 = 'OrderDeliveredButItemsWrongV1',
  OrderInvoiceIssueV1 = 'OrderInvoiceIssueV1',
  OrderOtherIssueV1 = 'OrderOtherIssueV1',
  OrderPaymentMethodWrongV1 = 'OrderPaymentMethodWrongV1',
  OrderPickupPointIssueV1 = 'OrderPickupPointIssueV1',
  OrderPromoCodeNotSetV1 = 'OrderPromoCodeNotSetV1',
  OrderRefundIncompleteV1 = 'OrderRefundIncompleteV1',
  OrderRefundNotReceivedV1 = 'OrderRefundNotReceivedV1',
  OrderReturnInfoV1 = 'OrderReturnInfoV1',
  OrderReturnInternationalV1 = 'OrderReturnInternationalV1',
  OrderReturnNotAvailableInfoV1 = 'OrderReturnNotAvailableInfoV1',
  OrderReturnNotEligibleInfoV1 = 'OrderReturnNotEligibleInfoV1',
  OrderReturnedToSenderV1 = 'OrderReturnedToSenderV1',
  OrderShippingAddressWrongV1 = 'OrderShippingAddressWrongV1',
  OrderTrackingBlockedV1 = 'OrderTrackingBlockedV1',
  OrderTrackingDeliveredButNotReceivedV1 = 'OrderTrackingDeliveredButNotReceivedV1',
  OtherAccountV1 = 'OtherAccountV1',
  OtherAfterSalePolicyV1 = 'OtherAfterSalePolicyV1',
  OtherBugV1 = 'OtherBugV1',
  OtherCheckoutV1 = 'OtherCheckoutV1',
  OtherReferralV1 = 'OtherReferralV1',
  OtherRequestV1 = 'OtherRequestV1',
  OtherSaleV1 = 'OtherSaleV1',
  SaleInfoV1 = 'SaleInfoV1',
  VariantInfoV1 = 'VariantInfoV1'
}

/** Output type for initial request flow filter. */
export type SupportTicketActivityInitialRequestFlowFilter = {
  __typename?: 'SupportTicketActivityInitialRequestFlowFilter';
  in?: Maybe<Array<SupportTicketActivityInitialRequestFlow>>;
  notIn?: Maybe<Array<SupportTicketActivityInitialRequestFlow>>;
};

/** Filter for initial request flow filter. */
export type SupportTicketActivityInitialRequestFlowFilterInput = {
  in?: InputMaybe<Array<SupportTicketActivityInitialRequestFlow>>;
  notIn?: InputMaybe<Array<SupportTicketActivityInitialRequestFlow>>;
};

/**
 * Verdict on the flow an initial request belongs to, given by an agent or by the bot that settled an
 * unambiguous request. Independent of the AI classification, which may have failed or never run
 */
export type SupportTicketActivityInitialRequestFlowReview = {
  __typename?: 'SupportTicketActivityInitialRequestFlowReview';
  /** Date the flow was reviewed at */
  reviewedAt: Scalars['DateTime']['output'];
  /** Agent who reviewed the flow, or the bot that settled an unambiguous request */
  reviewedBy: ActorStaffUser;
  /** Flow the request really belongs to */
  reviewedFlow: SupportTicketActivityInitialRequestFlow;
};

/** Support ticket activity initial request migration */
export type SupportTicketActivityInitialRequestMigration = {
  __typename?: 'SupportTicketActivityInitialRequestMigration';
  /** Actor who performed the initial request */
  actor: SupportActor;
  /** Actor id who performed the initial request */
  actorId: Scalars['ID']['output'];
  /** AI classification of the initial request message, null when it was never classified */
  aiClassification?: Maybe<SupportTicketActivityInitialRequestAiClassification>;
  /** Content to explain the issue */
  content: Scalars['String']['output'];
  /** Flow used to submit the issue */
  flow: SupportTicketActivityInitialRequestMigrationFlow;
  /** Verdict on the flow the request belongs to, null while nobody settled it */
  flowReview?: Maybe<SupportTicketActivityInitialRequestFlowReview>;
  /** Flow title */
  flowTitle: Scalars['String']['output'];
  /** Id of the initial request */
  id: Scalars['ID']['output'];
  /** Date and time when the initial request occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Flow used to submit the initial request migration */
export enum SupportTicketActivityInitialRequestMigrationFlow {
  /** Migration v1 */
  MigrationV1 = 'MigrationV1'
}

/** Support ticket activity initial request order */
export type SupportTicketActivityInitialRequestOrder = {
  __typename?: 'SupportTicketActivityInitialRequestOrder';
  /** Actor who performed the initial request */
  actor: SupportActor;
  /** Actor id who performed the initial request */
  actorId: Scalars['ID']['output'];
  /** AI classification of the initial request message, null when it was never classified */
  aiClassification?: Maybe<SupportTicketActivityInitialRequestAiClassification>;
  /** Whether the refund is applied with withheld or not */
  applyWithheld?: Maybe<Scalars['Boolean']['output']>;
  /** Content to explain the issue */
  content: Scalars['String']['output'];
  /** Flow used to submit the issue */
  flow: SupportTicketActivityInitialRequestOrderFlow;
  /** Verdict on the flow the request belongs to, null while nobody settled it */
  flowReview?: Maybe<SupportTicketActivityInitialRequestFlowReview>;
  /** Flow title */
  flowTitle: Scalars['String']['output'];
  /** Id of the initial request */
  id: Scalars['ID']['output'];
  /** Items ids concerned */
  itemIds: Array<Scalars['ID']['output']>;
  /** Items concerned */
  items: Array<Item>;
  /** Date and time when the initial request occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Order concerned */
  order: Order;
  /** Order id concerned */
  orderId: Scalars['ID']['output'];
  /** Preferred refund method */
  preferredRefundMethod?: Maybe<PreferredRefundMethod>;
  /** Preferred solution */
  preferredSolution?: Maybe<SupportTicketActivityInitialRequestOrderPreferredSolution>;
  /** Promo code */
  promoCode?: Maybe<Scalars['String']['output']>;
  /** Proofs attached */
  proofs: Array<SupportAttachment>;
  /** Return lines */
  returnLines: Array<SupportTicketActivityInitialRequestOrderReturnLine>;
  /** Shipping address */
  shippingAddress?: Maybe<ShippingAddress>;
  /** Shipping address formatted */
  shippingAddressFormatted: Array<Scalars['String']['output']>;
  /** Sworn statements attached */
  swornStatements: Array<SupportAttachment>;
};

/** Flow used to submit the initial request order */
export enum SupportTicketActivityInitialRequestOrderFlow {
  /** Order cancelation v1 */
  OrderCancelationV1 = 'OrderCancelationV1',
  /** Order delayed v1 */
  OrderDelayedV1 = 'OrderDelayedV1',
  /** Order delivered but items damaged v1 */
  OrderDeliveredButItemsDamagedV1 = 'OrderDeliveredButItemsDamagedV1',
  /** Order delivered but items missing v1 */
  OrderDeliveredButItemsMissingV1 = 'OrderDeliveredButItemsMissingV1',
  /** Order delivered but items not working anymore v1 */
  OrderDeliveredButItemsNotWorkingAnymoreV1 = 'OrderDeliveredButItemsNotWorkingAnymoreV1',
  /** Order delivered but items size issue v1 */
  OrderDeliveredButItemsSizeIssueV1 = 'OrderDeliveredButItemsSizeIssueV1',
  /** Order delivered but items vouchers not working v1 */
  OrderDeliveredButItemsVouchersNotWorkingV1 = 'OrderDeliveredButItemsVouchersNotWorkingV1',
  /** Order delivered but items wrong v1 */
  OrderDeliveredButItemsWrongV1 = 'OrderDeliveredButItemsWrongV1',
  /** Order invoice issue v1 */
  OrderInvoiceIssueV1 = 'OrderInvoiceIssueV1',
  /** Order other issue v1 */
  OrderOtherIssueV1 = 'OrderOtherIssueV1',
  /** Order payment method wrong v1 */
  OrderPaymentMethodWrongV1 = 'OrderPaymentMethodWrongV1',
  /** Order pickup point issue v1 */
  OrderPickupPointIssueV1 = 'OrderPickupPointIssueV1',
  /** Order promo code not set v1 */
  OrderPromoCodeNotSetV1 = 'OrderPromoCodeNotSetV1',
  /** Order refund incomplete v1 */
  OrderRefundIncompleteV1 = 'OrderRefundIncompleteV1',
  /** Order refund not received v1 */
  OrderRefundNotReceivedV1 = 'OrderRefundNotReceivedV1',
  /** Order return info v1 */
  OrderReturnInfoV1 = 'OrderReturnInfoV1',
  /** Order return international v1 */
  OrderReturnInternationalV1 = 'OrderReturnInternationalV1',
  /** Order return not available info v1 */
  OrderReturnNotAvailableInfoV1 = 'OrderReturnNotAvailableInfoV1',
  /** Order return not eligible info v1 */
  OrderReturnNotEligibleInfoV1 = 'OrderReturnNotEligibleInfoV1',
  /** Order returned to sender v1 */
  OrderReturnedToSenderV1 = 'OrderReturnedToSenderV1',
  /** Order shipping address wrong v1 */
  OrderShippingAddressWrongV1 = 'OrderShippingAddressWrongV1',
  /** Order tracking blocked v1 */
  OrderTrackingBlockedV1 = 'OrderTrackingBlockedV1',
  /** Order tracking delivered but not received v1 */
  OrderTrackingDeliveredButNotReceivedV1 = 'OrderTrackingDeliveredButNotReceivedV1'
}

/** Support ticket activity initial request order preferred solution */
export enum SupportTicketActivityInitialRequestOrderPreferredSolution {
  /** No preference */
  NoPreference = 'NoPreference',
  /** Refund */
  Refund = 'Refund',
  /** Reship */
  Reship = 'Reship'
}

/** Support ticket activity initial request order return line */
export type SupportTicketActivityInitialRequestOrderReturnLine = {
  __typename?: 'SupportTicketActivityInitialRequestOrderReturnLine';
  /** Item id */
  itemId: Scalars['ID']['output'];
  /** Reason */
  reason: ReturnLineReason;
  /** Sub reason */
  subReason?: Maybe<ReturnLineSubReason>;
};

/** Support ticket activity initial request order return line input */
export type SupportTicketActivityInitialRequestOrderReturnLineInput = {
  /** Item id */
  itemId: Scalars['ID']['input'];
  /** Reason */
  reason: ItemReturnReasonCode;
  /** Sub reason */
  subReason?: InputMaybe<ItemReturnSubReasonCode>;
};

/** Support ticket activity initial request other */
export type SupportTicketActivityInitialRequestOther = {
  __typename?: 'SupportTicketActivityInitialRequestOther';
  /** Actor who performed the initial request */
  actor: SupportActor;
  /** Actor id who performed the initial request */
  actorId: Scalars['ID']['output'];
  /** AI classification of the initial request message, null when it was never classified */
  aiClassification?: Maybe<SupportTicketActivityInitialRequestAiClassification>;
  /** Attachments attached */
  attachments: Array<SupportAttachment>;
  /** Content to explain the issue */
  content: Scalars['String']['output'];
  /** Flow used to submit the issue */
  flow: SupportTicketActivityInitialRequestOtherFlow;
  /** Verdict on the flow the request belongs to, null while nobody settled it */
  flowReview?: Maybe<SupportTicketActivityInitialRequestFlowReview>;
  /** Flow title */
  flowTitle: Scalars['String']['output'];
  /** Id of the initial request */
  id: Scalars['ID']['output'];
  /** Date and time when the initial request occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Flow used to submit the initial request other */
export enum SupportTicketActivityInitialRequestOtherFlow {
  /** Other account v1 */
  OtherAccountV1 = 'OtherAccountV1',
  /** Other after sale policy v1 */
  OtherAfterSalePolicyV1 = 'OtherAfterSalePolicyV1',
  /** Other bug v1 */
  OtherBugV1 = 'OtherBugV1',
  /** Other checkout v1 */
  OtherCheckoutV1 = 'OtherCheckoutV1',
  /** Other referral v1 */
  OtherReferralV1 = 'OtherReferralV1',
  /** Other request v1 */
  OtherRequestV1 = 'OtherRequestV1',
  /** Other sale v1 */
  OtherSaleV1 = 'OtherSaleV1'
}

/** Support ticket activity initial request sale */
export type SupportTicketActivityInitialRequestSale = {
  __typename?: 'SupportTicketActivityInitialRequestSale';
  /** Actor who performed the initial request */
  actor: SupportActor;
  /** Actor id who performed the initial request */
  actorId: Scalars['ID']['output'];
  /** AI classification of the initial request message, null when it was never classified */
  aiClassification?: Maybe<SupportTicketActivityInitialRequestAiClassification>;
  /** Content to explain the issue */
  content: Scalars['String']['output'];
  /** Flow used to submit the issue */
  flow: SupportTicketActivityInitialRequestSaleFlow;
  /** Verdict on the flow the request belongs to, null while nobody settled it */
  flowReview?: Maybe<SupportTicketActivityInitialRequestFlowReview>;
  /** Flow title */
  flowTitle: Scalars['String']['output'];
  /** Id of the initial request */
  id: Scalars['ID']['output'];
  /** Date and time when the initial request occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Sale concerned */
  sale: Sale;
  /** Sale id concerned */
  saleId: Scalars['ID']['output'];
};

/** Flow used to submit the initial request sale */
export enum SupportTicketActivityInitialRequestSaleFlow {
  /** Sale info v1 */
  SaleInfoV1 = 'SaleInfoV1'
}

/** Support ticket activity initial request variant */
export type SupportTicketActivityInitialRequestVariant = {
  __typename?: 'SupportTicketActivityInitialRequestVariant';
  /** Actor who performed the initial request */
  actor: SupportActor;
  /** Actor id who performed the initial request */
  actorId: Scalars['ID']['output'];
  /** AI classification of the initial request message, null when it was never classified */
  aiClassification?: Maybe<SupportTicketActivityInitialRequestAiClassification>;
  /** Content to explain the issue */
  content: Scalars['String']['output'];
  /** Flow used to submit the issue */
  flow: SupportTicketActivityInitialRequestVariantFlow;
  /** Verdict on the flow the request belongs to, null while nobody settled it */
  flowReview?: Maybe<SupportTicketActivityInitialRequestFlowReview>;
  /** Flow title */
  flowTitle: Scalars['String']['output'];
  /** Id of the initial request */
  id: Scalars['ID']['output'];
  /** Date and time when the initial request occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Variant concerned */
  variant: Variant;
  /** Variant id concerned */
  variantId: Scalars['ID']['output'];
};

/** Flow used to submit the initial request variant */
export enum SupportTicketActivityInitialRequestVariantFlow {
  /** Variant info v1 */
  VariantInfoV1 = 'VariantInfoV1'
}

/** Support ticket activity message (when a message is added to a ticket) */
export type SupportTicketActivityMessage = {
  __typename?: 'SupportTicketActivityMessage';
  /** Actor who performed the activity message */
  actor: SupportActorLegacy;
  /** Actor identifier who performed the activity message */
  actorId: Scalars['ID']['output'];
  /** AI suggestion that added the message to the ticket (null if the message was added manually) */
  aiSuggestion?: Maybe<SupportTicketAiSuggestion>;
  /** Identifier of the AI suggestion that added the message to the ticket (null if the message was added manually) */
  aiSuggestionId?: Maybe<Scalars['ID']['output']>;
  /** Attachments of the message added to the ticket */
  attachments: Array<SupportAttachment>;
  /** Content of the message added to the ticket */
  content: Scalars['String']['output'];
  /** Identifier of the activity message */
  id: Scalars['ID']['output'];
  /** Date and time when the activity message occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Planned action that added the message to the ticket (null if the message was added manually) */
  scheduleAction?: Maybe<SupportTicketScheduleAction>;
  /** Identifier of the planned action that added the message to the ticket (null if the message was added manually) */
  scheduleActionId?: Maybe<Scalars['ID']['output']>;
};

/** Support ticket activity note (when a note is added to a ticket) */
export type SupportTicketActivityNote = {
  __typename?: 'SupportTicketActivityNote';
  /** Actor who performed the activity note */
  actor: SupportActor;
  /** Actor identifier who performed the activity note */
  actorId: Scalars['ID']['output'];
  /** Attachments of the note added to the ticket */
  attachments: Array<SupportAttachment>;
  /** Content of the note added to the ticket */
  content: Scalars['String']['output'];
  /** Identifier of the activity note */
  id: Scalars['ID']['output'];
  /** Date and time when the activity note occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Reactions on this note */
  reactions: Array<SupportTicketActivityReaction>;
  /** Planned action that added the note to the ticket (null if the note was added manually) */
  scheduleAction?: Maybe<SupportTicketScheduleAction>;
  /** Identifier of the planned action that added the note to the ticket (null if the note was added manually) */
  scheduleActionId?: Maybe<Scalars['ID']['output']>;
};

/** Support ticket activity publish (when a ticket is published) */
export type SupportTicketActivityPublish = {
  __typename?: 'SupportTicketActivityPublish';
  /** Actor who performed the activity publish */
  actor: SupportActor;
  /** Actor identifier who performed the activity publish */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity publish */
  id: Scalars['ID']['output'];
  /** Date and time when the activity publish occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** A reaction on a support ticket activity */
export type SupportTicketActivityReaction = {
  __typename?: 'SupportTicketActivityReaction';
  /** Actor who reacted */
  actor: SupportActor;
  /** Actor identifier who reacted */
  actorId: Scalars['ID']['output'];
  /** Date when the reaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the reaction */
  id: Scalars['ID']['output'];
  /** Type of the reaction */
  type: SupportTicketActivityReactionType;
};

/** Reaction type for notifications (forward-declared for Phase 2) */
export enum SupportTicketActivityReactionType {
  Done = 'Done',
  Loading = 'Loading',
  No = 'No',
  Perfect = 'Perfect'
}

/** Support ticket activity resolution survey */
export type SupportTicketActivityResolutionSurvey = {
  __typename?: 'SupportTicketActivityResolutionSurvey';
  /** Actor who performed the activity resolution survey */
  actor: SupportActorLegacy;
  /** Actor identifier who performed the activity resolution survey */
  actorId: Scalars['ID']['output'];
  /** Content of the activity resolution survey */
  content: Scalars['String']['output'];
  /** Identifier of the activity resolution survey */
  id: Scalars['ID']['output'];
  /** Whether the activity resolution survey is marked as resolved */
  isResolved: Scalars['Boolean']['output'];
  /** Date and time when the activity resolution survey occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Support ticket activity schedule action (when a schedule action is created) */
export type SupportTicketActivityScheduleAction = {
  __typename?: 'SupportTicketActivityScheduleAction';
  /** Actor who performed the activity schedule action */
  actor: SupportActor;
  /** Actor identifier who performed the activity schedule action */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity schedule action */
  id: Scalars['ID']['output'];
  /** Date and time when the activity schedule action occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Schedule action */
  scheduleAction: SupportTicketScheduleAction;
  /** Schedule action identifier */
  scheduleActionId: Scalars['ID']['output'];
  /** Schedule action payload */
  scheduleActionPayload: SupportTicketScheduleActionPayload;
  /** Schedule action schedule at */
  scheduleActionScheduleAt: Scalars['DateTime']['output'];
  /** Schedule action status */
  scheduleActionStatus: SupportTicketScheduleActionStatus;
  /** Schedule action type */
  scheduleActionType: SupportTicketScheduleActionType;
};

/** Support ticket activity schedule action setup (when a schedule action setup is updated) */
export type SupportTicketActivityScheduleActionSetup = {
  __typename?: 'SupportTicketActivityScheduleActionSetup';
  /** Actor who performed the activity schedule action setup */
  actor: SupportActor;
  /** Actor identifier who performed the activity schedule action setup */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity schedule action setup */
  id: Scalars['ID']['output'];
  /** Next schedule action setup set on the ticket */
  nextScheduleActionPayload: SupportTicketScheduleActionPayload;
  /** Date and time when the activity schedule action setup occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Previous schedule action payload */
  previousScheduleActionPayload: SupportTicketScheduleActionPayload;
  /** Schedule action */
  scheduleAction: SupportTicketScheduleAction;
  /** Schedule action identifier */
  scheduleActionId: Scalars['ID']['output'];
  /** Schedule action type */
  scheduleActionType: SupportTicketScheduleActionType;
};

/** Support ticket activity schedule action status (when a schedule action status is updated) */
export type SupportTicketActivityScheduleActionStatus = {
  __typename?: 'SupportTicketActivityScheduleActionStatus';
  /** Actor who performed the activity schedule action status */
  actor: SupportActor;
  /** Actor identifier who performed the activity schedule action status */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity schedule action status */
  id: Scalars['ID']['output'];
  /** Next schedule action schedule at */
  nextScheduleActionScheduleAt: Scalars['DateTime']['output'];
  /** Next schedule action status */
  nextScheduleActionStatus: SupportTicketScheduleActionStatus;
  /** Date and time when the activity schedule action status occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Previous schedule action schedule at */
  previousScheduleActionScheduleAt: Scalars['DateTime']['output'];
  /** Previous schedule action status */
  previousScheduleActionStatus: SupportTicketScheduleActionStatus;
  /** Schedule action */
  scheduleAction: SupportTicketScheduleAction;
  /** Schedule action identifier */
  scheduleActionId: Scalars['ID']['output'];
  /** Schedule action type */
  scheduleActionType: SupportTicketScheduleActionType;
};

/** Support ticket activity status (when a new status is set on a ticket) */
export type SupportTicketActivityStatus = {
  __typename?: 'SupportTicketActivityStatus';
  /** Actor who performed the activity status */
  actor: SupportActor;
  /** Actor identifier who performed the activity status */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity status */
  id: Scalars['ID']['output'];
  /** New status set on the ticket */
  newStatus: SupportTicketStatus;
  /** New sub status set on the ticket */
  newSubStatus: SupportTicketSubStatus;
  /** Date and time when the activity status occurred */
  occurredAt: Scalars['DateTime']['output'];
  /** Planned action that changed the status to the ticket (null if the status was changed manually) */
  scheduleAction?: Maybe<SupportTicketScheduleAction>;
  /** Identifier of the planned action that changed the status to the ticket (null if the status was changed manually) */
  scheduleActionId?: Maybe<Scalars['ID']['output']>;
};

/** Support ticket activity title (when a new title is set on a ticket) */
export type SupportTicketActivityTitle = {
  __typename?: 'SupportTicketActivityTitle';
  /** Actor who performed the activity title */
  actor: SupportActor;
  /** Actor identifier who performed the activity title */
  actorId: Scalars['ID']['output'];
  /** Identifier of the activity title */
  id: Scalars['ID']['output'];
  /** New title set on the ticket */
  newTitle?: Maybe<Scalars['String']['output']>;
  /** Date and time when the activity title occurred */
  occurredAt: Scalars['DateTime']['output'];
};

/** Types of activities that can be performed on a ticket. */
export enum SupportTicketActivityType {
  /** Ticket AI suggestion added */
  SupportTicketActivityAiSuggestion = 'SupportTicketActivityAiSuggestion',
  /** Ticket AI suggestion setup updated */
  SupportTicketActivityAiSuggestionSetup = 'SupportTicketActivityAiSuggestionSetup',
  /** Ticket AI suggestion status updated */
  SupportTicketActivityAiSuggestionStatus = 'SupportTicketActivityAiSuggestionStatus',
  /** Ticket assigned to a internal user */
  SupportTicketActivityAssignment = 'SupportTicketActivityAssignment',
  /** Ticket closed for a specific reason (covers duplicate, unresolvable and junk closures) */
  SupportTicketActivityClosure = 'SupportTicketActivityClosure',
  /** Ticket context updated */
  SupportTicketActivityContext = 'SupportTicketActivityContext',
  /** Ticket context derived updated */
  SupportTicketActivityContextDerived = 'SupportTicketActivityContextDerived',
  /** Ticket email sent */
  SupportTicketActivityEmail = 'SupportTicketActivityEmail',
  /** Ticket initial request added */
  SupportTicketActivityInitialRequest = 'SupportTicketActivityInitialRequest',
  /** Ticket message sent */
  SupportTicketActivityMessage = 'SupportTicketActivityMessage',
  /** Ticket note added */
  SupportTicketActivityNote = 'SupportTicketActivityNote',
  /** Ticket publish added */
  SupportTicketActivityPublish = 'SupportTicketActivityPublish',
  /** Ticket resolution survey added */
  SupportTicketActivityResolutionSurvey = 'SupportTicketActivityResolutionSurvey',
  /** Ticket schedule action added */
  SupportTicketActivityScheduleAction = 'SupportTicketActivityScheduleAction',
  /** Ticket schedule action setup updated */
  SupportTicketActivityScheduleActionSetup = 'SupportTicketActivityScheduleActionSetup',
  /** Ticket schedule action status updated */
  SupportTicketActivityScheduleActionStatus = 'SupportTicketActivityScheduleActionStatus',
  /** Ticket status updated */
  SupportTicketActivityStatus = 'SupportTicketActivityStatus',
  /** Ticket title updated */
  SupportTicketActivityTitle = 'SupportTicketActivityTitle'
}

/** Input for filtering activities by type. */
export type SupportTicketActivityTypeFilterInput = {
  in?: InputMaybe<Array<SupportTicketActivityType>>;
  notIn?: InputMaybe<Array<SupportTicketActivityType>>;
};

/** Union of all possible support ticket AI suggestions */
export type SupportTicketAiSuggestion = SupportTicketAiSuggestionEmail | SupportTicketAiSuggestionMessage;

/** Support ticket AI suggestion accept input */
export type SupportTicketAiSuggestionAcceptInput = {
  /** AI suggestion id */
  aiSuggestionId: Scalars['ID']['input'];
  /** Ticket id */
  ticketId: Scalars['ID']['input'];
};

/** Support ticket AI suggestion connection */
export type SupportTicketAiSuggestionConnection = {
  __typename?: 'SupportTicketAiSuggestionConnection';
  /** Edges of the AI suggestion connection */
  edges: Array<SupportTicketAiSuggestionEdge>;
  /** Page info of the AI suggestion connection */
  pageInfo: PageInfo;
};

/** Support ticket AI suggestion edge */
export type SupportTicketAiSuggestionEdge = {
  __typename?: 'SupportTicketAiSuggestionEdge';
  /** Cursor of the AI suggestion edge */
  cursor: Scalars['String']['output'];
  /** Node of the AI suggestion edge */
  node: SupportTicketAiSuggestion;
};

/** Support ticket AI suggestion edit email input */
export type SupportTicketAiSuggestionEditEmailInput = {
  /** AI suggestion id */
  aiSuggestionId: Scalars['ID']['input'];
  /** Attachments */
  attachments: Array<Scalars['AttachmentUrl']['input']>;
  /** Content HTML */
  contentHtml: Scalars['String']['input'];
  /** Content text */
  contentText: Scalars['String']['input'];
  /** Reason */
  reason: SupportTicketAiSuggestionEditReason;
  /** Ticket id */
  ticketId: Scalars['ID']['input'];
};

/** Support ticket AI suggestion edit message input */
export type SupportTicketAiSuggestionEditMessageInput = {
  /** AI suggestion id */
  aiSuggestionId: Scalars['ID']['input'];
  /** Attachments */
  attachments: Array<Scalars['AttachmentUrl']['input']>;
  /** Content */
  content: Scalars['String']['input'];
  /** Reason */
  reason: SupportTicketAiSuggestionEditReason;
  /** Ticket id */
  ticketId: Scalars['ID']['input'];
};

/** Support ticket AI suggestion edit reason */
export enum SupportTicketAiSuggestionEditReason {
  /** Content adjustment */
  ContentAdjustment = 'ContentAdjustment',
  /** Content and tone of voice adjustment */
  ContentAndToneOfVoiceAdjustment = 'ContentAndToneOfVoiceAdjustment',
  /** Tone of voice adjustment */
  ToneOfVoiceAdjustment = 'ToneOfVoiceAdjustment'
}

/** Support ticket AI suggestion email (when an email AI suggestion is generated) */
export type SupportTicketAiSuggestionEmail = {
  __typename?: 'SupportTicketAiSuggestionEmail';
  /** Timestamp when the AI suggestion was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actor (e.g., user, bot) who created the AI suggestion */
  createdBy: SupportActor;
  /** Whether the AI suggestion has been edited */
  hasBeenEdited: Scalars['Boolean']['output'];
  /** The unique identifier of the AI suggestion */
  id: Scalars['ID']['output'];
  /** The payload of the AI suggestion */
  payload: SupportTicketAiSuggestionEmailPayload;
  /** The reasoning of the AI suggestion */
  reasoning: Scalars['String']['output'];
  /** The reasoning summary of the AI suggestion */
  reasoningSummary: Scalars['String']['output'];
  /** The status of the AI suggestion */
  status: SupportTicketAiSuggestionStatus;
  /** The ticket identifier of the AI suggestion */
  ticketId: Scalars['ID']['output'];
  /** The trace identifier of the AI suggestion */
  traceId: Scalars['String']['output'];
  /** The type of the AI suggestion */
  type: SupportTicketAiSuggestionType;
  /** Timestamp of the most recent update to the AI suggestion */
  updatedAt: Scalars['DateTime']['output'];
};

/** Payload of the support ticket AI suggestion email */
export type SupportTicketAiSuggestionEmailPayload = {
  __typename?: 'SupportTicketAiSuggestionEmailPayload';
  /** Attachments of the email */
  attachments: Array<SupportAttachmentPayload>;
  /** HTML content of the email */
  contentHtml: Scalars['String']['output'];
  /** Text content of the email */
  contentText: Scalars['String']['output'];
};

/** Support ticket AI suggestion message (when a message AI suggestion is generated) */
export type SupportTicketAiSuggestionMessage = {
  __typename?: 'SupportTicketAiSuggestionMessage';
  /** Timestamp when the AI suggestion was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actor (e.g., user, bot) who created the AI suggestion */
  createdBy: SupportActor;
  /** Whether the AI suggestion has been edited */
  hasBeenEdited: Scalars['Boolean']['output'];
  /** The unique identifier of the AI suggestion */
  id: Scalars['ID']['output'];
  /** The payload of the AI suggestion */
  payload: SupportTicketAiSuggestionMessagePayload;
  /** The reasoning of the AI suggestion */
  reasoning: Scalars['String']['output'];
  /** The reasoning summary of the AI suggestion */
  reasoningSummary: Scalars['String']['output'];
  /** The status of the AI suggestion */
  status: SupportTicketAiSuggestionStatus;
  /** The ticket identifier of the AI suggestion */
  ticketId: Scalars['ID']['output'];
  /** The trace identifier of the AI suggestion */
  traceId: Scalars['String']['output'];
  /** The type of the AI suggestion */
  type: SupportTicketAiSuggestionType;
  /** Timestamp of the most recent update to the AI suggestion */
  updatedAt: Scalars['DateTime']['output'];
};

/** Payload of the support ticket AI suggestion message */
export type SupportTicketAiSuggestionMessagePayload = {
  __typename?: 'SupportTicketAiSuggestionMessagePayload';
  /** Attachments of the message */
  attachments: Array<SupportAttachmentPayload>;
  /** Content of the message */
  content: Scalars['String']['output'];
};

/** Union of all possible support ticket AI suggestion payloads */
export type SupportTicketAiSuggestionPayload = SupportTicketAiSuggestionEmailPayload | SupportTicketAiSuggestionMessagePayload;

/** Types of AI suggestion statuses that can be set on an AI suggestion. */
export enum SupportTicketAiSuggestionStatus {
  /** Accepted */
  Accepted = 'Accepted',
  /** Canceled */
  Canceled = 'Canceled',
  /** Pending */
  Pending = 'Pending',
  /** Rejected */
  Rejected = 'Rejected'
}

/** Input for filtering AI suggestions by status. */
export type SupportTicketAiSuggestionStatusFilterInput = {
  in?: InputMaybe<Array<SupportTicketAiSuggestionStatus>>;
  notIn?: InputMaybe<Array<SupportTicketAiSuggestionStatus>>;
};

/** Types of AI suggestions that can be generated for a ticket. */
export enum SupportTicketAiSuggestionType {
  /** Email */
  Email = 'Email',
  /** Message */
  Message = 'Message'
}

/** Filter object for querying support ticket AI suggestions with various criteria. */
export type SupportTicketAiSuggestionsFilterInput = {
  /** Filter by AI suggestion ID. */
  id?: InputMaybe<IdFilterInput>;
  /** Filter by AI suggestion status. */
  status?: InputMaybe<SupportTicketAiSuggestionStatusFilterInput>;
  /** Filter by ticket ID. */
  ticketId?: InputMaybe<IdFilterInput>;
};

/** Input for sorting AI suggestions by specific fields. */
export type SupportTicketAiSuggestionsSortInput = {
  /** The sorting direction, either ASC for ascending or DESC for descending. */
  direction: SupportTicketAiSuggestionsSortableDirection;
  /** The field by which AI suggestions should be sorted (e.g., createdAt). */
  field: SupportTicketAiSuggestionsSortableFields;
};

export enum SupportTicketAiSuggestionsSortableDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SupportTicketAiSuggestionsSortableFields {
  CreatedAt = 'createdAt'
}

/** Channel through which a ticket was created or communicated. */
export enum SupportTicketChannel {
  /** Ticket created or communicated via a chat application. */
  AppChat = 'AppChat',
  /** Ticket created or communicated via email. */
  Email = 'Email'
}

/** Output type for SupportTicketChannel filter. */
export type SupportTicketChannelFilter = {
  __typename?: 'SupportTicketChannelFilter';
  in?: Maybe<Array<SupportTicketChannel>>;
  notIn?: Maybe<Array<SupportTicketChannel>>;
};

/** Filter for enum field: SupportTicketChannel. */
export type SupportTicketChannelFilterInput = {
  in?: InputMaybe<Array<SupportTicketChannel>>;
  notIn?: InputMaybe<Array<SupportTicketChannel>>;
};

/** A connection to a paginated list of tickets, containing edges and pagination info. */
export type SupportTicketConnection = {
  __typename?: 'SupportTicketConnection';
  /** A list of edges, each containing a ticket and its cursor. */
  edges: Array<SupportTicketEdge>;
  /** Pagination information (whether there are more pages of tickets). */
  pageInfo: PageInfo;
};

/** Custom fields associated with a support ticket, typically referencing business entities. */
export type SupportTicketContextDerived = {
  __typename?: 'SupportTicketContextDerived';
  /** Brand */
  brand?: Maybe<Brand>;
  /** Brand ID */
  brandId?: Maybe<Scalars['ID']['output']>;
  /** Identifier of the related claim, if applicable */
  claimId?: Maybe<Scalars['ID']['output']>;
  /**
   * The associated order entity.
   * Provides details about the order if linked.
   */
  order?: Maybe<Order>;
  /** Identifier of the related order, if applicable */
  orderId?: Maybe<Scalars['ID']['output']>;
  /**
   * The associated product entity.
   * Provides details about the product if linked.
   */
  product?: Maybe<Product>;
  /** Identifier of the related product, if applicable */
  productId?: Maybe<Scalars['ID']['output']>;
  /**
   * The associated sale entity.
   * Provides details about the sale if linked.
   */
  sale?: Maybe<Sale>;
  /** Identifier of the related sale, if applicable */
  saleId?: Maybe<Scalars['ID']['output']>;
  /** Identifier of the related store, if applicable */
  storeId?: Maybe<Store>;
  /**
   * The associated brand entity.
   * Provides details about the brand if linked.
   * @deprecated Use brand instead
   */
  supplier?: Maybe<Brand>;
  /**
   * Identifier of the related brand, if applicable
   * @deprecated Use brandId instead
   */
  supplierId?: Maybe<Scalars['ID']['output']>;
  /**
   * The associated variant entity.
   * Provides details about the variant if linked.
   */
  variant?: Maybe<Variant>;
  /** Identifier of the related variant, if applicable */
  variantId?: Maybe<Scalars['ID']['output']>;
};

/** Represents the possible derived contexts of a support ticket */
export enum SupportTicketContextDerivedKey {
  /** Claim ID linked to the support ticket context */
  ContextDerivedClaimId = 'contextDerivedClaimId',
  /** Order ID linked to the support ticket context */
  ContextDerivedOrderId = 'contextDerivedOrderId',
  /** Product ID linked to the support ticket context */
  ContextDerivedProductId = 'contextDerivedProductId',
  /** Sale ID linked to the support ticket context */
  ContextDerivedSaleId = 'contextDerivedSaleId',
  /** Store ID linked to the support ticket context */
  ContextDerivedStoreId = 'contextDerivedStoreId',
  /** Supplier ID linked to the support ticket context */
  ContextDerivedSupplierId = 'contextDerivedSupplierId',
  /** Variant ID linked to the support ticket context */
  ContextDerivedVariantId = 'contextDerivedVariantId'
}

/** Input used to link a specific business context (like an order, product, sale, or supplier) to a support ticket */
export type SupportTicketContextInput = {
  /** The unique identifier of the context object (e.g. order ID, product ID) */
  contextRefId: Scalars['ID']['input'];
  /** The type of context to attach to the support ticket (e.g. Order, Product) */
  contextType: SupportTicketContextType;
};

/** Defines the different context types that can be linked to a support ticket */
export enum SupportTicketContextType {
  /** Indicates that the ticket is related to a specific order */
  Order = 'Order',
  /** Indicates that the ticket is related to a specific product */
  Product = 'Product',
  /** Indicates that the ticket is related to a specific sale */
  Sale = 'Sale',
  /** Indicates that the ticket is related to a specific supplier */
  Supplier = 'Supplier',
  /** Indicates that the ticket is related to a specific product variant */
  Variant = 'Variant'
}

/** Represents an edge in the paginated list of tickets, containing the ticket data and a cursor. */
export type SupportTicketEdge = {
  __typename?: 'SupportTicketEdge';
  /** A unique cursor identifying this ticket, used for pagination. */
  cursor: Scalars['String']['output'];
  /** The actual ticket data. */
  node: SupportTicket;
};

/** Support ticket initial request review flow input */
export type SupportTicketInitialRequestReviewFlowInput = {
  /** Flow the request really belongs to */
  flow: SupportTicketActivityInitialRequestFlow;
  /** Ticket id */
  ticketId: Scalars['ID']['input'];
};

/** Union of all possible support ticket schedule actions */
export type SupportTicketScheduleAction = SupportTicketScheduleActionEmail | SupportTicketScheduleActionMessage | SupportTicketScheduleActionNote | SupportTicketScheduleActionSubStatus;

/** Input used to add an email to a support ticket (schedule action). */
export type SupportTicketScheduleActionAddEmailInput = {
  /** A list of attachment urls to attach to the email. */
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  /** The email HTML body. */
  contentHtml: Scalars['String']['input'];
  /** The email text body. */
  contentText: Scalars['String']['input'];
  /** The ID of the ticket related to the email. */
  ticketId: Scalars['ID']['input'];
};

/** Input used to add a message to a support ticket (schedule action). */
export type SupportTicketScheduleActionAddMessageInput = {
  /** A list of attachment urls to attach to the message. */
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  /** The message body. */
  content: Scalars['String']['input'];
  /** The ID of the ticket related to the message. */
  ticketId: Scalars['ID']['input'];
};

/** Input used to add a note to a support ticket (schedule action). */
export type SupportTicketScheduleActionAddNoteInput = {
  /** A list of attachment urls to attach to the note. */
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  /** The content of the note. */
  content: Scalars['String']['input'];
  /** The ID of the ticket related to the note. */
  ticketId: Scalars['ID']['input'];
};

/** Support ticket activity connection */
export type SupportTicketScheduleActionConnection = {
  __typename?: 'SupportTicketScheduleActionConnection';
  /** Edges of the schedule action connection */
  edges: Array<SupportTicketScheduleActionEdge>;
  /** Page info of the schedule action connection */
  pageInfo: PageInfo;
};

/** Support ticket schedule action edge */
export type SupportTicketScheduleActionEdge = {
  __typename?: 'SupportTicketScheduleActionEdge';
  /** Cursor of the schedule action edge */
  cursor: Scalars['String']['output'];
  /** Node of the schedule action edge */
  node: SupportTicketScheduleAction;
};

/** Support ticket schedule action email (when an email is sent to a ticket) */
export type SupportTicketScheduleActionEmail = {
  __typename?: 'SupportTicketScheduleActionEmail';
  /** Timestamp when the schedule action was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actor (e.g., user, bot) who created the schedule action */
  createdBy: SupportActor;
  /** The unique identifier of the schedule action */
  id: Scalars['ID']['output'];
  /** The payload of the schedule action */
  payload: SupportTicketScheduleActionEmailPayload;
  /** The schedule at of the schedule action */
  scheduleAt: Scalars['DateTime']['output'];
  /** The status of the schedule action */
  status: SupportTicketScheduleActionStatus;
  /** The ticket of the schedule action */
  ticket: SupportTicket;
  /** The ticket identifier of the schedule action */
  ticketId: Scalars['ID']['output'];
  /** The type of the schedule action */
  type: SupportTicketScheduleActionType;
  /** Timestamp of the most recent update to the schedule action */
  updatedAt: Scalars['DateTime']['output'];
};

/** Payload of the support ticket schedule action email */
export type SupportTicketScheduleActionEmailPayload = {
  __typename?: 'SupportTicketScheduleActionEmailPayload';
  /** Attachments of the email */
  attachments: Array<SupportAttachmentPayload>;
  /** HTML content of the email */
  contentHtml: Scalars['String']['output'];
  /** Text content of the email */
  contentText: Scalars['String']['output'];
};

/** Input used to mark a schedule action as canceled. */
export type SupportTicketScheduleActionMarkAsCanceledInput = {
  /** The ID of the schedule action to mark as canceled. */
  scheduleActionId: Scalars['ID']['input'];
  /** The ID of the ticket related to the schedule action. */
  ticketId: Scalars['ID']['input'];
};

/** Input used to mark a schedule action as paused. */
export type SupportTicketScheduleActionMarkAsPausedInput = {
  /** The ID of the schedule action to mark as paused. */
  scheduleActionId: Scalars['ID']['input'];
  /** The ID of the ticket related to the schedule action. */
  ticketId: Scalars['ID']['input'];
};

/** Support ticket schedule action message (when a message is added to a ticket) */
export type SupportTicketScheduleActionMessage = {
  __typename?: 'SupportTicketScheduleActionMessage';
  /** Timestamp when the schedule action was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actor (e.g., user, bot) who created the schedule action */
  createdBy: SupportActor;
  /** The unique identifier of the schedule action */
  id: Scalars['ID']['output'];
  /** The payload of the schedule action */
  payload: SupportTicketScheduleActionMessagePayload;
  /** The schedule at of the schedule action */
  scheduleAt: Scalars['DateTime']['output'];
  /** The status of the schedule action */
  status: SupportTicketScheduleActionStatus;
  /** The ticket of the schedule action */
  ticket: SupportTicket;
  /** The ticket identifier of the schedule action */
  ticketId: Scalars['ID']['output'];
  /** The type of the schedule action */
  type: SupportTicketScheduleActionType;
  /** Timestamp of the most recent update to the schedule action */
  updatedAt: Scalars['DateTime']['output'];
};

/** Payload of the support ticket schedule action message */
export type SupportTicketScheduleActionMessagePayload = {
  __typename?: 'SupportTicketScheduleActionMessagePayload';
  /** Attachments of the message */
  attachments: Array<SupportAttachmentPayload>;
  /** Content of the message */
  content: Scalars['String']['output'];
};

/** Support ticket schedule action note (when a note is added to a ticket) */
export type SupportTicketScheduleActionNote = {
  __typename?: 'SupportTicketScheduleActionNote';
  /** Timestamp when the schedule action was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actor (e.g., user, bot) who created the schedule action */
  createdBy: SupportActor;
  /** The unique identifier of the schedule action */
  id: Scalars['ID']['output'];
  /** The payload of the schedule action */
  payload: SupportTicketScheduleActionNotePayload;
  /** The schedule at of the schedule action */
  scheduleAt: Scalars['DateTime']['output'];
  /** The status of the schedule action */
  status: SupportTicketScheduleActionStatus;
  /** The ticket of the schedule action */
  ticket: SupportTicket;
  /** The ticket identifier of the schedule action */
  ticketId: Scalars['ID']['output'];
  /** The type of the schedule action */
  type: SupportTicketScheduleActionType;
  /** Timestamp of the most recent update to the schedule action */
  updatedAt: Scalars['DateTime']['output'];
};

/** Payload of the support ticket schedule action note */
export type SupportTicketScheduleActionNotePayload = {
  __typename?: 'SupportTicketScheduleActionNotePayload';
  /** Attachments of the note */
  attachments: Array<SupportAttachmentPayload>;
  /** Content of the note */
  content: Scalars['String']['output'];
};

/** Union of all possible support ticket schedule action payloads */
export type SupportTicketScheduleActionPayload = SupportTicketScheduleActionEmailPayload | SupportTicketScheduleActionMessagePayload | SupportTicketScheduleActionNotePayload | SupportTicketScheduleActionSubStatusPayload;

/** Input used to reschedule a schedule action. */
export type SupportTicketScheduleActionRescheduleInput = {
  /** The ID of the schedule action to reschedule. */
  scheduleActionId: Scalars['ID']['input'];
  /** The new date and time when the schedule action should be executed. */
  scheduleAt: Scalars['DateTime']['input'];
  /** The ID of the ticket related to the schedule action. */
  ticketId: Scalars['ID']['input'];
};

/** Input used to set the sub-status of a support ticket (schedule action). */
export type SupportTicketScheduleActionSetSubStatusInput = {
  /** The sub-status to set. */
  subStatus: SupportTicketSubStatus;
  /** The ID of the ticket related to the sub-status. */
  ticketId: Scalars['ID']['input'];
};

/** Types of schedule action statuses that can be set on a schedule action. */
export enum SupportTicketScheduleActionStatus {
  /** Cancelled */
  Cancelled = 'Cancelled',
  /** Executed */
  Executed = 'Executed',
  /** Paused */
  Paused = 'Paused',
  /** Pending */
  Pending = 'Pending'
}

/** Input for filtering schedule actions by status. */
export type SupportTicketScheduleActionStatusFilterInput = {
  in?: InputMaybe<Array<SupportTicketScheduleActionStatus>>;
  notIn?: InputMaybe<Array<SupportTicketScheduleActionStatus>>;
};

/** Support ticket schedule action sub status (when a sub status is set to a ticket) */
export type SupportTicketScheduleActionSubStatus = {
  __typename?: 'SupportTicketScheduleActionSubStatus';
  /** Timestamp when the schedule action was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actor (e.g., user, bot) who created the schedule action */
  createdBy: SupportActor;
  /** The unique identifier of the schedule action */
  id: Scalars['ID']['output'];
  /** The payload of the schedule action */
  payload: SupportTicketScheduleActionSubStatusPayload;
  /** The schedule at of the schedule action */
  scheduleAt: Scalars['DateTime']['output'];
  /** The status of the schedule action */
  status: SupportTicketScheduleActionStatus;
  /** The ticket of the schedule action */
  ticket: SupportTicket;
  /** The ticket identifier of the schedule action */
  ticketId: Scalars['ID']['output'];
  /** The type of the schedule action */
  type: SupportTicketScheduleActionType;
  /** Timestamp of the most recent update to the schedule action */
  updatedAt: Scalars['DateTime']['output'];
};

/** Payload of the support ticket schedule action sub status */
export type SupportTicketScheduleActionSubStatusPayload = {
  __typename?: 'SupportTicketScheduleActionSubStatusPayload';
  /** Sub status */
  subStatus: SupportTicketSubStatus;
};

/** Types of schedule actions that can be performed on a ticket. */
export enum SupportTicketScheduleActionType {
  /** Email */
  Email = 'Email',
  /** Message */
  Message = 'Message',
  /** Note */
  Note = 'Note',
  /** SubStatus */
  SubStatus = 'SubStatus'
}

/** Input used to update an email schedule action. */
export type SupportTicketScheduleActionUpdateEmailInput = {
  /** A list of attachment urls to attach to the email. */
  attachments: Array<Scalars['AttachmentUrl']['input']>;
  /** The new email HTML body. */
  contentHtml: Scalars['String']['input'];
  /** The new email text body. */
  contentText: Scalars['String']['input'];
  /** The ID of the schedule action to update. */
  scheduleActionId: Scalars['ID']['input'];
  /** The ID of the ticket related to the email. */
  ticketId: Scalars['ID']['input'];
};

/** Input used to update a message schedule action. */
export type SupportTicketScheduleActionUpdateMessageInput = {
  /** A list of attachment urls to attach to the message. */
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  /** The new message body. */
  content: Scalars['String']['input'];
  /** The ID of the schedule action to update. */
  scheduleActionId: Scalars['ID']['input'];
  /** The ID of the ticket related to the message. */
  ticketId: Scalars['ID']['input'];
};

/** Input used to update a note schedule action. */
export type SupportTicketScheduleActionUpdateNoteInput = {
  /** A list of attachment urls to attach to the note. */
  attachments: Array<Scalars['AttachmentUrl']['input']>;
  /** The new content of the note. */
  content: Scalars['String']['input'];
  /** The ID of the schedule action to update. */
  scheduleActionId: Scalars['ID']['input'];
  /** The ID of the ticket related to the note. */
  ticketId: Scalars['ID']['input'];
};

/** Input used to update a sub-status schedule action. */
export type SupportTicketScheduleActionUpdateSubStatusInput = {
  /** The ID of the schedule action to update. */
  scheduleActionId: Scalars['ID']['input'];
  /** The new sub-status. */
  subStatus: SupportTicketSubStatus;
  /** The ID of the ticket related to the sub-status. */
  ticketId: Scalars['ID']['input'];
};

/** Filter object for querying support tickets with various criteria. */
export type SupportTicketScheduleActionsFilterInput = {
  /** Filter by schedule action ID. */
  id?: InputMaybe<IdFilterInput>;
  /** Filter by schedule action schedule at. */
  scheduleAt?: InputMaybe<DateRangeFilterInput>;
  /** Filter by schedule action status. */
  status?: InputMaybe<SupportTicketScheduleActionStatusFilterInput>;
  /** Filter by ticket ID. */
  ticketId?: InputMaybe<IdFilterInput>;
};

/** Input for sorting schedule actions by specific fields. */
export type SupportTicketScheduleActionsSortInput = {
  /** The sorting direction, either ASC for ascending or DESC for descending. */
  direction: SupportTicketScheduleActionsSortableDirection;
  /** The field by which schedule actions should be sorted (e.g., scheduleAt). */
  field: SupportTicketScheduleActionsSortableFields;
};

export enum SupportTicketScheduleActionsSortableDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SupportTicketScheduleActionsSortableFields {
  ScheduleAt = 'scheduleAt'
}

export enum SupportTicketStatus {
  /** Ticket has been completed or resolved */
  Done = 'Done',
  /** Ticket is temporarily paused or on hold */
  Snoozed = 'Snoozed',
  /** Ticket is pending and requires action */
  Todo = 'Todo'
}

/** Output type for SupportTicketStatus filter. */
export type SupportTicketStatusFilter = {
  __typename?: 'SupportTicketStatusFilter';
  in?: Maybe<Array<SupportTicketStatus>>;
  notIn?: Maybe<Array<SupportTicketStatus>>;
};

/** Filter for enum field: SupportTicketStatus. */
export type SupportTicketStatusFilterInput = {
  in?: InputMaybe<Array<SupportTicketStatus>>;
  notIn?: InputMaybe<Array<SupportTicketStatus>>;
};

export enum SupportTicketSubStatus {
  /** Ticket has been archived */
  Archived = 'Archived',
  /** Ticket has been ignored or marked as not actionable */
  Ignored = 'Ignored',
  /** Issue is being investigated */
  Investigating = 'Investigating',
  /** Waiting for the first response to be sent */
  NeedsFirstResponse = 'NeedsFirstResponse',
  /** Waiting for a follow-up response */
  NeedsNextResponse = 'NeedsNextResponse',
  /** Informational only, no action required */
  OnlyInformation = 'OnlyInformation',
  /** Temporarily paused, to be resumed later */
  PausedForLater = 'PausedForLater',
  /** Issue has been resolved */
  Resolved = 'Resolved',
  /** Waiting for the customer to respond */
  WaitingContact = 'WaitingContact',
  /** Waiting for a supplier to respond */
  WaitingSupplier = 'WaitingSupplier'
}

/** Statuses indicating the ticket has reached an end state */
export enum SupportTicketSubStatusDone {
  /** Ticket has been archived */
  Archived = 'Archived',
  /** Ticket has been ignored or marked as not actionable */
  Ignored = 'Ignored',
  /** Informational only, no action required */
  OnlyInformation = 'OnlyInformation',
  /** Issue has been resolved */
  Resolved = 'Resolved'
}

/** Output type for SupportTicketSubStatus filter. */
export type SupportTicketSubStatusFilter = {
  __typename?: 'SupportTicketSubStatusFilter';
  in?: Maybe<Array<SupportTicketSubStatus>>;
  notIn?: Maybe<Array<SupportTicketSubStatus>>;
};

/** Filter for enum field: SupportTicketSubStatus. */
export type SupportTicketSubStatusFilterInput = {
  in?: InputMaybe<Array<SupportTicketSubStatus>>;
  notIn?: InputMaybe<Array<SupportTicketSubStatus>>;
};

/** Support - Order Flow - Ticket - Sub status */
export enum SupportTicketSubStatusOrderFlow {
  /** Only information */
  OnlyInformation = 'OnlyInformation',
  /** Waiting contact */
  WaitingContact = 'WaitingContact'
}

/** Statuses indicating the ticket is on hold or waiting */
export enum SupportTicketSubStatusSnooze {
  /** Temporarily paused, to be resumed later */
  PausedForLater = 'PausedForLater',
  /** Waiting for the customer to respond */
  WaitingContact = 'WaitingContact',
  /** Waiting for a supplier to respond */
  WaitingSupplier = 'WaitingSupplier'
}

/** Statuses indicating that some action is still required */
export enum SupportTicketSubStatusTodo {
  /** Issue is being investigated */
  Investigating = 'Investigating',
  /** Waiting for the first response to be sent */
  NeedsFirstResponse = 'NeedsFirstResponse',
  /** Waiting for a follow-up response */
  NeedsNextResponse = 'NeedsNextResponse'
}

/** Support ticket - Close as Duplicate - input */
export type SupportTicket_CloseAsDuplicate_Input = {
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Support ticket - Close as Junk - input */
export type SupportTicket_CloseAsJunk_Input = {
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Support ticket - Close as Unresolvable - input */
export type SupportTicket_CloseAsUnresolvable_Input = {
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Support ticket - Order - Declare items as out of stock - input */
export type SupportTicket_Order_DeclareItemsAsOutOfStock_Input = {
  /** Credit compensation enabled */
  creditCompensationEnabled: Scalars['Boolean']['input'];
  /** Order item ids */
  orderItemIds: Array<Scalars['ID']['input']>;
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Support ticket - Order - Declare items as out of stock - Output */
export type SupportTicket_Order_DeclareItemsAsOutOfStock_Output = {
  __typename?: 'SupportTicket_Order_DeclareItemsAsOutOfStock_Output';
  /** Credit compensation amount in cents */
  creditCompensationAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Whether the order has been canceled */
  orderCanceled: Scalars['Boolean']['output'];
  /** Refunds */
  refunds: Array<OrderRefundPlan>;
};

/** Support ticket - Order - Postpone delivery date range - input */
export type SupportTicket_Order_PostponeDeliveryDateRange_Input = {
  /** Postpone in days */
  postponeInDays: Scalars['PositiveInt']['input'];
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Support ticket - Order - Update delivery date range - input */
export type SupportTicket_Order_UpdateDeliveryDateRange_Input = {
  /** Delivery date range */
  deliveryDateRange: DeliveryDateRangeInput;
  /** Support ticket id */
  supportTicketId: Scalars['ID']['input'];
};

/** Output type for support ticket filters. */
export type SupportTicketsFilter = {
  __typename?: 'SupportTicketsFilter';
  /** Filter by the date the ticket was assigned. */
  assignedAt?: Maybe<DateRangeFilter>;
  /** Filter by the user the ticket is assigned to. */
  assignedToId?: Maybe<IdFilterNullable>;
  /** Filter by the channel through which the ticket was created. */
  channel?: Maybe<SupportTicketChannelFilter>;
  /** Filter by contact ID. */
  contactId?: Maybe<IdFilter>;
  /** Filter by context derived properties. */
  contextDerived?: Maybe<ContextDerivedFilter>;
  /** Filter by the date the ticket was created. */
  createdAt?: Maybe<DateRangeFilter>;
  /** Filter by the ID of the user who created the ticket. */
  createdById?: Maybe<IdFilter>;
  /** Filter by whether the ticket has pending schedule actions. */
  hasPendingScheduleActions?: Maybe<BooleanFilter>;
  /** Filter by ticket ID. */
  id?: Maybe<IdFilter>;
  /** Filter by initial request properties. */
  initialRequest?: Maybe<InitialRequestFilter>;
  /** Filter by draft status */
  isDraft?: Maybe<BooleanFilter>;
  /** Filter by read status by contact */
  isReadByContact?: Maybe<BooleanFilter>;
  /** Filter by the order flow ID from which the ticket was issued. */
  orderFlowId?: Maybe<IdFilterNullable>;
  /** Filter by ticket status. */
  status?: Maybe<SupportTicketStatusFilter>;
  /** Filter by the date the ticket status was last updated. */
  statusUpdatedAt?: Maybe<DateRangeFilter>;
  /** Filter by ticket sub-status. */
  subStatus?: Maybe<SupportTicketSubStatusFilter>;
};

/** Filter object for querying support tickets with various criteria. */
export type SupportTicketsFilterInput = {
  /** Filter by the date the ticket was assigned. */
  assignedAt?: InputMaybe<DateRangeFilterInput>;
  /** Filter by the user the ticket is assigned to. */
  assignedToId?: InputMaybe<IdFilterNullableInput>;
  /** Filter by the channel through which the ticket was created. */
  channel?: InputMaybe<SupportTicketChannelFilterInput>;
  /** Filter by contact ID. */
  contactId?: InputMaybe<IdFilterInput>;
  /** Filter by context derived properties. */
  contextDerived?: InputMaybe<ContextDerivedFilterInput>;
  /** Filter by the date the ticket was created. */
  createdAt?: InputMaybe<DateRangeFilterInput>;
  /** Filter by the ID of the user who created the ticket. */
  createdById?: InputMaybe<IdFilterInput>;
  /** Filter by whether the ticket has pending schedule actions. */
  hasPendingScheduleActions?: InputMaybe<BooleanFilterInput>;
  /** Filter by ticket ID. */
  id?: InputMaybe<IdFilterInput>;
  /** Filter by initial request properties. */
  initialRequest?: InputMaybe<InitialRequestFilterInput>;
  /** Filter by draft status */
  isDraft?: InputMaybe<BooleanFilterInput>;
  /** Filter by read status by contact */
  isReadByContact?: InputMaybe<BooleanFilterInput>;
  /** Filter by the order flow ID from which the ticket was issued. */
  orderFlowId?: InputMaybe<IdFilterNullableInput>;
  /** Filter by ticket status. */
  status?: InputMaybe<SupportTicketStatusFilterInput>;
  /** Filter by the date the ticket status was last updated. */
  statusUpdatedAt?: InputMaybe<DateRangeFilterInput>;
  /** Filter by ticket sub-status. */
  subStatus?: InputMaybe<SupportTicketSubStatusFilterInput>;
};

/** Output type for support ticket sorting. */
export type SupportTicketsSort = {
  __typename?: 'SupportTicketsSort';
  /** The sorting direction, either ASC for ascending or DESC for descending. */
  direction: SupportTicketsSortableDirection;
  /** The field by which tickets should be sorted (e.g., createdAt, priority). */
  field: SupportTicketsSortableFields;
};

/** Input for sorting tickets by specific fields. */
export type SupportTicketsSortInput = {
  /** The sorting direction, either ASC for ascending or DESC for descending. */
  direction: SupportTicketsSortableDirection;
  /** The field by which tickets should be sorted (e.g., createdAt, priority). */
  field: SupportTicketsSortableFields;
};

export enum SupportTicketsSortableDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SupportTicketsSortableFields {
  StatusUpdatedAt = 'statusUpdatedAt'
}

export type SupportView = {
  __typename?: 'SupportView';
  /** The date and time when the support view was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created the support view. */
  createdBy: ActorInternalUser;
  /** The ID of the user who created the support view. */
  createdById: Scalars['ID']['output'];
  /** The date and time when the support view was deleted, if any. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The actor who deleted the support view, if any. */
  deletedBy?: Maybe<ActorInternalUser>;
  /** The properties to display in the support view. */
  displayedProperties: SupportViewDisplayedProperty;
  /** The filters applied to the support tickets in this view. */
  filters: SupportTicketsFilter;
  /** The properties by which to group the support tickets in this view. */
  groupBy: SupportViewGroupByProperty;
  /** The icon representing the support view. */
  icon: Scalars['String']['output'];
  /** The color of the icon. */
  iconColor: Scalars['String']['output'];
  /** The unique identifier of the support view. */
  id: Scalars['ID']['output'];
  /** Whether the support view is deleted. */
  isDeleted: Scalars['Boolean']['output'];
  /** The sorting applied to the support tickets in this view. */
  sortBy: SupportTicketsSort;
  /** The title of the support view. */
  title: Scalars['String']['output'];
  /** The date and time when the support view was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type SupportViewConnection = {
  __typename?: 'SupportViewConnection';
  /** A list of edges, each containing a support view and its cursor. */
  edges: Array<SupportViewEdge>;
  /** Pagination information (whether there are more pages of support views). */
  pageInfo: PageInfo;
};

export type SupportViewDisplayedProperty = {
  __typename?: 'SupportViewDisplayedProperty';
  /** Display the assignee of the ticket. */
  assignedTo: Scalars['Boolean']['output'];
  /** Display the channel of the ticket. */
  channel: Scalars['Boolean']['output'];
  /** Display the contact of the ticket. */
  contact: Scalars['Boolean']['output'];
  /** Display whether the ticket has pending schedule actions. */
  hasPendingScheduleActions: Scalars['Boolean']['output'];
  /** Display the draft status of the ticket. */
  isDraft: Scalars['Boolean']['output'];
  /** Display the order flow of the ticket. */
  orderFlow: Scalars['Boolean']['output'];
  /** Display the preview text of the ticket. */
  previewText: Scalars['Boolean']['output'];
  /** Display the sale name of the ticket. */
  saleName: Scalars['Boolean']['output'];
  /** Display the status updated at of the ticket. */
  statusUpdatedAt: Scalars['Boolean']['output'];
  /** Display the sub-status of the ticket. */
  subStatus: Scalars['Boolean']['output'];
  /** Display the title of the ticket. */
  title: Scalars['Boolean']['output'];
};

export type SupportViewDisplayedPropertyInput = {
  /** Display the assignee of the ticket. */
  assignedTo: Scalars['Boolean']['input'];
  /** Display the channel of the ticket. */
  channel: Scalars['Boolean']['input'];
  /** Display the contact of the ticket. */
  contact: Scalars['Boolean']['input'];
  /** Display whether the ticket has pending schedule actions. */
  hasPendingScheduleActions: Scalars['Boolean']['input'];
  /** Display the draft status of the ticket. */
  isDraft: Scalars['Boolean']['input'];
  /** Display the order flow of the ticket. */
  orderFlow: Scalars['Boolean']['input'];
  /** Display the preview text of the ticket. */
  previewText: Scalars['Boolean']['input'];
  /** Display the sale name of the ticket. */
  saleName: Scalars['Boolean']['input'];
  /** Display the status updated at of the ticket. */
  statusUpdatedAt: Scalars['Boolean']['input'];
  /** Display the sub-status of the ticket. */
  subStatus: Scalars['Boolean']['input'];
  /** Display the title of the ticket. */
  title: Scalars['Boolean']['input'];
};

export type SupportViewEdge = {
  __typename?: 'SupportViewEdge';
  /** A unique cursor identifying this support view, used for pagination. */
  cursor: Scalars['String']['output'];
  /** The actual support view data. */
  node: SupportView;
};

/** Properties by which to group the support view. */
export enum SupportViewGroupByProperty {
  /** Group by assignee. */
  AssignedTo = 'assignedTo',
  /** No grouping. */
  None = 'none',
  /** Group by sale id. */
  SaleId = 'saleId',
  /** Group by sub-status. */
  SubStatus = 'subStatus'
}

export type SupportViewsFilterInput = {
  /** Filter by the date the view was created. */
  createdAt?: InputMaybe<DateRangeFilterInput>;
  /** Filter by the ID of the user who created the view. */
  createdById?: InputMaybe<IdFilterInput>;
  /** Filter by the ID of the user who deleted the view (nullable). */
  deletedById?: InputMaybe<IdFilterNullableInput>;
  /** Filter by support view ID. */
  id?: InputMaybe<IdFilterInput>;
  /** Filter by the date the view was last updated. */
  updatedAt?: InputMaybe<DateRangeFilterInput>;
};

export type SupportViewsSortInput = {
  /** The sorting direction, either ASC or DESC. */
  direction: SupportViewsSortableDirection;
  /** The field by which support views should be sorted. */
  field: SupportViewsSortableFields;
};

export enum SupportViewsSortableDirection {
  /** Sort in ascending order. */
  Asc = 'asc',
  /** Sort in descending order. */
  Desc = 'desc'
}

export enum SupportViewsSortableFields {
  /** Sort by creation date. */
  CreatedAt = 'createdAt',
  /** Sort by last update date. */
  UpdatedAt = 'updatedAt'
}

/** Support - Actor App Contact - Flag As Frauder - Input */
export type Support_ActorAppContact_FlagAsFrauder_Input = {
  /** Actor app contact id */
  actorAppContactId: Scalars['ID']['input'];
};

/** Support - Actor App Contact - Flag As Influencer - Input */
export type Support_ActorAppContact_FlagAsInfluencer_Input = {
  /** Actor app contact id */
  actorAppContactId: Scalars['ID']['input'];
};

/** Support - Actor App Contact - Unflag As Frauder - Input */
export type Support_ActorAppContact_UnflagAsFrauder_Input = {
  /** Actor app contact id */
  actorAppContactId: Scalars['ID']['input'];
};

/** Support - Actor App Contact - Unflag As Influencer - Input */
export type Support_ActorAppContact_UnflagAsInfluencer_Input = {
  /** Actor app contact id */
  actorAppContactId: Scalars['ID']['input'];
};

/** Support - Order Flow - Action - Add support app contact credit - Input */
export type Support_OrderFlow_Action_AddSupportAppContactCredit_Input = {
  /** Amount in cents */
  amountInCents: Scalars['PositiveInt']['input'];
};

/** Support - Order Flow - Action - Add support ticket message - Input */
export type Support_OrderFlow_Action_AddSupportTicketMessage_Input = {
  /** Attachments */
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']>>;
  /** Message content */
  content: Scalars['String']['input'];
};

/** Support - Order Flow - Action - Attach context - Input */
export type Support_OrderFlow_Action_AttachContext_Input = {
  /** The unique identifier of the context object (e.g. order ID, sale ID) */
  contextRefId: Scalars['ID']['input'];
  /** The type of context to attach to the support ticket (e.g. Order, Product, Sale) */
  contextType: SupportTicketContextType;
};

/** Support - Order Flow - Action - Cancel order - Input */
export type Support_OrderFlow_Action_CancelOrder_Input = {
  /** Whether to put items back in stock */
  putBackInStock: Scalars['Boolean']['input'];
  /** Reason for cancellation */
  reason: SupportOrderFlowCancelOrderReason;
};

/** Support - Order Flow - Action - Create supplier billing adjustment - Input */
export type Support_OrderFlow_Action_CreateSupplierBillingAdjustment_Input = {
  /** Description of the expense */
  description: Scalars['String']['input'];
  /** Documents attached to the adjustment */
  documents?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Title of the expense */
  title: Scalars['String']['input'];
};

/** Support - Order Flow - Action - Declare order items as out of stock - Input */
export type Support_OrderFlow_Action_DeclareOrderItemsAsOutOfStock_Input = {
  /** Credit compensation enabled */
  creditCompensationEnabled: Scalars['Boolean']['input'];
};

/** Support - Order Flow - Action - Postpone order delivery date range - Input */
export type Support_OrderFlow_Action_PostponeOrderDeliveryDateRange_Input = {
  /** Postpone in days */
  postponeInDays: Scalars['PositiveInt']['input'];
};

/** Support - Order Flow - Action - Update order delivery date range - Input */
export type Support_OrderFlow_Action_UpdateOrderDeliveryDateRange_Input = {
  /** Delivery date range */
  deliveryDateRange: DeliveryDateRangeInput;
};

/** Support - Order Flow - Communication App Users - Actions - Input */
export type Support_OrderFlow_CommunicationAppUsers_Actions_Input = {
  /** Add a message to the support ticket */
  addSupportTicketMessage: Support_OrderFlow_Action_AddSupportTicketMessage_Input;
  /** Attach a context to the support ticket */
  attachContext?: InputMaybe<Support_OrderFlow_Action_AttachContext_Input>;
};

/** Support - Order Flow - Communication App Users - Input */
export type Support_OrderFlow_CommunicationAppUsers_Input = {
  /** Actions to perform */
  actions: Support_OrderFlow_CommunicationAppUsers_Actions_Input;
  /** App user ids concerned */
  appUserIds: Array<Scalars['ID']['input']>;
  /** Ticket configuration */
  ticket?: InputMaybe<Support_OrderFlow_Ticket_Input>;
};

/** Support - Order Flow - Credit compensation supplier charged - Actions - Input */
export type Support_OrderFlow_CreditCompensationSupplierCharged_Actions_Input = {
  /** Add an amount of credit to the support app contact */
  addSupportAppContactCredit: Support_OrderFlow_Action_AddSupportAppContactCredit_Input;
  /** Add a message to the support ticket */
  addSupportTicketMessage: Support_OrderFlow_Action_AddSupportTicketMessage_Input;
  /** Create a supplier billing adjustment */
  createSupplierBillingAdjustment: Support_OrderFlow_Action_CreateSupplierBillingAdjustment_Input;
};

/** Support - Order Flow - Credit compensation supplier charged - Input */
export type Support_OrderFlow_CreditCompensationSupplierCharged_Input = {
  /** Actions to perform */
  actions: Support_OrderFlow_CreditCompensationSupplierCharged_Actions_Input;
  /** Order ids concerned */
  orderIds: Array<Scalars['ID']['input']>;
  /** Query to search for concerned orders */
  query: Orders_Search_Filter_Input;
};

/** Support - Order Flow - Delivery delay V2 - Actions - Input */
export type Support_OrderFlow_DeliveryDelayV2_Actions_Input = {
  /** Add an amount of credit to the support app contact */
  addSupportAppContactCredit?: InputMaybe<Support_OrderFlow_Action_AddSupportAppContactCredit_Input>;
  /** Postpone order delivery date range */
  postponeOrderDeliveryDateRange?: InputMaybe<Support_OrderFlow_Action_PostponeOrderDeliveryDateRange_Input>;
  /** Update order delivery date range */
  updateOrderDeliveryDateRange?: InputMaybe<Support_OrderFlow_Action_UpdateOrderDeliveryDateRange_Input>;
};

/** Support - Order Flow - Delivery delay V2 - Input */
export type Support_OrderFlow_DeliveryDelayV2_Input = {
  /** Actions to perform */
  actions: Support_OrderFlow_DeliveryDelayV2_Actions_Input;
  /** Order ids concerned */
  orderIds: Array<Scalars['ID']['input']>;
  /** Query to search for concerned orders */
  query: Orders_Search_Filter_Input;
};

/** Support - Order flow - Input */
export type Support_OrderFlow_Input = {
  /** Order flow id */
  orderFlowId: Scalars['ID']['input'];
};

/** Support - Order Flow - Order cancellation - Actions - Input */
export type Support_OrderFlow_OrderCancellation_Actions_Input = {
  /** Add credit to the support app contact (optional) */
  addSupportAppContactCredit?: InputMaybe<Support_OrderFlow_Action_AddSupportAppContactCredit_Input>;
  /** Add a message to the support ticket */
  addSupportTicketMessage: Support_OrderFlow_Action_AddSupportTicketMessage_Input;
  /** Cancel the order */
  cancelOrder: Support_OrderFlow_Action_CancelOrder_Input;
};

/** Support - Order Flow - Order cancellation - Input */
export type Support_OrderFlow_OrderCancellation_Input = {
  /** Actions to perform */
  actions: Support_OrderFlow_OrderCancellation_Actions_Input;
  /** Order ids concerned */
  orderIds: Array<Scalars['ID']['input']>;
  /** Query to search for concerned orders */
  query: Orders_Search_Filter_Input;
};

/** Support - Order Flow - Order optimization packaging - Actions - Input */
export type Support_OrderFlow_OrderOptimizationPackaging_Actions_Input = {
  /** Declare order items as out of stock */
  declareOrderItemsAsOutOfStock: Support_OrderFlow_Action_DeclareOrderItemsAsOutOfStock_Input;
};

/** Support - Order Flow - Order optimization packaging - Input */
export type Support_OrderFlow_OrderOptimizationPackaging_Input = {
  /** Actions to perform */
  actions: Support_OrderFlow_OrderOptimizationPackaging_Actions_Input;
  /** Order item lines to process */
  orderItemLines: Array<Support_OrderFlow_OrderOptimizationPackaging_OrderItemLine_Input>;
  /** Query to search for concerned orders */
  query: Orders_Search_Filter_Input;
};

/** Support - Order Flow - Order optimization packaging - Order item line - Input */
export type Support_OrderFlow_OrderOptimizationPackaging_OrderItemLine_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Quantity of items to declare as out of stock */
  quantity: Scalars['Int']['input'];
  /** Item reference */
  reference: Scalars['String']['input'];
};

/** Support - Order Flow - Other - Actions - Input */
export type Support_OrderFlow_Other_Actions_Input = {
  /** Add a message to the support ticket */
  addSupportTicketMessage: Support_OrderFlow_Action_AddSupportTicketMessage_Input;
};

/** Support - Order Flow - Other - input */
export type Support_OrderFlow_Other_Input = {
  /** Actions to perform */
  actions: Support_OrderFlow_Other_Actions_Input;
  /** Order ids concerned */
  orderIds: Array<Scalars['ID']['input']>;
  /** Query to search for concerned orders */
  query: Orders_Search_Filter_Input;
  /** Ticket configuration */
  ticket?: InputMaybe<Support_OrderFlow_Ticket_Input>;
};

/** Support - Order Flow - Product out of stock Shopify - Actions - Input */
export type Support_OrderFlow_ProductOutOfStockShopify_Actions_Input = {
  /** Declare order items as out of stock */
  declareOrderItemsAsOutOfStock: Support_OrderFlow_Action_DeclareOrderItemsAsOutOfStock_Input;
};

/** Support - Order Flow - Product out of stock Shopify - Input */
export type Support_OrderFlow_ProductOutOfStockShopify_Input = {
  /** Actions to perform */
  actions: Support_OrderFlow_ProductOutOfStockShopify_Actions_Input;
  /** Order item lines to process */
  orderItemLines: Array<Support_OrderFlow_ProductOutOfStockShopify_OrderItemLine_Input>;
  /** Query to search for concerned orders */
  query: Orders_Search_Filter_Input;
};

/** Support - Order Flow - Product out of stock Shopify - Order item line - Input */
export type Support_OrderFlow_ProductOutOfStockShopify_OrderItemLine_Input = {
  /** Order id */
  orderId: Scalars['ID']['input'];
  /** Quantity of items to declare as out of stock */
  quantity: Scalars['Int']['input'];
  /** Item reference */
  reference: Scalars['String']['input'];
};

/** Support - Order Flow - Product out of stock - Actions - Input */
export type Support_OrderFlow_ProductOutOfStock_Actions_Input = {
  /** Declare order items as out of stock */
  declareOrderItemsAsOutOfStock: Support_OrderFlow_Action_DeclareOrderItemsAsOutOfStock_Input;
};

/** Support - Order Flow - Product out of stock - Input */
export type Support_OrderFlow_ProductOutOfStock_Input = {
  /** Actions to perform */
  actions: Support_OrderFlow_ProductOutOfStock_Actions_Input;
  /** Order ids concerned */
  orderIds: Array<Scalars['ID']['input']>;
  /** Query to search for concerned orders */
  query: Orders_Search_Filter_Input;
};

/** Support - Order Flow - Product wrong description - Actions - Input */
export type Support_OrderFlow_ProductWrongDescription_Actions_Input = {
  /** Add an amount of credit to the support app contact */
  addSupportAppContactCredit?: InputMaybe<Support_OrderFlow_Action_AddSupportAppContactCredit_Input>;
  /** Add a message to the support ticket */
  addSupportTicketMessage: Support_OrderFlow_Action_AddSupportTicketMessage_Input;
};

/** Support - Order Flow - Product wrong description - Input */
export type Support_OrderFlow_ProductWrongDescription_Input = {
  /** Actions to perform */
  actions: Support_OrderFlow_ProductWrongDescription_Actions_Input;
  /** Order ids concerned */
  orderIds: Array<Scalars['ID']['input']>;
  /** Query to search for concerned orders */
  query: Orders_Search_Filter_Input;
  /** Ticket configuration */
  ticket?: InputMaybe<Support_OrderFlow_Ticket_Input>;
};

/** Support - Order flow - Search - Filter - Flow - Input */
export type Support_OrderFlow_Search_Filter_Flow_Input = {
  /** Filter in flow types */
  in?: InputMaybe<Array<SupportOrderFlowType>>;
  /** Filter not in flow types */
  notIn?: InputMaybe<Array<SupportOrderFlowType>>;
};

/** Support - Order flow - Search - Filter - Input */
export type Support_OrderFlow_Search_Filter_Input = {
  /** Filter by created by id */
  createdById?: InputMaybe<IdFilterInput>;
  /** Filter by flow */
  flow?: InputMaybe<Support_OrderFlow_Search_Filter_Flow_Input>;
  /** Filter by id */
  id?: InputMaybe<IdFilterInput>;
  /** Filter by status */
  status?: InputMaybe<Support_OrderFlow_Search_Filter_Status_Input>;
};

/** Support - Order flow - Search - Filter - Status - Input */
export type Support_OrderFlow_Search_Filter_Status_Input = {
  /** Filter in statuses */
  in?: InputMaybe<Array<SupportOrderFlowStatus>>;
  /** Filter not in statuses */
  notIn?: InputMaybe<Array<SupportOrderFlowStatus>>;
};

/** Support - Order flow - Search - Input */
export type Support_OrderFlow_Search_Input = {
  /** After cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Before cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filters */
  filters?: InputMaybe<Support_OrderFlow_Search_Filter_Input>;
  /** First number of order flows to return */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Last number of order flows to return */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Sort */
  sortBy?: InputMaybe<Support_OrderFlow_Search_Sort_Input>;
};

/** Support - Order flow - Search - Sort - Direction */
export enum Support_OrderFlow_Search_Sort_Direction {
  /** Sort in ascending order */
  Asc = 'asc',
  /** Sort in descending order */
  Desc = 'desc'
}

/** Support - Order flow - Search - Sort - Field */
export enum Support_OrderFlow_Search_Sort_Field {
  /** Sort by creation date */
  CreatedAt = 'createdAt'
}

/** Support - Order flow - Search - Sort - Input */
export type Support_OrderFlow_Search_Sort_Input = {
  /** Sort by direction */
  direction: Support_OrderFlow_Search_Sort_Direction;
  /** Sort by field */
  field: Support_OrderFlow_Search_Sort_Field;
};

/** Support - Order Flow - Ticket - Input */
export type Support_OrderFlow_Ticket_Input = {
  /** Sub status */
  subStatus?: InputMaybe<SupportTicketSubStatusOrderFlow>;
};

/** Support - Order flows - Input */
export type Support_OrderFlows_Input = {
  /** Order flow ids */
  orderFlowIds: Array<Scalars['ID']['input']>;
};

/** System information */
export type SystemInfo = {
  __typename?: 'SystemInfo';
  /** Environment */
  environment: Scalars['String']['output'];
  /** Version */
  version: Scalars['String']['output'];
};

/** Tracking */
export type Tracking = {
  __typename?: 'Tracking';
  /** Courier */
  courier: Courier;
  /** Courier slug */
  courierSlug: Scalars['String']['output'];
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Delivery date */
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier */
  id: Scalars['ID']['output'];
  /** Number */
  number: Scalars['String']['output'];
  /** Status */
  status: TrackingStatus;
  /** Sub status */
  subStatus: TrackingSubStatus;
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
  /** URL */
  url: Scalars['String']['output'];
};

/** Tracking info - Input */
export type TrackingInfo_Input = {
  /** Tracking courier slug */
  trackingCourierSlug: Scalars['String']['input'];
  /** Tracking number */
  trackingNumber: Scalars['String']['input'];
};

/** Tracking status */
export enum TrackingStatus {
  /** Attempt fail */
  AttemptFail = 'ATTEMPT_FAIL',
  /** Available for pickup */
  AvailableForPickup = 'AVAILABLE_FOR_PICKUP',
  /** Delivered */
  Delivered = 'DELIVERED',
  /** Exception */
  Exception = 'EXCEPTION',
  /** Expired */
  Expired = 'EXPIRED',
  /** Info received */
  InfoReceived = 'INFO_RECEIVED',
  /** In transit */
  InTransit = 'IN_TRANSIT',
  /** Out for delivery */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** Pending */
  Pending = 'PENDING'
}

/** Tracking sub status */
export enum TrackingSubStatus {
  /** Business is closed at the time of delivery (AttemptFail_003) */
  AttemptFailBusinessClosed = 'ATTEMPT_FAIL_BUSINESS_CLOSED',
  /** The delivery of the package failed due to some reason. Courier usually leaves a notice and will try to deliver again (AttemptFail_001) */
  AttemptFailDueToSomeReason = 'ATTEMPT_FAIL_DUE_TO_SOME_REASON',
  /** Recipient not available at the given address (AttemptFail_002) */
  AttemptFailRecipientNotAvailable = 'ATTEMPT_FAIL_RECIPIENT_NOT_AVAILABLE',
  /** The package arrived at a pickup point near you and is available for pickup (AvailableForPickup_001) */
  AvailableForPickup = 'AVAILABLE_FOR_PICKUP',
  /** Package delivered to the recipient and cash collected on delivery (Delivered_004) */
  DeliveredAndCashCollected = 'DELIVERED_AND_CASH_COLLECTED',
  /** Package delivered to and signed by the recipient (Delivered_003) */
  DeliveredAndSignedByRecipient = 'DELIVERED_AND_SIGNED_BY_RECIPIENT',
  /** CUSTOM: Marked delivered by a bot (Delivered_Mark_By_Bot) */
  DeliveredMarkedByBot = 'DELIVERED_MARKED_BY_BOT',
  /** CUSTOM: Marked delivered by the customer (Delivered_Mark_By_Customer) */
  DeliveredMarkedByCustomer = 'DELIVERED_MARKED_BY_CUSTOMER',
  /** CUSTOM: Marked delivered by a member of the support team (Delivered_Mark_By_Support) */
  DeliveredMarkedBySupportTeam = 'DELIVERED_MARKED_BY_SUPPORT_TEAM',
  /** Package picked up by the recipient (Delivered_002) */
  DeliveredPickedUpByRecipient = 'DELIVERED_PICKED_UP_BY_RECIPIENT',
  /** Shipment delivered successfully (Delivered_001) */
  DeliveredSuccessfully = 'DELIVERED_SUCCESSFULLY',
  /** The package is on its way back to the sender (Exception_010) */
  ExceptionBackToSender = 'EXCEPTION_BACK_TO_SENDER',
  /** The return package has been successfully received by the sender (Exception_011) */
  ExceptionBackToSenderReceived = 'EXCEPTION_BACK_TO_SENDER_RECEIVED',
  /** The carrier attempted to pick up the shipment but was unsuccessful (Exception_014) */
  ExceptionCarrierPickupFailed = 'EXCEPTION_CARRIER_PICKUP_FAILED',
  /** Shipment damaged (Exception_012) */
  ExceptionDamaged = 'EXCEPTION_DAMAGED',
  /** Package delayed due to some issues during the customs clearance (Exception_004) */
  ExceptionDelayedCustomsClearance = 'EXCEPTION_DELAYED_CUSTOMS_CLEARANCE',
  /** Package not delivered due to incorrect recipient address (Exception_007) */
  ExceptionIncorrectRecipientAddress = 'EXCEPTION_INCORRECT_RECIPIENT_ADDRESS',
  /** Delivery of the package failed as it got lost (Exception_013) */
  ExceptionLost = 'EXCEPTION_LOST',
  /** The package being held due to pending payment from the recipient's end (Exception_006) */
  ExceptionPendingPayment = 'EXCEPTION_PENDING_PAYMENT',
  /** Package available for the pickup but not collected by the recipient (Exception_008) */
  ExceptionPickupNotCollectedByRecipient = 'EXCEPTION_PICKUP_NOT_COLLECTED_BY_RECIPIENT',
  /** Delivery of the package failed as the recipient refused to take the package due to some reason (Exception_003) */
  ExceptionRecipientRefused = 'EXCEPTION_RECIPIENT_REFUSED',
  /** Delivery of the package failed as the recipient relocated (Exception_002) */
  ExceptionRecipientRelocated = 'EXCEPTION_RECIPIENT_RELOCATED',
  /** Package rejected by the carrier due to noncompliance with its guidelines (Exception_009) */
  ExceptionRejectedByCarrier = 'EXCEPTION_REJECTED_BY_CARRIER',
  /** Delivery of the package failed due to some shipping exception (Exception_001) */
  ExceptionShippingException = 'EXCEPTION_SHIPPING_EXCEPTION',
  /** Package delayed due to some unforeseen reasons (Exception_005) */
  ExceptionUnforseenReason = 'EXCEPTION_UNFORSEEN_REASON',
  /** No tracking information of the shipment, from the last 30 days (Expired_001) */
  ExpiredNoTrackingInformation = 'EXPIRED_NO_TRACKING_INFORMATION',
  /** The carrier received a request from the shipper and is about to pick up the shipment (InfoReceived_001) */
  InfoReceivedAboutToPickup = 'INFO_RECEIVED_ABOUT_TO_PICKUP',
  /** Shipment accepted by the carrier (InTransit_002) */
  InTransitAcceptedByCarrier = 'IN_TRANSIT_ACCEPTED_BY_CARRIER',
  /** Shipment arrived at a hub or sorting center (InTransit_003) */
  InTransitArrivedAtAHubOrSortingCenter = 'IN_TRANSIT_ARRIVED_AT_A_HUB_OR_SORTING_CENTER',
  /** International shipment arrived at the destination country / region (InTransit_004) */
  InTransitArrivedAtDestinationCountryOrRegion = 'IN_TRANSIT_ARRIVED_AT_DESTINATION_COUNTRY_OR_REGION',
  /** Customs clearance completed (InTransit_005) */
  InTransitCustomsClearanceCompleted = 'IN_TRANSIT_CUSTOMS_CLEARANCE_COMPLETED',
  /** Package departed from the facility (InTransit_007) */
  InTransitDepartedFromFacility = 'IN_TRANSIT_DEPARTED_FROM_FACILITY',
  /** Shipment forwarded to a different delivery address (InTransit_009) */
  InTransitForwardedToADifferentDeliveryAddress = 'IN_TRANSIT_FORWARDED_TO_A_DIFFERENT_DELIVERY_ADDRESS',
  /** Package handed over to customs for clearance (InTransit_006) */
  InTransitHandedOverToCustomsForClearance = 'IN_TRANSIT_HANDED_OVER_TO_CUSTOMS_FOR_CLEARANCE',
  /** Shipment on the way (InTransit_001) */
  InTransitOnTheWay = 'IN_TRANSIT_ON_THE_WAY',
  /** Problem resolved and shipment in transit (InTransit_008) */
  InTransitProblemResolved = 'IN_TRANSIT_PROBLEM_RESOLVED',
  /** The package is out for delivery (OutForDelivery_001) */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** A delivery appointment is scheduled (OutForDelivery_004) */
  OutForDeliveryAppointmentScheduled = 'OUT_FOR_DELIVERY_APPOINTMENT_SCHEDULED',
  /** The recipient is contacted before the final delivery (OutForDelivery_003) */
  OutForDeliveryRecipientContacted = 'OUT_FOR_DELIVERY_RECIPIENT_CONTACTED',
  /** Can’t track this type of shipment as the carrier is unrecognized (Pending_006) */
  PendingCarrierUnrecognized = 'PENDING_CARRIER_UNRECOGNIZED',
  /** The order has been processed / packaged, but not scanned at a shipping location yet (Pending_003) */
  PendingNotScanned = 'PENDING_NOT_SCANNED',
  /** It represents the shipments are pending due to no connection with carrier accounts (Pending_002) */
  PendingNoConnectionWithCarrier = 'PENDING_NO_CONNECTION_WITH_CARRIER',
  /** No information available on the carrier website or the tracking number is yet to be tracked (Pending_001) */
  PendingNoInformationAvailable = 'PENDING_NO_INFORMATION_AVAILABLE',
  /** There have been no new tracking updates in the last 120 days (Pending_005) */
  PendingNoUpdate = 'PENDING_NO_UPDATE',
  /** There is no tracking info available because the carrier is wrong (Pending_004) */
  PendingWrongCarrier = 'PENDING_WRONG_CARRIER'
}

/** Translate - Input */
export type Translate_Input = {
  /** Language */
  language: LanguageIso6391;
  /** Text */
  text: Scalars['String']['input'];
};

/** Translation */
export type Translation = {
  __typename?: 'Translation';
  /** Original language */
  originalLanguage: Scalars['String']['output'];
  /** Original text */
  originalText: Scalars['String']['output'];
  /** Translated language */
  translatedLanguage: LanguageIso6391;
  /** Translated text */
  translatedText: Scalars['String']['output'];
};

export type UpdateSupportSnippetInput = {
  /** The new store id of the snippet. */
  storeId?: InputMaybe<Store>;
  /** The new tag ids of the snippet. */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The new templates of the snippet. */
  templates?: InputMaybe<Array<UpdateSupportSnippetTemplateInput>>;
  /** The new title of the snippet. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupportSnippetTagInput = {
  /** The new background color of the snippet tag. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** The new description of the snippet tag. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The new label of the snippet tag. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The new text color of the snippet tag. */
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupportSnippetTemplateInput = {
  /** The language of the snippet template. */
  language: LanguageIso6391;
  /** The new template of the snippet template. */
  template: Scalars['String']['input'];
};

export type UpdateSupportViewInput = {
  /** The new properties to display in the support view (optional). */
  displayedProperties?: InputMaybe<SupportViewDisplayedPropertyInput>;
  /** The new filters to apply to the support tickets in this view (optional). */
  filters?: InputMaybe<SupportTicketsFilterInput>;
  /** The new properties by which to group the support tickets in this view (optional). */
  groupBy?: InputMaybe<SupportViewGroupByProperty>;
  /** The new icon for the support view (optional). */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The new color for the icon (optional). */
  iconColor?: InputMaybe<Scalars['String']['input']>;
  /** The new sorting to apply to the support tickets in this view (optional). */
  sortBy?: InputMaybe<SupportTicketsSortInput>;
  /** The new title for the support view (optional). */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Upload = {
  __typename?: 'Upload';
  expiresAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UploadInput = {
  fileMimeType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
};

/** A specific variant of a product (e.g. size/color combination). */
export type Variant = {
  __typename?: 'Variant';
  /** Alerts summary */
  alertsSummary: VariantAlertsSummary;
  /** Default delivery delays for the variant. */
  defaultDeliveryDelays?: Maybe<Scalars['Int']['output']>;
  /** Default shipping amount for the variant. */
  defaultShippingAmount?: Maybe<Scalars['Int']['output']>;
  /** Default time boundaries for the variant. */
  defaultTimeBoundaries?: Maybe<VariantTimeBoundaries>;
  /** Display name for the variant. */
  displayName: Scalars['String']['output'];
  /** Financial information for the variant. */
  financial: VariantFinancial;
  /** GTIN (Global Trade Item Number) for the variant, if any. */
  gtin?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the variant. */
  id: Scalars['String']['output'];
  /** List of images for the variant. */
  images: Array<VariantImage>;
  /** Inventory information for the variant. */
  inventory: VariantInventory;
  /** Indicates if the variant is unique. */
  isUnique: Scalars['Boolean']['output'];
  /** Packaging details for the variant. */
  packaging: VariantPackaging;
  /** Product */
  product: Product;
  /** Identifier of the parent product. */
  productId: Scalars['String']['output'];
  /** Shipping policy for the variant. */
  shippingPolicy: VariantShippingPolicy;
  /** SKU (Stock Keeping Unit) for the variant, if any. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Specific delivery delays for the variant. */
  specificDeliveryDelays?: Maybe<Scalars['Int']['output']>;
  /** Store where the variant is available. */
  storeId: Store;
  /** Title of the variant. */
  title: Scalars['String']['output'];
  /** Number of units per pack for the variant, if any. */
  unitsPerPack?: Maybe<Scalars['Int']['output']>;
  /** Visibility status of the variant. */
  visibility: VariantVisibility;
};

export type VariantAlertsSummary = {
  __typename?: 'VariantAlertsSummary';
  /** Active alert count */
  activeAlertCount: Scalars['NonNegativeInt']['output'];
  /** Archived alert count */
  archivedAlertCount: Scalars['NonNegativeInt']['output'];
  /** Potential revenue */
  potentialRevenueInCents: Scalars['NonNegativeInt']['output'];
};

/** A delivery offer with time boundaries for standard delivery. */
export type VariantDeliveryOfferWithBoundaries = {
  __typename?: 'VariantDeliveryOfferWithBoundaries';
  /** Shipping cost in cents. */
  cost: Scalars['Int']['output'];
  /** Delivery delays in days. */
  delays: Scalars['Int']['output'];
  /** Unique key identifying the delivery offer. */
  key: Scalars['String']['output'];
  /** Delivery method (home or pickup_point). */
  method: Scalars['String']['output'];
  /** Time boundaries for the delivery. */
  timeBoundaries: VariantTimeBoundaries;
};

/** A delivery offer with deadline for express delivery. */
export type VariantDeliveryOfferWithDeadline = {
  __typename?: 'VariantDeliveryOfferWithDeadline';
  /** Shipping cost in cents. */
  cost: Scalars['Int']['output'];
  /** Delivery delays in days. */
  delays: Scalars['Int']['output'];
  /** Estimated delivery date in LocalDate format. */
  deliveryDate: Scalars['String']['output'];
  /** Deadline for placing the order to get express delivery. */
  deliveryDeadLine: Scalars['DateTime']['output'];
  /** Unique key identifying the delivery offer (always ExpressHomeDelivery). */
  key: Scalars['String']['output'];
  /** Delivery method (always home for express). */
  method: Scalars['String']['output'];
};

/** Financial information for a product variant. */
export type VariantFinancial = {
  __typename?: 'VariantFinancial';
  /** Buying price for the variant. */
  buyingPrice: VariantPrice;
  /** Choose take rate for the variant. */
  chooseTakeRate?: Maybe<Scalars['Float']['output']>;
  /** Discount rate applied to the variant. */
  discountRate?: Maybe<Scalars['Float']['output']>;
  /** EEE price for the variant, if applicable. */
  eeePrice?: Maybe<VariantPrice>;
  /** Public price for the variant. */
  publicPrice: VariantPrice;
  /** Retail price for the variant. */
  retailPrice: VariantPrice;
};

/** Represents an image associated with a variant. */
export type VariantImage = {
  __typename?: 'VariantImage';
  /** Storage key for the image base. */
  baseKey: Scalars['String']['output'];
  /** Unique identifier of the image. */
  id: Scalars['String']['output'];
  /** Public URL of the image. */
  url: Scalars['String']['output'];
  /** Version number of the image (for cache busting). */
  version: Scalars['Int']['output'];
};

/** Inventory information for a product variant. */
export type VariantInventory = {
  __typename?: 'VariantInventory';
  /** Country of origin for the stock. */
  originCountry?: Maybe<Scalars['String']['output']>;
  /** Quantity available in stock. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier of the stock entry. */
  stockId?: Maybe<Scalars['String']['output']>;
};

/** Packaging details for a product variant. */
export type VariantPackaging = {
  __typename?: 'VariantPackaging';
  /** Height of the package in millimeters. */
  heightInMillimeters?: Maybe<Scalars['Int']['output']>;
  /** Length of the package in millimeters. */
  lengthInMillimeters?: Maybe<Scalars['Int']['output']>;
  /** Weight of the package in grams. */
  weightInGrams?: Maybe<Scalars['Int']['output']>;
  /** Width of the package in millimeters. */
  widthInMillimeters?: Maybe<Scalars['Int']['output']>;
};

/** Price information for variant. */
export type VariantPrice = {
  __typename?: 'VariantPrice';
  /** Price excluding VAT, in cents. */
  amountVatExcludedInCents: Scalars['Int']['output'];
  /** Price including VAT, in cents. */
  amountVatIncludedInCents: Scalars['Int']['output'];
  /** Currency code (e.g. "EUR"). */
  currency: CurrencyIso;
  /** VAT rate applied to the price. */
  vatRate: Scalars['Float']['output'];
};

/**
 * Union type representing different shipping policy configurations for a variant.
 * Can be either standard delivery offers or express-only delivery.
 */
export type VariantShippingPolicy = VariantShippingPolicyExpress | VariantShippingPolicyStandard;

/**
 * Express shipping policy for a variant.
 * Used when express delivery is the only available option (e.g., seasonal events).
 */
export type VariantShippingPolicyExpress = {
  __typename?: 'VariantShippingPolicyExpress';
  /** Indicates if the variant can be delivered to the specified country. */
  canBeDeliveredToCountry: Scalars['Boolean']['output'];
  /** Indicates if the country can be edited for this variant. */
  canEditCountry: Scalars['Boolean']['output'];
  /** Single express delivery offer with deadline. */
  deliveryOffers: Array<VariantDeliveryOfferWithDeadline>;
  /** Indicates if express delivery is available (always true for this type). */
  isExpress: Scalars['Boolean']['output'];
};

/**
 * Shipping policy for a variant with standard delivery offers.
 * Used when express delivery is not available.
 */
export type VariantShippingPolicyStandard = {
  __typename?: 'VariantShippingPolicyStandard';
  /** Indicates if the variant can be delivered to the specified country. */
  canBeDeliveredToCountry: Scalars['Boolean']['output'];
  /** Indicates if the country can be edited for this variant. */
  canEditCountry: Scalars['Boolean']['output'];
  /** List of available delivery offers with time boundaries. */
  deliveryOffers: Array<VariantDeliveryOfferWithBoundaries>;
  /** Indicates if express delivery is available (always false for this type). */
  isExpress: Scalars['Boolean']['output'];
};

/** Variant stats */
export type VariantStats = {
  __typename?: 'VariantStats';
  /** Id */
  id: Scalars['ID']['output'];
  /** Image url */
  imageUrl: Scalars['URL']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Option value */
  optionValue?: Maybe<Scalars['String']['output']>;
  /** Options */
  options: Array<Scalars['String']['output']>;
  /** Product id */
  productId: Scalars['ID']['output'];
  /** Total amount in cents */
  totalAmountInCents: Scalars['NonNegativeInt']['output'];
  /** Total count */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** Time boundaries for a variant, with a start and end date. */
export type VariantTimeBoundaries = {
  __typename?: 'VariantTimeBoundaries';
  /** Start date/time for the boundary. */
  from: Scalars['DateTime']['output'];
  /** End date/time for the boundary. */
  to: Scalars['DateTime']['output'];
};

/** Visibility status of a variant. */
export type VariantVisibility = {
  __typename?: 'VariantVisibility';
  /** Timestamp when the variant was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates if the variant is available for sale. */
  isAvailableForSale: Scalars['Boolean']['output'];
  /** Indicates if the variant is deleted. */
  isDeleted: Scalars['Boolean']['output'];
  /** Indicates if the variant is a draft. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates if the variant is hidden for sale. */
  isHidden: Scalars['Boolean']['output'];
};

/** Variant - Edit stock quantity - Input */
export type Variant_EditStockQuantity_Input = {
  /** Stock quantity */
  stockQuantity: Scalars['NonNegativeInt']['input'];
  /** Variant id */
  variantId: Scalars['ID']['input'];
};

/** Voucher replacement code - Input */
export type VoucherReplacementCode_Input = {
  /** Original code */
  originalCode: Scalars['String']['input'];
  /** Replacement code */
  replacementCode: Scalars['String']['input'];
};

type Agent_ActorBotUser_Fragment = { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } };

type Agent_ActorInternalUser_Fragment = { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } };

type Agent_ActorSupplierUser_Fragment = { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } };

export type AgentFragment =
  | Agent_ActorBotUser_Fragment
  | Agent_ActorInternalUser_Fragment
  | Agent_ActorSupplierUser_Fragment
;

type ActorLegacy_ActorBotUser_Fragment = { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } };

type ActorLegacy_ActorInternalUser_Fragment = { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } };

type ActorLegacy_ActorSupplierUser_Fragment = { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', firstName: string, id: string, lastName: string, picture: string } };

type ActorLegacy_SupportActorAppContact_Fragment = { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } };

type ActorLegacy_SupportActorBotUser_Fragment = { __typename: 'SupportActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } };

type ActorLegacy_SupportActorEmailContact_Fragment = { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } };

type ActorLegacy_SupportActorInternalUser_Fragment = { __typename: 'SupportActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } };

export type ActorLegacyFragment =
  | ActorLegacy_ActorBotUser_Fragment
  | ActorLegacy_ActorInternalUser_Fragment
  | ActorLegacy_ActorSupplierUser_Fragment
  | ActorLegacy_SupportActorAppContact_Fragment
  | ActorLegacy_SupportActorBotUser_Fragment
  | ActorLegacy_SupportActorEmailContact_Fragment
  | ActorLegacy_SupportActorInternalUser_Fragment
;

export type AttachmentFragment = { __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string };

export type AttachmentPayloadFragment = { __typename?: 'SupportAttachmentPayload', fileMimeType: string, fileName: string, fileSize: number, fileUrl: string };

type Contact_SupportActorAppContact_Fragment = { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } };

type Contact_SupportActorEmailContact_Fragment = { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } };

export type ContactFragment =
  | Contact_SupportActorAppContact_Fragment
  | Contact_SupportActorEmailContact_Fragment
;

export type PickupPointOpeningDaysFragment = { __typename?: 'PickupOpeningDays', monday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, tuesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, wednesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, thursday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, friday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, saturday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, sunday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null };

export type PartialAddressFragment = { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string };

export type PartialAppContactFragment = { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, lastName?: string | null };

export type PartialItemFragment = { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } };

export type PartialClaimItemFragment = { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } };

export type PartialItemInitialRequestFragment = { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } };

export type PartialOrderFragment = { __typename?: 'Order', brandId: string, createdAt: string, hasBeenExported: boolean, id: string, isCancelled: boolean, isFullDigital: boolean, saleId: string, buyer: { __typename?: 'Buyer', firstName: string, lastName: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, cashback?: { __typename?: 'Cashback', amount: number, amountUpdatedAt?: string | null, currency: CurrencyIso, dueDate: string, status: CashbackStatus } | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, parcels: Array<{ __typename?: 'Parcel', id: string, estimatedDeliveryDateRange?: { __typename?: 'ParcelEstimatedDeliveryDateRange', max: string, min: string } | null, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, recipient: { __typename?: 'Recipient', firstName: string, lastName: string, phoneNumber: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, returns: Array<{ __typename?: 'Return', applyWithheld: boolean, id: string, isValidationLocked: boolean, preferredRefundMethod: PreferredRefundMethod, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string, item: { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, newDigitalCouponCode?: string | null, name: string, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } } }>, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, shipping: { __typename?: 'OrderShipping', fees: number, feesSold: number, deliveryDateRangeHistory: Array<{ __typename?: 'DeliveryDateRange', end: string, start: string }>, pickupPoint?: { __typename?: 'PickupPoint', id: string, address?: { __typename?: 'PickupAddress', city: string, countryCode: string, name: string, street: string, streetAdditional?: string | null, zipCode: string } | null, openingDays?: { __typename?: 'PickupOpeningDays', monday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, tuesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, wednesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, thursday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, friday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, saturday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, sunday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null } | null } | null, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number } }, supportActorAppContact: { __typename?: 'SupportActorAppContact', id: string }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number } };

export type PartialOrderAddressFragment = { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string };

export type PartialSnippetFragment = { __typename?: 'SupportSnippet', deletedAt?: string | null, id: string, storeId: Store, tagIds: Array<string>, title: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }, templates: Array<{ __typename?: 'SupportSnippetTemplate', language: LanguageIso6391, template: string }> };

export type PartialSnippetTagFragment = { __typename?: 'SupportSnippetTag', description?: string | null, deletedAt?: string | null, id: string, label: string, textColor: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } } };

export type PartialTicketFragment = { __typename?: 'SupportTicket', assignedAt?: string | null, channel: SupportTicketChannel, createdAt: string, description?: string | null, hasPendingScheduleActions: boolean, id: string, isDraft: boolean, orderFlowId?: string | null, previewText?: string | null, status: SupportTicketStatus, statusUpdatedAt: string, subStatus: SupportTicketSubStatus, title: string, updatedAt: string, assignedTo?:
    | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
    | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
    | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
   | null, contact:
    | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
    | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
  , contextDerived?: { __typename?: 'SupportTicketContextDerived', orderId?: string | null, saleId?: string | null, storeId?: Store | null, supplierId?: string | null, sale?: { __typename?: 'Sale', name: string, salesTeamName?: SalesTeamName | null, type: SaleType } | null } | null, createdBy:
    | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
    | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
    | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
    | { __typename?: 'SupportActorAppContact' }
    | { __typename?: 'SupportActorEmailContact' }
  , initialRequest?:
    | { __typename: 'SupportTicketActivityInitialRequestMigration' }
    | { __typename: 'SupportTicketActivityInitialRequestOrder', flow: SupportTicketActivityInitialRequestOrderFlow }
    | { __typename: 'SupportTicketActivityInitialRequestOther', otherFlow: SupportTicketActivityInitialRequestOtherFlow }
    | { __typename: 'SupportTicketActivityInitialRequestSale', saleFlow: SupportTicketActivityInitialRequestSaleFlow }
    | { __typename: 'SupportTicketActivityInitialRequestVariant', variantFlow: SupportTicketActivityInitialRequestVariantFlow }
   | null };

export type LinkedTicketFragment = { __typename?: 'SupportTicket', id: string, statusUpdatedAt: string, subStatus: SupportTicketSubStatus, title: string, claims: Array<{ __typename?: 'Claim', acceptedAt?: string | null, canceledAt?: string | null, id: string }> };

export type AddAppContactCreditMutationVariables = Exact<{
  input: AddSupportActorAppContactCreditInput;
}>;


export type AddAppContactCreditMutation = { __typename?: 'Mutation', addSupportActorAppContactCredit?: any | null };

export type AddAppContactNoteMutationVariables = Exact<{
  input: AddSupportAppContactNoteInput;
}>;


export type AddAppContactNoteMutation = { __typename?: 'Mutation', addSupportAppContactNote: { __typename?: 'SupportActorAppContact', id: string } };

export type AddEmailMutationVariables = Exact<{
  input: AddSupportTicketEmailInput;
}>;


export type AddEmailMutation = { __typename?: 'Mutation', addSupportTicketEmail: { __typename?: 'SupportTicket', id: string } };

export type AddMessageMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']> | Scalars['AttachmentUrl']['input']>;
}>;


export type AddMessageMutation = { __typename?: 'Mutation', addSupportTicketMessage: { __typename?: 'SupportTicket', id: string } };

export type AddNoteMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  attachments?: InputMaybe<Array<Scalars['AttachmentUrl']['input']> | Scalars['AttachmentUrl']['input']>;
}>;


export type AddNoteMutation = { __typename?: 'Mutation', addSupportTicketNote: { __typename?: 'SupportTicket', id: string } };

export type AddSaleNoteMutationVariables = Exact<{
  input: AddSaleNoteInput;
}>;


export type AddSaleNoteMutation = { __typename?: 'Mutation', addSaleNote: { __typename?: 'Sale', id: string } };

export type AddTicketActivityReactionMutationVariables = Exact<{
  activityId: Scalars['ID']['input'];
  type: SupportTicketActivityReactionType;
}>;


export type AddTicketActivityReactionMutation = { __typename?: 'Mutation', addSupportTicketActivityReaction: { __typename?: 'SupportTicketActivityReaction', id: string } };

export type AddViewToFavoriteMutationVariables = Exact<{
  viewId: Scalars['ID']['input'];
}>;


export type AddViewToFavoriteMutation = { __typename?: 'Mutation', addSupportViewFavorite?: any | null };

export type AiSuggestionAcceptMutationVariables = Exact<{
  input: SupportTicketAiSuggestionAcceptInput;
}>;


export type AiSuggestionAcceptMutation = { __typename?: 'Mutation', supportTicket_aiSuggestion_accept: { __typename?: 'SupportTicket', id: string } };

export type AiSuggestionEditEmailMutationVariables = Exact<{
  input: SupportTicketAiSuggestionEditEmailInput;
}>;


export type AiSuggestionEditEmailMutation = { __typename?: 'Mutation', supportTicket_aiSuggestion_editEmail: { __typename?: 'SupportTicket', id: string } };

export type AiSuggestionEditMessageMutationVariables = Exact<{
  input: SupportTicketAiSuggestionEditMessageInput;
}>;


export type AiSuggestionEditMessageMutation = { __typename?: 'Mutation', supportTicket_aiSuggestion_editMessage: { __typename?: 'SupportTicket', id: string } };

export type ApplyAppContactReferralMutationVariables = Exact<{
  input: ApplySupportAppContactReferralInput;
}>;


export type ApplyAppContactReferralMutation = { __typename?: 'Mutation', applySupportAppContactReferral?: any | null };

export type ApplyAppContactReferralDryRunMutationVariables = Exact<{
  input: ApplySupportAppContactReferralInput;
}>;


export type ApplyAppContactReferralDryRunMutation = { __typename?: 'Mutation', applySupportAppContactReferralDryRun?:
    | { __typename: 'ReferralPlan', referee: { __typename?: 'Referee', appUserId: string, name: string, credit: { __typename?: 'ReferralCredit', amountInCents: number, currency: CurrencyIso } }, referrer: { __typename?: 'Referrer', appUserId: string, isMassReferrer: boolean, name: string, credit: { __typename?: 'ReferralCredit', amountInCents: number, currency: CurrencyIso } } }
    | { __typename: 'ReferralPlanError', code: ReferralPlanErrorCode }
   | null };

export type AssignSupportRoleToInternalUserMutationVariables = Exact<{
  actorId: Scalars['ID']['input'];
  role: SupportRole;
}>;


export type AssignSupportRoleToInternalUserMutation = { __typename?: 'Mutation', assignSupportRoleToInternalUser?: any | null };

export type AttachSupportTicketContextMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
  context: SupportTicketContextInput;
}>;


export type AttachSupportTicketContextMutation = { __typename?: 'Mutation', attachSupportTicketContext: { __typename?: 'SupportTicket', id: string } };

export type CancelOrderMutationVariables = Exact<{
  input: Order_Cancel_Input;
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', order_cancel?: any | null };

export type CancelOrderClaimMutationVariables = Exact<{
  input: Order_Claim_Cancel_Input;
}>;


export type CancelOrderClaimMutation = { __typename?: 'Mutation', order_claim_cancel?: any | null };

export type CancelOrderDryRunMutationVariables = Exact<{
  input: Order_Cancel_Input;
}>;


export type CancelOrderDryRunMutation = { __typename?: 'Mutation', order_cancel_dryRun: { __typename?: 'RefundSummary', cashAmountInCents: number, creditAmountInCents: number } };

export type CancelOrderItemsMutationVariables = Exact<{
  input: Order_Items_Cancel_Input;
}>;


export type CancelOrderItemsMutation = { __typename?: 'Mutation', order_items_cancel?: any | null };

export type CancelOrderItemsDryRunMutationVariables = Exact<{
  input: Order_Items_Cancel_Input;
}>;


export type CancelOrderItemsDryRunMutation = { __typename?: 'Mutation', order_items_cancel_dryRun: { __typename?: 'RefundSummary', cashAmountInCents: number, creditAmountInCents: number } };

export type CancelOrderReturnMutationVariables = Exact<{
  input: Order_Return_Cancel_Input;
}>;


export type CancelOrderReturnMutation = { __typename?: 'Mutation', order_return_cancel?: any | null };

export type CloseTicketAsDuplicateMutationVariables = Exact<{
  input: SupportTicket_CloseAsDuplicate_Input;
}>;


export type CloseTicketAsDuplicateMutation = { __typename?: 'Mutation', supportTicket_closeAsDuplicate: { __typename?: 'SupportTicket', id: string } };

export type CloseTicketAsJunkMutationVariables = Exact<{
  input: SupportTicket_CloseAsJunk_Input;
}>;


export type CloseTicketAsJunkMutation = { __typename?: 'Mutation', supportTicket_closeAsJunk: { __typename?: 'SupportTicket', id: string } };

export type CloseTicketAsUnresolvableMutationVariables = Exact<{
  input: SupportTicket_CloseAsUnresolvable_Input;
}>;


export type CloseTicketAsUnresolvableMutation = { __typename?: 'Mutation', supportTicket_closeAsUnresolvable: { __typename?: 'SupportTicket', id: string } };

export type CreateOrderReturnMutationVariables = Exact<{
  input: Order_Return_Create_Input;
}>;


export type CreateOrderReturnMutation = { __typename?: 'Mutation', order_return_create?: any | null };

export type CreateOrderReturnWithLabelMutationVariables = Exact<{
  input: Order_Return_CreateWithLabel_Input;
}>;


export type CreateOrderReturnWithLabelMutation = { __typename?: 'Mutation', order_return_createWithLabel?: any | null };

export type CreateSnippetMutationVariables = Exact<{
  input: CreateSupportSnippetInput;
}>;


export type CreateSnippetMutation = { __typename?: 'Mutation', createSupportSnippet: { __typename?: 'SupportSnippet', id: string } };

export type CreateSnippetTagMutationVariables = Exact<{
  input: CreateSupportSnippetTagInput;
}>;


export type CreateSnippetTagMutation = { __typename?: 'Mutation', createSupportSnippetTag: { __typename?: 'SupportSnippetTag', id: string } };

export type CreateTicketMutationVariables = Exact<{
  input: CreateSupportTicketInput;
}>;


export type CreateTicketMutation = { __typename?: 'Mutation', createSupportTicket: { __typename?: 'SupportTicket', id: string } };

export type CreateTicketByOrderIdMutationVariables = Exact<{
  input: CreateSupportTicketByOrderIdInput;
}>;


export type CreateTicketByOrderIdMutation = { __typename?: 'Mutation', createSupportTicketByOrderId: { __typename?: 'SupportTicket', id: string } };

export type CreateViewMutationVariables = Exact<{
  createSupportViewInput: CreateSupportViewInput;
}>;


export type CreateViewMutation = { __typename?: 'Mutation', createSupportView: { __typename?: 'SupportView', id: string } };

export type DeclareOrderItemsAsOutOfStockMutationVariables = Exact<{
  input: SupportTicket_Order_DeclareItemsAsOutOfStock_Input;
}>;


export type DeclareOrderItemsAsOutOfStockMutation = { __typename?: 'Mutation', supportTicket_order_declareItemsAsOutOfStock: { __typename?: 'SupportTicket', id: string } };

export type DeclareOrderItemsAsOutOfStockDryRunMutationVariables = Exact<{
  input: SupportTicket_Order_DeclareItemsAsOutOfStock_Input;
}>;


export type DeclareOrderItemsAsOutOfStockDryRunMutation = { __typename?: 'Mutation', supportTicket_order_declareItemsAsOutOfStock_dryRun: { __typename?: 'SupportTicket_Order_DeclareItemsAsOutOfStock_Output', creditCompensationAmountInCents: number, orderCanceled: boolean, refunds: Array<
      | { __typename?: 'OrderItemRefundPlan', itemId: string, orderId: string, breakdown: { __typename?: 'OrderRefundPlanBreakdown', cashAmountInCents: number, creditAmountInCents: number, discountAmountInCents: number } }
      | { __typename?: 'OrderItemTaxesRefundPlan', itemId: string, orderId: string, breakdown: { __typename?: 'OrderRefundPlanBreakdown', cashAmountInCents: number, creditAmountInCents: number, discountAmountInCents: number } }
      | { __typename?: 'OrderShippingFeesRefundPlan', orderId: string, breakdown: { __typename?: 'OrderRefundPlanBreakdown', cashAmountInCents: number, creditAmountInCents: number, discountAmountInCents: number } }
    > } };

export type DeleteAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
}>;


export type DeleteAttachmentMutation = { __typename?: 'Mutation', deleteSupportAttachment?: any | null };

export type DeleteTicketMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
}>;


export type DeleteTicketMutation = { __typename?: 'Mutation', deleteSupportTicket?: any | null };

export type DeleteViewMutationVariables = Exact<{
  viewId: Scalars['ID']['input'];
}>;


export type DeleteViewMutation = { __typename?: 'Mutation', deleteSupportView?: any | null };

export type DetachSupportTicketContextMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
}>;


export type DetachSupportTicketContextMutation = { __typename?: 'Mutation', detachSupportTicketContext: { __typename?: 'SupportTicket', id: string } };

export type EditOrderBillingAddressMutationVariables = Exact<{
  input: Order_EditBillingAddress_Input;
}>;


export type EditOrderBillingAddressMutation = { __typename?: 'Mutation', order_editBillingAddress?: any | null };

export type EditOrderReturnPreferredRefundMethodMutationVariables = Exact<{
  input: Order_Return_EditPreferredRefundMethod_Input;
}>;


export type EditOrderReturnPreferredRefundMethodMutation = { __typename?: 'Mutation', order_return_editPreferredRefundMethod?: any | null };

export type EditOrderReturnTrackingInfoMutationVariables = Exact<{
  input: Order_Return_EditTrackingInfo_Input;
}>;


export type EditOrderReturnTrackingInfoMutation = { __typename?: 'Mutation', order_return_editTrackingInfo?: any | null };

export type EditUserLanguageMutationVariables = Exact<{
  input: CurrentUser_EditLanguage_Input;
}>;


export type EditUserLanguageMutation = { __typename?: 'Mutation', currentUser_editLanguage?: any | null };

export type EditUserNameMutationVariables = Exact<{
  input: CurrentUser_EditName_Input;
}>;


export type EditUserNameMutation = { __typename?: 'Mutation', currentUser_editName?: any | null };

export type EditUserPictureMutationVariables = Exact<{
  input: CurrentUser_EditPicture_Input;
}>;


export type EditUserPictureMutation = { __typename?: 'Mutation', currentUser_editPicture?: any | null };

export type EditAppContactReferralCodeMutationVariables = Exact<{
  input: EditSupportActorAppContactReferralCodeInput;
}>;


export type EditAppContactReferralCodeMutation = { __typename?: 'Mutation', editSupportActorAppContactReferralCode?: any | null };

export type FlagContactAsFrauderMutationVariables = Exact<{
  input: Support_ActorAppContact_FlagAsFrauder_Input;
}>;


export type FlagContactAsFrauderMutation = { __typename?: 'Mutation', support_actorAppContact_flagAsFrauder: { __typename?: 'SupportActorAppContact', id: string } };

export type FlagContactAsInfluencerMutationVariables = Exact<{
  input: Support_ActorAppContact_FlagAsInfluencer_Input;
}>;


export type FlagContactAsInfluencerMutation = { __typename?: 'Mutation', support_actorAppContact_flagAsInfluencer: { __typename?: 'SupportActorAppContact', id: string } };

export type GenerateOrderReturnLabelUploadUrlMutationVariables = Exact<{
  input: Order_Return_GenerateLabelUploadUrl_Input;
}>;


export type GenerateOrderReturnLabelUploadUrlMutation = { __typename?: 'Mutation', order_return_generateLabelUploadUrl: { __typename?: 'Upload', expiresAt: string, key: string, url: string } };

export type GeneratePictureUploadUrlMutationVariables = Exact<{
  input: UploadInput;
}>;


export type GeneratePictureUploadUrlMutation = { __typename?: 'Mutation', currentUser_generatePictureUploadUrl: { __typename?: 'Upload', expiresAt: string, key: string, url: string } };

export type GenerateSupportAttachmentUploadUrlMutationVariables = Exact<{
  upload: SupportAttachmentUploadUrlInput;
}>;


export type GenerateSupportAttachmentUploadUrlMutation = { __typename?: 'Mutation', generateSupportAttachmentUploadUrl: { __typename?: 'Upload', expiresAt: string, key: string, url: string } };

export type LockOrderReturnValidationMutationVariables = Exact<{
  input: Order_Return_LockValidation_Input;
}>;


export type LockOrderReturnValidationMutation = { __typename?: 'Mutation', order_return_lockValidation?: any | null };

export type MakeReviewInitialRequestAiClassificationMutationVariables = Exact<{
  input: SupportTicketInitialRequestReviewFlowInput;
}>;


export type MakeReviewInitialRequestAiClassificationMutation = { __typename?: 'Mutation', supportTicket_initialRequest_reviewFlow: { __typename?: 'SupportTicketActivityInitialRequestFlowReview', reviewedFlow: SupportTicketActivityInitialRequestFlow } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllSupportNotificationsAsRead: boolean };

export type MarkNotificationAsReadMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markSupportNotificationAsRead?:
    | { __typename?: 'SupportNotificationMention', id: string }
    | { __typename?: 'SupportNotificationReaction', id: string }
   | null };

export type MarkOrderParcelsAsDeliveredMutationVariables = Exact<{
  input: Order_Parcels_MarkAsDelivered_Input;
}>;


export type MarkOrderParcelsAsDeliveredMutation = { __typename?: 'Mutation', order_parcels_markAsDelivered?: any | null };

export type OpenOrderClaimForDeliveredButDamagedMutationVariables = Exact<{
  input: Order_Claim_OpenForDeliveredButDamaged_Input;
}>;


export type OpenOrderClaimForDeliveredButDamagedMutation = { __typename?: 'Mutation', order_claim_openForDeliveredButDamaged?: any | null };

export type OpenOrderClaimForDeliveredButIncompleteMutationVariables = Exact<{
  input: Order_Claim_OpenForDeliveredButIncomplete_Input;
}>;


export type OpenOrderClaimForDeliveredButIncompleteMutation = { __typename?: 'Mutation', order_claim_openForDeliveredButIncomplete?: any | null };

export type OpenOrderClaimForDeliveredButWrongMutationVariables = Exact<{
  input: Order_Claim_OpenForDeliveredButWrong_Input;
}>;


export type OpenOrderClaimForDeliveredButWrongMutation = { __typename?: 'Mutation', order_claim_openForDeliveredButWrong?: any | null };

export type OpenOrderClaimForNotDeliveredAndReturnedToSenderMutationVariables = Exact<{
  input: Order_Claim_OpenForNotDeliveredAndReturnedToSender_Input;
}>;


export type OpenOrderClaimForNotDeliveredAndReturnedToSenderMutation = { __typename?: 'Mutation', order_claim_openForNotDeliveredAndReturnedToSender?: any | null };

export type OpenOrderClaimForNotDeliveredAndTrackingBlockedMutationVariables = Exact<{
  input: Order_Claim_OpenForNotDeliveredAndTrackingBlocked_Input;
}>;


export type OpenOrderClaimForNotDeliveredAndTrackingBlockedMutation = { __typename?: 'Mutation', order_claim_openForNotDeliveredAndTrackingBlocked?: any | null };

export type OpenOrderClaimForNotDeliveredAndTrackingDeliveredMutationVariables = Exact<{
  input: Order_Claim_OpenForNotDeliveredAndTrackingDelivered_Input;
}>;


export type OpenOrderClaimForNotDeliveredAndTrackingDeliveredMutation = { __typename?: 'Mutation', order_claim_openForNotDeliveredAndTrackingDelivered?: any | null };

export type OpenOrderClaimForOtherMutationVariables = Exact<{
  input: Order_Claim_OpenForOther_Input;
}>;


export type OpenOrderClaimForOtherMutation = { __typename?: 'Mutation', order_claim_openForOther?: any | null };

export type OpenOrderClaimForVoucherNotWorkingMutationVariables = Exact<{
  input: Order_Claim_OpenForVoucherNotWorking_Input;
}>;


export type OpenOrderClaimForVoucherNotWorkingMutation = { __typename?: 'Mutation', order_claim_openForVoucherNotWorking?: any | null };

export type OrderFlowCommunicationAppUsersMutationVariables = Exact<{
  input: Support_OrderFlow_CommunicationAppUsers_Input;
}>;


export type OrderFlowCommunicationAppUsersMutation = { __typename?: 'Mutation', support_orderFlow_communicationAppUsers?: any | null };

export type OrderFlowCreditCompensationSupplierChargedMutationVariables = Exact<{
  input: Support_OrderFlow_CreditCompensationSupplierCharged_Input;
}>;


export type OrderFlowCreditCompensationSupplierChargedMutation = { __typename?: 'Mutation', support_orderFlow_creditCompensationSupplierCharged?: any | null };

export type OrderFlowDeliveryDelayV2MutationVariables = Exact<{
  input: Support_OrderFlow_DeliveryDelayV2_Input;
}>;


export type OrderFlowDeliveryDelayV2Mutation = { __typename?: 'Mutation', support_orderFlow_deliveryDelayV2?: any | null };

export type OrderFlowOrderCancellationMutationVariables = Exact<{
  input: Support_OrderFlow_OrderCancellation_Input;
}>;


export type OrderFlowOrderCancellationMutation = { __typename?: 'Mutation', support_orderFlow_orderCancellation?: any | null };

export type OrderFlowOrderOptimizationPackagingMutationVariables = Exact<{
  input: Support_OrderFlow_OrderOptimizationPackaging_Input;
}>;


export type OrderFlowOrderOptimizationPackagingMutation = { __typename?: 'Mutation', support_orderFlow_orderOptimizationPackaging?: any | null };

export type OrderFlowOtherMutationVariables = Exact<{
  input: Support_OrderFlow_Other_Input;
}>;


export type OrderFlowOtherMutation = { __typename?: 'Mutation', support_orderFlow_other?: any | null };

export type OrderFlowProductOutOfStockMutationVariables = Exact<{
  input: Support_OrderFlow_ProductOutOfStock_Input;
}>;


export type OrderFlowProductOutOfStockMutation = { __typename?: 'Mutation', support_orderFlow_productOutOfStock?: any | null };

export type OrderFlowProductOutOfStockShopifyMutationVariables = Exact<{
  input: Support_OrderFlow_ProductOutOfStockShopify_Input;
}>;


export type OrderFlowProductOutOfStockShopifyMutation = { __typename?: 'Mutation', support_orderFlow_productOutOfStockShopify?: any | null };

export type OrderFlowProductWrongDescriptionMutationVariables = Exact<{
  input: Support_OrderFlow_ProductWrongDescription_Input;
}>;


export type OrderFlowProductWrongDescriptionMutation = { __typename?: 'Mutation', support_orderFlow_productWrongDescription?: any | null };

export type RefundOrderItemsMutationVariables = Exact<{
  input: Order_Items_Refund_Input;
}>;


export type RefundOrderItemsMutation = { __typename?: 'Mutation', order_items_refund?: any | null };

export type RefundOrderItemsDryRunMutationVariables = Exact<{
  input: Order_Items_Refund_Input;
}>;


export type RefundOrderItemsDryRunMutation = { __typename?: 'Mutation', order_items_refund_dryRun: { __typename?: 'RefundSummary', cashAmountInCents: number, creditAmountInCents: number } };

export type RefundOrderShippingFeesMutationVariables = Exact<{
  input: Order_ShippingFees_Refund_Input;
}>;


export type RefundOrderShippingFeesMutation = { __typename?: 'Mutation', order_shippingFees_refund?: any | null };

export type RefundOrderShippingFeesDryRunMutationVariables = Exact<{
  input: Order_ShippingFees_Refund_Input;
}>;


export type RefundOrderShippingFeesDryRunMutation = { __typename?: 'Mutation', order_shippingFees_refund_dryRun: { __typename?: 'RefundSummary', cashAmountInCents: number, creditAmountInCents: number } };

export type RemoveAppContactCreditMutationVariables = Exact<{
  input: RemoveSupportActorAppContactCreditInput;
}>;


export type RemoveAppContactCreditMutation = { __typename?: 'Mutation', removeSupportActorAppContactCredit?: any | null };

export type RemoveActorAppContactCreditMutationVariables = Exact<{
  input: RemoveSupportActorAppContactCreditInput;
}>;


export type RemoveActorAppContactCreditMutation = { __typename?: 'Mutation', removeSupportActorAppContactCredit?: any | null };

export type RemoveSnippetMutationVariables = Exact<{
  snippetId: Scalars['ID']['input'];
}>;


export type RemoveSnippetMutation = { __typename?: 'Mutation', removeSupportSnippet: { __typename?: 'SupportSnippet', id: string } };

export type RemoveSnippetTagMutationVariables = Exact<{
  snippetTagId: Scalars['ID']['input'];
}>;


export type RemoveSnippetTagMutation = { __typename?: 'Mutation', removeSupportSnippetTag: { __typename?: 'SupportSnippetTag', id: string } };

export type RemoveTicketActivityReactionMutationVariables = Exact<{
  activityId: Scalars['ID']['input'];
  type: SupportTicketActivityReactionType;
}>;


export type RemoveTicketActivityReactionMutation = { __typename?: 'Mutation', removeSupportTicketActivityReaction: boolean };

export type RemoveViewFromFavoriteMutationVariables = Exact<{
  viewId: Scalars['ID']['input'];
}>;


export type RemoveViewFromFavoriteMutation = { __typename?: 'Mutation', removeSupportViewFavorite?: any | null };

export type ScheduleActionAddMessageMutationVariables = Exact<{
  input: SupportTicketScheduleActionAddMessageInput;
  scheduleAt: Scalars['DateTime']['input'];
}>;


export type ScheduleActionAddMessageMutation = { __typename?: 'Mutation', supportTicket_scheduleAction_addMessage: { __typename?: 'SupportTicket', id: string } };

export type ScheduleActionAddEmailMutationVariables = Exact<{
  input: SupportTicketScheduleActionAddEmailInput;
  scheduleAt: Scalars['DateTime']['input'];
}>;


export type ScheduleActionAddEmailMutation = { __typename?: 'Mutation', supportTicket_scheduleAction_addEmail: { __typename?: 'SupportTicket', id: string } };

export type ScheduleActionMarkAsCancelledMutationVariables = Exact<{
  input: SupportTicketScheduleActionMarkAsCanceledInput;
}>;


export type ScheduleActionMarkAsCancelledMutation = { __typename?: 'Mutation', supportTicket_scheduleAction_markAsCanceled: { __typename?: 'SupportTicket', id: string } };

export type ScheduleActionMarkAsPausedMutationVariables = Exact<{
  input: SupportTicketScheduleActionMarkAsPausedInput;
}>;


export type ScheduleActionMarkAsPausedMutation = { __typename?: 'Mutation', supportTicket_scheduleAction_markAsPaused: { __typename?: 'SupportTicket', id: string } };

export type ScheduleActionRescheduleMutationVariables = Exact<{
  input: SupportTicketScheduleActionRescheduleInput;
}>;


export type ScheduleActionRescheduleMutation = { __typename?: 'Mutation', supportTicket_scheduleAction_reschedule: { __typename?: 'SupportTicket', id: string } };

export type ScheduleActionSetSubStatusMutationVariables = Exact<{
  input: SupportTicketScheduleActionSetSubStatusInput;
  scheduleAt: Scalars['DateTime']['input'];
}>;


export type ScheduleActionSetSubStatusMutation = { __typename?: 'Mutation', supportTicket_scheduleAction_setSubStatus: { __typename?: 'SupportTicket', id: string } };

export type ScheduleActionUpdateEmailMutationVariables = Exact<{
  input: SupportTicketScheduleActionUpdateEmailInput;
}>;


export type ScheduleActionUpdateEmailMutation = { __typename?: 'Mutation', supportTicket_scheduleAction_updateEmail: { __typename?: 'SupportTicket', id: string } };

export type ScheduleActionUpdateMessageMutationVariables = Exact<{
  input: SupportTicketScheduleActionUpdateMessageInput;
}>;


export type ScheduleActionUpdateMessageMutation = { __typename?: 'Mutation', supportTicket_scheduleAction_updateMessage: { __typename?: 'SupportTicket', id: string } };

export type ScheduleActionUpdateSubStatusMutationVariables = Exact<{
  input: SupportTicketScheduleActionUpdateSubStatusInput;
}>;


export type ScheduleActionUpdateSubStatusMutation = { __typename?: 'Mutation', supportTicket_scheduleAction_updateSubStatus: { __typename?: 'SupportTicket', id: string } };

export type SetAssignedToMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
  actorUserId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetAssignedToMutation = { __typename?: 'Mutation', setSupportTicketAssignee: { __typename?: 'SupportTicket', id: string } };

export type SetTicketTitleMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type SetTicketTitleMutation = { __typename?: 'Mutation', setSupportTicketTitle: { __typename?: 'SupportTicket', id: string } };

export type SetSubStatusMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
  subStatus: SupportTicketSubStatus;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type SetSubStatusMutation = { __typename?: 'Mutation', setSupportTicketSubStatus: { __typename?: 'SupportTicket', id: string } };

export type SplitOrderMutationVariables = Exact<{
  input: Order_Split_Input;
}>;


export type SplitOrderMutation = { __typename?: 'Mutation', order_split?: any | null };

export type UnflagContactAsFrauderMutationVariables = Exact<{
  input: Support_ActorAppContact_UnflagAsFrauder_Input;
}>;


export type UnflagContactAsFrauderMutation = { __typename?: 'Mutation', support_actorAppContact_unflagAsFrauder: { __typename?: 'SupportActorAppContact', id: string } };

export type UnflagContactAsInfluencerMutationVariables = Exact<{
  input: Support_ActorAppContact_UnflagAsInfluencer_Input;
}>;


export type UnflagContactAsInfluencerMutation = { __typename?: 'Mutation', support_actorAppContact_unflagAsInfluencer: { __typename?: 'SupportActorAppContact', id: string } };

export type UnlockOrderReturnValidationMutationVariables = Exact<{
  input: Order_Return_UnlockValidation_Input;
}>;


export type UnlockOrderReturnValidationMutation = { __typename?: 'Mutation', order_return_unlockValidation?: any | null };

export type UpdateOrderDeliveryDateRangeMutationVariables = Exact<{
  input: SupportTicket_Order_UpdateDeliveryDateRange_Input;
}>;


export type UpdateOrderDeliveryDateRangeMutation = { __typename?: 'Mutation', supportTicket_order_updateDeliveryDateRange: { __typename?: 'SupportTicket', id: string } };

export type UpdateSnippetMutationVariables = Exact<{
  snippetId: Scalars['ID']['input'];
  input: UpdateSupportSnippetInput;
}>;


export type UpdateSnippetMutation = { __typename?: 'Mutation', updateSupportSnippet: { __typename?: 'SupportSnippet', id: string } };

export type UpdateSnippetTagMutationVariables = Exact<{
  snippetTagId: Scalars['ID']['input'];
  input: UpdateSupportSnippetTagInput;
}>;


export type UpdateSnippetTagMutation = { __typename?: 'Mutation', updateSupportSnippetTag: { __typename?: 'SupportSnippetTag', id: string } };

export type UpdateViewMutationVariables = Exact<{
  viewId: Scalars['ID']['input'];
  input: UpdateSupportViewInput;
}>;


export type UpdateViewMutation = { __typename?: 'Mutation', updateSupportView: { __typename?: 'SupportView', icon: string, iconColor: string, id: string, title: string } };

export type ValidateOrderReturnMutationVariables = Exact<{
  input: Order_Return_Validate_Input;
}>;


export type ValidateOrderReturnMutation = { __typename?: 'Mutation', order_return_validate?: any | null };

export type ActorAppContactByAppUserIdQueryVariables = Exact<{
  appUserId: Scalars['ID']['input'];
}>;


export type ActorAppContactByAppUserIdQuery = { __typename?: 'Query', supportActorAppContactByAppUserId: { __typename?: 'SupportActorAppContact', id: string } };

export type ActorAppContactsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ActorAppContactsByIdsQuery = { __typename?: 'Query', supportActorAppContactsByIds: Array<{ __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, lastName?: string | null } }> };

export type ContactQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactQuery = { __typename?: 'Query', supportActorById:
    | { __typename: 'ActorBotUser' }
    | { __typename: 'ActorInternalUser' }
    | { __typename: 'ActorSupplierUser' }
    | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', appUserId: string, email?: string | null, firstName?: string | null, isFrauder: boolean, isInfluencer: boolean, language: LanguageIso6391, lastName?: string | null, latestActivityAt: string, phoneNumber?: string | null, referralCode?: string | null, store: Store, timezone: string, credits: Array<{ __typename?: 'Credit', balanceAmountInCents: number, store: Store, lines: Array<{ __typename?: 'CreditLine', amountInCents: number, description?: string | null, expiresAt: string, id: string, isExpired: boolean, remainingAmountInCents: number, spentAmountInCents: number }>, transactions: Array<{ __typename?: 'CreditTransaction', amountInCents: number, billingId?: string | null, createdAt: string, description?: string | null, id: string, operator?: string | null, orderId?: string | null, refereeUserId?: string | null, type: CreditTransactionType }> }>, latestShippingAddress?: { __typename?: 'ShippingAddress', city: string, countryCode: string, firstName: string, lastName: string, phoneNumber: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } | null, mobile: { __typename?: 'SupportAppContactMobile', app: { __typename?: 'SupportAppContactMobileApp', isLatestVersion: boolean, version: string }, device?: { __typename?: 'SupportAppContactMobileDevice', brand: string, os: SupportAppContactMobileDeviceOs, osVersion: string } | null }, referralGodfather?: { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', firstName?: string | null, lastName?: string | null, referralCode?: string | null } } | null } }
    | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
   };

export type ContactActivitiesQueryVariables = Exact<{
  contactId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportActorActivitiesSortInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportActorActivitiesFilterInput>;
}>;


export type ContactActivitiesQuery = { __typename?: 'Query', supportActorById:
    | { __typename: 'ActorBotUser' }
    | { __typename: 'ActorInternalUser' }
    | { __typename: 'ActorSupplierUser' }
    | { __typename: 'SupportActorAppContact', activities: { __typename?: 'SupportActorActivityConnection', edges: Array<{ __typename?: 'SupportActorActivityEdge', node:
            | { __typename: 'SupportActorActivityCredit', amountInCents: number, action: SupportActorActivityCreditAction, currency: CurrencyIso, id: string, occurredAt: string, actor:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
                | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
                | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
                | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
               }
            | { __typename: 'SupportActorActivityFrauder', id: string, isFrauder: boolean, occurredAt: string, actor:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
                | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
                | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
                | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
               }
            | { __typename: 'SupportActorActivityInfluencer', id: string, isInfluencer: boolean, occurredAt: string, actor:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
                | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
                | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
                | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
               }
            | { __typename: 'SupportActorActivityNote', content: string, id: string, occurredAt: string, actor:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
                | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
                | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
                | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
              , attachments: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }> }
            | { __typename: 'SupportActorActivityReferralCode', id: string, newReferralCode: string, occurredAt: string, oldReferralCode?: string | null, actor:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
                | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
                | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
                | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
               }
           }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } }
    | { __typename: 'SupportActorEmailContact' }
   };

export type ContactByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactByIdQuery = { __typename?: 'Query', supportActorById:
    | { __typename: 'ActorBotUser' }
    | { __typename: 'ActorInternalUser' }
    | { __typename: 'ActorSupplierUser' }
    | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', firstName?: string | null, lastName?: string | null } }
    | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
   };

export type CourierBySlugQueryVariables = Exact<{
  input: Courier_BySlug_Input;
}>;


export type CourierBySlugQuery = { __typename?: 'Query', courier_bySlug: { __typename?: 'Courier', logoUrl: string, name: string, slug: string } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser:
    | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, language: LanguageIso6391, lastName: string, picture: string, supportRole: SupportRole } }
    | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, language: LanguageIso6391, lastName: string, picture: string } }
   };

export type CurrentUserFavoriteViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserFavoriteViewsQuery = { __typename?: 'Query', currentUserFavoriteSupportViews: Array<{ __typename?: 'SupportView', groupBy: SupportViewGroupByProperty, icon: string, iconColor: string, id: string, title: string, displayedProperties: { __typename?: 'SupportViewDisplayedProperty', assignedTo: boolean, channel: boolean, contact: boolean, hasPendingScheduleActions: boolean, isDraft: boolean, orderFlow: boolean, previewText: boolean, saleName: boolean, statusUpdatedAt: boolean, subStatus: boolean, title: boolean }, filters: { __typename?: 'SupportTicketsFilter', assignedToId?: { __typename?: 'IDFilterNullable', in?: Array<string | null> | null, notIn?: Array<string | null> | null } | null, channel?: { __typename?: 'SupportTicketChannelFilter', in?: Array<SupportTicketChannel> | null, notIn?: Array<SupportTicketChannel> | null } | null, contactId?: { __typename?: 'IDFilter', in?: Array<string> | null, notIn?: Array<string> | null } | null, createdAt?: { __typename?: 'DateRangeFilter', gt?: string | null, gte?: string | null, lt?: string | null, lte?: string | null } | null, contextDerived?: { __typename?: 'ContextDerivedFilter', orderId?: { __typename?: 'IDFilterNullable', in?: Array<string | null> | null, notIn?: Array<string | null> | null } | null, sale?: { __typename?: 'ContextDerivedSaleFilter', salesTeamName?: { __typename?: 'SaleSalesTeamNameFilter', in?: Array<SalesTeamName> | null, notIn?: Array<SalesTeamName> | null } | null, type?: { __typename?: 'SaleTypeFilter', in?: Array<SaleType> | null, notIn?: Array<SaleType> | null } | null } | null, saleId?: { __typename?: 'IDFilterNullable', in?: Array<string | null> | null, notIn?: Array<string | null> | null } | null, storeId?: { __typename?: 'StoreFilterNullable', in?: Array<Store | null> | null, notIn?: Array<Store | null> | null } | null, supplierId?: { __typename?: 'IDFilterNullable', in?: Array<string | null> | null, notIn?: Array<string | null> | null } | null } | null, hasPendingScheduleActions?: { __typename?: 'BooleanFilter', equals?: boolean | null, not?: boolean | null } | null, initialRequest?: { __typename?: 'InitialRequestFilter', flow?: { __typename?: 'SupportTicketActivityInitialRequestFlowFilter', in?: Array<SupportTicketActivityInitialRequestFlow> | null, notIn?: Array<SupportTicketActivityInitialRequestFlow> | null } | null } | null, isDraft?: { __typename?: 'BooleanFilter', equals?: boolean | null, not?: boolean | null } | null, orderFlowId?: { __typename?: 'IDFilterNullable', in?: Array<string | null> | null, notIn?: Array<string | null> | null } | null, subStatus?: { __typename?: 'SupportTicketSubStatusFilter', in?: Array<SupportTicketSubStatus> | null, notIn?: Array<SupportTicketSubStatus> | null } | null }, sortBy: { __typename?: 'SupportTicketsSort', direction: SupportTicketsSortableDirection, field: SupportTicketsSortableFields } }> };

export type InternalUsersQueryVariables = Exact<{
  filters?: InputMaybe<InternalUsersFilterInput>;
}>;


export type InternalUsersQuery = { __typename?: 'Query', internalUsers: Array<{ __typename?: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, lastName: string, picture: string, supportRole: SupportRole } }> };

export type NotificationsQueryVariables = Exact<{
  filters?: InputMaybe<SupportNotificationsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', supportNotifications: { __typename?: 'SupportNotificationConnection', edges: Array<{ __typename?: 'SupportNotificationEdge', cursor: string, node:
        | { __typename: 'SupportNotificationMention', createdAt: string, id: string, readAt?: string | null, activity:
            | { __typename: 'SupportTicketActivityAiSuggestion' }
            | { __typename: 'SupportTicketActivityAiSuggestionSetup' }
            | { __typename: 'SupportTicketActivityAiSuggestionStatus' }
            | { __typename: 'SupportTicketActivityAssignment' }
            | { __typename: 'SupportTicketActivityClosureDuplicate' }
            | { __typename: 'SupportTicketActivityClosureJunk' }
            | { __typename: 'SupportTicketActivityClosureUnresolvable' }
            | { __typename: 'SupportTicketActivityContext' }
            | { __typename: 'SupportTicketActivityContextDerived' }
            | { __typename: 'SupportTicketActivityEmail' }
            | { __typename: 'SupportTicketActivityInitialRequestMigration' }
            | { __typename: 'SupportTicketActivityInitialRequestOrder' }
            | { __typename: 'SupportTicketActivityInitialRequestOther' }
            | { __typename: 'SupportTicketActivityInitialRequestSale' }
            | { __typename: 'SupportTicketActivityInitialRequestVariant' }
            | { __typename: 'SupportTicketActivityMessage' }
            | { __typename: 'SupportTicketActivityNote', content: string, id: string }
            | { __typename: 'SupportTicketActivityPublish' }
            | { __typename: 'SupportTicketActivityResolutionSurvey' }
            | { __typename: 'SupportTicketActivityScheduleAction' }
            | { __typename: 'SupportTicketActivityScheduleActionSetup' }
            | { __typename: 'SupportTicketActivityScheduleActionStatus' }
            | { __typename: 'SupportTicketActivityStatus' }
            | { __typename: 'SupportTicketActivityTitle' }
          , sender:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
            | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
            | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
          , ticket: { __typename?: 'SupportTicket', id: string, title: string } }
        | { __typename: 'SupportNotificationReaction', createdAt: string, id: string, reactionType: SupportTicketActivityReactionType, readAt?: string | null, activity:
            | { __typename: 'SupportTicketActivityAiSuggestion' }
            | { __typename: 'SupportTicketActivityAiSuggestionSetup' }
            | { __typename: 'SupportTicketActivityAiSuggestionStatus' }
            | { __typename: 'SupportTicketActivityAssignment' }
            | { __typename: 'SupportTicketActivityClosureDuplicate' }
            | { __typename: 'SupportTicketActivityClosureJunk' }
            | { __typename: 'SupportTicketActivityClosureUnresolvable' }
            | { __typename: 'SupportTicketActivityContext' }
            | { __typename: 'SupportTicketActivityContextDerived' }
            | { __typename: 'SupportTicketActivityEmail' }
            | { __typename: 'SupportTicketActivityInitialRequestMigration' }
            | { __typename: 'SupportTicketActivityInitialRequestOrder' }
            | { __typename: 'SupportTicketActivityInitialRequestOther' }
            | { __typename: 'SupportTicketActivityInitialRequestSale' }
            | { __typename: 'SupportTicketActivityInitialRequestVariant' }
            | { __typename: 'SupportTicketActivityMessage' }
            | { __typename: 'SupportTicketActivityNote', content: string, id: string }
            | { __typename: 'SupportTicketActivityPublish' }
            | { __typename: 'SupportTicketActivityResolutionSurvey' }
            | { __typename: 'SupportTicketActivityScheduleAction' }
            | { __typename: 'SupportTicketActivityScheduleActionSetup' }
            | { __typename: 'SupportTicketActivityScheduleActionStatus' }
            | { __typename: 'SupportTicketActivityStatus' }
            | { __typename: 'SupportTicketActivityTitle' }
          , sender:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
            | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
            | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
          , ticket: { __typename?: 'SupportTicket', id: string, title: string } }
       }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type NotificationsUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsUnreadCountQuery = { __typename?: 'Query', supportNotificationsUnreadCount: number };

export type OrderQueryVariables = Exact<{
  input: Order_Input;
}>;


export type OrderQuery = { __typename?: 'Query', order: { __typename?: 'Order', createdAt: string, id: string, isCancelled: boolean, isFullDigital: boolean, brand: { __typename?: 'Brand', id: string }, cashback?: { __typename?: 'Cashback', amount: number, amountUpdatedAt?: string | null, currency: CurrencyIso, dueDate: string, status: CashbackStatus } | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, parcels: Array<{ __typename?: 'Parcel', id: string, estimatedDeliveryDateRange?: { __typename?: 'ParcelEstimatedDeliveryDateRange', max: string, min: string } | null, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, recipient: { __typename?: 'Recipient', firstName: string, lastName: string, phoneNumber: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, returns: Array<{ __typename?: 'Return', id: string, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string }> }>, sale: { __typename?: 'Sale', id: string, name: string }, shipping: { __typename?: 'OrderShipping', fees: number, feesSold: number, deliveryDateRangeHistory: Array<{ __typename?: 'DeliveryDateRange', end: string, start: string }>, pickupPoint?: { __typename?: 'PickupPoint', id: string, address?: { __typename?: 'PickupAddress', city: string, countryCode: string, name: string, street: string, streetAdditional?: string | null, zipCode: string } | null, openingDays?: { __typename?: 'PickupOpeningDays', monday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, tuesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, wednesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, thursday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, friday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, saturday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, sunday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null } | null } | null, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number } }, supportActorAppContact: { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', firstName?: string | null, lastName?: string | null } }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number } } };

export type OrderFlowQueryVariables = Exact<{
  input: Support_OrderFlow_Input;
}>;


export type OrderFlowQuery = { __typename?: 'Query', support_orderFlow:
    | { __typename: 'SupportOrderFlowCommunicationAppUsers', appUserIds: Array<string>, createdAt: string, flow: SupportOrderFlowType, id: string, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }> }
    | { __typename: 'SupportOrderFlowCreditCompensationSupplierCharged', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersCreditCompensationSupplierCharged', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowDeliveryDelay', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersDeliveryDelay', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowDeliveryDelayV2', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersDeliveryDelayV2', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowOrderCancellation', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersOrderCancellation', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowOrderOptimizationPackaging', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersOrderOptimizationPackaging', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowOther', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersOther', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowProductOutOfStock', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersProductOutOfStock', productReferences: Array<string>, sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowProductOutOfStockShopify', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersProductOutOfStockShopify', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowProductWrongDescription', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersProductWrongDescription', productReferences: Array<string>, sale: { __typename?: 'Sale', id: string, name: string } } }
   };

export type OrderFlowsQueryVariables = Exact<{
  input: Support_OrderFlow_Search_Input;
}>;


export type OrderFlowsQuery = { __typename?: 'Query', support_orderFlow_search: { __typename?: 'SupportOrderFlowConnection', edges: Array<{ __typename?: 'SupportOrderFlowEdge', cursor: string, node:
        | { __typename: 'SupportOrderFlowCommunicationAppUsers', appUserIds: Array<string>, createdAt: string, flow: SupportOrderFlowType, id: string, status: SupportOrderFlowStatus, createdBy:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }> }
        | { __typename: 'SupportOrderFlowCreditCompensationSupplierCharged', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersCreditCompensationSupplierCharged', sale: { __typename?: 'Sale', id: string, name: string } } }
        | { __typename: 'SupportOrderFlowDeliveryDelay', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersDeliveryDelay', sale: { __typename?: 'Sale', name: string } } }
        | { __typename: 'SupportOrderFlowDeliveryDelayV2', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersDeliveryDelayV2', sale: { __typename?: 'Sale', id: string, name: string } } }
        | { __typename: 'SupportOrderFlowOrderCancellation', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersOrderCancellation', sale: { __typename?: 'Sale', id: string, name: string } } }
        | { __typename: 'SupportOrderFlowOrderOptimizationPackaging', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersOrderOptimizationPackaging', sale: { __typename?: 'Sale', name: string } } }
        | { __typename: 'SupportOrderFlowOther', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersOther', sale: { __typename?: 'Sale', name: string } } }
        | { __typename: 'SupportOrderFlowProductOutOfStock', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersProductOutOfStock', sale: { __typename?: 'Sale', name: string } } }
        | { __typename: 'SupportOrderFlowProductOutOfStockShopify', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersProductOutOfStockShopify', sale: { __typename?: 'Sale', id: string, name: string } } }
        | { __typename: 'SupportOrderFlowProductWrongDescription', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersProductWrongDescription', sale: { __typename?: 'Sale', name: string } } }
       }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type OrderFlowsByIdsQueryVariables = Exact<{
  input: Support_OrderFlows_Input;
}>;


export type OrderFlowsByIdsQuery = { __typename?: 'Query', support_orderFlows: Array<
    | { __typename: 'SupportOrderFlowCommunicationAppUsers', appUserIds: Array<string>, createdAt: string, flow: SupportOrderFlowType, id: string, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }> }
    | { __typename: 'SupportOrderFlowCreditCompensationSupplierCharged', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersCreditCompensationSupplierCharged', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowDeliveryDelay', flow: SupportOrderFlowType, id: string, status: SupportOrderFlowStatus, filters: { __typename?: 'SupportOrderFlowFiltersDeliveryDelay', sale: { __typename?: 'Sale', name: string } } }
    | { __typename: 'SupportOrderFlowDeliveryDelayV2', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersDeliveryDelayV2', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowOrderCancellation', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersOrderCancellation', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowOrderOptimizationPackaging', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersOrderOptimizationPackaging', sale: { __typename?: 'Sale', name: string } } }
    | { __typename: 'SupportOrderFlowOther', flow: SupportOrderFlowType, id: string, status: SupportOrderFlowStatus, filters: { __typename?: 'SupportOrderFlowFiltersOther', sale: { __typename?: 'Sale', name: string } } }
    | { __typename: 'SupportOrderFlowProductOutOfStock', flow: SupportOrderFlowType, id: string, status: SupportOrderFlowStatus, filters: { __typename?: 'SupportOrderFlowFiltersProductOutOfStock', sale: { __typename?: 'Sale', name: string } } }
    | { __typename: 'SupportOrderFlowProductOutOfStockShopify', createdAt: string, flow: SupportOrderFlowType, id: string, orderIds: Array<string>, status: SupportOrderFlowStatus, createdBy:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      , errors: Array<{ __typename?: 'SupportOrderFlowError', errorCode: SupportOrderFlowErrorCode, orderId: string }>, filters: { __typename?: 'SupportOrderFlowFiltersProductOutOfStockShopify', sale: { __typename?: 'Sale', id: string, name: string } } }
    | { __typename: 'SupportOrderFlowProductWrongDescription', flow: SupportOrderFlowType, id: string, status: SupportOrderFlowStatus, filters: { __typename?: 'SupportOrderFlowFiltersProductWrongDescription', sale: { __typename?: 'Sale', name: string } } }
  > };

export type OrderPreviewQueryVariables = Exact<{
  input: Order_Input;
}>;


export type OrderPreviewQuery = { __typename?: 'Query', order: { __typename?: 'Order', createdAt: string, id: string, isCancelled: boolean, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, parcels: Array<{ __typename?: 'Parcel', id: string, tracking: { __typename?: 'Tracking', status: TrackingStatus, subStatus: TrackingSubStatus } }>, returns: Array<{ __typename?: 'Return', id: string, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string }> }>, shipping: { __typename?: 'OrderShipping', feesSold: number }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number } } };

export type OrderRefundPlanQueryVariables = Exact<{
  input: Order_RefundPlan_Input;
}>;


export type OrderRefundPlanQuery = { __typename?: 'Query', order_refundPlan: Array<
    | { __typename: 'OrderItemRefundPlan', itemId: string, breakdown: { __typename?: 'OrderRefundPlanBreakdown', cashAmountInCents: number, creditAmountInCents: number }, withheld?: { __typename?: 'OrderRefundPlanWithheld', cashAmountInCents: number } | null }
    | { __typename: 'OrderItemTaxesRefundPlan', itemId: string, breakdown: { __typename?: 'OrderRefundPlanBreakdown', cashAmountInCents: number, creditAmountInCents: number }, withheld?: { __typename?: 'OrderRefundPlanWithheld', cashAmountInCents: number } | null }
    | { __typename: 'OrderShippingFeesRefundPlan', breakdown: { __typename?: 'OrderRefundPlanBreakdown', cashAmountInCents: number, creditAmountInCents: number }, withheld?: { __typename?: 'OrderRefundPlanWithheld', cashAmountInCents: number } | null }
  > };

export type OrdersByIdsQueryVariables = Exact<{
  input: Orders_Input;
}>;


export type OrdersByIdsQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', createdAt: string, id: string, brand: { __typename?: 'Brand', id: string, name: string }, parcels: Array<{ __typename?: 'Parcel', tracking: { __typename?: 'Tracking', status: TrackingStatus, subStatus: TrackingSubStatus } }> }> };

export type OrderTicketsQueryVariables = Exact<{
  filters?: InputMaybe<SupportTicketsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrderTicketsQuery = { __typename?: 'Query', supportTickets: { __typename?: 'SupportTicketConnection', edges: Array<{ __typename?: 'SupportTicketEdge', node: { __typename?: 'SupportTicket', id: string, statusUpdatedAt: string, subStatus: SupportTicketSubStatus, title: string, claims: Array<{ __typename?: 'Claim', acceptedAt?: string | null, canceledAt?: string | null, id: string }> } }> } };

export type ProductInformationQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type ProductInformationQuery = { __typename?: 'Query', product:
    | { __typename: 'ProductDigital', brandId: string, couponExpirationDate?: string | null, description: string, howToUse?: Array<string> | null, id: string, name: string, terms?: Array<string> | null, faq: { __typename?: 'ProductDigitalFaq', afterPurchase?: string | null }, variants: Array<{ __typename?: 'Variant', gtin?: string | null, id: string, sku?: string | null, title: string, images: Array<{ __typename?: 'VariantImage', url: string }> }>, visuals: { __typename?: 'ProductVisuals', images: Array<{ __typename?: 'ProductImage', url: string }> } }
    | { __typename: 'ProductPhysical', brandId: string, description: string, id: string, name: string, returnPolicy: { __typename?: 'ProductPhysicalReturnPolicy', isReturnable: boolean }, variants: Array<{ __typename?: 'Variant', gtin?: string | null, id: string, sku?: string | null, title: string, images: Array<{ __typename?: 'VariantImage', url: string }> }>, visuals: { __typename?: 'ProductVisuals', images: Array<{ __typename?: 'ProductImage', url: string }> } }
   };

export type ProductPreviewQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type ProductPreviewQuery = { __typename?: 'Query', product:
    | { __typename: 'ProductDigital', id: string, name: string, saleId: string, storeId: Store, financial: { __typename?: 'ProductFinancial', frenchTaxRate: number, readableCategory: string }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, type: string, values: Array<{ __typename?: 'ProductOptionValue', id: string, value: string }> }>, visibility: { __typename?: 'ProductVisibility', isAvailableForSale: boolean }, visuals: { __typename?: 'ProductVisuals', images: Array<{ __typename?: 'ProductImage', url: string }> } }
    | { __typename: 'ProductPhysical', id: string, name: string, saleId: string, storeId: Store, financial: { __typename?: 'ProductFinancial', frenchTaxRate: number, readableCategory: string }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, type: string, values: Array<{ __typename?: 'ProductOptionValue', id: string, value: string }> }>, returnPolicy: { __typename?: 'ProductPhysicalReturnPolicy', isReturnable: boolean }, visibility: { __typename?: 'ProductVisibility', isAvailableForSale: boolean }, visuals: { __typename?: 'ProductVisuals', images: Array<{ __typename?: 'ProductImage', url: string }> } }
   };

export type SaleQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type SaleQuery = { __typename?: 'Query', sale: { __typename?: 'Sale', accountManager?: string | null, brandId?: string | null, endsAt: string, name: string, id: string, salesTeamName?: SalesTeamName | null, setupManager?: string | null, startsAt: string, status: SaleStatus, type: SaleType } };

export type SalesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SalesByIdsQuery = { __typename?: 'Query', salesByIds: Array<{ __typename?: 'Sale', endsAt: string, id: string, name: string, startsAt: string, status: SaleStatus, storeId: Store }> };

export type SaleActivitiesQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleActivitiesSortInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SaleActivitiesFilterInput>;
}>;


export type SaleActivitiesQuery = { __typename?: 'Query', sale: { __typename?: 'Sale', activities: { __typename?: 'SaleActivityConnection', edges: Array<{ __typename?: 'SaleActivityEdge', node: { __typename: 'SaleActivityNote', content: string, id: string, occurredAt: string, actor:
            | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
            | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
            | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
            | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
          , attachments: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } };

export type SalePreviewQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type SalePreviewQuery = { __typename?: 'Query', sale: { __typename?: 'Sale', endsAt: string, id: string, name: string, startsAt: string, type: SaleType } };

export type SaleProductsQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type SaleProductsQuery = { __typename?: 'Query', sale: { __typename?: 'Sale', products: Array<
      | { __typename: 'ProductDigital', id: string, name: string, variants: Array<{ __typename?: 'Variant', gtin?: string | null, id: string, sku?: string | null, title: string, financial: { __typename?: 'VariantFinancial', retailPrice: { __typename?: 'VariantPrice', amountVatIncludedInCents: number, currency: CurrencyIso } }, images: Array<{ __typename?: 'VariantImage', url: string }> }>, visuals: { __typename?: 'ProductVisuals', images: Array<{ __typename?: 'ProductImage', url: string }> } }
      | { __typename: 'ProductPhysical', id: string, name: string, variants: Array<{ __typename?: 'Variant', gtin?: string | null, id: string, sku?: string | null, title: string, financial: { __typename?: 'VariantFinancial', retailPrice: { __typename?: 'VariantPrice', amountVatIncludedInCents: number, currency: CurrencyIso } }, images: Array<{ __typename?: 'VariantImage', url: string }> }>, visuals: { __typename?: 'ProductVisuals', images: Array<{ __typename?: 'ProductImage', url: string }> } }
    > } };

export type SearchAppContactQueryVariables = Exact<{
  input: SearchSupportActorAppContactInput;
}>;


export type SearchAppContactQuery = { __typename?: 'Query', searchSupportActorAppContact: Array<{ __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } }> };

export type SearchAppContactsQueryVariables = Exact<{
  input: SearchSupportActorAppContactInput;
}>;


export type SearchAppContactsQuery = { __typename?: 'Query', searchSupportActorAppContact: Array<{ __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, lastName?: string | null } }> };

export type SearchBrandsQueryVariables = Exact<{
  input: SearchBrandsInput;
}>;


export type SearchBrandsQuery = { __typename?: 'Query', searchBrands: Array<{ __typename?: 'Brand', id: string, name: string, storeId: Store }> };

export type SearchEmailContactsQueryVariables = Exact<{
  input: SearchSupportActorEmailContactsInput;
}>;


export type SearchEmailContactsQuery = { __typename?: 'Query', searchSupportActorEmailContacts: Array<{ __typename?: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }> };

export type SearchCouriersQueryVariables = Exact<{
  input: Couriers_Search_Input;
}>;


export type SearchCouriersQuery = { __typename?: 'Query', couriers_search: Array<{ __typename?: 'Courier', logoUrl: string, name: string, slug: string }> };

export type SearchOrdersQueryVariables = Exact<{
  input: Orders_Search_Input;
}>;


export type SearchOrdersQuery = { __typename?: 'Query', orders_search: { __typename?: 'OrdersConnection', totalCount: number, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'Order', createdAt: string, id: string, brand: { __typename?: 'Brand', id: string, name: string }, parcels: Array<{ __typename?: 'Parcel', tracking: { __typename?: 'Tracking', status: TrackingStatus, subStatus: TrackingSubStatus } }>, recipient: { __typename?: 'Recipient', firstName: string, lastName: string }, tags: { __typename?: 'OrderTags', claimReason: Array<OrderTagClaimReason> }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type SearchSalesQueryVariables = Exact<{
  input: SearchSalesInput;
}>;


export type SearchSalesQuery = { __typename?: 'Query', searchSales: Array<{ __typename?: 'Sale', endsAt: string, id: string, name: string, startsAt: string, status: SaleStatus, storeId: Store }> };

export type SnippetQueryVariables = Exact<{
  supportSnippetId: Scalars['ID']['input'];
}>;


export type SnippetQuery = { __typename?: 'Query', supportSnippet: { __typename?: 'SupportSnippet', deletedAt?: string | null, id: string, storeId: Store, tagIds: Array<string>, title: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }, templates: Array<{ __typename?: 'SupportSnippetTemplate', language: LanguageIso6391, template: string }> } };

export type SnippetsQueryVariables = Exact<{
  filters?: InputMaybe<SupportSnippetsFilterInput>;
  sortBy?: InputMaybe<SupportSnippetsSortInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SnippetsQuery = { __typename?: 'Query', supportSnippets: { __typename?: 'SupportSnippetConnection', edges: Array<{ __typename?: 'SupportSnippetEdge', node: { __typename?: 'SupportSnippet', deletedAt?: string | null, id: string, storeId: Store, tagIds: Array<string>, title: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }, templates: Array<{ __typename?: 'SupportSnippetTemplate', language: LanguageIso6391, template: string }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type SnippetTagQueryVariables = Exact<{
  supportSnippetTagId: Scalars['ID']['input'];
}>;


export type SnippetTagQuery = { __typename?: 'Query', supportSnippetTag: { __typename?: 'SupportSnippetTag', description?: string | null, deletedAt?: string | null, id: string, label: string, textColor: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } } } };

export type SnippetTagsQueryVariables = Exact<{
  filters?: InputMaybe<SupportSnippetTagsFilterInput>;
  sortBy?: InputMaybe<SupportSnippetTagsSortInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SnippetTagsQuery = { __typename?: 'Query', supportSnippetTags: { __typename?: 'SupportSnippetTagConnection', edges: Array<{ __typename?: 'SupportSnippetTagEdge', node: { __typename?: 'SupportSnippetTag', description?: string | null, deletedAt?: string | null, id: string, label: string, textColor: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type BrandInformationQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type BrandInformationQuery = { __typename?: 'Query', brand: { __typename?: 'Brand', id: string, returnAddress?: { __typename?: 'ReturnAddress', name: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } } | null } };

export type BrandPreviewQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type BrandPreviewQuery = { __typename?: 'Query', brand: { __typename?: 'Brand', id: string, name: string, saleManager?: string | null, website?: string | null } };

export type BrandsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BrandsByIdsQuery = { __typename?: 'Query', brandsByIds: Array<{ __typename?: 'Brand', id: string, name: string, storeId: Store }> };

export type TicketQueryVariables = Exact<{
  ticketId: Scalars['ID']['input'];
  aiSuggestionsFilters?: InputMaybe<SupportTicketAiSuggestionsFilterInput>;
  aiSuggestionsFirst?: InputMaybe<Scalars['Int']['input']>;
  contactTicketsFirst?: InputMaybe<Scalars['Int']['input']>;
  contactTicketsSortBy?: InputMaybe<SupportTicketsSortInput>;
  contactOrdersLimit?: InputMaybe<Scalars['PositiveInt']['input']>;
  scheduleActionsFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TicketQuery = { __typename?: 'Query', supportTicket: { __typename?: 'SupportTicket', assignedAt?: string | null, channel: SupportTicketChannel, createdAt: string, description?: string | null, id: string, isDraft: boolean, isReadByContact: boolean, orderFlowId?: string | null, previewText?: string | null, status: SupportTicketStatus, subStatus: SupportTicketSubStatus, statusUpdatedAt: string, title: string, updatedAt: string, aiSuggestions: { __typename?: 'SupportTicketAiSuggestionConnection', edges: Array<{ __typename?: 'SupportTicketAiSuggestionEdge', node:
          | { __typename: 'SupportTicketAiSuggestionEmail', createdAt: string, id: string, reasoning: string, reasoningSummary: string, status: SupportTicketAiSuggestionStatus, ticketId: string, type: SupportTicketAiSuggestionType, payload: { __typename?: 'SupportTicketAiSuggestionEmailPayload', contentHtml: string, contentText: string, attachments: Array<{ __typename?: 'SupportAttachmentPayload', fileMimeType: string, fileName: string, fileSize: number, fileUrl: string }> } }
          | { __typename: 'SupportTicketAiSuggestionMessage', createdAt: string, id: string, reasoning: string, reasoningSummary: string, status: SupportTicketAiSuggestionStatus, ticketId: string, type: SupportTicketAiSuggestionType, payload: { __typename?: 'SupportTicketAiSuggestionMessagePayload', content: string, attachments: Array<{ __typename?: 'SupportAttachmentPayload', fileMimeType: string, fileName: string, fileSize: number, fileUrl: string }> } }
         }> }, assignedTo?:
      | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
      | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
      | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
     | null, attachments: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }>, claims: Array<{ __typename?: 'Claim', acceptedAction?: ClaimAcceptedAction | null, acceptedAt?: string | null, canceledAt?: string | null, createdAt: string, id: string, isOpenedByBot: boolean, preferredSolution: ClaimPreferredSolution, proofUrls: Array<string>, reason: ClaimReason, acceptedBy?:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
       | null, canceledBy?:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
       | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }> }>, contact:
      | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', appUserId: string, email?: string | null, firstName?: string | null, id: string, isFrauder: boolean, isInfluencer: boolean, language: LanguageIso6391, lastName?: string | null, latestActivityAt: string, ordersCount: number, phoneNumber?: string | null, referralCode?: string | null, store: Store, timezone: string, credits: Array<{ __typename?: 'Credit', balanceAmountInCents: number, store: Store, lines: Array<{ __typename?: 'CreditLine', amountInCents: number, description?: string | null, expiresAt: string, id: string, isExpired: boolean, remainingAmountInCents: number, spentAmountInCents: number }>, transactions: Array<{ __typename?: 'CreditTransaction', amountInCents: number, billingId?: string | null, createdAt: string, description?: string | null, id: string, operator?: string | null, orderId?: string | null, refereeUserId?: string | null, type: CreditTransactionType }> }>, latestOrders: Array<{ __typename?: 'Order', createdAt: string, id: string, saleId: string, brand: { __typename?: 'Brand', id: string, name: string }, initialOrder?: { __typename?: 'Order', id: string } | null, parcels: Array<{ __typename?: 'Parcel', tracking: { __typename?: 'Tracking', status: TrackingStatus, subStatus: TrackingSubStatus } }> }>, mobile: { __typename?: 'SupportAppContactMobile', app: { __typename?: 'SupportAppContactMobileApp', isLatestVersion: boolean, version: string }, device?: { __typename?: 'SupportAppContactMobileDevice', brand: string, os: SupportAppContactMobileDeviceOs, osVersion: string } | null }, referralGodfather?: { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', firstName?: string | null, lastName?: string | null, referralCode?: string | null } } | null }, tickets: { __typename?: 'SupportTicketConnection', edges: Array<{ __typename?: 'SupportTicketEdge', node: { __typename?: 'SupportTicket', id: string, statusUpdatedAt: string, subStatus: SupportTicketSubStatus, title: string, claims: Array<{ __typename?: 'Claim', acceptedAt?: string | null, canceledAt?: string | null, id: string }> } }> } }
      | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null }, tickets: { __typename?: 'SupportTicketConnection', edges: Array<{ __typename?: 'SupportTicketEdge', node: { __typename?: 'SupportTicket', id: string, statusUpdatedAt: string, subStatus: SupportTicketSubStatus, title: string, claims: Array<{ __typename?: 'Claim', acceptedAt?: string | null, canceledAt?: string | null, id: string }> } }> } }
    , contextDerived?: { __typename?: 'SupportTicketContextDerived', storeId?: Store | null, order?: { __typename?: 'Order', brandId: string, createdAt: string, hasBeenExported: boolean, id: string, isCancelled: boolean, isFullDigital: boolean, saleId: string, cashback?: { __typename?: 'Cashback', amount: number, amountUpdatedAt?: string | null, currency: CurrencyIso, dueDate: string, status: CashbackStatus } | null, claims: Array<{ __typename?: 'Claim', acceptedAt?: string | null, canceledAt?: string | null, createdAt: string, id: string }>, initialOrder?: { __typename?: 'Order', brandId: string, createdAt: string, hasBeenExported: boolean, id: string, isCancelled: boolean, isFullDigital: boolean, saleId: string, buyer: { __typename?: 'Buyer', firstName: string, lastName: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, cashback?: { __typename?: 'Cashback', amount: number, amountUpdatedAt?: string | null, currency: CurrencyIso, dueDate: string, status: CashbackStatus } | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, parcels: Array<{ __typename?: 'Parcel', id: string, estimatedDeliveryDateRange?: { __typename?: 'ParcelEstimatedDeliveryDateRange', max: string, min: string } | null, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, recipient: { __typename?: 'Recipient', firstName: string, lastName: string, phoneNumber: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, returns: Array<{ __typename?: 'Return', applyWithheld: boolean, id: string, isValidationLocked: boolean, preferredRefundMethod: PreferredRefundMethod, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string, item: { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, newDigitalCouponCode?: string | null, name: string, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } } }>, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, shipping: { __typename?: 'OrderShipping', fees: number, feesSold: number, deliveryDateRangeHistory: Array<{ __typename?: 'DeliveryDateRange', end: string, start: string }>, pickupPoint?: { __typename?: 'PickupPoint', id: string, address?: { __typename?: 'PickupAddress', city: string, countryCode: string, name: string, street: string, streetAdditional?: string | null, zipCode: string } | null, openingDays?: { __typename?: 'PickupOpeningDays', monday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, tuesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, wednesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, thursday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, friday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, saturday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, sunday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null } | null } | null, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number } }, supportActorAppContact: { __typename?: 'SupportActorAppContact', id: string }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number } } | null, linesRefunds: Array<{ __typename?: 'OrderLineRefund', amountInCents: number, coveredBy: OrderLineRefundCover, createdAt: string, id: string, lineId: string, lineType: OrderLineType, reason: OrderLineRefundReason }>, parentOrders: Array<{ __typename?: 'Order', brandId: string, createdAt: string, hasBeenExported: boolean, id: string, isCancelled: boolean, isFullDigital: boolean, saleId: string, initialOrder?: { __typename?: 'Order', brandId: string, createdAt: string, hasBeenExported: boolean, id: string, isCancelled: boolean, isFullDigital: boolean, saleId: string, buyer: { __typename?: 'Buyer', firstName: string, lastName: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, cashback?: { __typename?: 'Cashback', amount: number, amountUpdatedAt?: string | null, currency: CurrencyIso, dueDate: string, status: CashbackStatus } | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, parcels: Array<{ __typename?: 'Parcel', id: string, estimatedDeliveryDateRange?: { __typename?: 'ParcelEstimatedDeliveryDateRange', max: string, min: string } | null, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, recipient: { __typename?: 'Recipient', firstName: string, lastName: string, phoneNumber: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, returns: Array<{ __typename?: 'Return', applyWithheld: boolean, id: string, isValidationLocked: boolean, preferredRefundMethod: PreferredRefundMethod, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string, item: { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, newDigitalCouponCode?: string | null, name: string, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } } }>, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, shipping: { __typename?: 'OrderShipping', fees: number, feesSold: number, deliveryDateRangeHistory: Array<{ __typename?: 'DeliveryDateRange', end: string, start: string }>, pickupPoint?: { __typename?: 'PickupPoint', id: string, address?: { __typename?: 'PickupAddress', city: string, countryCode: string, name: string, street: string, streetAdditional?: string | null, zipCode: string } | null, openingDays?: { __typename?: 'PickupOpeningDays', monday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, tuesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, wednesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, thursday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, friday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, saturday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, sunday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null } | null } | null, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number } }, supportActorAppContact: { __typename?: 'SupportActorAppContact', id: string }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number } } | null, reshipOrder?: { __typename?: 'Order', brandId: string, createdAt: string, hasBeenExported: boolean, id: string, isCancelled: boolean, isFullDigital: boolean, saleId: string, buyer: { __typename?: 'Buyer', firstName: string, lastName: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, cashback?: { __typename?: 'Cashback', amount: number, amountUpdatedAt?: string | null, currency: CurrencyIso, dueDate: string, status: CashbackStatus } | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, parcels: Array<{ __typename?: 'Parcel', id: string, estimatedDeliveryDateRange?: { __typename?: 'ParcelEstimatedDeliveryDateRange', max: string, min: string } | null, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, recipient: { __typename?: 'Recipient', firstName: string, lastName: string, phoneNumber: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, returns: Array<{ __typename?: 'Return', applyWithheld: boolean, id: string, isValidationLocked: boolean, preferredRefundMethod: PreferredRefundMethod, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string, item: { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, newDigitalCouponCode?: string | null, name: string, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } } }>, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, shipping: { __typename?: 'OrderShipping', fees: number, feesSold: number, deliveryDateRangeHistory: Array<{ __typename?: 'DeliveryDateRange', end: string, start: string }>, pickupPoint?: { __typename?: 'PickupPoint', id: string, address?: { __typename?: 'PickupAddress', city: string, countryCode: string, name: string, street: string, streetAdditional?: string | null, zipCode: string } | null, openingDays?: { __typename?: 'PickupOpeningDays', monday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, tuesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, wednesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, thursday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, friday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, saturday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, sunday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null } | null } | null, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number } }, supportActorAppContact: { __typename?: 'SupportActorAppContact', id: string }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number } } | null, buyer: { __typename?: 'Buyer', firstName: string, lastName: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, cashback?: { __typename?: 'Cashback', amount: number, amountUpdatedAt?: string | null, currency: CurrencyIso, dueDate: string, status: CashbackStatus } | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, parcels: Array<{ __typename?: 'Parcel', id: string, estimatedDeliveryDateRange?: { __typename?: 'ParcelEstimatedDeliveryDateRange', max: string, min: string } | null, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, recipient: { __typename?: 'Recipient', firstName: string, lastName: string, phoneNumber: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, returns: Array<{ __typename?: 'Return', applyWithheld: boolean, id: string, isValidationLocked: boolean, preferredRefundMethod: PreferredRefundMethod, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string, item: { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, newDigitalCouponCode?: string | null, name: string, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } } }>, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, shipping: { __typename?: 'OrderShipping', fees: number, feesSold: number, deliveryDateRangeHistory: Array<{ __typename?: 'DeliveryDateRange', end: string, start: string }>, pickupPoint?: { __typename?: 'PickupPoint', id: string, address?: { __typename?: 'PickupAddress', city: string, countryCode: string, name: string, street: string, streetAdditional?: string | null, zipCode: string } | null, openingDays?: { __typename?: 'PickupOpeningDays', monday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, tuesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, wednesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, thursday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, friday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, saturday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, sunday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null } | null } | null, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number } }, supportActorAppContact: { __typename?: 'SupportActorAppContact', id: string }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number } }>, payment: { __typename?: 'OrderPayment', processor: PaymentProcessor, subProcessor?: PaymentSubProcessor | null, processorTransactionUrl: string, transactionPlan: { __typename?: 'OrderPaymentPlan', paidTransactionsCount: number, pendingTransactionsCount: number } }, reshipOrder?: { __typename?: 'Order', brandId: string, createdAt: string, hasBeenExported: boolean, id: string, isCancelled: boolean, isFullDigital: boolean, saleId: string, buyer: { __typename?: 'Buyer', firstName: string, lastName: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, cashback?: { __typename?: 'Cashback', amount: number, amountUpdatedAt?: string | null, currency: CurrencyIso, dueDate: string, status: CashbackStatus } | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, parcels: Array<{ __typename?: 'Parcel', id: string, estimatedDeliveryDateRange?: { __typename?: 'ParcelEstimatedDeliveryDateRange', max: string, min: string } | null, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, recipient: { __typename?: 'Recipient', firstName: string, lastName: string, phoneNumber: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, returns: Array<{ __typename?: 'Return', applyWithheld: boolean, id: string, isValidationLocked: boolean, preferredRefundMethod: PreferredRefundMethod, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string, item: { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, newDigitalCouponCode?: string | null, name: string, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } } }>, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, shipping: { __typename?: 'OrderShipping', fees: number, feesSold: number, deliveryDateRangeHistory: Array<{ __typename?: 'DeliveryDateRange', end: string, start: string }>, pickupPoint?: { __typename?: 'PickupPoint', id: string, address?: { __typename?: 'PickupAddress', city: string, countryCode: string, name: string, street: string, streetAdditional?: string | null, zipCode: string } | null, openingDays?: { __typename?: 'PickupOpeningDays', monday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, tuesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, wednesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, thursday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, friday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, saturday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, sunday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null } | null } | null, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number } }, supportActorAppContact: { __typename?: 'SupportActorAppContact', id: string }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number } } | null, buyer: { __typename?: 'Buyer', firstName: string, lastName: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, parcels: Array<{ __typename?: 'Parcel', id: string, estimatedDeliveryDateRange?: { __typename?: 'ParcelEstimatedDeliveryDateRange', max: string, min: string } | null, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, recipient: { __typename?: 'Recipient', firstName: string, lastName: string, phoneNumber: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } }, returns: Array<{ __typename?: 'Return', applyWithheld: boolean, id: string, isValidationLocked: boolean, preferredRefundMethod: PreferredRefundMethod, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string, item: { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, newDigitalCouponCode?: string | null, name: string, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } } }>, tracking: { __typename?: 'Tracking', courierSlug: string, deliveredAt?: string | null, number: string, status: TrackingStatus, subStatus: TrackingSubStatus, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string } } }>, shipping: { __typename?: 'OrderShipping', fees: number, feesSold: number, deliveryDateRangeHistory: Array<{ __typename?: 'DeliveryDateRange', end: string, start: string }>, pickupPoint?: { __typename?: 'PickupPoint', id: string, address?: { __typename?: 'PickupAddress', city: string, countryCode: string, name: string, street: string, streetAdditional?: string | null, zipCode: string } | null, openingDays?: { __typename?: 'PickupOpeningDays', monday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, tuesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, wednesday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, thursday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, friday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, saturday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null, sunday?: Array<{ __typename?: 'PickupOpeningHours', open: string, close: string }> | null } | null } | null, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number } }, supportActorAppContact: { __typename?: 'SupportActorAppContact', id: string }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number } } | null, product?:
        | { __typename: 'ProductDigital', id: string, name: string, saleId: string, storeId: Store, financial: { __typename?: 'ProductFinancial', frenchTaxRate: number, readableCategory: string }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, type: string, values: Array<{ __typename?: 'ProductOptionValue', id: string, value: string }> }>, visibility: { __typename?: 'ProductVisibility', isAvailableForSale: boolean }, visuals: { __typename?: 'ProductVisuals', images: Array<{ __typename?: 'ProductImage', url: string }> } }
        | { __typename: 'ProductPhysical', id: string, name: string, saleId: string, storeId: Store, financial: { __typename?: 'ProductFinancial', frenchTaxRate: number, readableCategory: string }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, type: string, values: Array<{ __typename?: 'ProductOptionValue', id: string, value: string }> }>, returnPolicy: { __typename?: 'ProductPhysicalReturnPolicy', isReturnable: boolean }, visibility: { __typename?: 'ProductVisibility', isAvailableForSale: boolean }, visuals: { __typename?: 'ProductVisuals', images: Array<{ __typename?: 'ProductImage', url: string }> } }
       | null, sale?: { __typename?: 'Sale', accountManager?: string | null, brandId?: string | null, endsAt: string, name: string, id: string, salesTeamName?: SalesTeamName | null, setupManager?: string | null, startsAt: string, status: SaleStatus, type: SaleType } | null, supplier?: { __typename?: 'Brand', contactEmail?: string | null, contactPhone?: string | null, hubspotId?: string | null, id: string, instagram?: string | null, language: LanguageIso6391, name: string, saleManager?: string | null, shopifyUrl?: string | null, website?: string | null, returnAddress?: { __typename?: 'ReturnAddress', name: string, address: { __typename?: 'Address', city: string, countryCode: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } } | null } | null, variant?: { __typename?: 'Variant', gtin?: string | null, id: string, sku?: string | null, title: string, financial: { __typename?: 'VariantFinancial', buyingPrice: { __typename?: 'VariantPrice', amountVatIncludedInCents: number, currency: CurrencyIso }, retailPrice: { __typename?: 'VariantPrice', amountVatIncludedInCents: number, currency: CurrencyIso } }, images: Array<{ __typename?: 'VariantImage', url: string }>, visibility: { __typename?: 'VariantVisibility', isAvailableForSale: boolean } } | null } | null, createdBy:
      | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
      | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
      | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
      | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
    , initialRequest?:
      | { __typename: 'SupportTicketActivityInitialRequestMigration' }
      | { __typename: 'SupportTicketActivityInitialRequestOrder', content: string, flow: SupportTicketActivityInitialRequestOrderFlow, id: string, orderId: string, preferredRefundMethod?: PreferredRefundMethod | null, preferredSolution?: SupportTicketActivityInitialRequestOrderPreferredSolution | null, promoCode?: string | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, order: { __typename?: 'Order', returns: Array<{ __typename?: 'Return', id: string, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string }> }> }, proofs: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }>, returnLines: Array<{ __typename?: 'SupportTicketActivityInitialRequestOrderReturnLine', itemId: string, reason: ReturnLineReason, subReason?: ReturnLineSubReason | null }>, shippingAddress?: { __typename?: 'ShippingAddress', city: string, countryCode: string, firstName: string, lastName: string, phoneNumber: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } | null, swornStatements: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }> }
      | { __typename: 'SupportTicketActivityInitialRequestOther', content: string, id: string, otherFlow: SupportTicketActivityInitialRequestOtherFlow }
      | { __typename: 'SupportTicketActivityInitialRequestSale', content: string, id: string, saleId: string, saleFlow: SupportTicketActivityInitialRequestSaleFlow }
      | { __typename: 'SupportTicketActivityInitialRequestVariant', content: string, id: string, variantId: string, variantFlow: SupportTicketActivityInitialRequestVariantFlow }
     | null, scheduleActions: { __typename?: 'SupportTicketScheduleActionConnection', edges: Array<{ __typename?: 'SupportTicketScheduleActionEdge', node:
          | { __typename: 'SupportTicketScheduleActionEmail', createdAt: string, id: string, scheduleAt: string, status: SupportTicketScheduleActionStatus, createdBy:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , payload: { __typename?: 'SupportTicketScheduleActionEmailPayload', contentHtml: string, contentText: string, attachments: Array<{ __typename?: 'SupportAttachmentPayload', fileMimeType: string, fileName: string, fileSize: number, fileUrl: string }> } }
          | { __typename: 'SupportTicketScheduleActionMessage', createdAt: string, id: string, scheduleAt: string, status: SupportTicketScheduleActionStatus, createdBy:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , payload: { __typename?: 'SupportTicketScheduleActionMessagePayload', content: string, attachments: Array<{ __typename?: 'SupportAttachmentPayload', fileMimeType: string, fileName: string, fileSize: number, fileUrl: string }> } }
          | { __typename: 'SupportTicketScheduleActionNote', createdAt: string, id: string, scheduleAt: string, status: SupportTicketScheduleActionStatus, createdBy:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , payload: { __typename?: 'SupportTicketScheduleActionNotePayload', content: string } }
          | { __typename: 'SupportTicketScheduleActionSubStatus', createdAt: string, id: string, scheduleAt: string, status: SupportTicketScheduleActionStatus, createdBy:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , payload: { __typename?: 'SupportTicketScheduleActionSubStatusPayload', subStatus: SupportTicketSubStatus } }
         }> } } };

export type TicketActivitiesQueryVariables = Exact<{
  ticketId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SupportTicketActivitiesSortInput>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TicketActivitiesQuery = { __typename?: 'Query', supportTicket: { __typename?: 'SupportTicket', activities: { __typename?: 'SupportTicketActivityConnection', edges: Array<{ __typename?: 'SupportTicketActivityEdge', node:
          | { __typename: 'SupportTicketActivityAiSuggestion', id: string, occurredAt: string }
          | { __typename: 'SupportTicketActivityAiSuggestionSetup', id: string, occurredAt: string }
          | { __typename: 'SupportTicketActivityAiSuggestionStatus', id: string, occurredAt: string }
          | { __typename: 'SupportTicketActivityAssignment', id: string, occurredAt: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , newAssignee?:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
             | null }
          | { __typename: 'SupportTicketActivityClosureDuplicate', id: string, occurredAt: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
             }
          | { __typename: 'SupportTicketActivityClosureJunk', id: string, occurredAt: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
             }
          | { __typename: 'SupportTicketActivityClosureUnresolvable', id: string, occurredAt: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
             }
          | { __typename: 'SupportTicketActivityContext', id: string, newContextRefId?: string | null, newContextType?: SupportTicketContextType | null, occurredAt: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
             }
          | { __typename: 'SupportTicketActivityContextDerived', contextDerivedKey: SupportTicketContextDerivedKey, id: string, newContextDerivedValue?: string | null, occurredAt: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
             }
          | { __typename: 'SupportTicketActivityEmail', contentHtml: string, contentText: string, id: string, occurredAt: string, subject: string, emailScheduleActionId?: string | null, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , aiSuggestion?:
              | { __typename?: 'SupportTicketAiSuggestionEmail', hasBeenEdited: boolean, id: string }
              | { __typename?: 'SupportTicketAiSuggestionMessage', hasBeenEdited: boolean, id: string }
             | null, attachments: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }> }
          | { __typename: 'SupportTicketActivityInitialRequestMigration', content: string, id: string, occurredAt: string, migrationFlow: SupportTicketActivityInitialRequestMigrationFlow, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , aiClassification?: { __typename?: 'SupportTicketActivityInitialRequestAiClassification', confidence?: number | null, flowSuggested?: SupportTicketActivityInitialRequestFlow | null, id: string, status: SupportTicketActivityInitialRequestAiClassificationStatus } | null, flowReview?: { __typename?: 'SupportTicketActivityInitialRequestFlowReview', reviewedAt: string, reviewedFlow: SupportTicketActivityInitialRequestFlow, reviewedBy:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
               } | null }
          | { __typename: 'SupportTicketActivityInitialRequestOrder', content: string, flow: SupportTicketActivityInitialRequestOrderFlow, id: string, occurredAt: string, orderId: string, preferredRefundMethod?: PreferredRefundMethod | null, preferredSolution?: SupportTicketActivityInitialRequestOrderPreferredSolution | null, promoCode?: string | null, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , aiClassification?: { __typename?: 'SupportTicketActivityInitialRequestAiClassification', confidence?: number | null, flowSuggested?: SupportTicketActivityInitialRequestFlow | null, id: string, status: SupportTicketActivityInitialRequestAiClassificationStatus } | null, flowReview?: { __typename?: 'SupportTicketActivityInitialRequestFlowReview', reviewedAt: string, reviewedFlow: SupportTicketActivityInitialRequestFlow, reviewedBy:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
               } | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isReturnable: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInCents: number, remainingToRefundAmountInCents: number } }>, order: { __typename?: 'Order', returns: Array<{ __typename?: 'Return', id: string, status: ReturnStatus, lines: Array<{ __typename?: 'ReturnLine', itemId: string }> }>, sale: { __typename?: 'Sale', id: string, name: string } }, proofs: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }>, returnLines: Array<{ __typename?: 'SupportTicketActivityInitialRequestOrderReturnLine', itemId: string, reason: ReturnLineReason, subReason?: ReturnLineSubReason | null }>, shippingAddress?: { __typename?: 'ShippingAddress', city: string, countryCode: string, firstName: string, lastName: string, phoneNumber: string, state?: string | null, street: string, streetAdditional?: string | null, zipCode: string } | null, swornStatements: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }> }
          | { __typename: 'SupportTicketActivityInitialRequestOther', content: string, id: string, occurredAt: string, otherFlow: SupportTicketActivityInitialRequestOtherFlow, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , aiClassification?: { __typename?: 'SupportTicketActivityInitialRequestAiClassification', confidence?: number | null, flowSuggested?: SupportTicketActivityInitialRequestFlow | null, id: string, status: SupportTicketActivityInitialRequestAiClassificationStatus } | null, attachments: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }>, flowReview?: { __typename?: 'SupportTicketActivityInitialRequestFlowReview', reviewedAt: string, reviewedFlow: SupportTicketActivityInitialRequestFlow, reviewedBy:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
               } | null }
          | { __typename: 'SupportTicketActivityInitialRequestSale', content: string, id: string, occurredAt: string, saleId: string, saleFlow: SupportTicketActivityInitialRequestSaleFlow, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , aiClassification?: { __typename?: 'SupportTicketActivityInitialRequestAiClassification', confidence?: number | null, flowSuggested?: SupportTicketActivityInitialRequestFlow | null, id: string, status: SupportTicketActivityInitialRequestAiClassificationStatus } | null, flowReview?: { __typename?: 'SupportTicketActivityInitialRequestFlowReview', reviewedAt: string, reviewedFlow: SupportTicketActivityInitialRequestFlow, reviewedBy:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
               } | null }
          | { __typename: 'SupportTicketActivityInitialRequestVariant', content: string, id: string, occurredAt: string, variantId: string, variantFlow: SupportTicketActivityInitialRequestVariantFlow, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , aiClassification?: { __typename?: 'SupportTicketActivityInitialRequestAiClassification', confidence?: number | null, flowSuggested?: SupportTicketActivityInitialRequestFlow | null, id: string, status: SupportTicketActivityInitialRequestAiClassificationStatus } | null, flowReview?: { __typename?: 'SupportTicketActivityInitialRequestFlowReview', reviewedAt: string, reviewedFlow: SupportTicketActivityInitialRequestFlow, reviewedBy:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
               } | null }
          | { __typename: 'SupportTicketActivityMessage', content: string, id: string, occurredAt: string, messageScheduleActionId?: string | null, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
              | { __typename: 'SupportActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
            , aiSuggestion?:
              | { __typename?: 'SupportTicketAiSuggestionEmail', hasBeenEdited: boolean, id: string }
              | { __typename?: 'SupportTicketAiSuggestionMessage', hasBeenEdited: boolean, id: string }
             | null, attachments: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }> }
          | { __typename: 'SupportTicketActivityNote', content: string, id: string, occurredAt: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , attachments: Array<{ __typename?: 'SupportAttachment', deletedAt?: string | null, fileMimeType: string, fileName: string, fileSize: number, fileUrl: string, id: string }>, reactions: Array<{ __typename?: 'SupportTicketActivityReaction', actorId: string, createdAt: string, id: string, type: SupportTicketActivityReactionType, actor:
                | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
                | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
                | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
                | { __typename?: 'SupportActorAppContact' }
                | { __typename?: 'SupportActorEmailContact' }
               }> }
          | { __typename: 'SupportTicketActivityPublish', id: string, occurredAt: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
             }
          | { __typename: 'SupportTicketActivityResolutionSurvey', content: string, id: string, isResolved: boolean, occurredAt: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
              | { __typename: 'SupportActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
             }
          | { __typename: 'SupportTicketActivityScheduleAction', id: string, occurredAt: string, scheduleActionId: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
             }
          | { __typename: 'SupportTicketActivityScheduleActionSetup', id: string, occurredAt: string, scheduleActionId: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
            , nextScheduleActionPayload:
              | { __typename: 'SupportTicketScheduleActionEmailPayload', contentHtml: string, contentText: string, attachments: Array<{ __typename?: 'SupportAttachmentPayload', fileMimeType: string, fileName: string, fileSize: number, fileUrl: string }> }
              | { __typename: 'SupportTicketScheduleActionMessagePayload', content: string, attachments: Array<{ __typename?: 'SupportAttachmentPayload', fileMimeType: string, fileName: string, fileSize: number, fileUrl: string }> }
              | { __typename: 'SupportTicketScheduleActionNotePayload' }
              | { __typename: 'SupportTicketScheduleActionSubStatusPayload', subStatus: SupportTicketSubStatus }
            , previousScheduleActionPayload:
              | { __typename: 'SupportTicketScheduleActionEmailPayload', contentHtml: string, contentText: string, attachments: Array<{ __typename?: 'SupportAttachmentPayload', fileMimeType: string, fileName: string, fileSize: number, fileUrl: string }> }
              | { __typename: 'SupportTicketScheduleActionMessagePayload', content: string, attachments: Array<{ __typename?: 'SupportAttachmentPayload', fileMimeType: string, fileName: string, fileSize: number, fileUrl: string }> }
              | { __typename: 'SupportTicketScheduleActionNotePayload' }
              | { __typename: 'SupportTicketScheduleActionSubStatusPayload', subStatus: SupportTicketSubStatus }
             }
          | { __typename: 'SupportTicketActivityScheduleActionStatus', id: string, nextScheduleActionStatus: SupportTicketScheduleActionStatus, nextScheduleActionScheduleAt: string, occurredAt: string, previousScheduleActionScheduleAt: string, previousScheduleActionStatus: SupportTicketScheduleActionStatus, scheduleActionId: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
             }
          | { __typename: 'SupportTicketActivityStatus', id: string, newStatus: SupportTicketStatus, newSubStatus: SupportTicketSubStatus, occurredAt: string, statusScheduleActionId?: string | null, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
             }
          | { __typename: 'SupportTicketActivityTitle', id: string, newTitle?: string | null, occurredAt: string, actor:
              | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
              | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
              | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
              | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
              | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
             }
         }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } };

export type TicketPreviewQueryVariables = Exact<{
  ticketId: Scalars['ID']['input'];
}>;


export type TicketPreviewQuery = { __typename?: 'Query', supportTicket: { __typename?: 'SupportTicket', channel: SupportTicketChannel, createdAt: string, description?: string | null, id: string, status: SupportTicketStatus, subStatus: SupportTicketSubStatus, title: string, assignedTo?:
      | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
      | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
      | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
     | null, claims: Array<{ __typename?: 'Claim', acceptedAt?: string | null, canceledAt?: string | null, id: string }>, contact:
      | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
      | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
    , contextDerived?: { __typename?: 'SupportTicketContextDerived', sale?: { __typename?: 'Sale', name: string } | null } | null } };

export type TicketsQueryVariables = Exact<{
  filters?: InputMaybe<SupportTicketsFilterInput>;
  sortBy?: InputMaybe<SupportTicketsSortInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TicketsQuery = { __typename?: 'Query', supportTickets: { __typename?: 'SupportTicketConnection', edges: Array<{ __typename?: 'SupportTicketEdge', cursor: string, node: { __typename?: 'SupportTicket', assignedAt?: string | null, channel: SupportTicketChannel, createdAt: string, description?: string | null, hasPendingScheduleActions: boolean, id: string, isDraft: boolean, orderFlowId?: string | null, previewText?: string | null, status: SupportTicketStatus, statusUpdatedAt: string, subStatus: SupportTicketSubStatus, title: string, updatedAt: string, assignedTo?:
          | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
          | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
          | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
         | null, contact:
          | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
          | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
        , contextDerived?: { __typename?: 'SupportTicketContextDerived', orderId?: string | null, saleId?: string | null, storeId?: Store | null, supplierId?: string | null, sale?: { __typename?: 'Sale', name: string, salesTeamName?: SalesTeamName | null, type: SaleType } | null } | null, createdBy:
          | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
          | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
          | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
          | { __typename?: 'SupportActorAppContact' }
          | { __typename?: 'SupportActorEmailContact' }
        , initialRequest?:
          | { __typename: 'SupportTicketActivityInitialRequestMigration' }
          | { __typename: 'SupportTicketActivityInitialRequestOrder', flow: SupportTicketActivityInitialRequestOrderFlow }
          | { __typename: 'SupportTicketActivityInitialRequestOther', otherFlow: SupportTicketActivityInitialRequestOtherFlow }
          | { __typename: 'SupportTicketActivityInitialRequestSale', saleFlow: SupportTicketActivityInitialRequestSaleFlow }
          | { __typename: 'SupportTicketActivityInitialRequestVariant', variantFlow: SupportTicketActivityInitialRequestVariantFlow }
         | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type VariantPreviewQueryVariables = Exact<{
  variantId: Scalars['ID']['input'];
}>;


export type VariantPreviewQuery = { __typename?: 'Query', variant: { __typename?: 'Variant', id: string, gtin?: string | null, productId: string, sku?: string | null, title: string, financial: { __typename?: 'VariantFinancial', retailPrice: { __typename?: 'VariantPrice', amountVatIncludedInCents: number, currency: CurrencyIso } }, images: Array<{ __typename?: 'VariantImage', url: string }>, product:
      | { __typename: 'ProductDigital', id: string, name: string, financial: { __typename?: 'ProductFinancial', frenchTaxRate: number, readableCategory: string }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, type: string, values: Array<{ __typename?: 'ProductOptionValue', id: string, value: string }> }>, visibility: { __typename?: 'ProductVisibility', isAvailableForSale: boolean }, visuals: { __typename?: 'ProductVisuals', images: Array<{ __typename?: 'ProductImage', url: string }> } }
      | { __typename: 'ProductPhysical', id: string, name: string, financial: { __typename?: 'ProductFinancial', frenchTaxRate: number, readableCategory: string }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, type: string, values: Array<{ __typename?: 'ProductOptionValue', id: string, value: string }> }>, visibility: { __typename?: 'ProductVisibility', isAvailableForSale: boolean }, visuals: { __typename?: 'ProductVisuals', images: Array<{ __typename?: 'ProductImage', url: string }> } }
    , visibility: { __typename?: 'VariantVisibility', isAvailableForSale: boolean } } };

export type ViewQueryVariables = Exact<{
  viewId: Scalars['ID']['input'];
}>;


export type ViewQuery = { __typename?: 'Query', supportView: { __typename?: 'SupportView', groupBy: SupportViewGroupByProperty, icon: string, iconColor: string, id: string, title: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }, displayedProperties: { __typename?: 'SupportViewDisplayedProperty', assignedTo: boolean, channel: boolean, contact: boolean, hasPendingScheduleActions: boolean, isDraft: boolean, orderFlow: boolean, previewText: boolean, saleName: boolean, statusUpdatedAt: boolean, subStatus: boolean, title: boolean }, filters: { __typename?: 'SupportTicketsFilter', assignedToId?: { __typename?: 'IDFilterNullable', in?: Array<string | null> | null, notIn?: Array<string | null> | null } | null, channel?: { __typename?: 'SupportTicketChannelFilter', in?: Array<SupportTicketChannel> | null, notIn?: Array<SupportTicketChannel> | null } | null, contactId?: { __typename?: 'IDFilter', in?: Array<string> | null, notIn?: Array<string> | null } | null, createdAt?: { __typename?: 'DateRangeFilter', gt?: string | null, gte?: string | null, lt?: string | null, lte?: string | null } | null, contextDerived?: { __typename?: 'ContextDerivedFilter', orderId?: { __typename?: 'IDFilterNullable', in?: Array<string | null> | null, notIn?: Array<string | null> | null } | null, sale?: { __typename?: 'ContextDerivedSaleFilter', salesTeamName?: { __typename?: 'SaleSalesTeamNameFilter', in?: Array<SalesTeamName> | null, notIn?: Array<SalesTeamName> | null } | null, type?: { __typename?: 'SaleTypeFilter', in?: Array<SaleType> | null, notIn?: Array<SaleType> | null } | null } | null, saleId?: { __typename?: 'IDFilterNullable', in?: Array<string | null> | null, notIn?: Array<string | null> | null } | null, storeId?: { __typename?: 'StoreFilterNullable', in?: Array<Store | null> | null, notIn?: Array<Store | null> | null } | null, supplierId?: { __typename?: 'IDFilterNullable', in?: Array<string | null> | null, notIn?: Array<string | null> | null } | null } | null, hasPendingScheduleActions?: { __typename?: 'BooleanFilter', equals?: boolean | null, not?: boolean | null } | null, initialRequest?: { __typename?: 'InitialRequestFilter', flow?: { __typename?: 'SupportTicketActivityInitialRequestFlowFilter', in?: Array<SupportTicketActivityInitialRequestFlow> | null, notIn?: Array<SupportTicketActivityInitialRequestFlow> | null } | null } | null, isDraft?: { __typename?: 'BooleanFilter', equals?: boolean | null, not?: boolean | null } | null, orderFlowId?: { __typename?: 'IDFilterNullable', in?: Array<string | null> | null, notIn?: Array<string | null> | null } | null, subStatus?: { __typename?: 'SupportTicketSubStatusFilter', in?: Array<SupportTicketSubStatus> | null, notIn?: Array<SupportTicketSubStatus> | null } | null }, sortBy: { __typename?: 'SupportTicketsSort', direction: SupportTicketsSortableDirection, field: SupportTicketsSortableFields } } };

export type ViewsQueryVariables = Exact<{
  input: SearchSupportViewsInput;
}>;


export type ViewsQuery = { __typename?: 'Query', supportViews: { __typename?: 'SupportViewConnection', edges: Array<{ __typename?: 'SupportViewEdge', node: { __typename?: 'SupportView', icon: string, iconColor: string, id: string, title: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type NotificationCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationCreatedSubscription = { __typename?: 'Subscription', supportNotificationCreated:
    | { __typename: 'SupportNotificationMention', id: string, sender:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
        | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
        | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
      , ticket: { __typename?: 'SupportTicket', id: string, title: string } }
    | { __typename: 'SupportNotificationReaction', id: string, reactionType: SupportTicketActivityReactionType, sender:
        | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
        | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
        | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
        | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
        | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
      , ticket: { __typename?: 'SupportTicket', id: string, title: string } }
   };

export type SnippetCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SnippetCreatedSubscription = { __typename?: 'Subscription', supportSnippetCreated: { __typename?: 'SupportSnippet', deletedAt?: string | null, id: string, storeId: Store, tagIds: Array<string>, title: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }, templates: Array<{ __typename?: 'SupportSnippetTemplate', language: LanguageIso6391, template: string }> } };

export type SnippetUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SnippetUpdatedSubscription = { __typename?: 'Subscription', supportSnippetUpdated: { __typename?: 'SupportSnippet', deletedAt?: string | null, id: string, storeId: Store, tagIds: Array<string>, title: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }, templates: Array<{ __typename?: 'SupportSnippetTemplate', language: LanguageIso6391, template: string }> } };

export type SnippetTagCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SnippetTagCreatedSubscription = { __typename?: 'Subscription', supportSnippetTagCreated: { __typename?: 'SupportSnippetTag', description?: string | null, deletedAt?: string | null, id: string, label: string, textColor: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } } } };

export type SnippetTagUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SnippetTagUpdatedSubscription = { __typename?: 'Subscription', supportSnippetTagUpdated: { __typename?: 'SupportSnippetTag', description?: string | null, deletedAt?: string | null, id: string, label: string, textColor: string, createdBy: { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } } } };

export type TicketCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TicketCreatedSubscription = { __typename?: 'Subscription', supportTicketCreated: { __typename?: 'SupportTicket', assignedAt?: string | null, channel: SupportTicketChannel, createdAt: string, description?: string | null, hasPendingScheduleActions: boolean, id: string, isDraft: boolean, orderFlowId?: string | null, previewText?: string | null, status: SupportTicketStatus, statusUpdatedAt: string, subStatus: SupportTicketSubStatus, title: string, updatedAt: string, assignedTo?:
      | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
      | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
      | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
     | null, contact:
      | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
      | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
    , contextDerived?: { __typename?: 'SupportTicketContextDerived', orderId?: string | null, saleId?: string | null, storeId?: Store | null, supplierId?: string | null, sale?: { __typename?: 'Sale', name: string, salesTeamName?: SalesTeamName | null, type: SaleType } | null } | null, createdBy:
      | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
      | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
      | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      | { __typename?: 'SupportActorAppContact' }
      | { __typename?: 'SupportActorEmailContact' }
    , initialRequest?:
      | { __typename: 'SupportTicketActivityInitialRequestMigration' }
      | { __typename: 'SupportTicketActivityInitialRequestOrder', flow: SupportTicketActivityInitialRequestOrderFlow }
      | { __typename: 'SupportTicketActivityInitialRequestOther', otherFlow: SupportTicketActivityInitialRequestOtherFlow }
      | { __typename: 'SupportTicketActivityInitialRequestSale', saleFlow: SupportTicketActivityInitialRequestSaleFlow }
      | { __typename: 'SupportTicketActivityInitialRequestVariant', variantFlow: SupportTicketActivityInitialRequestVariantFlow }
     | null } };

export type TicketUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TicketUpdatedSubscription = { __typename?: 'Subscription', supportTicketUpdated: { __typename?: 'SupportTicket', assignedAt?: string | null, channel: SupportTicketChannel, createdAt: string, description?: string | null, hasPendingScheduleActions: boolean, id: string, isDraft: boolean, orderFlowId?: string | null, previewText?: string | null, status: SupportTicketStatus, statusUpdatedAt: string, subStatus: SupportTicketSubStatus, title: string, updatedAt: string, assignedTo?:
      | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
      | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
      | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
     | null, contact:
      | { __typename: 'SupportActorAppContact', id: string, appContact: { __typename?: 'SupportAppContact', email?: string | null, firstName?: string | null, id: string, lastName?: string | null } }
      | { __typename: 'SupportActorEmailContact', id: string, emailContact: { __typename?: 'SupportEmailContact', email: string, name?: string | null } }
    , contextDerived?: { __typename?: 'SupportTicketContextDerived', orderId?: string | null, saleId?: string | null, storeId?: Store | null, supplierId?: string | null, sale?: { __typename?: 'Sale', name: string, salesTeamName?: SalesTeamName | null, type: SaleType } | null } | null, createdBy:
      | { __typename: 'ActorBotUser', id: string, botUser: { __typename?: 'BotUser', id: string, name: string } }
      | { __typename: 'ActorInternalUser', id: string, internalUser: { __typename?: 'InternalUser', email: string, firstName: string, id: string, picture: string, lastName: string } }
      | { __typename: 'ActorSupplierUser', id: string, supplierUser: { __typename?: 'SupplierUser', email: string, firstName: string, id: string, lastName: string, picture: string } }
      | { __typename?: 'SupportActorAppContact' }
      | { __typename?: 'SupportActorEmailContact' }
    , initialRequest?:
      | { __typename: 'SupportTicketActivityInitialRequestMigration' }
      | { __typename: 'SupportTicketActivityInitialRequestOrder', flow: SupportTicketActivityInitialRequestOrderFlow }
      | { __typename: 'SupportTicketActivityInitialRequestOther', otherFlow: SupportTicketActivityInitialRequestOtherFlow }
      | { __typename: 'SupportTicketActivityInitialRequestSale', saleFlow: SupportTicketActivityInitialRequestSaleFlow }
      | { __typename: 'SupportTicketActivityInitialRequestVariant', variantFlow: SupportTicketActivityInitialRequestVariantFlow }
     | null } };

export type TicketDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TicketDeletedSubscription = { __typename?: 'Subscription', supportTicketDeleted: string };


export const ActorLegacyFragmentDoc = `
    fragment ActorLegacy on SupportActorLegacy {
  __typename
  ... on ActorBotUser {
    botUser {
      id
      name
    }
    id
  }
  ... on ActorInternalUser {
    id
    internalUser {
      email
      firstName
      id
      picture
      lastName
    }
  }
  ... on ActorSupplierUser {
    id
    supplierUser {
      firstName
      id
      lastName
      picture
    }
  }
  ... on SupportActorAppContact {
    appContact {
      email
      firstName
      id
      lastName
    }
    id
  }
  ... on SupportActorEmailContact {
    emailContact {
      email
      name
    }
    id
  }
  ... on SupportActorBotUser {
    botUser {
      id
      name
    }
    id
  }
  ... on SupportActorInternalUser {
    id
    internalUser {
      email
      firstName
      id
      picture
      lastName
    }
  }
}
    `;
export const AttachmentFragmentDoc = `
    fragment Attachment on SupportAttachment {
  deletedAt
  fileMimeType
  fileName
  fileSize
  fileUrl
  id
}
    `;
export const AttachmentPayloadFragmentDoc = `
    fragment AttachmentPayload on SupportAttachmentPayload {
  fileMimeType
  fileName
  fileSize
  fileUrl
}
    `;
export const PartialAddressFragmentDoc = `
    fragment PartialAddress on Address {
  city
  countryCode
  state
  street
  streetAdditional
  zipCode
}
    `;
export const PartialAppContactFragmentDoc = `
    fragment PartialAppContact on SupportAppContact {
  email
  firstName
  lastName
}
    `;
export const PartialClaimItemFragmentDoc = `
    fragment PartialClaimItem on Item {
  digitalCouponCode
  gtin
  id
  imageUrl
  isCancelled
  isReturnable
  name
  newDigitalCouponCode
  priceSold {
    currency
    valueWithVat
  }
  productId
  productVariantId
  refundSummary {
    isTotallyRefunded
    refundedAmountInCents
    remainingToRefundAmountInCents
  }
  size
  sku
}
    `;
export const PartialItemInitialRequestFragmentDoc = `
    fragment PartialItemInitialRequest on Item {
  digitalCouponCode
  gtin
  id
  imageUrl
  isCancelled
  isReturnable
  name
  newDigitalCouponCode
  priceSold {
    currency
    valueWithVat
  }
  productId
  productVariantId
  refundSummary {
    isTotallyRefunded
    refundedAmountInCents
    remainingToRefundAmountInCents
  }
  size
  sku
}
    `;
export const PartialOrderAddressFragmentDoc = `
    fragment PartialOrderAddress on Address {
  city
  countryCode
  state
  street
  streetAdditional
  zipCode
}
    `;
export const PartialItemFragmentDoc = `
    fragment PartialItem on Item {
  digitalCouponCode
  gtin
  id
  imageUrl
  isCancelled
  isReturnable
  name
  newDigitalCouponCode
  priceSold {
    currency
    valueWithVat
  }
  productId
  productVariantId
  refundSummary {
    isTotallyRefunded
    refundedAmountInCents
    remainingToRefundAmountInCents
  }
  size
  sku
}
    `;
export const PickupPointOpeningDaysFragmentDoc = `
    fragment PickupPointOpeningDays on PickupOpeningDays {
  monday {
    open
    close
  }
  tuesday {
    open
    close
  }
  wednesday {
    open
    close
  }
  thursday {
    open
    close
  }
  friday {
    open
    close
  }
  saturday {
    open
    close
  }
  sunday {
    open
    close
  }
}
    `;
export const PartialOrderFragmentDoc = `
    fragment PartialOrder on Order {
  brandId
  buyer {
    address {
      ...PartialOrderAddress
    }
    firstName
    lastName
  }
  cashback {
    amount
    amountUpdatedAt
    currency
    dueDate
    status
  }
  createdAt
  hasBeenExported
  id
  isCancelled
  isFullDigital
  items {
    ...PartialItem
  }
  parcels {
    estimatedDeliveryDateRange {
      max
      min
    }
    id
    tracking {
      courier {
        logoUrl
        name
      }
      courierSlug
      deliveredAt
      number
      status
      subStatus
      url
    }
  }
  recipient {
    address {
      ...PartialOrderAddress
    }
    firstName
    lastName
    phoneNumber
  }
  returns {
    applyWithheld
    id
    isValidationLocked
    lines {
      item {
        digitalCouponCode
        gtin
        id
        imageUrl
        isCancelled
        isReturnable
        newDigitalCouponCode
        name
        priceSold {
          currency
          valueWithVat
        }
        productId
        productVariantId
        refundSummary {
          isTotallyRefunded
          refundedAmountInCents
          remainingToRefundAmountInCents
        }
        size
        sku
      }
      itemId
    }
    preferredRefundMethod
    status
    tracking {
      courier {
        logoUrl
        name
      }
      courierSlug
      deliveredAt
      number
      status
      subStatus
      url
    }
  }
  saleId
  shipping {
    deliveryDateRangeHistory {
      end
      start
    }
    fees
    feesSold
    pickupPoint {
      address {
        city
        countryCode
        name
        street
        streetAdditional
        zipCode
      }
      id
      openingDays {
        ...PickupPointOpeningDays
      }
    }
    refundSummary {
      isTotallyRefunded
      refundedAmountInCents
    }
  }
  supportActorAppContact {
    id
  }
  totalPriceSold {
    currency
    valueWithVat
  }
}
    ${PartialOrderAddressFragmentDoc}
${PartialItemFragmentDoc}
${PickupPointOpeningDaysFragmentDoc}`;
export const AgentFragmentDoc = `
    fragment Agent on ActorUser {
  __typename
  ... on ActorBotUser {
    botUser {
      id
      name
    }
    id
  }
  ... on ActorInternalUser {
    id
    internalUser {
      email
      firstName
      id
      picture
      lastName
    }
  }
  ... on ActorSupplierUser {
    id
    supplierUser {
      email
      firstName
      id
      lastName
      picture
    }
  }
}
    `;
export const PartialSnippetFragmentDoc = `
    fragment PartialSnippet on SupportSnippet {
  createdBy {
    ...Agent
  }
  deletedAt
  id
  storeId
  tagIds
  templates {
    language
    template
  }
  title
}
    ${AgentFragmentDoc}`;
export const PartialSnippetTagFragmentDoc = `
    fragment PartialSnippetTag on SupportSnippetTag {
  createdBy {
    ...Agent
  }
  description
  deletedAt
  id
  label
  textColor
}
    ${AgentFragmentDoc}`;
export const ContactFragmentDoc = `
    fragment Contact on SupportActorContact {
  __typename
  ... on SupportActorAppContact {
    appContact {
      email
      firstName
      id
      lastName
    }
    id
  }
  ... on SupportActorEmailContact {
    emailContact {
      email
      name
    }
    id
  }
}
    `;
export const PartialTicketFragmentDoc = `
    fragment PartialTicket on SupportTicket {
  assignedAt
  assignedTo {
    ...Agent
  }
  channel
  contact {
    ...Contact
  }
  contextDerived {
    orderId
    sale {
      name
      salesTeamName
      type
    }
    saleId
    storeId
    supplierId
  }
  createdAt
  createdBy {
    ...Agent
  }
  description
  hasPendingScheduleActions
  id
  initialRequest {
    __typename
    ... on SupportTicketActivityInitialRequestOrder {
      flow
    }
    ... on SupportTicketActivityInitialRequestOther {
      otherFlow: flow
    }
    ... on SupportTicketActivityInitialRequestSale {
      saleFlow: flow
    }
    ... on SupportTicketActivityInitialRequestVariant {
      variantFlow: flow
    }
  }
  isDraft
  orderFlowId
  previewText
  status
  statusUpdatedAt
  subStatus
  title
  updatedAt
}
    ${AgentFragmentDoc}
${ContactFragmentDoc}`;
export const LinkedTicketFragmentDoc = `
    fragment LinkedTicket on SupportTicket {
  claims {
    acceptedAt
    canceledAt
    id
  }
  id
  statusUpdatedAt
  subStatus
  title
}
    `;
export const AddAppContactCreditDocument = `
    mutation addAppContactCredit($input: AddSupportActorAppContactCreditInput!) {
  addSupportActorAppContactCredit(input: $input)
}
    `;

export const useAddAppContactCreditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddAppContactCreditMutation, TError, AddAppContactCreditMutationVariables, TContext>) => {
    
    return useMutation<AddAppContactCreditMutation, TError, AddAppContactCreditMutationVariables, TContext>(
      {
    mutationKey: ['addAppContactCredit'],
    mutationFn: useFetchData<AddAppContactCreditMutation, AddAppContactCreditMutationVariables>(AddAppContactCreditDocument),
    ...options
  }
    )};

export const AddAppContactNoteDocument = `
    mutation addAppContactNote($input: AddSupportAppContactNoteInput!) {
  addSupportAppContactNote(input: $input) {
    id
  }
}
    `;

export const useAddAppContactNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddAppContactNoteMutation, TError, AddAppContactNoteMutationVariables, TContext>) => {
    
    return useMutation<AddAppContactNoteMutation, TError, AddAppContactNoteMutationVariables, TContext>(
      {
    mutationKey: ['addAppContactNote'],
    mutationFn: useFetchData<AddAppContactNoteMutation, AddAppContactNoteMutationVariables>(AddAppContactNoteDocument),
    ...options
  }
    )};

export const AddEmailDocument = `
    mutation addEmail($input: AddSupportTicketEmailInput!) {
  addSupportTicketEmail(input: $input) {
    id
  }
}
    `;

export const useAddEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddEmailMutation, TError, AddEmailMutationVariables, TContext>) => {
    
    return useMutation<AddEmailMutation, TError, AddEmailMutationVariables, TContext>(
      {
    mutationKey: ['addEmail'],
    mutationFn: useFetchData<AddEmailMutation, AddEmailMutationVariables>(AddEmailDocument),
    ...options
  }
    )};

export const AddMessageDocument = `
    mutation addMessage($ticketId: ID!, $content: String!, $attachments: [AttachmentUrl!]) {
  addSupportTicketMessage(
    ticketId: $ticketId
    content: $content
    attachments: $attachments
  ) {
    id
  }
}
    `;

export const useAddMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddMessageMutation, TError, AddMessageMutationVariables, TContext>) => {
    
    return useMutation<AddMessageMutation, TError, AddMessageMutationVariables, TContext>(
      {
    mutationKey: ['addMessage'],
    mutationFn: useFetchData<AddMessageMutation, AddMessageMutationVariables>(AddMessageDocument),
    ...options
  }
    )};

export const AddNoteDocument = `
    mutation addNote($ticketId: ID!, $content: String!, $attachments: [AttachmentUrl!]) {
  addSupportTicketNote(
    ticketId: $ticketId
    content: $content
    attachments: $attachments
  ) {
    id
  }
}
    `;

export const useAddNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddNoteMutation, TError, AddNoteMutationVariables, TContext>) => {
    
    return useMutation<AddNoteMutation, TError, AddNoteMutationVariables, TContext>(
      {
    mutationKey: ['addNote'],
    mutationFn: useFetchData<AddNoteMutation, AddNoteMutationVariables>(AddNoteDocument),
    ...options
  }
    )};

export const AddSaleNoteDocument = `
    mutation addSaleNote($input: AddSaleNoteInput!) {
  addSaleNote(input: $input) {
    id
  }
}
    `;

export const useAddSaleNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSaleNoteMutation, TError, AddSaleNoteMutationVariables, TContext>) => {
    
    return useMutation<AddSaleNoteMutation, TError, AddSaleNoteMutationVariables, TContext>(
      {
    mutationKey: ['addSaleNote'],
    mutationFn: useFetchData<AddSaleNoteMutation, AddSaleNoteMutationVariables>(AddSaleNoteDocument),
    ...options
  }
    )};

export const AddTicketActivityReactionDocument = `
    mutation addTicketActivityReaction($activityId: ID!, $type: SupportTicketActivityReactionType!) {
  addSupportTicketActivityReaction(activityId: $activityId, type: $type) {
    id
  }
}
    `;

export const useAddTicketActivityReactionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddTicketActivityReactionMutation, TError, AddTicketActivityReactionMutationVariables, TContext>) => {
    
    return useMutation<AddTicketActivityReactionMutation, TError, AddTicketActivityReactionMutationVariables, TContext>(
      {
    mutationKey: ['addTicketActivityReaction'],
    mutationFn: useFetchData<AddTicketActivityReactionMutation, AddTicketActivityReactionMutationVariables>(AddTicketActivityReactionDocument),
    ...options
  }
    )};

export const AddViewToFavoriteDocument = `
    mutation addViewToFavorite($viewId: ID!) {
  addSupportViewFavorite(viewId: $viewId)
}
    `;

export const useAddViewToFavoriteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddViewToFavoriteMutation, TError, AddViewToFavoriteMutationVariables, TContext>) => {
    
    return useMutation<AddViewToFavoriteMutation, TError, AddViewToFavoriteMutationVariables, TContext>(
      {
    mutationKey: ['addViewToFavorite'],
    mutationFn: useFetchData<AddViewToFavoriteMutation, AddViewToFavoriteMutationVariables>(AddViewToFavoriteDocument),
    ...options
  }
    )};

export const AiSuggestionAcceptDocument = `
    mutation aiSuggestionAccept($input: SupportTicketAiSuggestionAcceptInput!) {
  supportTicket_aiSuggestion_accept(input: $input) {
    id
  }
}
    `;

export const useAiSuggestionAcceptMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AiSuggestionAcceptMutation, TError, AiSuggestionAcceptMutationVariables, TContext>) => {
    
    return useMutation<AiSuggestionAcceptMutation, TError, AiSuggestionAcceptMutationVariables, TContext>(
      {
    mutationKey: ['aiSuggestionAccept'],
    mutationFn: useFetchData<AiSuggestionAcceptMutation, AiSuggestionAcceptMutationVariables>(AiSuggestionAcceptDocument),
    ...options
  }
    )};

export const AiSuggestionEditEmailDocument = `
    mutation aiSuggestionEditEmail($input: SupportTicketAiSuggestionEditEmailInput!) {
  supportTicket_aiSuggestion_editEmail(input: $input) {
    id
  }
}
    `;

export const useAiSuggestionEditEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AiSuggestionEditEmailMutation, TError, AiSuggestionEditEmailMutationVariables, TContext>) => {
    
    return useMutation<AiSuggestionEditEmailMutation, TError, AiSuggestionEditEmailMutationVariables, TContext>(
      {
    mutationKey: ['aiSuggestionEditEmail'],
    mutationFn: useFetchData<AiSuggestionEditEmailMutation, AiSuggestionEditEmailMutationVariables>(AiSuggestionEditEmailDocument),
    ...options
  }
    )};

export const AiSuggestionEditMessageDocument = `
    mutation aiSuggestionEditMessage($input: SupportTicketAiSuggestionEditMessageInput!) {
  supportTicket_aiSuggestion_editMessage(input: $input) {
    id
  }
}
    `;

export const useAiSuggestionEditMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AiSuggestionEditMessageMutation, TError, AiSuggestionEditMessageMutationVariables, TContext>) => {
    
    return useMutation<AiSuggestionEditMessageMutation, TError, AiSuggestionEditMessageMutationVariables, TContext>(
      {
    mutationKey: ['aiSuggestionEditMessage'],
    mutationFn: useFetchData<AiSuggestionEditMessageMutation, AiSuggestionEditMessageMutationVariables>(AiSuggestionEditMessageDocument),
    ...options
  }
    )};

export const ApplyAppContactReferralDocument = `
    mutation applyAppContactReferral($input: ApplySupportAppContactReferralInput!) {
  applySupportAppContactReferral(input: $input)
}
    `;

export const useApplyAppContactReferralMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApplyAppContactReferralMutation, TError, ApplyAppContactReferralMutationVariables, TContext>) => {
    
    return useMutation<ApplyAppContactReferralMutation, TError, ApplyAppContactReferralMutationVariables, TContext>(
      {
    mutationKey: ['applyAppContactReferral'],
    mutationFn: useFetchData<ApplyAppContactReferralMutation, ApplyAppContactReferralMutationVariables>(ApplyAppContactReferralDocument),
    ...options
  }
    )};

export const ApplyAppContactReferralDryRunDocument = `
    mutation applyAppContactReferralDryRun($input: ApplySupportAppContactReferralInput!) {
  applySupportAppContactReferralDryRun(input: $input) {
    __typename
    ... on ReferralPlanError {
      code
    }
    ... on ReferralPlan {
      referee {
        appUserId
        credit {
          amountInCents
          currency
        }
        name
      }
      referrer {
        appUserId
        credit {
          amountInCents
          currency
        }
        isMassReferrer
        name
      }
    }
  }
}
    `;

export const useApplyAppContactReferralDryRunMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApplyAppContactReferralDryRunMutation, TError, ApplyAppContactReferralDryRunMutationVariables, TContext>) => {
    
    return useMutation<ApplyAppContactReferralDryRunMutation, TError, ApplyAppContactReferralDryRunMutationVariables, TContext>(
      {
    mutationKey: ['applyAppContactReferralDryRun'],
    mutationFn: useFetchData<ApplyAppContactReferralDryRunMutation, ApplyAppContactReferralDryRunMutationVariables>(ApplyAppContactReferralDryRunDocument),
    ...options
  }
    )};

export const AssignSupportRoleToInternalUserDocument = `
    mutation assignSupportRoleToInternalUser($actorId: ID!, $role: SupportRole!) {
  assignSupportRoleToInternalUser(actorId: $actorId, role: $role)
}
    `;

export const useAssignSupportRoleToInternalUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AssignSupportRoleToInternalUserMutation, TError, AssignSupportRoleToInternalUserMutationVariables, TContext>) => {
    
    return useMutation<AssignSupportRoleToInternalUserMutation, TError, AssignSupportRoleToInternalUserMutationVariables, TContext>(
      {
    mutationKey: ['assignSupportRoleToInternalUser'],
    mutationFn: useFetchData<AssignSupportRoleToInternalUserMutation, AssignSupportRoleToInternalUserMutationVariables>(AssignSupportRoleToInternalUserDocument),
    ...options
  }
    )};

export const AttachSupportTicketContextDocument = `
    mutation attachSupportTicketContext($ticketId: ID!, $context: SupportTicketContextInput!) {
  attachSupportTicketContext(ticketId: $ticketId, context: $context) {
    id
  }
}
    `;

export const useAttachSupportTicketContextMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AttachSupportTicketContextMutation, TError, AttachSupportTicketContextMutationVariables, TContext>) => {
    
    return useMutation<AttachSupportTicketContextMutation, TError, AttachSupportTicketContextMutationVariables, TContext>(
      {
    mutationKey: ['attachSupportTicketContext'],
    mutationFn: useFetchData<AttachSupportTicketContextMutation, AttachSupportTicketContextMutationVariables>(AttachSupportTicketContextDocument),
    ...options
  }
    )};

export const CancelOrderDocument = `
    mutation cancelOrder($input: Order_Cancel_Input!) {
  order_cancel(input: $input)
}
    `;

export const useCancelOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelOrderMutation, TError, CancelOrderMutationVariables, TContext>) => {
    
    return useMutation<CancelOrderMutation, TError, CancelOrderMutationVariables, TContext>(
      {
    mutationKey: ['cancelOrder'],
    mutationFn: useFetchData<CancelOrderMutation, CancelOrderMutationVariables>(CancelOrderDocument),
    ...options
  }
    )};

export const CancelOrderClaimDocument = `
    mutation cancelOrderClaim($input: Order_Claim_Cancel_Input!) {
  order_claim_cancel(input: $input)
}
    `;

export const useCancelOrderClaimMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelOrderClaimMutation, TError, CancelOrderClaimMutationVariables, TContext>) => {
    
    return useMutation<CancelOrderClaimMutation, TError, CancelOrderClaimMutationVariables, TContext>(
      {
    mutationKey: ['cancelOrderClaim'],
    mutationFn: useFetchData<CancelOrderClaimMutation, CancelOrderClaimMutationVariables>(CancelOrderClaimDocument),
    ...options
  }
    )};

export const CancelOrderDryRunDocument = `
    mutation cancelOrderDryRun($input: Order_Cancel_Input!) {
  order_cancel_dryRun(input: $input) {
    cashAmountInCents
    creditAmountInCents
  }
}
    `;

export const useCancelOrderDryRunMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelOrderDryRunMutation, TError, CancelOrderDryRunMutationVariables, TContext>) => {
    
    return useMutation<CancelOrderDryRunMutation, TError, CancelOrderDryRunMutationVariables, TContext>(
      {
    mutationKey: ['cancelOrderDryRun'],
    mutationFn: useFetchData<CancelOrderDryRunMutation, CancelOrderDryRunMutationVariables>(CancelOrderDryRunDocument),
    ...options
  }
    )};

export const CancelOrderItemsDocument = `
    mutation cancelOrderItems($input: Order_Items_Cancel_Input!) {
  order_items_cancel(input: $input)
}
    `;

export const useCancelOrderItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelOrderItemsMutation, TError, CancelOrderItemsMutationVariables, TContext>) => {
    
    return useMutation<CancelOrderItemsMutation, TError, CancelOrderItemsMutationVariables, TContext>(
      {
    mutationKey: ['cancelOrderItems'],
    mutationFn: useFetchData<CancelOrderItemsMutation, CancelOrderItemsMutationVariables>(CancelOrderItemsDocument),
    ...options
  }
    )};

export const CancelOrderItemsDryRunDocument = `
    mutation cancelOrderItemsDryRun($input: Order_Items_Cancel_Input!) {
  order_items_cancel_dryRun(input: $input) {
    cashAmountInCents
    creditAmountInCents
  }
}
    `;

export const useCancelOrderItemsDryRunMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelOrderItemsDryRunMutation, TError, CancelOrderItemsDryRunMutationVariables, TContext>) => {
    
    return useMutation<CancelOrderItemsDryRunMutation, TError, CancelOrderItemsDryRunMutationVariables, TContext>(
      {
    mutationKey: ['cancelOrderItemsDryRun'],
    mutationFn: useFetchData<CancelOrderItemsDryRunMutation, CancelOrderItemsDryRunMutationVariables>(CancelOrderItemsDryRunDocument),
    ...options
  }
    )};

export const CancelOrderReturnDocument = `
    mutation cancelOrderReturn($input: Order_Return_Cancel_Input!) {
  order_return_cancel(input: $input)
}
    `;

export const useCancelOrderReturnMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelOrderReturnMutation, TError, CancelOrderReturnMutationVariables, TContext>) => {
    
    return useMutation<CancelOrderReturnMutation, TError, CancelOrderReturnMutationVariables, TContext>(
      {
    mutationKey: ['cancelOrderReturn'],
    mutationFn: useFetchData<CancelOrderReturnMutation, CancelOrderReturnMutationVariables>(CancelOrderReturnDocument),
    ...options
  }
    )};

export const CloseTicketAsDuplicateDocument = `
    mutation closeTicketAsDuplicate($input: SupportTicket_CloseAsDuplicate_Input!) {
  supportTicket_closeAsDuplicate(input: $input) {
    id
  }
}
    `;

export const useCloseTicketAsDuplicateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CloseTicketAsDuplicateMutation, TError, CloseTicketAsDuplicateMutationVariables, TContext>) => {
    
    return useMutation<CloseTicketAsDuplicateMutation, TError, CloseTicketAsDuplicateMutationVariables, TContext>(
      {
    mutationKey: ['closeTicketAsDuplicate'],
    mutationFn: useFetchData<CloseTicketAsDuplicateMutation, CloseTicketAsDuplicateMutationVariables>(CloseTicketAsDuplicateDocument),
    ...options
  }
    )};

export const CloseTicketAsJunkDocument = `
    mutation closeTicketAsJunk($input: SupportTicket_CloseAsJunk_Input!) {
  supportTicket_closeAsJunk(input: $input) {
    id
  }
}
    `;

export const useCloseTicketAsJunkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CloseTicketAsJunkMutation, TError, CloseTicketAsJunkMutationVariables, TContext>) => {
    
    return useMutation<CloseTicketAsJunkMutation, TError, CloseTicketAsJunkMutationVariables, TContext>(
      {
    mutationKey: ['closeTicketAsJunk'],
    mutationFn: useFetchData<CloseTicketAsJunkMutation, CloseTicketAsJunkMutationVariables>(CloseTicketAsJunkDocument),
    ...options
  }
    )};

export const CloseTicketAsUnresolvableDocument = `
    mutation closeTicketAsUnresolvable($input: SupportTicket_CloseAsUnresolvable_Input!) {
  supportTicket_closeAsUnresolvable(input: $input) {
    id
  }
}
    `;

export const useCloseTicketAsUnresolvableMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CloseTicketAsUnresolvableMutation, TError, CloseTicketAsUnresolvableMutationVariables, TContext>) => {
    
    return useMutation<CloseTicketAsUnresolvableMutation, TError, CloseTicketAsUnresolvableMutationVariables, TContext>(
      {
    mutationKey: ['closeTicketAsUnresolvable'],
    mutationFn: useFetchData<CloseTicketAsUnresolvableMutation, CloseTicketAsUnresolvableMutationVariables>(CloseTicketAsUnresolvableDocument),
    ...options
  }
    )};

export const CreateOrderReturnDocument = `
    mutation createOrderReturn($input: Order_Return_Create_Input!) {
  order_return_create(input: $input)
}
    `;

export const useCreateOrderReturnMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOrderReturnMutation, TError, CreateOrderReturnMutationVariables, TContext>) => {
    
    return useMutation<CreateOrderReturnMutation, TError, CreateOrderReturnMutationVariables, TContext>(
      {
    mutationKey: ['createOrderReturn'],
    mutationFn: useFetchData<CreateOrderReturnMutation, CreateOrderReturnMutationVariables>(CreateOrderReturnDocument),
    ...options
  }
    )};

export const CreateOrderReturnWithLabelDocument = `
    mutation createOrderReturnWithLabel($input: Order_Return_CreateWithLabel_Input!) {
  order_return_createWithLabel(input: $input)
}
    `;

export const useCreateOrderReturnWithLabelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOrderReturnWithLabelMutation, TError, CreateOrderReturnWithLabelMutationVariables, TContext>) => {
    
    return useMutation<CreateOrderReturnWithLabelMutation, TError, CreateOrderReturnWithLabelMutationVariables, TContext>(
      {
    mutationKey: ['createOrderReturnWithLabel'],
    mutationFn: useFetchData<CreateOrderReturnWithLabelMutation, CreateOrderReturnWithLabelMutationVariables>(CreateOrderReturnWithLabelDocument),
    ...options
  }
    )};

export const CreateSnippetDocument = `
    mutation createSnippet($input: CreateSupportSnippetInput!) {
  createSupportSnippet(input: $input) {
    id
  }
}
    `;

export const useCreateSnippetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSnippetMutation, TError, CreateSnippetMutationVariables, TContext>) => {
    
    return useMutation<CreateSnippetMutation, TError, CreateSnippetMutationVariables, TContext>(
      {
    mutationKey: ['createSnippet'],
    mutationFn: useFetchData<CreateSnippetMutation, CreateSnippetMutationVariables>(CreateSnippetDocument),
    ...options
  }
    )};

export const CreateSnippetTagDocument = `
    mutation createSnippetTag($input: CreateSupportSnippetTagInput!) {
  createSupportSnippetTag(input: $input) {
    id
  }
}
    `;

export const useCreateSnippetTagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSnippetTagMutation, TError, CreateSnippetTagMutationVariables, TContext>) => {
    
    return useMutation<CreateSnippetTagMutation, TError, CreateSnippetTagMutationVariables, TContext>(
      {
    mutationKey: ['createSnippetTag'],
    mutationFn: useFetchData<CreateSnippetTagMutation, CreateSnippetTagMutationVariables>(CreateSnippetTagDocument),
    ...options
  }
    )};

export const CreateTicketDocument = `
    mutation createTicket($input: CreateSupportTicketInput!) {
  createSupportTicket(input: $input) {
    id
  }
}
    `;

export const useCreateTicketMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTicketMutation, TError, CreateTicketMutationVariables, TContext>) => {
    
    return useMutation<CreateTicketMutation, TError, CreateTicketMutationVariables, TContext>(
      {
    mutationKey: ['createTicket'],
    mutationFn: useFetchData<CreateTicketMutation, CreateTicketMutationVariables>(CreateTicketDocument),
    ...options
  }
    )};

export const CreateTicketByOrderIdDocument = `
    mutation createTicketByOrderId($input: CreateSupportTicketByOrderIdInput!) {
  createSupportTicketByOrderId(input: $input) {
    id
  }
}
    `;

export const useCreateTicketByOrderIdMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTicketByOrderIdMutation, TError, CreateTicketByOrderIdMutationVariables, TContext>) => {
    
    return useMutation<CreateTicketByOrderIdMutation, TError, CreateTicketByOrderIdMutationVariables, TContext>(
      {
    mutationKey: ['createTicketByOrderId'],
    mutationFn: useFetchData<CreateTicketByOrderIdMutation, CreateTicketByOrderIdMutationVariables>(CreateTicketByOrderIdDocument),
    ...options
  }
    )};

export const CreateViewDocument = `
    mutation createView($createSupportViewInput: CreateSupportViewInput!) {
  createSupportView(input: $createSupportViewInput) {
    id
  }
}
    `;

export const useCreateViewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateViewMutation, TError, CreateViewMutationVariables, TContext>) => {
    
    return useMutation<CreateViewMutation, TError, CreateViewMutationVariables, TContext>(
      {
    mutationKey: ['createView'],
    mutationFn: useFetchData<CreateViewMutation, CreateViewMutationVariables>(CreateViewDocument),
    ...options
  }
    )};

export const DeclareOrderItemsAsOutOfStockDocument = `
    mutation declareOrderItemsAsOutOfStock($input: SupportTicket_Order_DeclareItemsAsOutOfStock_Input!) {
  supportTicket_order_declareItemsAsOutOfStock(input: $input) {
    id
  }
}
    `;

export const useDeclareOrderItemsAsOutOfStockMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeclareOrderItemsAsOutOfStockMutation, TError, DeclareOrderItemsAsOutOfStockMutationVariables, TContext>) => {
    
    return useMutation<DeclareOrderItemsAsOutOfStockMutation, TError, DeclareOrderItemsAsOutOfStockMutationVariables, TContext>(
      {
    mutationKey: ['declareOrderItemsAsOutOfStock'],
    mutationFn: useFetchData<DeclareOrderItemsAsOutOfStockMutation, DeclareOrderItemsAsOutOfStockMutationVariables>(DeclareOrderItemsAsOutOfStockDocument),
    ...options
  }
    )};

export const DeclareOrderItemsAsOutOfStockDryRunDocument = `
    mutation declareOrderItemsAsOutOfStockDryRun($input: SupportTicket_Order_DeclareItemsAsOutOfStock_Input!) {
  supportTicket_order_declareItemsAsOutOfStock_dryRun(input: $input) {
    creditCompensationAmountInCents
    orderCanceled
    refunds {
      ... on OrderItemRefundPlan {
        breakdown {
          cashAmountInCents
          creditAmountInCents
          discountAmountInCents
        }
        itemId
        orderId
      }
      ... on OrderItemTaxesRefundPlan {
        breakdown {
          cashAmountInCents
          creditAmountInCents
          discountAmountInCents
        }
        itemId
        orderId
      }
      ... on OrderShippingFeesRefundPlan {
        breakdown {
          cashAmountInCents
          creditAmountInCents
          discountAmountInCents
        }
        orderId
      }
    }
  }
}
    `;

export const useDeclareOrderItemsAsOutOfStockDryRunMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeclareOrderItemsAsOutOfStockDryRunMutation, TError, DeclareOrderItemsAsOutOfStockDryRunMutationVariables, TContext>) => {
    
    return useMutation<DeclareOrderItemsAsOutOfStockDryRunMutation, TError, DeclareOrderItemsAsOutOfStockDryRunMutationVariables, TContext>(
      {
    mutationKey: ['declareOrderItemsAsOutOfStockDryRun'],
    mutationFn: useFetchData<DeclareOrderItemsAsOutOfStockDryRunMutation, DeclareOrderItemsAsOutOfStockDryRunMutationVariables>(DeclareOrderItemsAsOutOfStockDryRunDocument),
    ...options
  }
    )};

export const DeleteAttachmentDocument = `
    mutation deleteAttachment($attachmentId: ID!) {
  deleteSupportAttachment(id: $attachmentId)
}
    `;

export const useDeleteAttachmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAttachmentMutation, TError, DeleteAttachmentMutationVariables, TContext>) => {
    
    return useMutation<DeleteAttachmentMutation, TError, DeleteAttachmentMutationVariables, TContext>(
      {
    mutationKey: ['deleteAttachment'],
    mutationFn: useFetchData<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(DeleteAttachmentDocument),
    ...options
  }
    )};

export const DeleteTicketDocument = `
    mutation deleteTicket($ticketId: ID!) {
  deleteSupportTicket(ticketId: $ticketId)
}
    `;

export const useDeleteTicketMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTicketMutation, TError, DeleteTicketMutationVariables, TContext>) => {
    
    return useMutation<DeleteTicketMutation, TError, DeleteTicketMutationVariables, TContext>(
      {
    mutationKey: ['deleteTicket'],
    mutationFn: useFetchData<DeleteTicketMutation, DeleteTicketMutationVariables>(DeleteTicketDocument),
    ...options
  }
    )};

export const DeleteViewDocument = `
    mutation deleteView($viewId: ID!) {
  deleteSupportView(viewId: $viewId)
}
    `;

export const useDeleteViewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteViewMutation, TError, DeleteViewMutationVariables, TContext>) => {
    
    return useMutation<DeleteViewMutation, TError, DeleteViewMutationVariables, TContext>(
      {
    mutationKey: ['deleteView'],
    mutationFn: useFetchData<DeleteViewMutation, DeleteViewMutationVariables>(DeleteViewDocument),
    ...options
  }
    )};

export const DetachSupportTicketContextDocument = `
    mutation detachSupportTicketContext($ticketId: ID!) {
  detachSupportTicketContext(ticketId: $ticketId) {
    id
  }
}
    `;

export const useDetachSupportTicketContextMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DetachSupportTicketContextMutation, TError, DetachSupportTicketContextMutationVariables, TContext>) => {
    
    return useMutation<DetachSupportTicketContextMutation, TError, DetachSupportTicketContextMutationVariables, TContext>(
      {
    mutationKey: ['detachSupportTicketContext'],
    mutationFn: useFetchData<DetachSupportTicketContextMutation, DetachSupportTicketContextMutationVariables>(DetachSupportTicketContextDocument),
    ...options
  }
    )};

export const EditOrderBillingAddressDocument = `
    mutation editOrderBillingAddress($input: Order_EditBillingAddress_Input!) {
  order_editBillingAddress(input: $input)
}
    `;

export const useEditOrderBillingAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditOrderBillingAddressMutation, TError, EditOrderBillingAddressMutationVariables, TContext>) => {
    
    return useMutation<EditOrderBillingAddressMutation, TError, EditOrderBillingAddressMutationVariables, TContext>(
      {
    mutationKey: ['editOrderBillingAddress'],
    mutationFn: useFetchData<EditOrderBillingAddressMutation, EditOrderBillingAddressMutationVariables>(EditOrderBillingAddressDocument),
    ...options
  }
    )};

export const EditOrderReturnPreferredRefundMethodDocument = `
    mutation editOrderReturnPreferredRefundMethod($input: Order_Return_EditPreferredRefundMethod_Input!) {
  order_return_editPreferredRefundMethod(input: $input)
}
    `;

export const useEditOrderReturnPreferredRefundMethodMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditOrderReturnPreferredRefundMethodMutation, TError, EditOrderReturnPreferredRefundMethodMutationVariables, TContext>) => {
    
    return useMutation<EditOrderReturnPreferredRefundMethodMutation, TError, EditOrderReturnPreferredRefundMethodMutationVariables, TContext>(
      {
    mutationKey: ['editOrderReturnPreferredRefundMethod'],
    mutationFn: useFetchData<EditOrderReturnPreferredRefundMethodMutation, EditOrderReturnPreferredRefundMethodMutationVariables>(EditOrderReturnPreferredRefundMethodDocument),
    ...options
  }
    )};

export const EditOrderReturnTrackingInfoDocument = `
    mutation editOrderReturnTrackingInfo($input: Order_Return_EditTrackingInfo_Input!) {
  order_return_editTrackingInfo(input: $input)
}
    `;

export const useEditOrderReturnTrackingInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditOrderReturnTrackingInfoMutation, TError, EditOrderReturnTrackingInfoMutationVariables, TContext>) => {
    
    return useMutation<EditOrderReturnTrackingInfoMutation, TError, EditOrderReturnTrackingInfoMutationVariables, TContext>(
      {
    mutationKey: ['editOrderReturnTrackingInfo'],
    mutationFn: useFetchData<EditOrderReturnTrackingInfoMutation, EditOrderReturnTrackingInfoMutationVariables>(EditOrderReturnTrackingInfoDocument),
    ...options
  }
    )};

export const EditUserLanguageDocument = `
    mutation editUserLanguage($input: CurrentUser_EditLanguage_Input!) {
  currentUser_editLanguage(input: $input)
}
    `;

export const useEditUserLanguageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditUserLanguageMutation, TError, EditUserLanguageMutationVariables, TContext>) => {
    
    return useMutation<EditUserLanguageMutation, TError, EditUserLanguageMutationVariables, TContext>(
      {
    mutationKey: ['editUserLanguage'],
    mutationFn: useFetchData<EditUserLanguageMutation, EditUserLanguageMutationVariables>(EditUserLanguageDocument),
    ...options
  }
    )};

export const EditUserNameDocument = `
    mutation editUserName($input: CurrentUser_EditName_Input!) {
  currentUser_editName(input: $input)
}
    `;

export const useEditUserNameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditUserNameMutation, TError, EditUserNameMutationVariables, TContext>) => {
    
    return useMutation<EditUserNameMutation, TError, EditUserNameMutationVariables, TContext>(
      {
    mutationKey: ['editUserName'],
    mutationFn: useFetchData<EditUserNameMutation, EditUserNameMutationVariables>(EditUserNameDocument),
    ...options
  }
    )};

export const EditUserPictureDocument = `
    mutation editUserPicture($input: CurrentUser_EditPicture_Input!) {
  currentUser_editPicture(input: $input)
}
    `;

export const useEditUserPictureMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditUserPictureMutation, TError, EditUserPictureMutationVariables, TContext>) => {
    
    return useMutation<EditUserPictureMutation, TError, EditUserPictureMutationVariables, TContext>(
      {
    mutationKey: ['editUserPicture'],
    mutationFn: useFetchData<EditUserPictureMutation, EditUserPictureMutationVariables>(EditUserPictureDocument),
    ...options
  }
    )};

export const EditAppContactReferralCodeDocument = `
    mutation editAppContactReferralCode($input: EditSupportActorAppContactReferralCodeInput!) {
  editSupportActorAppContactReferralCode(input: $input)
}
    `;

export const useEditAppContactReferralCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditAppContactReferralCodeMutation, TError, EditAppContactReferralCodeMutationVariables, TContext>) => {
    
    return useMutation<EditAppContactReferralCodeMutation, TError, EditAppContactReferralCodeMutationVariables, TContext>(
      {
    mutationKey: ['editAppContactReferralCode'],
    mutationFn: useFetchData<EditAppContactReferralCodeMutation, EditAppContactReferralCodeMutationVariables>(EditAppContactReferralCodeDocument),
    ...options
  }
    )};

export const FlagContactAsFrauderDocument = `
    mutation flagContactAsFrauder($input: Support_ActorAppContact_FlagAsFrauder_Input!) {
  support_actorAppContact_flagAsFrauder(input: $input) {
    id
  }
}
    `;

export const useFlagContactAsFrauderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FlagContactAsFrauderMutation, TError, FlagContactAsFrauderMutationVariables, TContext>) => {
    
    return useMutation<FlagContactAsFrauderMutation, TError, FlagContactAsFrauderMutationVariables, TContext>(
      {
    mutationKey: ['flagContactAsFrauder'],
    mutationFn: useFetchData<FlagContactAsFrauderMutation, FlagContactAsFrauderMutationVariables>(FlagContactAsFrauderDocument),
    ...options
  }
    )};

export const FlagContactAsInfluencerDocument = `
    mutation flagContactAsInfluencer($input: Support_ActorAppContact_FlagAsInfluencer_Input!) {
  support_actorAppContact_flagAsInfluencer(input: $input) {
    id
  }
}
    `;

export const useFlagContactAsInfluencerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FlagContactAsInfluencerMutation, TError, FlagContactAsInfluencerMutationVariables, TContext>) => {
    
    return useMutation<FlagContactAsInfluencerMutation, TError, FlagContactAsInfluencerMutationVariables, TContext>(
      {
    mutationKey: ['flagContactAsInfluencer'],
    mutationFn: useFetchData<FlagContactAsInfluencerMutation, FlagContactAsInfluencerMutationVariables>(FlagContactAsInfluencerDocument),
    ...options
  }
    )};

export const GenerateOrderReturnLabelUploadUrlDocument = `
    mutation generateOrderReturnLabelUploadUrl($input: Order_Return_GenerateLabelUploadUrl_Input!) {
  order_return_generateLabelUploadUrl(input: $input) {
    expiresAt
    key
    url
  }
}
    `;

export const useGenerateOrderReturnLabelUploadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateOrderReturnLabelUploadUrlMutation, TError, GenerateOrderReturnLabelUploadUrlMutationVariables, TContext>) => {
    
    return useMutation<GenerateOrderReturnLabelUploadUrlMutation, TError, GenerateOrderReturnLabelUploadUrlMutationVariables, TContext>(
      {
    mutationKey: ['generateOrderReturnLabelUploadUrl'],
    mutationFn: useFetchData<GenerateOrderReturnLabelUploadUrlMutation, GenerateOrderReturnLabelUploadUrlMutationVariables>(GenerateOrderReturnLabelUploadUrlDocument),
    ...options
  }
    )};

export const GeneratePictureUploadUrlDocument = `
    mutation generatePictureUploadUrl($input: UploadInput!) {
  currentUser_generatePictureUploadUrl(input: $input) {
    expiresAt
    key
    url
  }
}
    `;

export const useGeneratePictureUploadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GeneratePictureUploadUrlMutation, TError, GeneratePictureUploadUrlMutationVariables, TContext>) => {
    
    return useMutation<GeneratePictureUploadUrlMutation, TError, GeneratePictureUploadUrlMutationVariables, TContext>(
      {
    mutationKey: ['generatePictureUploadUrl'],
    mutationFn: useFetchData<GeneratePictureUploadUrlMutation, GeneratePictureUploadUrlMutationVariables>(GeneratePictureUploadUrlDocument),
    ...options
  }
    )};

export const GenerateSupportAttachmentUploadUrlDocument = `
    mutation generateSupportAttachmentUploadUrl($upload: SupportAttachmentUploadUrlInput!) {
  generateSupportAttachmentUploadUrl(upload: $upload) {
    expiresAt
    key
    url
  }
}
    `;

export const useGenerateSupportAttachmentUploadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateSupportAttachmentUploadUrlMutation, TError, GenerateSupportAttachmentUploadUrlMutationVariables, TContext>) => {
    
    return useMutation<GenerateSupportAttachmentUploadUrlMutation, TError, GenerateSupportAttachmentUploadUrlMutationVariables, TContext>(
      {
    mutationKey: ['generateSupportAttachmentUploadUrl'],
    mutationFn: useFetchData<GenerateSupportAttachmentUploadUrlMutation, GenerateSupportAttachmentUploadUrlMutationVariables>(GenerateSupportAttachmentUploadUrlDocument),
    ...options
  }
    )};

export const LockOrderReturnValidationDocument = `
    mutation lockOrderReturnValidation($input: Order_Return_LockValidation_Input!) {
  order_return_lockValidation(input: $input)
}
    `;

export const useLockOrderReturnValidationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LockOrderReturnValidationMutation, TError, LockOrderReturnValidationMutationVariables, TContext>) => {
    
    return useMutation<LockOrderReturnValidationMutation, TError, LockOrderReturnValidationMutationVariables, TContext>(
      {
    mutationKey: ['lockOrderReturnValidation'],
    mutationFn: useFetchData<LockOrderReturnValidationMutation, LockOrderReturnValidationMutationVariables>(LockOrderReturnValidationDocument),
    ...options
  }
    )};

export const MakeReviewInitialRequestAiClassificationDocument = `
    mutation makeReviewInitialRequestAiClassification($input: SupportTicketInitialRequestReviewFlowInput!) {
  supportTicket_initialRequest_reviewFlow(input: $input) {
    reviewedFlow
  }
}
    `;

export const useMakeReviewInitialRequestAiClassificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MakeReviewInitialRequestAiClassificationMutation, TError, MakeReviewInitialRequestAiClassificationMutationVariables, TContext>) => {
    
    return useMutation<MakeReviewInitialRequestAiClassificationMutation, TError, MakeReviewInitialRequestAiClassificationMutationVariables, TContext>(
      {
    mutationKey: ['makeReviewInitialRequestAiClassification'],
    mutationFn: useFetchData<MakeReviewInitialRequestAiClassificationMutation, MakeReviewInitialRequestAiClassificationMutationVariables>(MakeReviewInitialRequestAiClassificationDocument),
    ...options
  }
    )};

export const MarkAllNotificationsAsReadDocument = `
    mutation markAllNotificationsAsRead {
  markAllSupportNotificationsAsRead
}
    `;

export const useMarkAllNotificationsAsReadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkAllNotificationsAsReadMutation, TError, MarkAllNotificationsAsReadMutationVariables, TContext>) => {
    
    return useMutation<MarkAllNotificationsAsReadMutation, TError, MarkAllNotificationsAsReadMutationVariables, TContext>(
      {
    mutationKey: ['markAllNotificationsAsRead'],
    mutationFn: useFetchData<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument),
    ...options
  }
    )};

export const MarkNotificationAsReadDocument = `
    mutation markNotificationAsRead($notificationId: ID!) {
  markSupportNotificationAsRead(notificationId: $notificationId) {
    ... on SupportNotificationMention {
      id
    }
    ... on SupportNotificationReaction {
      id
    }
  }
}
    `;

export const useMarkNotificationAsReadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkNotificationAsReadMutation, TError, MarkNotificationAsReadMutationVariables, TContext>) => {
    
    return useMutation<MarkNotificationAsReadMutation, TError, MarkNotificationAsReadMutationVariables, TContext>(
      {
    mutationKey: ['markNotificationAsRead'],
    mutationFn: useFetchData<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument),
    ...options
  }
    )};

export const MarkOrderParcelsAsDeliveredDocument = `
    mutation markOrderParcelsAsDelivered($input: Order_Parcels_MarkAsDelivered_Input!) {
  order_parcels_markAsDelivered(input: $input)
}
    `;

export const useMarkOrderParcelsAsDeliveredMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkOrderParcelsAsDeliveredMutation, TError, MarkOrderParcelsAsDeliveredMutationVariables, TContext>) => {
    
    return useMutation<MarkOrderParcelsAsDeliveredMutation, TError, MarkOrderParcelsAsDeliveredMutationVariables, TContext>(
      {
    mutationKey: ['markOrderParcelsAsDelivered'],
    mutationFn: useFetchData<MarkOrderParcelsAsDeliveredMutation, MarkOrderParcelsAsDeliveredMutationVariables>(MarkOrderParcelsAsDeliveredDocument),
    ...options
  }
    )};

export const OpenOrderClaimForDeliveredButDamagedDocument = `
    mutation openOrderClaimForDeliveredButDamaged($input: Order_Claim_OpenForDeliveredButDamaged_Input!) {
  order_claim_openForDeliveredButDamaged(input: $input)
}
    `;

export const useOpenOrderClaimForDeliveredButDamagedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OpenOrderClaimForDeliveredButDamagedMutation, TError, OpenOrderClaimForDeliveredButDamagedMutationVariables, TContext>) => {
    
    return useMutation<OpenOrderClaimForDeliveredButDamagedMutation, TError, OpenOrderClaimForDeliveredButDamagedMutationVariables, TContext>(
      {
    mutationKey: ['openOrderClaimForDeliveredButDamaged'],
    mutationFn: useFetchData<OpenOrderClaimForDeliveredButDamagedMutation, OpenOrderClaimForDeliveredButDamagedMutationVariables>(OpenOrderClaimForDeliveredButDamagedDocument),
    ...options
  }
    )};

export const OpenOrderClaimForDeliveredButIncompleteDocument = `
    mutation openOrderClaimForDeliveredButIncomplete($input: Order_Claim_OpenForDeliveredButIncomplete_Input!) {
  order_claim_openForDeliveredButIncomplete(input: $input)
}
    `;

export const useOpenOrderClaimForDeliveredButIncompleteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OpenOrderClaimForDeliveredButIncompleteMutation, TError, OpenOrderClaimForDeliveredButIncompleteMutationVariables, TContext>) => {
    
    return useMutation<OpenOrderClaimForDeliveredButIncompleteMutation, TError, OpenOrderClaimForDeliveredButIncompleteMutationVariables, TContext>(
      {
    mutationKey: ['openOrderClaimForDeliveredButIncomplete'],
    mutationFn: useFetchData<OpenOrderClaimForDeliveredButIncompleteMutation, OpenOrderClaimForDeliveredButIncompleteMutationVariables>(OpenOrderClaimForDeliveredButIncompleteDocument),
    ...options
  }
    )};

export const OpenOrderClaimForDeliveredButWrongDocument = `
    mutation openOrderClaimForDeliveredButWrong($input: Order_Claim_OpenForDeliveredButWrong_Input!) {
  order_claim_openForDeliveredButWrong(input: $input)
}
    `;

export const useOpenOrderClaimForDeliveredButWrongMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OpenOrderClaimForDeliveredButWrongMutation, TError, OpenOrderClaimForDeliveredButWrongMutationVariables, TContext>) => {
    
    return useMutation<OpenOrderClaimForDeliveredButWrongMutation, TError, OpenOrderClaimForDeliveredButWrongMutationVariables, TContext>(
      {
    mutationKey: ['openOrderClaimForDeliveredButWrong'],
    mutationFn: useFetchData<OpenOrderClaimForDeliveredButWrongMutation, OpenOrderClaimForDeliveredButWrongMutationVariables>(OpenOrderClaimForDeliveredButWrongDocument),
    ...options
  }
    )};

export const OpenOrderClaimForNotDeliveredAndReturnedToSenderDocument = `
    mutation openOrderClaimForNotDeliveredAndReturnedToSender($input: Order_Claim_OpenForNotDeliveredAndReturnedToSender_Input!) {
  order_claim_openForNotDeliveredAndReturnedToSender(input: $input)
}
    `;

export const useOpenOrderClaimForNotDeliveredAndReturnedToSenderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OpenOrderClaimForNotDeliveredAndReturnedToSenderMutation, TError, OpenOrderClaimForNotDeliveredAndReturnedToSenderMutationVariables, TContext>) => {
    
    return useMutation<OpenOrderClaimForNotDeliveredAndReturnedToSenderMutation, TError, OpenOrderClaimForNotDeliveredAndReturnedToSenderMutationVariables, TContext>(
      {
    mutationKey: ['openOrderClaimForNotDeliveredAndReturnedToSender'],
    mutationFn: useFetchData<OpenOrderClaimForNotDeliveredAndReturnedToSenderMutation, OpenOrderClaimForNotDeliveredAndReturnedToSenderMutationVariables>(OpenOrderClaimForNotDeliveredAndReturnedToSenderDocument),
    ...options
  }
    )};

export const OpenOrderClaimForNotDeliveredAndTrackingBlockedDocument = `
    mutation openOrderClaimForNotDeliveredAndTrackingBlocked($input: Order_Claim_OpenForNotDeliveredAndTrackingBlocked_Input!) {
  order_claim_openForNotDeliveredAndTrackingBlocked(input: $input)
}
    `;

export const useOpenOrderClaimForNotDeliveredAndTrackingBlockedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OpenOrderClaimForNotDeliveredAndTrackingBlockedMutation, TError, OpenOrderClaimForNotDeliveredAndTrackingBlockedMutationVariables, TContext>) => {
    
    return useMutation<OpenOrderClaimForNotDeliveredAndTrackingBlockedMutation, TError, OpenOrderClaimForNotDeliveredAndTrackingBlockedMutationVariables, TContext>(
      {
    mutationKey: ['openOrderClaimForNotDeliveredAndTrackingBlocked'],
    mutationFn: useFetchData<OpenOrderClaimForNotDeliveredAndTrackingBlockedMutation, OpenOrderClaimForNotDeliveredAndTrackingBlockedMutationVariables>(OpenOrderClaimForNotDeliveredAndTrackingBlockedDocument),
    ...options
  }
    )};

export const OpenOrderClaimForNotDeliveredAndTrackingDeliveredDocument = `
    mutation openOrderClaimForNotDeliveredAndTrackingDelivered($input: Order_Claim_OpenForNotDeliveredAndTrackingDelivered_Input!) {
  order_claim_openForNotDeliveredAndTrackingDelivered(input: $input)
}
    `;

export const useOpenOrderClaimForNotDeliveredAndTrackingDeliveredMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OpenOrderClaimForNotDeliveredAndTrackingDeliveredMutation, TError, OpenOrderClaimForNotDeliveredAndTrackingDeliveredMutationVariables, TContext>) => {
    
    return useMutation<OpenOrderClaimForNotDeliveredAndTrackingDeliveredMutation, TError, OpenOrderClaimForNotDeliveredAndTrackingDeliveredMutationVariables, TContext>(
      {
    mutationKey: ['openOrderClaimForNotDeliveredAndTrackingDelivered'],
    mutationFn: useFetchData<OpenOrderClaimForNotDeliveredAndTrackingDeliveredMutation, OpenOrderClaimForNotDeliveredAndTrackingDeliveredMutationVariables>(OpenOrderClaimForNotDeliveredAndTrackingDeliveredDocument),
    ...options
  }
    )};

export const OpenOrderClaimForOtherDocument = `
    mutation openOrderClaimForOther($input: Order_Claim_OpenForOther_Input!) {
  order_claim_openForOther(input: $input)
}
    `;

export const useOpenOrderClaimForOtherMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OpenOrderClaimForOtherMutation, TError, OpenOrderClaimForOtherMutationVariables, TContext>) => {
    
    return useMutation<OpenOrderClaimForOtherMutation, TError, OpenOrderClaimForOtherMutationVariables, TContext>(
      {
    mutationKey: ['openOrderClaimForOther'],
    mutationFn: useFetchData<OpenOrderClaimForOtherMutation, OpenOrderClaimForOtherMutationVariables>(OpenOrderClaimForOtherDocument),
    ...options
  }
    )};

export const OpenOrderClaimForVoucherNotWorkingDocument = `
    mutation openOrderClaimForVoucherNotWorking($input: Order_Claim_OpenForVoucherNotWorking_Input!) {
  order_claim_openForVoucherNotWorking(input: $input)
}
    `;

export const useOpenOrderClaimForVoucherNotWorkingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OpenOrderClaimForVoucherNotWorkingMutation, TError, OpenOrderClaimForVoucherNotWorkingMutationVariables, TContext>) => {
    
    return useMutation<OpenOrderClaimForVoucherNotWorkingMutation, TError, OpenOrderClaimForVoucherNotWorkingMutationVariables, TContext>(
      {
    mutationKey: ['openOrderClaimForVoucherNotWorking'],
    mutationFn: useFetchData<OpenOrderClaimForVoucherNotWorkingMutation, OpenOrderClaimForVoucherNotWorkingMutationVariables>(OpenOrderClaimForVoucherNotWorkingDocument),
    ...options
  }
    )};

export const OrderFlowCommunicationAppUsersDocument = `
    mutation orderFlowCommunicationAppUsers($input: Support_OrderFlow_CommunicationAppUsers_Input!) {
  support_orderFlow_communicationAppUsers(input: $input)
}
    `;

export const useOrderFlowCommunicationAppUsersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OrderFlowCommunicationAppUsersMutation, TError, OrderFlowCommunicationAppUsersMutationVariables, TContext>) => {
    
    return useMutation<OrderFlowCommunicationAppUsersMutation, TError, OrderFlowCommunicationAppUsersMutationVariables, TContext>(
      {
    mutationKey: ['orderFlowCommunicationAppUsers'],
    mutationFn: useFetchData<OrderFlowCommunicationAppUsersMutation, OrderFlowCommunicationAppUsersMutationVariables>(OrderFlowCommunicationAppUsersDocument),
    ...options
  }
    )};

export const OrderFlowCreditCompensationSupplierChargedDocument = `
    mutation orderFlowCreditCompensationSupplierCharged($input: Support_OrderFlow_CreditCompensationSupplierCharged_Input!) {
  support_orderFlow_creditCompensationSupplierCharged(input: $input)
}
    `;

export const useOrderFlowCreditCompensationSupplierChargedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OrderFlowCreditCompensationSupplierChargedMutation, TError, OrderFlowCreditCompensationSupplierChargedMutationVariables, TContext>) => {
    
    return useMutation<OrderFlowCreditCompensationSupplierChargedMutation, TError, OrderFlowCreditCompensationSupplierChargedMutationVariables, TContext>(
      {
    mutationKey: ['orderFlowCreditCompensationSupplierCharged'],
    mutationFn: useFetchData<OrderFlowCreditCompensationSupplierChargedMutation, OrderFlowCreditCompensationSupplierChargedMutationVariables>(OrderFlowCreditCompensationSupplierChargedDocument),
    ...options
  }
    )};

export const OrderFlowDeliveryDelayV2Document = `
    mutation orderFlowDeliveryDelayV2($input: Support_OrderFlow_DeliveryDelayV2_Input!) {
  support_orderFlow_deliveryDelayV2(input: $input)
}
    `;

export const useOrderFlowDeliveryDelayV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OrderFlowDeliveryDelayV2Mutation, TError, OrderFlowDeliveryDelayV2MutationVariables, TContext>) => {
    
    return useMutation<OrderFlowDeliveryDelayV2Mutation, TError, OrderFlowDeliveryDelayV2MutationVariables, TContext>(
      {
    mutationKey: ['orderFlowDeliveryDelayV2'],
    mutationFn: useFetchData<OrderFlowDeliveryDelayV2Mutation, OrderFlowDeliveryDelayV2MutationVariables>(OrderFlowDeliveryDelayV2Document),
    ...options
  }
    )};

export const OrderFlowOrderCancellationDocument = `
    mutation orderFlowOrderCancellation($input: Support_OrderFlow_OrderCancellation_Input!) {
  support_orderFlow_orderCancellation(input: $input)
}
    `;

export const useOrderFlowOrderCancellationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OrderFlowOrderCancellationMutation, TError, OrderFlowOrderCancellationMutationVariables, TContext>) => {
    
    return useMutation<OrderFlowOrderCancellationMutation, TError, OrderFlowOrderCancellationMutationVariables, TContext>(
      {
    mutationKey: ['orderFlowOrderCancellation'],
    mutationFn: useFetchData<OrderFlowOrderCancellationMutation, OrderFlowOrderCancellationMutationVariables>(OrderFlowOrderCancellationDocument),
    ...options
  }
    )};

export const OrderFlowOrderOptimizationPackagingDocument = `
    mutation orderFlowOrderOptimizationPackaging($input: Support_OrderFlow_OrderOptimizationPackaging_Input!) {
  support_orderFlow_orderOptimizationPackaging(input: $input)
}
    `;

export const useOrderFlowOrderOptimizationPackagingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OrderFlowOrderOptimizationPackagingMutation, TError, OrderFlowOrderOptimizationPackagingMutationVariables, TContext>) => {
    
    return useMutation<OrderFlowOrderOptimizationPackagingMutation, TError, OrderFlowOrderOptimizationPackagingMutationVariables, TContext>(
      {
    mutationKey: ['orderFlowOrderOptimizationPackaging'],
    mutationFn: useFetchData<OrderFlowOrderOptimizationPackagingMutation, OrderFlowOrderOptimizationPackagingMutationVariables>(OrderFlowOrderOptimizationPackagingDocument),
    ...options
  }
    )};

export const OrderFlowOtherDocument = `
    mutation orderFlowOther($input: Support_OrderFlow_Other_Input!) {
  support_orderFlow_other(input: $input)
}
    `;

export const useOrderFlowOtherMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OrderFlowOtherMutation, TError, OrderFlowOtherMutationVariables, TContext>) => {
    
    return useMutation<OrderFlowOtherMutation, TError, OrderFlowOtherMutationVariables, TContext>(
      {
    mutationKey: ['orderFlowOther'],
    mutationFn: useFetchData<OrderFlowOtherMutation, OrderFlowOtherMutationVariables>(OrderFlowOtherDocument),
    ...options
  }
    )};

export const OrderFlowProductOutOfStockDocument = `
    mutation orderFlowProductOutOfStock($input: Support_OrderFlow_ProductOutOfStock_Input!) {
  support_orderFlow_productOutOfStock(input: $input)
}
    `;

export const useOrderFlowProductOutOfStockMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OrderFlowProductOutOfStockMutation, TError, OrderFlowProductOutOfStockMutationVariables, TContext>) => {
    
    return useMutation<OrderFlowProductOutOfStockMutation, TError, OrderFlowProductOutOfStockMutationVariables, TContext>(
      {
    mutationKey: ['orderFlowProductOutOfStock'],
    mutationFn: useFetchData<OrderFlowProductOutOfStockMutation, OrderFlowProductOutOfStockMutationVariables>(OrderFlowProductOutOfStockDocument),
    ...options
  }
    )};

export const OrderFlowProductOutOfStockShopifyDocument = `
    mutation orderFlowProductOutOfStockShopify($input: Support_OrderFlow_ProductOutOfStockShopify_Input!) {
  support_orderFlow_productOutOfStockShopify(input: $input)
}
    `;

export const useOrderFlowProductOutOfStockShopifyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OrderFlowProductOutOfStockShopifyMutation, TError, OrderFlowProductOutOfStockShopifyMutationVariables, TContext>) => {
    
    return useMutation<OrderFlowProductOutOfStockShopifyMutation, TError, OrderFlowProductOutOfStockShopifyMutationVariables, TContext>(
      {
    mutationKey: ['orderFlowProductOutOfStockShopify'],
    mutationFn: useFetchData<OrderFlowProductOutOfStockShopifyMutation, OrderFlowProductOutOfStockShopifyMutationVariables>(OrderFlowProductOutOfStockShopifyDocument),
    ...options
  }
    )};

export const OrderFlowProductWrongDescriptionDocument = `
    mutation orderFlowProductWrongDescription($input: Support_OrderFlow_ProductWrongDescription_Input!) {
  support_orderFlow_productWrongDescription(input: $input)
}
    `;

export const useOrderFlowProductWrongDescriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OrderFlowProductWrongDescriptionMutation, TError, OrderFlowProductWrongDescriptionMutationVariables, TContext>) => {
    
    return useMutation<OrderFlowProductWrongDescriptionMutation, TError, OrderFlowProductWrongDescriptionMutationVariables, TContext>(
      {
    mutationKey: ['orderFlowProductWrongDescription'],
    mutationFn: useFetchData<OrderFlowProductWrongDescriptionMutation, OrderFlowProductWrongDescriptionMutationVariables>(OrderFlowProductWrongDescriptionDocument),
    ...options
  }
    )};

export const RefundOrderItemsDocument = `
    mutation refundOrderItems($input: Order_Items_Refund_Input!) {
  order_items_refund(input: $input)
}
    `;

export const useRefundOrderItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RefundOrderItemsMutation, TError, RefundOrderItemsMutationVariables, TContext>) => {
    
    return useMutation<RefundOrderItemsMutation, TError, RefundOrderItemsMutationVariables, TContext>(
      {
    mutationKey: ['refundOrderItems'],
    mutationFn: useFetchData<RefundOrderItemsMutation, RefundOrderItemsMutationVariables>(RefundOrderItemsDocument),
    ...options
  }
    )};

export const RefundOrderItemsDryRunDocument = `
    mutation refundOrderItemsDryRun($input: Order_Items_Refund_Input!) {
  order_items_refund_dryRun(input: $input) {
    cashAmountInCents
    creditAmountInCents
  }
}
    `;

export const useRefundOrderItemsDryRunMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RefundOrderItemsDryRunMutation, TError, RefundOrderItemsDryRunMutationVariables, TContext>) => {
    
    return useMutation<RefundOrderItemsDryRunMutation, TError, RefundOrderItemsDryRunMutationVariables, TContext>(
      {
    mutationKey: ['refundOrderItemsDryRun'],
    mutationFn: useFetchData<RefundOrderItemsDryRunMutation, RefundOrderItemsDryRunMutationVariables>(RefundOrderItemsDryRunDocument),
    ...options
  }
    )};

export const RefundOrderShippingFeesDocument = `
    mutation refundOrderShippingFees($input: Order_ShippingFees_Refund_Input!) {
  order_shippingFees_refund(input: $input)
}
    `;

export const useRefundOrderShippingFeesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RefundOrderShippingFeesMutation, TError, RefundOrderShippingFeesMutationVariables, TContext>) => {
    
    return useMutation<RefundOrderShippingFeesMutation, TError, RefundOrderShippingFeesMutationVariables, TContext>(
      {
    mutationKey: ['refundOrderShippingFees'],
    mutationFn: useFetchData<RefundOrderShippingFeesMutation, RefundOrderShippingFeesMutationVariables>(RefundOrderShippingFeesDocument),
    ...options
  }
    )};

export const RefundOrderShippingFeesDryRunDocument = `
    mutation refundOrderShippingFeesDryRun($input: Order_ShippingFees_Refund_Input!) {
  order_shippingFees_refund_dryRun(input: $input) {
    cashAmountInCents
    creditAmountInCents
  }
}
    `;

export const useRefundOrderShippingFeesDryRunMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RefundOrderShippingFeesDryRunMutation, TError, RefundOrderShippingFeesDryRunMutationVariables, TContext>) => {
    
    return useMutation<RefundOrderShippingFeesDryRunMutation, TError, RefundOrderShippingFeesDryRunMutationVariables, TContext>(
      {
    mutationKey: ['refundOrderShippingFeesDryRun'],
    mutationFn: useFetchData<RefundOrderShippingFeesDryRunMutation, RefundOrderShippingFeesDryRunMutationVariables>(RefundOrderShippingFeesDryRunDocument),
    ...options
  }
    )};

export const RemoveAppContactCreditDocument = `
    mutation removeAppContactCredit($input: RemoveSupportActorAppContactCreditInput!) {
  removeSupportActorAppContactCredit(input: $input)
}
    `;

export const useRemoveAppContactCreditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveAppContactCreditMutation, TError, RemoveAppContactCreditMutationVariables, TContext>) => {
    
    return useMutation<RemoveAppContactCreditMutation, TError, RemoveAppContactCreditMutationVariables, TContext>(
      {
    mutationKey: ['removeAppContactCredit'],
    mutationFn: useFetchData<RemoveAppContactCreditMutation, RemoveAppContactCreditMutationVariables>(RemoveAppContactCreditDocument),
    ...options
  }
    )};

export const RemoveActorAppContactCreditDocument = `
    mutation removeActorAppContactCredit($input: RemoveSupportActorAppContactCreditInput!) {
  removeSupportActorAppContactCredit(input: $input)
}
    `;

export const useRemoveActorAppContactCreditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveActorAppContactCreditMutation, TError, RemoveActorAppContactCreditMutationVariables, TContext>) => {
    
    return useMutation<RemoveActorAppContactCreditMutation, TError, RemoveActorAppContactCreditMutationVariables, TContext>(
      {
    mutationKey: ['removeActorAppContactCredit'],
    mutationFn: useFetchData<RemoveActorAppContactCreditMutation, RemoveActorAppContactCreditMutationVariables>(RemoveActorAppContactCreditDocument),
    ...options
  }
    )};

export const RemoveSnippetDocument = `
    mutation removeSnippet($snippetId: ID!) {
  removeSupportSnippet(snippetId: $snippetId) {
    id
  }
}
    `;

export const useRemoveSnippetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSnippetMutation, TError, RemoveSnippetMutationVariables, TContext>) => {
    
    return useMutation<RemoveSnippetMutation, TError, RemoveSnippetMutationVariables, TContext>(
      {
    mutationKey: ['removeSnippet'],
    mutationFn: useFetchData<RemoveSnippetMutation, RemoveSnippetMutationVariables>(RemoveSnippetDocument),
    ...options
  }
    )};

export const RemoveSnippetTagDocument = `
    mutation removeSnippetTag($snippetTagId: ID!) {
  removeSupportSnippetTag(snippetTagId: $snippetTagId) {
    id
  }
}
    `;

export const useRemoveSnippetTagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSnippetTagMutation, TError, RemoveSnippetTagMutationVariables, TContext>) => {
    
    return useMutation<RemoveSnippetTagMutation, TError, RemoveSnippetTagMutationVariables, TContext>(
      {
    mutationKey: ['removeSnippetTag'],
    mutationFn: useFetchData<RemoveSnippetTagMutation, RemoveSnippetTagMutationVariables>(RemoveSnippetTagDocument),
    ...options
  }
    )};

export const RemoveTicketActivityReactionDocument = `
    mutation removeTicketActivityReaction($activityId: ID!, $type: SupportTicketActivityReactionType!) {
  removeSupportTicketActivityReaction(activityId: $activityId, type: $type)
}
    `;

export const useRemoveTicketActivityReactionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTicketActivityReactionMutation, TError, RemoveTicketActivityReactionMutationVariables, TContext>) => {
    
    return useMutation<RemoveTicketActivityReactionMutation, TError, RemoveTicketActivityReactionMutationVariables, TContext>(
      {
    mutationKey: ['removeTicketActivityReaction'],
    mutationFn: useFetchData<RemoveTicketActivityReactionMutation, RemoveTicketActivityReactionMutationVariables>(RemoveTicketActivityReactionDocument),
    ...options
  }
    )};

export const RemoveViewFromFavoriteDocument = `
    mutation removeViewFromFavorite($viewId: ID!) {
  removeSupportViewFavorite(viewId: $viewId)
}
    `;

export const useRemoveViewFromFavoriteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveViewFromFavoriteMutation, TError, RemoveViewFromFavoriteMutationVariables, TContext>) => {
    
    return useMutation<RemoveViewFromFavoriteMutation, TError, RemoveViewFromFavoriteMutationVariables, TContext>(
      {
    mutationKey: ['removeViewFromFavorite'],
    mutationFn: useFetchData<RemoveViewFromFavoriteMutation, RemoveViewFromFavoriteMutationVariables>(RemoveViewFromFavoriteDocument),
    ...options
  }
    )};

export const ScheduleActionAddMessageDocument = `
    mutation scheduleActionAddMessage($input: SupportTicketScheduleActionAddMessageInput!, $scheduleAt: DateTime!) {
  supportTicket_scheduleAction_addMessage(input: $input, scheduleAt: $scheduleAt) {
    id
  }
}
    `;

export const useScheduleActionAddMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ScheduleActionAddMessageMutation, TError, ScheduleActionAddMessageMutationVariables, TContext>) => {
    
    return useMutation<ScheduleActionAddMessageMutation, TError, ScheduleActionAddMessageMutationVariables, TContext>(
      {
    mutationKey: ['scheduleActionAddMessage'],
    mutationFn: useFetchData<ScheduleActionAddMessageMutation, ScheduleActionAddMessageMutationVariables>(ScheduleActionAddMessageDocument),
    ...options
  }
    )};

export const ScheduleActionAddEmailDocument = `
    mutation scheduleActionAddEmail($input: SupportTicketScheduleActionAddEmailInput!, $scheduleAt: DateTime!) {
  supportTicket_scheduleAction_addEmail(input: $input, scheduleAt: $scheduleAt) {
    id
  }
}
    `;

export const useScheduleActionAddEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ScheduleActionAddEmailMutation, TError, ScheduleActionAddEmailMutationVariables, TContext>) => {
    
    return useMutation<ScheduleActionAddEmailMutation, TError, ScheduleActionAddEmailMutationVariables, TContext>(
      {
    mutationKey: ['scheduleActionAddEmail'],
    mutationFn: useFetchData<ScheduleActionAddEmailMutation, ScheduleActionAddEmailMutationVariables>(ScheduleActionAddEmailDocument),
    ...options
  }
    )};

export const ScheduleActionMarkAsCancelledDocument = `
    mutation scheduleActionMarkAsCancelled($input: SupportTicketScheduleActionMarkAsCanceledInput!) {
  supportTicket_scheduleAction_markAsCanceled(input: $input) {
    id
  }
}
    `;

export const useScheduleActionMarkAsCancelledMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ScheduleActionMarkAsCancelledMutation, TError, ScheduleActionMarkAsCancelledMutationVariables, TContext>) => {
    
    return useMutation<ScheduleActionMarkAsCancelledMutation, TError, ScheduleActionMarkAsCancelledMutationVariables, TContext>(
      {
    mutationKey: ['scheduleActionMarkAsCancelled'],
    mutationFn: useFetchData<ScheduleActionMarkAsCancelledMutation, ScheduleActionMarkAsCancelledMutationVariables>(ScheduleActionMarkAsCancelledDocument),
    ...options
  }
    )};

export const ScheduleActionMarkAsPausedDocument = `
    mutation scheduleActionMarkAsPaused($input: SupportTicketScheduleActionMarkAsPausedInput!) {
  supportTicket_scheduleAction_markAsPaused(input: $input) {
    id
  }
}
    `;

export const useScheduleActionMarkAsPausedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ScheduleActionMarkAsPausedMutation, TError, ScheduleActionMarkAsPausedMutationVariables, TContext>) => {
    
    return useMutation<ScheduleActionMarkAsPausedMutation, TError, ScheduleActionMarkAsPausedMutationVariables, TContext>(
      {
    mutationKey: ['scheduleActionMarkAsPaused'],
    mutationFn: useFetchData<ScheduleActionMarkAsPausedMutation, ScheduleActionMarkAsPausedMutationVariables>(ScheduleActionMarkAsPausedDocument),
    ...options
  }
    )};

export const ScheduleActionRescheduleDocument = `
    mutation scheduleActionReschedule($input: SupportTicketScheduleActionRescheduleInput!) {
  supportTicket_scheduleAction_reschedule(input: $input) {
    id
  }
}
    `;

export const useScheduleActionRescheduleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ScheduleActionRescheduleMutation, TError, ScheduleActionRescheduleMutationVariables, TContext>) => {
    
    return useMutation<ScheduleActionRescheduleMutation, TError, ScheduleActionRescheduleMutationVariables, TContext>(
      {
    mutationKey: ['scheduleActionReschedule'],
    mutationFn: useFetchData<ScheduleActionRescheduleMutation, ScheduleActionRescheduleMutationVariables>(ScheduleActionRescheduleDocument),
    ...options
  }
    )};

export const ScheduleActionSetSubStatusDocument = `
    mutation scheduleActionSetSubStatus($input: SupportTicketScheduleActionSetSubStatusInput!, $scheduleAt: DateTime!) {
  supportTicket_scheduleAction_setSubStatus(
    input: $input
    scheduleAt: $scheduleAt
  ) {
    id
  }
}
    `;

export const useScheduleActionSetSubStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ScheduleActionSetSubStatusMutation, TError, ScheduleActionSetSubStatusMutationVariables, TContext>) => {
    
    return useMutation<ScheduleActionSetSubStatusMutation, TError, ScheduleActionSetSubStatusMutationVariables, TContext>(
      {
    mutationKey: ['scheduleActionSetSubStatus'],
    mutationFn: useFetchData<ScheduleActionSetSubStatusMutation, ScheduleActionSetSubStatusMutationVariables>(ScheduleActionSetSubStatusDocument),
    ...options
  }
    )};

export const ScheduleActionUpdateEmailDocument = `
    mutation scheduleActionUpdateEmail($input: SupportTicketScheduleActionUpdateEmailInput!) {
  supportTicket_scheduleAction_updateEmail(input: $input) {
    id
  }
}
    `;

export const useScheduleActionUpdateEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ScheduleActionUpdateEmailMutation, TError, ScheduleActionUpdateEmailMutationVariables, TContext>) => {
    
    return useMutation<ScheduleActionUpdateEmailMutation, TError, ScheduleActionUpdateEmailMutationVariables, TContext>(
      {
    mutationKey: ['scheduleActionUpdateEmail'],
    mutationFn: useFetchData<ScheduleActionUpdateEmailMutation, ScheduleActionUpdateEmailMutationVariables>(ScheduleActionUpdateEmailDocument),
    ...options
  }
    )};

export const ScheduleActionUpdateMessageDocument = `
    mutation scheduleActionUpdateMessage($input: SupportTicketScheduleActionUpdateMessageInput!) {
  supportTicket_scheduleAction_updateMessage(input: $input) {
    id
  }
}
    `;

export const useScheduleActionUpdateMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ScheduleActionUpdateMessageMutation, TError, ScheduleActionUpdateMessageMutationVariables, TContext>) => {
    
    return useMutation<ScheduleActionUpdateMessageMutation, TError, ScheduleActionUpdateMessageMutationVariables, TContext>(
      {
    mutationKey: ['scheduleActionUpdateMessage'],
    mutationFn: useFetchData<ScheduleActionUpdateMessageMutation, ScheduleActionUpdateMessageMutationVariables>(ScheduleActionUpdateMessageDocument),
    ...options
  }
    )};

export const ScheduleActionUpdateSubStatusDocument = `
    mutation scheduleActionUpdateSubStatus($input: SupportTicketScheduleActionUpdateSubStatusInput!) {
  supportTicket_scheduleAction_updateSubStatus(input: $input) {
    id
  }
}
    `;

export const useScheduleActionUpdateSubStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ScheduleActionUpdateSubStatusMutation, TError, ScheduleActionUpdateSubStatusMutationVariables, TContext>) => {
    
    return useMutation<ScheduleActionUpdateSubStatusMutation, TError, ScheduleActionUpdateSubStatusMutationVariables, TContext>(
      {
    mutationKey: ['scheduleActionUpdateSubStatus'],
    mutationFn: useFetchData<ScheduleActionUpdateSubStatusMutation, ScheduleActionUpdateSubStatusMutationVariables>(ScheduleActionUpdateSubStatusDocument),
    ...options
  }
    )};

export const SetAssignedToDocument = `
    mutation setAssignedTo($ticketId: ID!, $actorUserId: ID) {
  setSupportTicketAssignee(ticketId: $ticketId, actorUserId: $actorUserId) {
    id
  }
}
    `;

export const useSetAssignedToMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetAssignedToMutation, TError, SetAssignedToMutationVariables, TContext>) => {
    
    return useMutation<SetAssignedToMutation, TError, SetAssignedToMutationVariables, TContext>(
      {
    mutationKey: ['setAssignedTo'],
    mutationFn: useFetchData<SetAssignedToMutation, SetAssignedToMutationVariables>(SetAssignedToDocument),
    ...options
  }
    )};

export const SetTicketTitleDocument = `
    mutation setTicketTitle($ticketId: ID!, $title: String!) {
  setSupportTicketTitle(ticketId: $ticketId, title: $title) {
    id
  }
}
    `;

export const useSetTicketTitleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetTicketTitleMutation, TError, SetTicketTitleMutationVariables, TContext>) => {
    
    return useMutation<SetTicketTitleMutation, TError, SetTicketTitleMutationVariables, TContext>(
      {
    mutationKey: ['setTicketTitle'],
    mutationFn: useFetchData<SetTicketTitleMutation, SetTicketTitleMutationVariables>(SetTicketTitleDocument),
    ...options
  }
    )};

export const SetSubStatusDocument = `
    mutation setSubStatus($ticketId: ID!, $subStatus: SupportTicketSubStatus!, $snoozedUntil: DateTime) {
  setSupportTicketSubStatus(
    ticketId: $ticketId
    subStatus: $subStatus
    snoozedUntil: $snoozedUntil
  ) {
    id
  }
}
    `;

export const useSetSubStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetSubStatusMutation, TError, SetSubStatusMutationVariables, TContext>) => {
    
    return useMutation<SetSubStatusMutation, TError, SetSubStatusMutationVariables, TContext>(
      {
    mutationKey: ['setSubStatus'],
    mutationFn: useFetchData<SetSubStatusMutation, SetSubStatusMutationVariables>(SetSubStatusDocument),
    ...options
  }
    )};

export const SplitOrderDocument = `
    mutation splitOrder($input: Order_Split_Input!) {
  order_split(input: $input)
}
    `;

export const useSplitOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SplitOrderMutation, TError, SplitOrderMutationVariables, TContext>) => {
    
    return useMutation<SplitOrderMutation, TError, SplitOrderMutationVariables, TContext>(
      {
    mutationKey: ['splitOrder'],
    mutationFn: useFetchData<SplitOrderMutation, SplitOrderMutationVariables>(SplitOrderDocument),
    ...options
  }
    )};

export const UnflagContactAsFrauderDocument = `
    mutation unflagContactAsFrauder($input: Support_ActorAppContact_UnflagAsFrauder_Input!) {
  support_actorAppContact_unflagAsFrauder(input: $input) {
    id
  }
}
    `;

export const useUnflagContactAsFrauderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnflagContactAsFrauderMutation, TError, UnflagContactAsFrauderMutationVariables, TContext>) => {
    
    return useMutation<UnflagContactAsFrauderMutation, TError, UnflagContactAsFrauderMutationVariables, TContext>(
      {
    mutationKey: ['unflagContactAsFrauder'],
    mutationFn: useFetchData<UnflagContactAsFrauderMutation, UnflagContactAsFrauderMutationVariables>(UnflagContactAsFrauderDocument),
    ...options
  }
    )};

export const UnflagContactAsInfluencerDocument = `
    mutation unflagContactAsInfluencer($input: Support_ActorAppContact_UnflagAsInfluencer_Input!) {
  support_actorAppContact_unflagAsInfluencer(input: $input) {
    id
  }
}
    `;

export const useUnflagContactAsInfluencerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnflagContactAsInfluencerMutation, TError, UnflagContactAsInfluencerMutationVariables, TContext>) => {
    
    return useMutation<UnflagContactAsInfluencerMutation, TError, UnflagContactAsInfluencerMutationVariables, TContext>(
      {
    mutationKey: ['unflagContactAsInfluencer'],
    mutationFn: useFetchData<UnflagContactAsInfluencerMutation, UnflagContactAsInfluencerMutationVariables>(UnflagContactAsInfluencerDocument),
    ...options
  }
    )};

export const UnlockOrderReturnValidationDocument = `
    mutation unlockOrderReturnValidation($input: Order_Return_UnlockValidation_Input!) {
  order_return_unlockValidation(input: $input)
}
    `;

export const useUnlockOrderReturnValidationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnlockOrderReturnValidationMutation, TError, UnlockOrderReturnValidationMutationVariables, TContext>) => {
    
    return useMutation<UnlockOrderReturnValidationMutation, TError, UnlockOrderReturnValidationMutationVariables, TContext>(
      {
    mutationKey: ['unlockOrderReturnValidation'],
    mutationFn: useFetchData<UnlockOrderReturnValidationMutation, UnlockOrderReturnValidationMutationVariables>(UnlockOrderReturnValidationDocument),
    ...options
  }
    )};

export const UpdateOrderDeliveryDateRangeDocument = `
    mutation updateOrderDeliveryDateRange($input: SupportTicket_Order_UpdateDeliveryDateRange_Input!) {
  supportTicket_order_updateDeliveryDateRange(input: $input) {
    id
  }
}
    `;

export const useUpdateOrderDeliveryDateRangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOrderDeliveryDateRangeMutation, TError, UpdateOrderDeliveryDateRangeMutationVariables, TContext>) => {
    
    return useMutation<UpdateOrderDeliveryDateRangeMutation, TError, UpdateOrderDeliveryDateRangeMutationVariables, TContext>(
      {
    mutationKey: ['updateOrderDeliveryDateRange'],
    mutationFn: useFetchData<UpdateOrderDeliveryDateRangeMutation, UpdateOrderDeliveryDateRangeMutationVariables>(UpdateOrderDeliveryDateRangeDocument),
    ...options
  }
    )};

export const UpdateSnippetDocument = `
    mutation updateSnippet($snippetId: ID!, $input: UpdateSupportSnippetInput!) {
  updateSupportSnippet(snippetId: $snippetId, input: $input) {
    id
  }
}
    `;

export const useUpdateSnippetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSnippetMutation, TError, UpdateSnippetMutationVariables, TContext>) => {
    
    return useMutation<UpdateSnippetMutation, TError, UpdateSnippetMutationVariables, TContext>(
      {
    mutationKey: ['updateSnippet'],
    mutationFn: useFetchData<UpdateSnippetMutation, UpdateSnippetMutationVariables>(UpdateSnippetDocument),
    ...options
  }
    )};

export const UpdateSnippetTagDocument = `
    mutation updateSnippetTag($snippetTagId: ID!, $input: UpdateSupportSnippetTagInput!) {
  updateSupportSnippetTag(snippetTagId: $snippetTagId, input: $input) {
    id
  }
}
    `;

export const useUpdateSnippetTagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSnippetTagMutation, TError, UpdateSnippetTagMutationVariables, TContext>) => {
    
    return useMutation<UpdateSnippetTagMutation, TError, UpdateSnippetTagMutationVariables, TContext>(
      {
    mutationKey: ['updateSnippetTag'],
    mutationFn: useFetchData<UpdateSnippetTagMutation, UpdateSnippetTagMutationVariables>(UpdateSnippetTagDocument),
    ...options
  }
    )};

export const UpdateViewDocument = `
    mutation updateView($viewId: ID!, $input: UpdateSupportViewInput!) {
  updateSupportView(viewId: $viewId, input: $input) {
    icon
    iconColor
    id
    title
  }
}
    `;

export const useUpdateViewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateViewMutation, TError, UpdateViewMutationVariables, TContext>) => {
    
    return useMutation<UpdateViewMutation, TError, UpdateViewMutationVariables, TContext>(
      {
    mutationKey: ['updateView'],
    mutationFn: useFetchData<UpdateViewMutation, UpdateViewMutationVariables>(UpdateViewDocument),
    ...options
  }
    )};

export const ValidateOrderReturnDocument = `
    mutation validateOrderReturn($input: Order_Return_Validate_Input!) {
  order_return_validate(input: $input)
}
    `;

export const useValidateOrderReturnMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateOrderReturnMutation, TError, ValidateOrderReturnMutationVariables, TContext>) => {
    
    return useMutation<ValidateOrderReturnMutation, TError, ValidateOrderReturnMutationVariables, TContext>(
      {
    mutationKey: ['validateOrderReturn'],
    mutationFn: useFetchData<ValidateOrderReturnMutation, ValidateOrderReturnMutationVariables>(ValidateOrderReturnDocument),
    ...options
  }
    )};

export const ActorAppContactByAppUserIdDocument = `
    query actorAppContactByAppUserId($appUserId: ID!) {
  supportActorAppContactByAppUserId(appUserId: $appUserId) {
    id
  }
}
    `;

export const useActorAppContactByAppUserIdQuery = <
      TData = ActorAppContactByAppUserIdQuery,
      TError = unknown
    >(
      variables: ActorAppContactByAppUserIdQueryVariables,
      options?: Omit<UseQueryOptions<ActorAppContactByAppUserIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ActorAppContactByAppUserIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ActorAppContactByAppUserIdQuery, TError, TData>(
      {
    queryKey: ['actorAppContactByAppUserId', variables],
    queryFn: useFetchData<ActorAppContactByAppUserIdQuery, ActorAppContactByAppUserIdQueryVariables>(ActorAppContactByAppUserIdDocument).bind(null, variables),
    ...options
  }
    )};

useActorAppContactByAppUserIdQuery.getKey = (variables: ActorAppContactByAppUserIdQueryVariables) => ['actorAppContactByAppUserId', variables];

export const useInfiniteActorAppContactByAppUserIdQuery = <
      TData = InfiniteData<ActorAppContactByAppUserIdQuery>,
      TError = unknown
    >(
      variables: ActorAppContactByAppUserIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ActorAppContactByAppUserIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ActorAppContactByAppUserIdQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ActorAppContactByAppUserIdQuery, ActorAppContactByAppUserIdQueryVariables>(ActorAppContactByAppUserIdDocument)
    return useInfiniteQuery<ActorAppContactByAppUserIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['actorAppContactByAppUserId.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteActorAppContactByAppUserIdQuery.getKey = (variables: ActorAppContactByAppUserIdQueryVariables) => ['actorAppContactByAppUserId.infinite', variables];

export const ActorAppContactsByIdsDocument = `
    query actorAppContactsByIds($ids: [ID!]!) {
  supportActorAppContactsByIds(ids: $ids) {
    __typename
    appContact {
      ...PartialAppContact
    }
    id
  }
}
    ${PartialAppContactFragmentDoc}`;

export const useActorAppContactsByIdsQuery = <
      TData = ActorAppContactsByIdsQuery,
      TError = unknown
    >(
      variables: ActorAppContactsByIdsQueryVariables,
      options?: Omit<UseQueryOptions<ActorAppContactsByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ActorAppContactsByIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ActorAppContactsByIdsQuery, TError, TData>(
      {
    queryKey: ['actorAppContactsByIds', variables],
    queryFn: useFetchData<ActorAppContactsByIdsQuery, ActorAppContactsByIdsQueryVariables>(ActorAppContactsByIdsDocument).bind(null, variables),
    ...options
  }
    )};

useActorAppContactsByIdsQuery.getKey = (variables: ActorAppContactsByIdsQueryVariables) => ['actorAppContactsByIds', variables];

export const useInfiniteActorAppContactsByIdsQuery = <
      TData = InfiniteData<ActorAppContactsByIdsQuery>,
      TError = unknown
    >(
      variables: ActorAppContactsByIdsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ActorAppContactsByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ActorAppContactsByIdsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ActorAppContactsByIdsQuery, ActorAppContactsByIdsQueryVariables>(ActorAppContactsByIdsDocument)
    return useInfiniteQuery<ActorAppContactsByIdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['actorAppContactsByIds.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteActorAppContactsByIdsQuery.getKey = (variables: ActorAppContactsByIdsQueryVariables) => ['actorAppContactsByIds.infinite', variables];

export const ContactDocument = `
    query contact($id: ID!) {
  supportActorById(id: $id) {
    __typename
    ... on SupportActorAppContact {
      id
      appContact {
        appUserId
        credits {
          balanceAmountInCents
          lines {
            amountInCents
            description
            expiresAt
            id
            isExpired
            remainingAmountInCents
            spentAmountInCents
          }
          store
          transactions {
            amountInCents
            billingId
            createdAt
            description
            id
            operator
            orderId
            refereeUserId
            type
          }
        }
        email
        firstName
        isFrauder
        isInfluencer
        language
        lastName
        latestActivityAt
        latestShippingAddress {
          city
          countryCode
          firstName
          lastName
          phoneNumber
          state
          street
          streetAdditional
          zipCode
        }
        mobile {
          app {
            isLatestVersion
            version
          }
          device {
            brand
            os
            osVersion
          }
        }
        phoneNumber
        referralCode
        referralGodfather {
          __typename
          appContact {
            firstName
            lastName
            referralCode
          }
          id
        }
        store
        timezone
      }
    }
    ... on SupportActorEmailContact {
      emailContact {
        email
        name
      }
      id
    }
  }
}
    `;

export const useContactQuery = <
      TData = ContactQuery,
      TError = unknown
    >(
      variables: ContactQueryVariables,
      options?: Omit<UseQueryOptions<ContactQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ContactQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ContactQuery, TError, TData>(
      {
    queryKey: ['contact', variables],
    queryFn: useFetchData<ContactQuery, ContactQueryVariables>(ContactDocument).bind(null, variables),
    ...options
  }
    )};

useContactQuery.getKey = (variables: ContactQueryVariables) => ['contact', variables];

export const useInfiniteContactQuery = <
      TData = InfiniteData<ContactQuery>,
      TError = unknown
    >(
      variables: ContactQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ContactQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ContactQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ContactQuery, ContactQueryVariables>(ContactDocument)
    return useInfiniteQuery<ContactQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['contact.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteContactQuery.getKey = (variables: ContactQueryVariables) => ['contact.infinite', variables];

export const ContactActivitiesDocument = `
    query contactActivities($contactId: ID!, $first: Int, $sortBy: SupportActorActivitiesSortInput, $after: String, $filters: SupportActorActivitiesFilterInput) {
  supportActorById(id: $contactId) {
    __typename
    ... on SupportActorAppContact {
      activities(sortBy: $sortBy, first: $first, after: $after, filters: $filters) {
        edges {
          node {
            __typename
            ... on SupportActorActivityCredit {
              amountInCents
              action
              actor {
                ...Agent
                ...Contact
              }
              currency
              id
              occurredAt
            }
            ... on SupportActorActivityFrauder {
              actor {
                ...Agent
                ...Contact
              }
              id
              isFrauder
              occurredAt
            }
            ... on SupportActorActivityInfluencer {
              actor {
                ...Agent
                ...Contact
              }
              id
              isInfluencer
              occurredAt
            }
            ... on SupportActorActivityNote {
              actor {
                ...Agent
                ...Contact
              }
              attachments {
                ...Attachment
              }
              content
              id
              occurredAt
            }
            ... on SupportActorActivityReferralCode {
              actor {
                ...Agent
                ...Contact
              }
              id
              newReferralCode
              occurredAt
              oldReferralCode
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}
    ${AgentFragmentDoc}
${ContactFragmentDoc}
${AttachmentFragmentDoc}`;

export const useContactActivitiesQuery = <
      TData = ContactActivitiesQuery,
      TError = unknown
    >(
      variables: ContactActivitiesQueryVariables,
      options?: Omit<UseQueryOptions<ContactActivitiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ContactActivitiesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ContactActivitiesQuery, TError, TData>(
      {
    queryKey: ['contactActivities', variables],
    queryFn: useFetchData<ContactActivitiesQuery, ContactActivitiesQueryVariables>(ContactActivitiesDocument).bind(null, variables),
    ...options
  }
    )};

useContactActivitiesQuery.getKey = (variables: ContactActivitiesQueryVariables) => ['contactActivities', variables];

export const useInfiniteContactActivitiesQuery = <
      TData = InfiniteData<ContactActivitiesQuery>,
      TError = unknown
    >(
      variables: ContactActivitiesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ContactActivitiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ContactActivitiesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ContactActivitiesQuery, ContactActivitiesQueryVariables>(ContactActivitiesDocument)
    return useInfiniteQuery<ContactActivitiesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['contactActivities.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteContactActivitiesQuery.getKey = (variables: ContactActivitiesQueryVariables) => ['contactActivities.infinite', variables];

export const ContactByIdDocument = `
    query contactById($id: ID!) {
  supportActorById(id: $id) {
    __typename
    ... on SupportActorAppContact {
      id
      appContact {
        firstName
        lastName
      }
    }
    ... on SupportActorEmailContact {
      emailContact {
        email
        name
      }
      id
    }
  }
}
    `;

export const useContactByIdQuery = <
      TData = ContactByIdQuery,
      TError = unknown
    >(
      variables: ContactByIdQueryVariables,
      options?: Omit<UseQueryOptions<ContactByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ContactByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ContactByIdQuery, TError, TData>(
      {
    queryKey: ['contactById', variables],
    queryFn: useFetchData<ContactByIdQuery, ContactByIdQueryVariables>(ContactByIdDocument).bind(null, variables),
    ...options
  }
    )};

useContactByIdQuery.getKey = (variables: ContactByIdQueryVariables) => ['contactById', variables];

export const useInfiniteContactByIdQuery = <
      TData = InfiniteData<ContactByIdQuery>,
      TError = unknown
    >(
      variables: ContactByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ContactByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ContactByIdQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ContactByIdQuery, ContactByIdQueryVariables>(ContactByIdDocument)
    return useInfiniteQuery<ContactByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['contactById.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteContactByIdQuery.getKey = (variables: ContactByIdQueryVariables) => ['contactById.infinite', variables];

export const CourierBySlugDocument = `
    query courierBySlug($input: Courier_BySlug_Input!) {
  courier_bySlug(input: $input) {
    logoUrl
    name
    slug
  }
}
    `;

export const useCourierBySlugQuery = <
      TData = CourierBySlugQuery,
      TError = unknown
    >(
      variables: CourierBySlugQueryVariables,
      options?: Omit<UseQueryOptions<CourierBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CourierBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CourierBySlugQuery, TError, TData>(
      {
    queryKey: ['courierBySlug', variables],
    queryFn: useFetchData<CourierBySlugQuery, CourierBySlugQueryVariables>(CourierBySlugDocument).bind(null, variables),
    ...options
  }
    )};

useCourierBySlugQuery.getKey = (variables: CourierBySlugQueryVariables) => ['courierBySlug', variables];

export const useInfiniteCourierBySlugQuery = <
      TData = InfiniteData<CourierBySlugQuery>,
      TError = unknown
    >(
      variables: CourierBySlugQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CourierBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CourierBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CourierBySlugQuery, CourierBySlugQueryVariables>(CourierBySlugDocument)
    return useInfiniteQuery<CourierBySlugQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['courierBySlug.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCourierBySlugQuery.getKey = (variables: CourierBySlugQueryVariables) => ['courierBySlug.infinite', variables];

export const CurrentUserDocument = `
    query currentUser {
  currentUser {
    __typename
    ... on ActorInternalUser {
      id
      internalUser {
        email
        firstName
        id
        language
        lastName
        picture
        supportRole
      }
    }
    ... on ActorSupplierUser {
      id
      supplierUser {
        email
        firstName
        id
        language
        lastName
        picture
      }
    }
  }
}
    `;

export const useCurrentUserQuery = <
      TData = CurrentUserQuery,
      TError = unknown
    >(
      variables?: CurrentUserQueryVariables,
      options?: Omit<UseQueryOptions<CurrentUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CurrentUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CurrentUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['currentUser'] : ['currentUser', variables],
    queryFn: useFetchData<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument).bind(null, variables),
    ...options
  }
    )};

useCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) => variables === undefined ? ['currentUser'] : ['currentUser', variables];

export const useInfiniteCurrentUserQuery = <
      TData = InfiniteData<CurrentUserQuery>,
      TError = unknown
    >(
      variables: CurrentUserQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CurrentUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CurrentUserQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument)
    return useInfiniteQuery<CurrentUserQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['currentUser.infinite'] : ['currentUser.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) => variables === undefined ? ['currentUser.infinite'] : ['currentUser.infinite', variables];

export const CurrentUserFavoriteViewsDocument = `
    query currentUserFavoriteViews {
  currentUserFavoriteSupportViews {
    displayedProperties {
      assignedTo
      channel
      contact
      hasPendingScheduleActions
      isDraft
      orderFlow
      previewText
      saleName
      statusUpdatedAt
      subStatus
      title
    }
    filters {
      assignedToId {
        in
        notIn
      }
      channel {
        in
        notIn
      }
      contactId {
        in
        notIn
      }
      createdAt {
        gt
        gte
        lt
        lte
      }
      contextDerived {
        orderId {
          in
          notIn
        }
        sale {
          salesTeamName {
            in
            notIn
          }
          type {
            in
            notIn
          }
        }
        saleId {
          in
          notIn
        }
        storeId {
          in
          notIn
        }
        supplierId {
          in
          notIn
        }
      }
      hasPendingScheduleActions {
        equals
        not
      }
      initialRequest {
        flow {
          in
          notIn
        }
      }
      isDraft {
        equals
        not
      }
      orderFlowId {
        in
        notIn
      }
      subStatus {
        in
        notIn
      }
    }
    groupBy
    icon
    iconColor
    id
    sortBy {
      direction
      field
    }
    title
  }
}
    `;

export const useCurrentUserFavoriteViewsQuery = <
      TData = CurrentUserFavoriteViewsQuery,
      TError = unknown
    >(
      variables?: CurrentUserFavoriteViewsQueryVariables,
      options?: Omit<UseQueryOptions<CurrentUserFavoriteViewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CurrentUserFavoriteViewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CurrentUserFavoriteViewsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['currentUserFavoriteViews'] : ['currentUserFavoriteViews', variables],
    queryFn: useFetchData<CurrentUserFavoriteViewsQuery, CurrentUserFavoriteViewsQueryVariables>(CurrentUserFavoriteViewsDocument).bind(null, variables),
    ...options
  }
    )};

useCurrentUserFavoriteViewsQuery.getKey = (variables?: CurrentUserFavoriteViewsQueryVariables) => variables === undefined ? ['currentUserFavoriteViews'] : ['currentUserFavoriteViews', variables];

export const useInfiniteCurrentUserFavoriteViewsQuery = <
      TData = InfiniteData<CurrentUserFavoriteViewsQuery>,
      TError = unknown
    >(
      variables: CurrentUserFavoriteViewsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CurrentUserFavoriteViewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CurrentUserFavoriteViewsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CurrentUserFavoriteViewsQuery, CurrentUserFavoriteViewsQueryVariables>(CurrentUserFavoriteViewsDocument)
    return useInfiniteQuery<CurrentUserFavoriteViewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['currentUserFavoriteViews.infinite'] : ['currentUserFavoriteViews.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCurrentUserFavoriteViewsQuery.getKey = (variables?: CurrentUserFavoriteViewsQueryVariables) => variables === undefined ? ['currentUserFavoriteViews.infinite'] : ['currentUserFavoriteViews.infinite', variables];

export const InternalUsersDocument = `
    query internalUsers($filters: InternalUsersFilterInput) {
  internalUsers(filters: $filters) {
    internalUser {
      email
      firstName
      id
      lastName
      picture
      supportRole
    }
    id
  }
}
    `;

export const useInternalUsersQuery = <
      TData = InternalUsersQuery,
      TError = unknown
    >(
      variables?: InternalUsersQueryVariables,
      options?: Omit<UseQueryOptions<InternalUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InternalUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InternalUsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['internalUsers'] : ['internalUsers', variables],
    queryFn: useFetchData<InternalUsersQuery, InternalUsersQueryVariables>(InternalUsersDocument).bind(null, variables),
    ...options
  }
    )};

useInternalUsersQuery.getKey = (variables?: InternalUsersQueryVariables) => variables === undefined ? ['internalUsers'] : ['internalUsers', variables];

export const useInfiniteInternalUsersQuery = <
      TData = InfiniteData<InternalUsersQuery>,
      TError = unknown
    >(
      variables: InternalUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<InternalUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<InternalUsersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<InternalUsersQuery, InternalUsersQueryVariables>(InternalUsersDocument)
    return useInfiniteQuery<InternalUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['internalUsers.infinite'] : ['internalUsers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteInternalUsersQuery.getKey = (variables?: InternalUsersQueryVariables) => variables === undefined ? ['internalUsers.infinite'] : ['internalUsers.infinite', variables];

export const NotificationsDocument = `
    query notifications($filters: SupportNotificationsFilterInput, $first: Int, $after: String, $last: Int, $before: String) {
  supportNotifications(
    filters: $filters
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    edges {
      cursor
      node {
        __typename
        ... on SupportNotificationMention {
          activity {
            __typename
            ... on SupportTicketActivityNote {
              content
              id
            }
          }
          createdAt
          id
          readAt
          sender {
            ...Agent
            ...Contact
          }
          ticket {
            id
            title
          }
        }
        ... on SupportNotificationReaction {
          activity {
            __typename
            ... on SupportTicketActivityNote {
              content
              id
            }
          }
          createdAt
          id
          reactionType
          readAt
          sender {
            ...Agent
            ...Contact
          }
          ticket {
            id
            title
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${AgentFragmentDoc}
${ContactFragmentDoc}`;

export const useNotificationsQuery = <
      TData = NotificationsQuery,
      TError = unknown
    >(
      variables?: NotificationsQueryVariables,
      options?: Omit<UseQueryOptions<NotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NotificationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['notifications'] : ['notifications', variables],
    queryFn: useFetchData<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument).bind(null, variables),
    ...options
  }
    )};

useNotificationsQuery.getKey = (variables?: NotificationsQueryVariables) => variables === undefined ? ['notifications'] : ['notifications', variables];

export const useInfiniteNotificationsQuery = <
      TData = InfiniteData<NotificationsQuery>,
      TError = unknown
    >(
      variables: NotificationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument)
    return useInfiniteQuery<NotificationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['notifications.infinite'] : ['notifications.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteNotificationsQuery.getKey = (variables?: NotificationsQueryVariables) => variables === undefined ? ['notifications.infinite'] : ['notifications.infinite', variables];

export const NotificationsUnreadCountDocument = `
    query notificationsUnreadCount {
  supportNotificationsUnreadCount
}
    `;

export const useNotificationsUnreadCountQuery = <
      TData = NotificationsUnreadCountQuery,
      TError = unknown
    >(
      variables?: NotificationsUnreadCountQueryVariables,
      options?: Omit<UseQueryOptions<NotificationsUnreadCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NotificationsUnreadCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NotificationsUnreadCountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['notificationsUnreadCount'] : ['notificationsUnreadCount', variables],
    queryFn: useFetchData<NotificationsUnreadCountQuery, NotificationsUnreadCountQueryVariables>(NotificationsUnreadCountDocument).bind(null, variables),
    ...options
  }
    )};

useNotificationsUnreadCountQuery.getKey = (variables?: NotificationsUnreadCountQueryVariables) => variables === undefined ? ['notificationsUnreadCount'] : ['notificationsUnreadCount', variables];

export const useInfiniteNotificationsUnreadCountQuery = <
      TData = InfiniteData<NotificationsUnreadCountQuery>,
      TError = unknown
    >(
      variables: NotificationsUnreadCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NotificationsUnreadCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NotificationsUnreadCountQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<NotificationsUnreadCountQuery, NotificationsUnreadCountQueryVariables>(NotificationsUnreadCountDocument)
    return useInfiniteQuery<NotificationsUnreadCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['notificationsUnreadCount.infinite'] : ['notificationsUnreadCount.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteNotificationsUnreadCountQuery.getKey = (variables?: NotificationsUnreadCountQueryVariables) => variables === undefined ? ['notificationsUnreadCount.infinite'] : ['notificationsUnreadCount.infinite', variables];

export const OrderDocument = `
    query order($input: Order_Input!) {
  order(input: $input) {
    brand {
      id
    }
    cashback {
      amount
      amountUpdatedAt
      currency
      dueDate
      status
    }
    createdAt
    id
    isCancelled
    isFullDigital
    items {
      ...PartialItem
    }
    parcels {
      estimatedDeliveryDateRange {
        max
        min
      }
      id
      tracking {
        courier {
          logoUrl
          name
        }
        courierSlug
        deliveredAt
        number
        status
        subStatus
        url
      }
    }
    recipient {
      address {
        ...PartialOrderAddress
      }
      firstName
      lastName
      phoneNumber
    }
    returns {
      id
      lines {
        itemId
      }
      status
    }
    sale {
      id
      name
    }
    shipping {
      deliveryDateRangeHistory {
        end
        start
      }
      fees
      feesSold
      pickupPoint {
        address {
          city
          countryCode
          name
          street
          streetAdditional
          zipCode
        }
        id
        openingDays {
          ...PickupPointOpeningDays
        }
      }
      refundSummary {
        isTotallyRefunded
        refundedAmountInCents
      }
    }
    supportActorAppContact {
      __typename
      appContact {
        firstName
        lastName
      }
      id
    }
    totalPriceSold {
      currency
      valueWithVat
    }
  }
}
    ${PartialItemFragmentDoc}
${PartialOrderAddressFragmentDoc}
${PickupPointOpeningDaysFragmentDoc}`;

export const useOrderQuery = <
      TData = OrderQuery,
      TError = unknown
    >(
      variables: OrderQueryVariables,
      options?: Omit<UseQueryOptions<OrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderQuery, TError, TData>(
      {
    queryKey: ['order', variables],
    queryFn: useFetchData<OrderQuery, OrderQueryVariables>(OrderDocument).bind(null, variables),
    ...options
  }
    )};

useOrderQuery.getKey = (variables: OrderQueryVariables) => ['order', variables];

export const useInfiniteOrderQuery = <
      TData = InfiniteData<OrderQuery>,
      TError = unknown
    >(
      variables: OrderQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrderQuery, OrderQueryVariables>(OrderDocument)
    return useInfiniteQuery<OrderQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['order.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderQuery.getKey = (variables: OrderQueryVariables) => ['order.infinite', variables];

export const OrderFlowDocument = `
    query orderFlow($input: Support_OrderFlow_Input!) {
  support_orderFlow(input: $input) {
    __typename
    ... on SupportOrderFlowCommunicationAppUsers {
      appUserIds
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      flow
      id
      status
    }
    ... on SupportOrderFlowCreditCompensationSupplierCharged {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowDeliveryDelay {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowDeliveryDelayV2 {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowOrderCancellation {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowOrderOptimizationPackaging {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowOther {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowProductOutOfStock {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        productReferences
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowProductOutOfStockShopify {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowProductWrongDescription {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        productReferences
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
  }
}
    ${AgentFragmentDoc}`;

export const useOrderFlowQuery = <
      TData = OrderFlowQuery,
      TError = unknown
    >(
      variables: OrderFlowQueryVariables,
      options?: Omit<UseQueryOptions<OrderFlowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderFlowQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderFlowQuery, TError, TData>(
      {
    queryKey: ['orderFlow', variables],
    queryFn: useFetchData<OrderFlowQuery, OrderFlowQueryVariables>(OrderFlowDocument).bind(null, variables),
    ...options
  }
    )};

useOrderFlowQuery.getKey = (variables: OrderFlowQueryVariables) => ['orderFlow', variables];

export const useInfiniteOrderFlowQuery = <
      TData = InfiniteData<OrderFlowQuery>,
      TError = unknown
    >(
      variables: OrderFlowQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderFlowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderFlowQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrderFlowQuery, OrderFlowQueryVariables>(OrderFlowDocument)
    return useInfiniteQuery<OrderFlowQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['orderFlow.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderFlowQuery.getKey = (variables: OrderFlowQueryVariables) => ['orderFlow.infinite', variables];

export const OrderFlowsDocument = `
    query orderFlows($input: Support_OrderFlow_Search_Input!) {
  support_orderFlow_search(input: $input) {
    edges {
      cursor
      node {
        __typename
        ... on SupportOrderFlowCommunicationAppUsers {
          appUserIds
          createdAt
          createdBy {
            ...Agent
          }
          errors {
            errorCode
            orderId
          }
          flow
          id
          status
        }
        ... on SupportOrderFlowCreditCompensationSupplierCharged {
          createdAt
          createdBy {
            ...Agent
          }
          errors {
            errorCode
            orderId
          }
          filters {
            sale {
              id
              name
            }
          }
          flow
          id
          orderIds
          status
        }
        ... on SupportOrderFlowDeliveryDelay {
          createdAt
          createdBy {
            ...Agent
          }
          errors {
            errorCode
            orderId
          }
          filters {
            sale {
              name
            }
          }
          flow
          id
          orderIds
          status
        }
        ... on SupportOrderFlowDeliveryDelayV2 {
          createdAt
          createdBy {
            ...Agent
          }
          errors {
            errorCode
            orderId
          }
          filters {
            sale {
              id
              name
            }
          }
          flow
          id
          orderIds
          status
        }
        ... on SupportOrderFlowOrderCancellation {
          createdAt
          createdBy {
            ...Agent
          }
          errors {
            errorCode
            orderId
          }
          filters {
            sale {
              id
              name
            }
          }
          flow
          id
          orderIds
          status
        }
        ... on SupportOrderFlowOrderOptimizationPackaging {
          createdAt
          createdBy {
            ...Agent
          }
          errors {
            errorCode
            orderId
          }
          filters {
            sale {
              name
            }
          }
          flow
          id
          orderIds
          status
        }
        ... on SupportOrderFlowOther {
          createdAt
          createdBy {
            ...Agent
          }
          errors {
            errorCode
            orderId
          }
          filters {
            sale {
              name
            }
          }
          flow
          id
          orderIds
          status
        }
        ... on SupportOrderFlowProductOutOfStock {
          createdAt
          createdBy {
            ...Agent
          }
          errors {
            errorCode
            orderId
          }
          filters {
            sale {
              name
            }
          }
          flow
          id
          orderIds
          status
        }
        ... on SupportOrderFlowProductOutOfStockShopify {
          createdAt
          createdBy {
            ...Agent
          }
          errors {
            errorCode
            orderId
          }
          filters {
            sale {
              id
              name
            }
          }
          flow
          id
          orderIds
          status
        }
        ... on SupportOrderFlowProductWrongDescription {
          createdAt
          createdBy {
            ...Agent
          }
          errors {
            errorCode
            orderId
          }
          filters {
            sale {
              name
            }
          }
          flow
          id
          orderIds
          status
        }
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${AgentFragmentDoc}`;

export const useOrderFlowsQuery = <
      TData = OrderFlowsQuery,
      TError = unknown
    >(
      variables: OrderFlowsQueryVariables,
      options?: Omit<UseQueryOptions<OrderFlowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderFlowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderFlowsQuery, TError, TData>(
      {
    queryKey: ['orderFlows', variables],
    queryFn: useFetchData<OrderFlowsQuery, OrderFlowsQueryVariables>(OrderFlowsDocument).bind(null, variables),
    ...options
  }
    )};

useOrderFlowsQuery.getKey = (variables: OrderFlowsQueryVariables) => ['orderFlows', variables];

export const useInfiniteOrderFlowsQuery = <
      TData = InfiniteData<OrderFlowsQuery>,
      TError = unknown
    >(
      variables: OrderFlowsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderFlowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderFlowsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrderFlowsQuery, OrderFlowsQueryVariables>(OrderFlowsDocument)
    return useInfiniteQuery<OrderFlowsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['orderFlows.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderFlowsQuery.getKey = (variables: OrderFlowsQueryVariables) => ['orderFlows.infinite', variables];

export const OrderFlowsByIdsDocument = `
    query orderFlowsByIds($input: Support_OrderFlows_Input!) {
  support_orderFlows(input: $input) {
    __typename
    ... on SupportOrderFlowCommunicationAppUsers {
      appUserIds
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      flow
      id
      status
    }
    ... on SupportOrderFlowCreditCompensationSupplierCharged {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowDeliveryDelay {
      filters {
        sale {
          name
        }
      }
      flow
      id
      status
    }
    ... on SupportOrderFlowDeliveryDelayV2 {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowOrderCancellation {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowOrderOptimizationPackaging {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowOther {
      filters {
        sale {
          name
        }
      }
      flow
      id
      status
    }
    ... on SupportOrderFlowProductOutOfStock {
      filters {
        sale {
          name
        }
      }
      flow
      id
      status
    }
    ... on SupportOrderFlowProductOutOfStockShopify {
      createdAt
      createdBy {
        ...Agent
      }
      errors {
        errorCode
        orderId
      }
      filters {
        sale {
          id
          name
        }
      }
      flow
      id
      orderIds
      status
    }
    ... on SupportOrderFlowProductWrongDescription {
      filters {
        sale {
          name
        }
      }
      flow
      id
      status
    }
  }
}
    ${AgentFragmentDoc}`;

export const useOrderFlowsByIdsQuery = <
      TData = OrderFlowsByIdsQuery,
      TError = unknown
    >(
      variables: OrderFlowsByIdsQueryVariables,
      options?: Omit<UseQueryOptions<OrderFlowsByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderFlowsByIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderFlowsByIdsQuery, TError, TData>(
      {
    queryKey: ['orderFlowsByIds', variables],
    queryFn: useFetchData<OrderFlowsByIdsQuery, OrderFlowsByIdsQueryVariables>(OrderFlowsByIdsDocument).bind(null, variables),
    ...options
  }
    )};

useOrderFlowsByIdsQuery.getKey = (variables: OrderFlowsByIdsQueryVariables) => ['orderFlowsByIds', variables];

export const useInfiniteOrderFlowsByIdsQuery = <
      TData = InfiniteData<OrderFlowsByIdsQuery>,
      TError = unknown
    >(
      variables: OrderFlowsByIdsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderFlowsByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderFlowsByIdsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrderFlowsByIdsQuery, OrderFlowsByIdsQueryVariables>(OrderFlowsByIdsDocument)
    return useInfiniteQuery<OrderFlowsByIdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['orderFlowsByIds.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderFlowsByIdsQuery.getKey = (variables: OrderFlowsByIdsQueryVariables) => ['orderFlowsByIds.infinite', variables];

export const OrderPreviewDocument = `
    query orderPreview($input: Order_Input!) {
  order(input: $input) {
    createdAt
    id
    isCancelled
    items {
      ...PartialItem
    }
    parcels {
      id
      tracking {
        status
        subStatus
      }
    }
    returns {
      id
      lines {
        itemId
      }
      status
    }
    shipping {
      feesSold
    }
    totalPriceSold {
      currency
      valueWithVat
    }
  }
}
    ${PartialItemFragmentDoc}`;

export const useOrderPreviewQuery = <
      TData = OrderPreviewQuery,
      TError = unknown
    >(
      variables: OrderPreviewQueryVariables,
      options?: Omit<UseQueryOptions<OrderPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderPreviewQuery, TError, TData>(
      {
    queryKey: ['orderPreview', variables],
    queryFn: useFetchData<OrderPreviewQuery, OrderPreviewQueryVariables>(OrderPreviewDocument).bind(null, variables),
    ...options
  }
    )};

useOrderPreviewQuery.getKey = (variables: OrderPreviewQueryVariables) => ['orderPreview', variables];

export const useInfiniteOrderPreviewQuery = <
      TData = InfiniteData<OrderPreviewQuery>,
      TError = unknown
    >(
      variables: OrderPreviewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrderPreviewQuery, OrderPreviewQueryVariables>(OrderPreviewDocument)
    return useInfiniteQuery<OrderPreviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['orderPreview.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderPreviewQuery.getKey = (variables: OrderPreviewQueryVariables) => ['orderPreview.infinite', variables];

export const OrderRefundPlanDocument = `
    query orderRefundPlan($input: Order_RefundPlan_Input!) {
  order_refundPlan(input: $input) {
    __typename
    ... on OrderItemRefundPlan {
      breakdown {
        cashAmountInCents
        creditAmountInCents
      }
      itemId
      withheld {
        cashAmountInCents
      }
    }
    ... on OrderItemTaxesRefundPlan {
      breakdown {
        cashAmountInCents
        creditAmountInCents
      }
      itemId
      withheld {
        cashAmountInCents
      }
    }
    ... on OrderShippingFeesRefundPlan {
      breakdown {
        cashAmountInCents
        creditAmountInCents
      }
      withheld {
        cashAmountInCents
      }
    }
  }
}
    `;

export const useOrderRefundPlanQuery = <
      TData = OrderRefundPlanQuery,
      TError = unknown
    >(
      variables: OrderRefundPlanQueryVariables,
      options?: Omit<UseQueryOptions<OrderRefundPlanQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderRefundPlanQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderRefundPlanQuery, TError, TData>(
      {
    queryKey: ['orderRefundPlan', variables],
    queryFn: useFetchData<OrderRefundPlanQuery, OrderRefundPlanQueryVariables>(OrderRefundPlanDocument).bind(null, variables),
    ...options
  }
    )};

useOrderRefundPlanQuery.getKey = (variables: OrderRefundPlanQueryVariables) => ['orderRefundPlan', variables];

export const useInfiniteOrderRefundPlanQuery = <
      TData = InfiniteData<OrderRefundPlanQuery>,
      TError = unknown
    >(
      variables: OrderRefundPlanQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderRefundPlanQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderRefundPlanQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrderRefundPlanQuery, OrderRefundPlanQueryVariables>(OrderRefundPlanDocument)
    return useInfiniteQuery<OrderRefundPlanQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['orderRefundPlan.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderRefundPlanQuery.getKey = (variables: OrderRefundPlanQueryVariables) => ['orderRefundPlan.infinite', variables];

export const OrdersByIdsDocument = `
    query ordersByIds($input: Orders_Input!) {
  orders(input: $input) {
    brand {
      id
      name
    }
    createdAt
    id
    parcels {
      tracking {
        status
        subStatus
      }
    }
  }
}
    `;

export const useOrdersByIdsQuery = <
      TData = OrdersByIdsQuery,
      TError = unknown
    >(
      variables: OrdersByIdsQueryVariables,
      options?: Omit<UseQueryOptions<OrdersByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrdersByIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrdersByIdsQuery, TError, TData>(
      {
    queryKey: ['ordersByIds', variables],
    queryFn: useFetchData<OrdersByIdsQuery, OrdersByIdsQueryVariables>(OrdersByIdsDocument).bind(null, variables),
    ...options
  }
    )};

useOrdersByIdsQuery.getKey = (variables: OrdersByIdsQueryVariables) => ['ordersByIds', variables];

export const useInfiniteOrdersByIdsQuery = <
      TData = InfiniteData<OrdersByIdsQuery>,
      TError = unknown
    >(
      variables: OrdersByIdsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrdersByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrdersByIdsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrdersByIdsQuery, OrdersByIdsQueryVariables>(OrdersByIdsDocument)
    return useInfiniteQuery<OrdersByIdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ordersByIds.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrdersByIdsQuery.getKey = (variables: OrdersByIdsQueryVariables) => ['ordersByIds.infinite', variables];

export const OrderTicketsDocument = `
    query orderTickets($filters: SupportTicketsFilterInput, $first: Int) {
  supportTickets(filters: $filters, first: $first) {
    edges {
      node {
        ...LinkedTicket
      }
    }
  }
}
    ${LinkedTicketFragmentDoc}`;

export const useOrderTicketsQuery = <
      TData = OrderTicketsQuery,
      TError = unknown
    >(
      variables?: OrderTicketsQueryVariables,
      options?: Omit<UseQueryOptions<OrderTicketsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderTicketsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderTicketsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['orderTickets'] : ['orderTickets', variables],
    queryFn: useFetchData<OrderTicketsQuery, OrderTicketsQueryVariables>(OrderTicketsDocument).bind(null, variables),
    ...options
  }
    )};

useOrderTicketsQuery.getKey = (variables?: OrderTicketsQueryVariables) => variables === undefined ? ['orderTickets'] : ['orderTickets', variables];

export const useInfiniteOrderTicketsQuery = <
      TData = InfiniteData<OrderTicketsQuery>,
      TError = unknown
    >(
      variables: OrderTicketsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderTicketsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderTicketsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrderTicketsQuery, OrderTicketsQueryVariables>(OrderTicketsDocument)
    return useInfiniteQuery<OrderTicketsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['orderTickets.infinite'] : ['orderTickets.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderTicketsQuery.getKey = (variables?: OrderTicketsQueryVariables) => variables === undefined ? ['orderTickets.infinite'] : ['orderTickets.infinite', variables];

export const ProductInformationDocument = `
    query productInformation($productId: ID!) {
  product(id: $productId) {
    __typename
    ... on ProductDigital {
      brandId
      couponExpirationDate
      description
      faq {
        afterPurchase
      }
      howToUse
      id
      name
      terms
      variants {
        gtin
        id
        images {
          url
        }
        sku
        title
      }
      visuals {
        images {
          url
        }
      }
    }
    ... on ProductPhysical {
      brandId
      description
      id
      name
      returnPolicy {
        isReturnable
      }
      variants {
        gtin
        id
        images {
          url
        }
        sku
        title
      }
      visuals {
        images {
          url
        }
      }
    }
  }
}
    `;

export const useProductInformationQuery = <
      TData = ProductInformationQuery,
      TError = unknown
    >(
      variables: ProductInformationQueryVariables,
      options?: Omit<UseQueryOptions<ProductInformationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductInformationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductInformationQuery, TError, TData>(
      {
    queryKey: ['productInformation', variables],
    queryFn: useFetchData<ProductInformationQuery, ProductInformationQueryVariables>(ProductInformationDocument).bind(null, variables),
    ...options
  }
    )};

useProductInformationQuery.getKey = (variables: ProductInformationQueryVariables) => ['productInformation', variables];

export const useInfiniteProductInformationQuery = <
      TData = InfiniteData<ProductInformationQuery>,
      TError = unknown
    >(
      variables: ProductInformationQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductInformationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductInformationQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ProductInformationQuery, ProductInformationQueryVariables>(ProductInformationDocument)
    return useInfiniteQuery<ProductInformationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['productInformation.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteProductInformationQuery.getKey = (variables: ProductInformationQueryVariables) => ['productInformation.infinite', variables];

export const ProductPreviewDocument = `
    query productPreview($productId: ID!) {
  product(id: $productId) {
    __typename
    ... on ProductDigital {
      financial {
        frenchTaxRate
        readableCategory
      }
      id
      name
      options {
        id
        name
        type
        values {
          id
          value
        }
      }
      saleId
      storeId
      visibility {
        isAvailableForSale
      }
      visuals {
        images {
          url
        }
      }
    }
    ... on ProductPhysical {
      financial {
        frenchTaxRate
        readableCategory
      }
      id
      name
      options {
        id
        name
        type
        values {
          id
          value
        }
      }
      returnPolicy {
        isReturnable
      }
      saleId
      storeId
      visibility {
        isAvailableForSale
      }
      visuals {
        images {
          url
        }
      }
    }
  }
}
    `;

export const useProductPreviewQuery = <
      TData = ProductPreviewQuery,
      TError = unknown
    >(
      variables: ProductPreviewQueryVariables,
      options?: Omit<UseQueryOptions<ProductPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductPreviewQuery, TError, TData>(
      {
    queryKey: ['productPreview', variables],
    queryFn: useFetchData<ProductPreviewQuery, ProductPreviewQueryVariables>(ProductPreviewDocument).bind(null, variables),
    ...options
  }
    )};

useProductPreviewQuery.getKey = (variables: ProductPreviewQueryVariables) => ['productPreview', variables];

export const useInfiniteProductPreviewQuery = <
      TData = InfiniteData<ProductPreviewQuery>,
      TError = unknown
    >(
      variables: ProductPreviewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ProductPreviewQuery, ProductPreviewQueryVariables>(ProductPreviewDocument)
    return useInfiniteQuery<ProductPreviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['productPreview.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteProductPreviewQuery.getKey = (variables: ProductPreviewQueryVariables) => ['productPreview.infinite', variables];

export const SaleDocument = `
    query sale($saleId: ID!) {
  sale(id: $saleId) {
    accountManager
    brandId
    endsAt
    name
    id
    salesTeamName
    setupManager
    startsAt
    status
    type
  }
}
    `;

export const useSaleQuery = <
      TData = SaleQuery,
      TError = unknown
    >(
      variables: SaleQueryVariables,
      options?: Omit<UseQueryOptions<SaleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SaleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SaleQuery, TError, TData>(
      {
    queryKey: ['sale', variables],
    queryFn: useFetchData<SaleQuery, SaleQueryVariables>(SaleDocument).bind(null, variables),
    ...options
  }
    )};

useSaleQuery.getKey = (variables: SaleQueryVariables) => ['sale', variables];

export const useInfiniteSaleQuery = <
      TData = InfiniteData<SaleQuery>,
      TError = unknown
    >(
      variables: SaleQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SaleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SaleQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SaleQuery, SaleQueryVariables>(SaleDocument)
    return useInfiniteQuery<SaleQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['sale.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSaleQuery.getKey = (variables: SaleQueryVariables) => ['sale.infinite', variables];

export const SalesByIdsDocument = `
    query salesByIds($ids: [ID!]!) {
  salesByIds(ids: $ids) {
    endsAt
    id
    name
    startsAt
    status
    storeId
  }
}
    `;

export const useSalesByIdsQuery = <
      TData = SalesByIdsQuery,
      TError = unknown
    >(
      variables: SalesByIdsQueryVariables,
      options?: Omit<UseQueryOptions<SalesByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SalesByIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SalesByIdsQuery, TError, TData>(
      {
    queryKey: ['salesByIds', variables],
    queryFn: useFetchData<SalesByIdsQuery, SalesByIdsQueryVariables>(SalesByIdsDocument).bind(null, variables),
    ...options
  }
    )};

useSalesByIdsQuery.getKey = (variables: SalesByIdsQueryVariables) => ['salesByIds', variables];

export const useInfiniteSalesByIdsQuery = <
      TData = InfiniteData<SalesByIdsQuery>,
      TError = unknown
    >(
      variables: SalesByIdsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SalesByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SalesByIdsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SalesByIdsQuery, SalesByIdsQueryVariables>(SalesByIdsDocument)
    return useInfiniteQuery<SalesByIdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['salesByIds.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSalesByIdsQuery.getKey = (variables: SalesByIdsQueryVariables) => ['salesByIds.infinite', variables];

export const SaleActivitiesDocument = `
    query saleActivities($saleId: ID!, $first: Int, $sortBy: SaleActivitiesSortInput, $after: String, $filters: SaleActivitiesFilterInput) {
  sale(id: $saleId) {
    activities(sortBy: $sortBy, first: $first, after: $after, filters: $filters) {
      edges {
        node {
          __typename
          ... on SaleActivityNote {
            actor {
              ...Agent
              ...Contact
            }
            attachments {
              ...Attachment
            }
            content
            id
            occurredAt
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${AgentFragmentDoc}
${ContactFragmentDoc}
${AttachmentFragmentDoc}`;

export const useSaleActivitiesQuery = <
      TData = SaleActivitiesQuery,
      TError = unknown
    >(
      variables: SaleActivitiesQueryVariables,
      options?: Omit<UseQueryOptions<SaleActivitiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SaleActivitiesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SaleActivitiesQuery, TError, TData>(
      {
    queryKey: ['saleActivities', variables],
    queryFn: useFetchData<SaleActivitiesQuery, SaleActivitiesQueryVariables>(SaleActivitiesDocument).bind(null, variables),
    ...options
  }
    )};

useSaleActivitiesQuery.getKey = (variables: SaleActivitiesQueryVariables) => ['saleActivities', variables];

export const useInfiniteSaleActivitiesQuery = <
      TData = InfiniteData<SaleActivitiesQuery>,
      TError = unknown
    >(
      variables: SaleActivitiesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SaleActivitiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SaleActivitiesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SaleActivitiesQuery, SaleActivitiesQueryVariables>(SaleActivitiesDocument)
    return useInfiniteQuery<SaleActivitiesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['saleActivities.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSaleActivitiesQuery.getKey = (variables: SaleActivitiesQueryVariables) => ['saleActivities.infinite', variables];

export const SalePreviewDocument = `
    query salePreview($saleId: ID!) {
  sale(id: $saleId) {
    endsAt
    id
    name
    startsAt
    type
  }
}
    `;

export const useSalePreviewQuery = <
      TData = SalePreviewQuery,
      TError = unknown
    >(
      variables: SalePreviewQueryVariables,
      options?: Omit<UseQueryOptions<SalePreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SalePreviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SalePreviewQuery, TError, TData>(
      {
    queryKey: ['salePreview', variables],
    queryFn: useFetchData<SalePreviewQuery, SalePreviewQueryVariables>(SalePreviewDocument).bind(null, variables),
    ...options
  }
    )};

useSalePreviewQuery.getKey = (variables: SalePreviewQueryVariables) => ['salePreview', variables];

export const useInfiniteSalePreviewQuery = <
      TData = InfiniteData<SalePreviewQuery>,
      TError = unknown
    >(
      variables: SalePreviewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SalePreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SalePreviewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SalePreviewQuery, SalePreviewQueryVariables>(SalePreviewDocument)
    return useInfiniteQuery<SalePreviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['salePreview.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSalePreviewQuery.getKey = (variables: SalePreviewQueryVariables) => ['salePreview.infinite', variables];

export const SaleProductsDocument = `
    query saleProducts($saleId: ID!) {
  sale(id: $saleId) {
    products {
      __typename
      ... on ProductDigital {
        id
        name
        variants {
          financial {
            retailPrice {
              amountVatIncludedInCents
              currency
            }
          }
          gtin
          id
          images {
            url
          }
          sku
          title
        }
        visuals {
          images {
            url
          }
        }
      }
      ... on ProductPhysical {
        id
        name
        variants {
          financial {
            retailPrice {
              amountVatIncludedInCents
              currency
            }
          }
          gtin
          id
          images {
            url
          }
          sku
          title
        }
        visuals {
          images {
            url
          }
        }
      }
    }
  }
}
    `;

export const useSaleProductsQuery = <
      TData = SaleProductsQuery,
      TError = unknown
    >(
      variables: SaleProductsQueryVariables,
      options?: Omit<UseQueryOptions<SaleProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SaleProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SaleProductsQuery, TError, TData>(
      {
    queryKey: ['saleProducts', variables],
    queryFn: useFetchData<SaleProductsQuery, SaleProductsQueryVariables>(SaleProductsDocument).bind(null, variables),
    ...options
  }
    )};

useSaleProductsQuery.getKey = (variables: SaleProductsQueryVariables) => ['saleProducts', variables];

export const useInfiniteSaleProductsQuery = <
      TData = InfiniteData<SaleProductsQuery>,
      TError = unknown
    >(
      variables: SaleProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SaleProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SaleProductsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SaleProductsQuery, SaleProductsQueryVariables>(SaleProductsDocument)
    return useInfiniteQuery<SaleProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['saleProducts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSaleProductsQuery.getKey = (variables: SaleProductsQueryVariables) => ['saleProducts.infinite', variables];

export const SearchAppContactDocument = `
    query searchAppContact($input: SearchSupportActorAppContactInput!) {
  searchSupportActorAppContact(input: $input) {
    __typename
    appContact {
      ...PartialAppContact
      phoneNumber
    }
    id
  }
}
    ${PartialAppContactFragmentDoc}`;

export const useSearchAppContactQuery = <
      TData = SearchAppContactQuery,
      TError = unknown
    >(
      variables: SearchAppContactQueryVariables,
      options?: Omit<UseQueryOptions<SearchAppContactQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchAppContactQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchAppContactQuery, TError, TData>(
      {
    queryKey: ['searchAppContact', variables],
    queryFn: useFetchData<SearchAppContactQuery, SearchAppContactQueryVariables>(SearchAppContactDocument).bind(null, variables),
    ...options
  }
    )};

useSearchAppContactQuery.getKey = (variables: SearchAppContactQueryVariables) => ['searchAppContact', variables];

export const useInfiniteSearchAppContactQuery = <
      TData = InfiniteData<SearchAppContactQuery>,
      TError = unknown
    >(
      variables: SearchAppContactQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchAppContactQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchAppContactQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchAppContactQuery, SearchAppContactQueryVariables>(SearchAppContactDocument)
    return useInfiniteQuery<SearchAppContactQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchAppContact.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchAppContactQuery.getKey = (variables: SearchAppContactQueryVariables) => ['searchAppContact.infinite', variables];

export const SearchAppContactsDocument = `
    query searchAppContacts($input: SearchSupportActorAppContactInput!) {
  searchSupportActorAppContact(input: $input) {
    __typename
    appContact {
      email
      firstName
      lastName
    }
    id
  }
}
    `;

export const useSearchAppContactsQuery = <
      TData = SearchAppContactsQuery,
      TError = unknown
    >(
      variables: SearchAppContactsQueryVariables,
      options?: Omit<UseQueryOptions<SearchAppContactsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchAppContactsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchAppContactsQuery, TError, TData>(
      {
    queryKey: ['searchAppContacts', variables],
    queryFn: useFetchData<SearchAppContactsQuery, SearchAppContactsQueryVariables>(SearchAppContactsDocument).bind(null, variables),
    ...options
  }
    )};

useSearchAppContactsQuery.getKey = (variables: SearchAppContactsQueryVariables) => ['searchAppContacts', variables];

export const useInfiniteSearchAppContactsQuery = <
      TData = InfiniteData<SearchAppContactsQuery>,
      TError = unknown
    >(
      variables: SearchAppContactsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchAppContactsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchAppContactsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchAppContactsQuery, SearchAppContactsQueryVariables>(SearchAppContactsDocument)
    return useInfiniteQuery<SearchAppContactsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchAppContacts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchAppContactsQuery.getKey = (variables: SearchAppContactsQueryVariables) => ['searchAppContacts.infinite', variables];

export const SearchBrandsDocument = `
    query searchBrands($input: SearchBrandsInput!) {
  searchBrands(input: $input) {
    id
    name
    storeId
  }
}
    `;

export const useSearchBrandsQuery = <
      TData = SearchBrandsQuery,
      TError = unknown
    >(
      variables: SearchBrandsQueryVariables,
      options?: Omit<UseQueryOptions<SearchBrandsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchBrandsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchBrandsQuery, TError, TData>(
      {
    queryKey: ['searchBrands', variables],
    queryFn: useFetchData<SearchBrandsQuery, SearchBrandsQueryVariables>(SearchBrandsDocument).bind(null, variables),
    ...options
  }
    )};

useSearchBrandsQuery.getKey = (variables: SearchBrandsQueryVariables) => ['searchBrands', variables];

export const useInfiniteSearchBrandsQuery = <
      TData = InfiniteData<SearchBrandsQuery>,
      TError = unknown
    >(
      variables: SearchBrandsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchBrandsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchBrandsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchBrandsQuery, SearchBrandsQueryVariables>(SearchBrandsDocument)
    return useInfiniteQuery<SearchBrandsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchBrands.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchBrandsQuery.getKey = (variables: SearchBrandsQueryVariables) => ['searchBrands.infinite', variables];

export const SearchEmailContactsDocument = `
    query searchEmailContacts($input: SearchSupportActorEmailContactsInput!) {
  searchSupportActorEmailContacts(input: $input) {
    id
    emailContact {
      email
      name
    }
  }
}
    `;

export const useSearchEmailContactsQuery = <
      TData = SearchEmailContactsQuery,
      TError = unknown
    >(
      variables: SearchEmailContactsQueryVariables,
      options?: Omit<UseQueryOptions<SearchEmailContactsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchEmailContactsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchEmailContactsQuery, TError, TData>(
      {
    queryKey: ['searchEmailContacts', variables],
    queryFn: useFetchData<SearchEmailContactsQuery, SearchEmailContactsQueryVariables>(SearchEmailContactsDocument).bind(null, variables),
    ...options
  }
    )};

useSearchEmailContactsQuery.getKey = (variables: SearchEmailContactsQueryVariables) => ['searchEmailContacts', variables];

export const useInfiniteSearchEmailContactsQuery = <
      TData = InfiniteData<SearchEmailContactsQuery>,
      TError = unknown
    >(
      variables: SearchEmailContactsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchEmailContactsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchEmailContactsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchEmailContactsQuery, SearchEmailContactsQueryVariables>(SearchEmailContactsDocument)
    return useInfiniteQuery<SearchEmailContactsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchEmailContacts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchEmailContactsQuery.getKey = (variables: SearchEmailContactsQueryVariables) => ['searchEmailContacts.infinite', variables];

export const SearchCouriersDocument = `
    query searchCouriers($input: Couriers_Search_Input!) {
  couriers_search(input: $input) {
    logoUrl
    name
    slug
  }
}
    `;

export const useSearchCouriersQuery = <
      TData = SearchCouriersQuery,
      TError = unknown
    >(
      variables: SearchCouriersQueryVariables,
      options?: Omit<UseQueryOptions<SearchCouriersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchCouriersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchCouriersQuery, TError, TData>(
      {
    queryKey: ['searchCouriers', variables],
    queryFn: useFetchData<SearchCouriersQuery, SearchCouriersQueryVariables>(SearchCouriersDocument).bind(null, variables),
    ...options
  }
    )};

useSearchCouriersQuery.getKey = (variables: SearchCouriersQueryVariables) => ['searchCouriers', variables];

export const useInfiniteSearchCouriersQuery = <
      TData = InfiniteData<SearchCouriersQuery>,
      TError = unknown
    >(
      variables: SearchCouriersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchCouriersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchCouriersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchCouriersQuery, SearchCouriersQueryVariables>(SearchCouriersDocument)
    return useInfiniteQuery<SearchCouriersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchCouriers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchCouriersQuery.getKey = (variables: SearchCouriersQueryVariables) => ['searchCouriers.infinite', variables];

export const SearchOrdersDocument = `
    query searchOrders($input: Orders_Search_Input!) {
  orders_search(input: $input) {
    edges {
      node {
        brand {
          id
          name
        }
        createdAt
        id
        parcels {
          tracking {
            status
            subStatus
          }
        }
        recipient {
          firstName
          lastName
        }
        tags {
          claimReason
        }
        totalPriceSold {
          currency
          valueWithVat
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    `;

export const useSearchOrdersQuery = <
      TData = SearchOrdersQuery,
      TError = unknown
    >(
      variables: SearchOrdersQueryVariables,
      options?: Omit<UseQueryOptions<SearchOrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchOrdersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchOrdersQuery, TError, TData>(
      {
    queryKey: ['searchOrders', variables],
    queryFn: useFetchData<SearchOrdersQuery, SearchOrdersQueryVariables>(SearchOrdersDocument).bind(null, variables),
    ...options
  }
    )};

useSearchOrdersQuery.getKey = (variables: SearchOrdersQueryVariables) => ['searchOrders', variables];

export const useInfiniteSearchOrdersQuery = <
      TData = InfiniteData<SearchOrdersQuery>,
      TError = unknown
    >(
      variables: SearchOrdersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchOrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchOrdersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchOrdersQuery, SearchOrdersQueryVariables>(SearchOrdersDocument)
    return useInfiniteQuery<SearchOrdersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchOrders.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchOrdersQuery.getKey = (variables: SearchOrdersQueryVariables) => ['searchOrders.infinite', variables];

export const SearchSalesDocument = `
    query searchSales($input: SearchSalesInput!) {
  searchSales(input: $input) {
    endsAt
    id
    name
    startsAt
    status
    storeId
  }
}
    `;

export const useSearchSalesQuery = <
      TData = SearchSalesQuery,
      TError = unknown
    >(
      variables: SearchSalesQueryVariables,
      options?: Omit<UseQueryOptions<SearchSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchSalesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchSalesQuery, TError, TData>(
      {
    queryKey: ['searchSales', variables],
    queryFn: useFetchData<SearchSalesQuery, SearchSalesQueryVariables>(SearchSalesDocument).bind(null, variables),
    ...options
  }
    )};

useSearchSalesQuery.getKey = (variables: SearchSalesQueryVariables) => ['searchSales', variables];

export const useInfiniteSearchSalesQuery = <
      TData = InfiniteData<SearchSalesQuery>,
      TError = unknown
    >(
      variables: SearchSalesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchSalesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchSalesQuery, SearchSalesQueryVariables>(SearchSalesDocument)
    return useInfiniteQuery<SearchSalesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchSales.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchSalesQuery.getKey = (variables: SearchSalesQueryVariables) => ['searchSales.infinite', variables];

export const SnippetDocument = `
    query snippet($supportSnippetId: ID!) {
  supportSnippet(id: $supportSnippetId) {
    ...PartialSnippet
  }
}
    ${PartialSnippetFragmentDoc}`;

export const useSnippetQuery = <
      TData = SnippetQuery,
      TError = unknown
    >(
      variables: SnippetQueryVariables,
      options?: Omit<UseQueryOptions<SnippetQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SnippetQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SnippetQuery, TError, TData>(
      {
    queryKey: ['snippet', variables],
    queryFn: useFetchData<SnippetQuery, SnippetQueryVariables>(SnippetDocument).bind(null, variables),
    ...options
  }
    )};

useSnippetQuery.getKey = (variables: SnippetQueryVariables) => ['snippet', variables];

export const useInfiniteSnippetQuery = <
      TData = InfiniteData<SnippetQuery>,
      TError = unknown
    >(
      variables: SnippetQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SnippetQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SnippetQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SnippetQuery, SnippetQueryVariables>(SnippetDocument)
    return useInfiniteQuery<SnippetQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['snippet.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSnippetQuery.getKey = (variables: SnippetQueryVariables) => ['snippet.infinite', variables];

export const SnippetsDocument = `
    query snippets($filters: SupportSnippetsFilterInput, $sortBy: SupportSnippetsSortInput, $first: Int, $after: String) {
  supportSnippets(
    filters: $filters
    sortBy: $sortBy
    first: $first
    after: $after
  ) {
    edges {
      node {
        ...PartialSnippet
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${PartialSnippetFragmentDoc}`;

export const useSnippetsQuery = <
      TData = SnippetsQuery,
      TError = unknown
    >(
      variables?: SnippetsQueryVariables,
      options?: Omit<UseQueryOptions<SnippetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SnippetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SnippetsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['snippets'] : ['snippets', variables],
    queryFn: useFetchData<SnippetsQuery, SnippetsQueryVariables>(SnippetsDocument).bind(null, variables),
    ...options
  }
    )};

useSnippetsQuery.getKey = (variables?: SnippetsQueryVariables) => variables === undefined ? ['snippets'] : ['snippets', variables];

export const useInfiniteSnippetsQuery = <
      TData = InfiniteData<SnippetsQuery>,
      TError = unknown
    >(
      variables: SnippetsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SnippetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SnippetsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SnippetsQuery, SnippetsQueryVariables>(SnippetsDocument)
    return useInfiniteQuery<SnippetsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['snippets.infinite'] : ['snippets.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSnippetsQuery.getKey = (variables?: SnippetsQueryVariables) => variables === undefined ? ['snippets.infinite'] : ['snippets.infinite', variables];

export const SnippetTagDocument = `
    query snippetTag($supportSnippetTagId: ID!) {
  supportSnippetTag(id: $supportSnippetTagId) {
    ...PartialSnippetTag
  }
}
    ${PartialSnippetTagFragmentDoc}`;

export const useSnippetTagQuery = <
      TData = SnippetTagQuery,
      TError = unknown
    >(
      variables: SnippetTagQueryVariables,
      options?: Omit<UseQueryOptions<SnippetTagQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SnippetTagQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SnippetTagQuery, TError, TData>(
      {
    queryKey: ['snippetTag', variables],
    queryFn: useFetchData<SnippetTagQuery, SnippetTagQueryVariables>(SnippetTagDocument).bind(null, variables),
    ...options
  }
    )};

useSnippetTagQuery.getKey = (variables: SnippetTagQueryVariables) => ['snippetTag', variables];

export const useInfiniteSnippetTagQuery = <
      TData = InfiniteData<SnippetTagQuery>,
      TError = unknown
    >(
      variables: SnippetTagQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SnippetTagQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SnippetTagQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SnippetTagQuery, SnippetTagQueryVariables>(SnippetTagDocument)
    return useInfiniteQuery<SnippetTagQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['snippetTag.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSnippetTagQuery.getKey = (variables: SnippetTagQueryVariables) => ['snippetTag.infinite', variables];

export const SnippetTagsDocument = `
    query snippetTags($filters: SupportSnippetTagsFilterInput, $sortBy: SupportSnippetTagsSortInput, $first: Int, $after: String) {
  supportSnippetTags(
    filters: $filters
    sortBy: $sortBy
    first: $first
    after: $after
  ) {
    edges {
      node {
        ...PartialSnippetTag
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${PartialSnippetTagFragmentDoc}`;

export const useSnippetTagsQuery = <
      TData = SnippetTagsQuery,
      TError = unknown
    >(
      variables?: SnippetTagsQueryVariables,
      options?: Omit<UseQueryOptions<SnippetTagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SnippetTagsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SnippetTagsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['snippetTags'] : ['snippetTags', variables],
    queryFn: useFetchData<SnippetTagsQuery, SnippetTagsQueryVariables>(SnippetTagsDocument).bind(null, variables),
    ...options
  }
    )};

useSnippetTagsQuery.getKey = (variables?: SnippetTagsQueryVariables) => variables === undefined ? ['snippetTags'] : ['snippetTags', variables];

export const useInfiniteSnippetTagsQuery = <
      TData = InfiniteData<SnippetTagsQuery>,
      TError = unknown
    >(
      variables: SnippetTagsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SnippetTagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SnippetTagsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SnippetTagsQuery, SnippetTagsQueryVariables>(SnippetTagsDocument)
    return useInfiniteQuery<SnippetTagsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['snippetTags.infinite'] : ['snippetTags.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSnippetTagsQuery.getKey = (variables?: SnippetTagsQueryVariables) => variables === undefined ? ['snippetTags.infinite'] : ['snippetTags.infinite', variables];

export const BrandInformationDocument = `
    query brandInformation($brandId: ID!) {
  brand(id: $brandId) {
    id
    returnAddress {
      address {
        ...PartialAddress
      }
      name
    }
  }
}
    ${PartialAddressFragmentDoc}`;

export const useBrandInformationQuery = <
      TData = BrandInformationQuery,
      TError = unknown
    >(
      variables: BrandInformationQueryVariables,
      options?: Omit<UseQueryOptions<BrandInformationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandInformationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandInformationQuery, TError, TData>(
      {
    queryKey: ['brandInformation', variables],
    queryFn: useFetchData<BrandInformationQuery, BrandInformationQueryVariables>(BrandInformationDocument).bind(null, variables),
    ...options
  }
    )};

useBrandInformationQuery.getKey = (variables: BrandInformationQueryVariables) => ['brandInformation', variables];

export const useInfiniteBrandInformationQuery = <
      TData = InfiniteData<BrandInformationQuery>,
      TError = unknown
    >(
      variables: BrandInformationQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BrandInformationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BrandInformationQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BrandInformationQuery, BrandInformationQueryVariables>(BrandInformationDocument)
    return useInfiniteQuery<BrandInformationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['brandInformation.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBrandInformationQuery.getKey = (variables: BrandInformationQueryVariables) => ['brandInformation.infinite', variables];

export const BrandPreviewDocument = `
    query brandPreview($brandId: ID!) {
  brand(id: $brandId) {
    id
    name
    saleManager
    website
  }
}
    `;

export const useBrandPreviewQuery = <
      TData = BrandPreviewQuery,
      TError = unknown
    >(
      variables: BrandPreviewQueryVariables,
      options?: Omit<UseQueryOptions<BrandPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandPreviewQuery, TError, TData>(
      {
    queryKey: ['brandPreview', variables],
    queryFn: useFetchData<BrandPreviewQuery, BrandPreviewQueryVariables>(BrandPreviewDocument).bind(null, variables),
    ...options
  }
    )};

useBrandPreviewQuery.getKey = (variables: BrandPreviewQueryVariables) => ['brandPreview', variables];

export const useInfiniteBrandPreviewQuery = <
      TData = InfiniteData<BrandPreviewQuery>,
      TError = unknown
    >(
      variables: BrandPreviewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BrandPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BrandPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BrandPreviewQuery, BrandPreviewQueryVariables>(BrandPreviewDocument)
    return useInfiniteQuery<BrandPreviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['brandPreview.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBrandPreviewQuery.getKey = (variables: BrandPreviewQueryVariables) => ['brandPreview.infinite', variables];

export const BrandsByIdsDocument = `
    query brandsByIds($ids: [ID!]!) {
  brandsByIds(ids: $ids) {
    id
    name
    storeId
  }
}
    `;

export const useBrandsByIdsQuery = <
      TData = BrandsByIdsQuery,
      TError = unknown
    >(
      variables: BrandsByIdsQueryVariables,
      options?: Omit<UseQueryOptions<BrandsByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandsByIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandsByIdsQuery, TError, TData>(
      {
    queryKey: ['brandsByIds', variables],
    queryFn: useFetchData<BrandsByIdsQuery, BrandsByIdsQueryVariables>(BrandsByIdsDocument).bind(null, variables),
    ...options
  }
    )};

useBrandsByIdsQuery.getKey = (variables: BrandsByIdsQueryVariables) => ['brandsByIds', variables];

export const useInfiniteBrandsByIdsQuery = <
      TData = InfiniteData<BrandsByIdsQuery>,
      TError = unknown
    >(
      variables: BrandsByIdsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BrandsByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BrandsByIdsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BrandsByIdsQuery, BrandsByIdsQueryVariables>(BrandsByIdsDocument)
    return useInfiniteQuery<BrandsByIdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['brandsByIds.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBrandsByIdsQuery.getKey = (variables: BrandsByIdsQueryVariables) => ['brandsByIds.infinite', variables];

export const TicketDocument = `
    query ticket($ticketId: ID!, $aiSuggestionsFilters: SupportTicketAiSuggestionsFilterInput, $aiSuggestionsFirst: Int, $contactTicketsFirst: Int, $contactTicketsSortBy: SupportTicketsSortInput, $contactOrdersLimit: PositiveInt, $scheduleActionsFirst: Int) {
  supportTicket(id: $ticketId) {
    aiSuggestions(filters: $aiSuggestionsFilters, first: $aiSuggestionsFirst) {
      edges {
        node {
          ... on SupportTicketAiSuggestionEmail {
            __typename
            createdAt
            id
            payload {
              attachments {
                ...AttachmentPayload
              }
              contentHtml
              contentText
            }
            reasoning
            reasoningSummary
            status
            ticketId
            type
          }
          ... on SupportTicketAiSuggestionMessage {
            __typename
            createdAt
            id
            payload {
              attachments {
                ...AttachmentPayload
              }
              content
            }
            reasoning
            reasoningSummary
            status
            ticketId
            type
          }
        }
      }
    }
    assignedAt
    assignedTo {
      ...Agent
    }
    attachments {
      ...Attachment
    }
    channel
    claims {
      acceptedAction
      acceptedAt
      acceptedBy {
        __typename
        ...Agent
      }
      canceledAt
      canceledBy {
        __typename
        ...Agent
      }
      createdAt
      id
      isOpenedByBot
      items {
        ...PartialClaimItem
      }
      preferredSolution
      proofUrls
      reason
    }
    contact {
      __typename
      ... on SupportActorAppContact {
        appContact {
          appUserId
          credits {
            balanceAmountInCents
            lines {
              amountInCents
              description
              expiresAt
              id
              isExpired
              remainingAmountInCents
              spentAmountInCents
            }
            store
            transactions {
              amountInCents
              billingId
              createdAt
              description
              id
              operator
              orderId
              refereeUserId
              type
            }
          }
          email
          firstName
          id
          isFrauder
          isInfluencer
          language
          lastName
          latestActivityAt
          latestOrders(limit: $contactOrdersLimit) {
            brand {
              id
              name
            }
            createdAt
            id
            initialOrder {
              id
            }
            parcels {
              tracking {
                status
                subStatus
              }
            }
            saleId
          }
          mobile {
            app {
              isLatestVersion
              version
            }
            device {
              brand
              os
              osVersion
            }
          }
          ordersCount
          phoneNumber
          referralCode
          referralGodfather {
            __typename
            appContact {
              firstName
              lastName
              referralCode
            }
            id
          }
          store
          timezone
        }
        id
        tickets(first: $contactTicketsFirst, sortBy: $contactTicketsSortBy) {
          edges {
            node {
              ...LinkedTicket
            }
          }
        }
      }
      ... on SupportActorEmailContact {
        emailContact {
          email
          name
        }
        id
        tickets(first: $contactTicketsFirst, sortBy: $contactTicketsSortBy) {
          edges {
            node {
              claims {
                acceptedAt
                canceledAt
                id
              }
              id
              statusUpdatedAt
              subStatus
              title
            }
          }
        }
      }
    }
    contextDerived {
      order {
        cashback {
          amount
          amountUpdatedAt
          currency
          dueDate
          status
        }
        claims {
          acceptedAt
          canceledAt
          createdAt
          id
        }
        initialOrder {
          ...PartialOrder
        }
        linesRefunds {
          amountInCents
          coveredBy
          createdAt
          id
          lineId
          lineType
          reason
        }
        parentOrders {
          initialOrder {
            ...PartialOrder
          }
          reshipOrder {
            ...PartialOrder
          }
          ...PartialOrder
        }
        payment {
          processor
          subProcessor
          processorTransactionUrl
          transactionPlan {
            paidTransactionsCount
            pendingTransactionsCount
          }
        }
        reshipOrder {
          ...PartialOrder
        }
        ...PartialOrder
      }
      product {
        __typename
        ... on ProductDigital {
          financial {
            frenchTaxRate
            readableCategory
          }
          id
          name
          options {
            id
            name
            type
            values {
              id
              value
            }
          }
          saleId
          storeId
          visibility {
            isAvailableForSale
          }
          visuals {
            images {
              url
            }
          }
        }
        ... on ProductPhysical {
          financial {
            frenchTaxRate
            readableCategory
          }
          id
          name
          options {
            id
            name
            type
            values {
              id
              value
            }
          }
          returnPolicy {
            isReturnable
          }
          saleId
          storeId
          visibility {
            isAvailableForSale
          }
          visuals {
            images {
              url
            }
          }
        }
      }
      sale {
        accountManager
        brandId
        endsAt
        name
        id
        salesTeamName
        setupManager
        startsAt
        status
        type
      }
      storeId
      supplier {
        contactEmail
        contactPhone
        hubspotId
        id
        instagram
        language
        name
        returnAddress {
          address {
            ...PartialAddress
          }
          name
        }
        saleManager
        shopifyUrl
        website
      }
      variant {
        financial {
          buyingPrice {
            amountVatIncludedInCents
            currency
          }
          retailPrice {
            amountVatIncludedInCents
            currency
          }
        }
        gtin
        id
        images {
          url
        }
        sku
        title
        visibility {
          isAvailableForSale
        }
      }
    }
    createdAt
    createdBy {
      ...Agent
      ...Contact
    }
    description
    id
    initialRequest {
      __typename
      ... on SupportTicketActivityInitialRequestOrder {
        content
        flow
        id
        items {
          ...PartialItemInitialRequest
        }
        order {
          returns {
            id
            lines {
              itemId
            }
            status
          }
        }
        orderId
        preferredRefundMethod
        preferredSolution
        promoCode
        proofs {
          ...Attachment
        }
        returnLines {
          itemId
          reason
          subReason
        }
        shippingAddress {
          city
          countryCode
          firstName
          lastName
          phoneNumber
          state
          street
          streetAdditional
          zipCode
        }
        swornStatements {
          ...Attachment
        }
      }
      ... on SupportTicketActivityInitialRequestOther {
        content
        otherFlow: flow
        id
      }
      ... on SupportTicketActivityInitialRequestSale {
        content
        saleFlow: flow
        id
        saleId
      }
      ... on SupportTicketActivityInitialRequestVariant {
        content
        variantFlow: flow
        id
        variantId
      }
    }
    isDraft
    isReadByContact
    orderFlowId
    previewText
    scheduleActions(first: $scheduleActionsFirst) {
      edges {
        node {
          __typename
          ... on SupportTicketScheduleActionEmail {
            createdAt
            createdBy {
              ...Contact
              ...Agent
            }
            id
            payload {
              attachments {
                ...AttachmentPayload
              }
              contentHtml
              contentText
            }
            scheduleAt
            status
          }
          ... on SupportTicketScheduleActionMessage {
            createdAt
            createdBy {
              ...Contact
              ...Agent
            }
            id
            payload {
              attachments {
                ...AttachmentPayload
              }
              content
            }
            scheduleAt
            status
          }
          ... on SupportTicketScheduleActionNote {
            createdAt
            createdBy {
              ...Contact
              ...Agent
            }
            id
            payload {
              content
            }
            scheduleAt
            status
          }
          ... on SupportTicketScheduleActionSubStatus {
            createdAt
            createdBy {
              ...Contact
              ...Agent
            }
            id
            payload {
              subStatus
            }
            scheduleAt
            status
          }
        }
      }
    }
    status
    subStatus
    statusUpdatedAt
    title
    updatedAt
  }
}
    ${AttachmentPayloadFragmentDoc}
${AgentFragmentDoc}
${AttachmentFragmentDoc}
${PartialClaimItemFragmentDoc}
${LinkedTicketFragmentDoc}
${PartialOrderFragmentDoc}
${PartialAddressFragmentDoc}
${ContactFragmentDoc}
${PartialItemInitialRequestFragmentDoc}`;

export const useTicketQuery = <
      TData = TicketQuery,
      TError = unknown
    >(
      variables: TicketQueryVariables,
      options?: Omit<UseQueryOptions<TicketQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TicketQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TicketQuery, TError, TData>(
      {
    queryKey: ['ticket', variables],
    queryFn: useFetchData<TicketQuery, TicketQueryVariables>(TicketDocument).bind(null, variables),
    ...options
  }
    )};

useTicketQuery.getKey = (variables: TicketQueryVariables) => ['ticket', variables];

export const useInfiniteTicketQuery = <
      TData = InfiniteData<TicketQuery>,
      TError = unknown
    >(
      variables: TicketQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TicketQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TicketQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TicketQuery, TicketQueryVariables>(TicketDocument)
    return useInfiniteQuery<TicketQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ticket.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTicketQuery.getKey = (variables: TicketQueryVariables) => ['ticket.infinite', variables];

export const TicketActivitiesDocument = `
    query ticketActivities($ticketId: ID!, $first: Int, $sortBy: SupportTicketActivitiesSortInput, $after: String) {
  supportTicket(id: $ticketId) {
    activities(sortBy: $sortBy, first: $first, after: $after) {
      edges {
        node {
          __typename
          ... on SupportTicketActivityAiSuggestion {
            id
            occurredAt
          }
          ... on SupportTicketActivityAiSuggestionSetup {
            id
            occurredAt
          }
          ... on SupportTicketActivityAiSuggestionStatus {
            id
            occurredAt
          }
          ... on SupportTicketActivityAssignment {
            actor {
              ...Agent
              ...Contact
            }
            newAssignee {
              ...Agent
            }
            id
            occurredAt
          }
          ... on SupportTicketActivityClosureDuplicate {
            actor {
              ...Agent
              ...Contact
            }
            id
            occurredAt
          }
          ... on SupportTicketActivityClosureJunk {
            actor {
              ...Agent
              ...Contact
            }
            id
            occurredAt
          }
          ... on SupportTicketActivityClosureUnresolvable {
            actor {
              ...Agent
              ...Contact
            }
            id
            occurredAt
          }
          ... on SupportTicketActivityContext {
            actor {
              ...Agent
              ...Contact
            }
            id
            newContextRefId
            newContextType
            occurredAt
          }
          ... on SupportTicketActivityContextDerived {
            actor {
              ...Agent
              ...Contact
            }
            contextDerivedKey
            id
            newContextDerivedValue
            occurredAt
          }
          ... on SupportTicketActivityEmail {
            actor {
              ...Agent
              ...Contact
            }
            aiSuggestion {
              ... on SupportTicketAiSuggestionEmail {
                hasBeenEdited
                id
              }
              ... on SupportTicketAiSuggestionMessage {
                hasBeenEdited
                id
              }
            }
            attachments {
              ...Attachment
            }
            contentHtml
            contentText
            emailScheduleActionId: scheduleActionId
            id
            occurredAt
            subject
          }
          ... on SupportTicketActivityInitialRequestMigration {
            actor {
              ...Agent
              ...Contact
            }
            aiClassification {
              confidence
              flowSuggested
              id
              status
            }
            content
            migrationFlow: flow
            flowReview {
              reviewedAt
              reviewedBy {
                ...Agent
              }
              reviewedFlow
            }
            id
            occurredAt
          }
          ... on SupportTicketActivityInitialRequestOrder {
            actor {
              ...Agent
              ...Contact
            }
            aiClassification {
              confidence
              flowSuggested
              id
              status
            }
            content
            flow
            flowReview {
              reviewedAt
              reviewedBy {
                ...Agent
              }
              reviewedFlow
            }
            id
            items {
              ...PartialItem
            }
            occurredAt
            order {
              returns {
                id
                lines {
                  itemId
                }
                status
              }
              sale {
                id
                name
              }
            }
            orderId
            preferredRefundMethod
            preferredSolution
            promoCode
            proofs {
              ...Attachment
            }
            returnLines {
              itemId
              reason
              subReason
            }
            shippingAddress {
              city
              countryCode
              firstName
              lastName
              phoneNumber
              state
              street
              streetAdditional
              zipCode
            }
            swornStatements {
              ...Attachment
            }
          }
          ... on SupportTicketActivityInitialRequestOther {
            actor {
              ...Agent
              ...Contact
            }
            aiClassification {
              confidence
              flowSuggested
              id
              status
            }
            attachments {
              ...Attachment
            }
            content
            otherFlow: flow
            flowReview {
              reviewedAt
              reviewedBy {
                ...Agent
              }
              reviewedFlow
            }
            id
            occurredAt
          }
          ... on SupportTicketActivityInitialRequestSale {
            actor {
              ...Agent
              ...Contact
            }
            aiClassification {
              confidence
              flowSuggested
              id
              status
            }
            content
            saleFlow: flow
            flowReview {
              reviewedAt
              reviewedBy {
                ...Agent
              }
              reviewedFlow
            }
            id
            occurredAt
            saleId
          }
          ... on SupportTicketActivityInitialRequestVariant {
            actor {
              ...Agent
              ...Contact
            }
            aiClassification {
              confidence
              flowSuggested
              id
              status
            }
            content
            variantFlow: flow
            flowReview {
              reviewedAt
              reviewedBy {
                ...Agent
              }
              reviewedFlow
            }
            id
            occurredAt
            variantId
          }
          ... on SupportTicketActivityMessage {
            actor {
              ...ActorLegacy
            }
            aiSuggestion {
              ... on SupportTicketAiSuggestionEmail {
                hasBeenEdited
                id
              }
              ... on SupportTicketAiSuggestionMessage {
                hasBeenEdited
                id
              }
            }
            attachments {
              ...Attachment
            }
            content
            id
            messageScheduleActionId: scheduleActionId
            occurredAt
          }
          ... on SupportTicketActivityNote {
            actor {
              ...Agent
              ...Contact
            }
            attachments {
              ...Attachment
            }
            content
            id
            occurredAt
            reactions {
              actor {
                ...Agent
              }
              actorId
              createdAt
              id
              type
            }
          }
          ... on SupportTicketActivityPublish {
            actor {
              ...Agent
              ...Contact
            }
            id
            occurredAt
          }
          ... on SupportTicketActivityResolutionSurvey {
            actor {
              ...ActorLegacy
            }
            content
            id
            isResolved
            occurredAt
          }
          ... on SupportTicketActivityScheduleAction {
            actor {
              ...Agent
              ...Contact
            }
            id
            occurredAt
            scheduleActionId
          }
          ... on SupportTicketActivityScheduleActionSetup {
            actor {
              ...Agent
              ...Contact
            }
            id
            nextScheduleActionPayload {
              __typename
              ... on SupportTicketScheduleActionEmailPayload {
                attachments {
                  ...AttachmentPayload
                }
                contentHtml
                contentText
              }
              ... on SupportTicketScheduleActionMessagePayload {
                attachments {
                  ...AttachmentPayload
                }
                content
              }
              ... on SupportTicketScheduleActionSubStatusPayload {
                subStatus
              }
            }
            previousScheduleActionPayload {
              __typename
              ... on SupportTicketScheduleActionEmailPayload {
                attachments {
                  ...AttachmentPayload
                }
                contentHtml
                contentText
              }
              ... on SupportTicketScheduleActionMessagePayload {
                attachments {
                  ...AttachmentPayload
                }
                content
              }
              ... on SupportTicketScheduleActionSubStatusPayload {
                subStatus
              }
            }
            occurredAt
            scheduleActionId
          }
          ... on SupportTicketActivityScheduleActionStatus {
            actor {
              ...Agent
              ...Contact
            }
            id
            nextScheduleActionStatus
            nextScheduleActionScheduleAt
            occurredAt
            previousScheduleActionScheduleAt
            previousScheduleActionStatus
            scheduleActionId
          }
          ... on SupportTicketActivityStatus {
            actor {
              ...Agent
              ...Contact
            }
            id
            newStatus
            newSubStatus
            occurredAt
            statusScheduleActionId: scheduleActionId
          }
          ... on SupportTicketActivityTitle {
            actor {
              ...Agent
              ...Contact
            }
            id
            newTitle
            occurredAt
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${AgentFragmentDoc}
${ContactFragmentDoc}
${AttachmentFragmentDoc}
${PartialItemFragmentDoc}
${ActorLegacyFragmentDoc}
${AttachmentPayloadFragmentDoc}`;

export const useTicketActivitiesQuery = <
      TData = TicketActivitiesQuery,
      TError = unknown
    >(
      variables: TicketActivitiesQueryVariables,
      options?: Omit<UseQueryOptions<TicketActivitiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TicketActivitiesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TicketActivitiesQuery, TError, TData>(
      {
    queryKey: ['ticketActivities', variables],
    queryFn: useFetchData<TicketActivitiesQuery, TicketActivitiesQueryVariables>(TicketActivitiesDocument).bind(null, variables),
    ...options
  }
    )};

useTicketActivitiesQuery.getKey = (variables: TicketActivitiesQueryVariables) => ['ticketActivities', variables];

export const useInfiniteTicketActivitiesQuery = <
      TData = InfiniteData<TicketActivitiesQuery>,
      TError = unknown
    >(
      variables: TicketActivitiesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TicketActivitiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TicketActivitiesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TicketActivitiesQuery, TicketActivitiesQueryVariables>(TicketActivitiesDocument)
    return useInfiniteQuery<TicketActivitiesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ticketActivities.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTicketActivitiesQuery.getKey = (variables: TicketActivitiesQueryVariables) => ['ticketActivities.infinite', variables];

export const TicketPreviewDocument = `
    query ticketPreview($ticketId: ID!) {
  supportTicket(id: $ticketId) {
    assignedTo {
      ...Agent
    }
    channel
    claims {
      acceptedAt
      canceledAt
      id
    }
    contact {
      __typename
      ... on SupportActorAppContact {
        appContact {
          email
          firstName
          id
          lastName
        }
        id
      }
      ... on SupportActorEmailContact {
        emailContact {
          email
          name
        }
        id
      }
    }
    contextDerived {
      sale {
        name
      }
    }
    createdAt
    description
    id
    status
    subStatus
    title
  }
}
    ${AgentFragmentDoc}`;

export const useTicketPreviewQuery = <
      TData = TicketPreviewQuery,
      TError = unknown
    >(
      variables: TicketPreviewQueryVariables,
      options?: Omit<UseQueryOptions<TicketPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TicketPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TicketPreviewQuery, TError, TData>(
      {
    queryKey: ['ticketPreview', variables],
    queryFn: useFetchData<TicketPreviewQuery, TicketPreviewQueryVariables>(TicketPreviewDocument).bind(null, variables),
    ...options
  }
    )};

useTicketPreviewQuery.getKey = (variables: TicketPreviewQueryVariables) => ['ticketPreview', variables];

export const useInfiniteTicketPreviewQuery = <
      TData = InfiniteData<TicketPreviewQuery>,
      TError = unknown
    >(
      variables: TicketPreviewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TicketPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TicketPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TicketPreviewQuery, TicketPreviewQueryVariables>(TicketPreviewDocument)
    return useInfiniteQuery<TicketPreviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ticketPreview.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTicketPreviewQuery.getKey = (variables: TicketPreviewQueryVariables) => ['ticketPreview.infinite', variables];

export const TicketsDocument = `
    query tickets($filters: SupportTicketsFilterInput, $sortBy: SupportTicketsSortInput, $first: Int, $after: String) {
  supportTickets(filters: $filters, sortBy: $sortBy, first: $first, after: $after) {
    edges {
      node {
        ...PartialTicket
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${PartialTicketFragmentDoc}`;

export const useTicketsQuery = <
      TData = TicketsQuery,
      TError = unknown
    >(
      variables?: TicketsQueryVariables,
      options?: Omit<UseQueryOptions<TicketsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TicketsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TicketsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['tickets'] : ['tickets', variables],
    queryFn: useFetchData<TicketsQuery, TicketsQueryVariables>(TicketsDocument).bind(null, variables),
    ...options
  }
    )};

useTicketsQuery.getKey = (variables?: TicketsQueryVariables) => variables === undefined ? ['tickets'] : ['tickets', variables];

export const useInfiniteTicketsQuery = <
      TData = InfiniteData<TicketsQuery>,
      TError = unknown
    >(
      variables: TicketsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TicketsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TicketsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TicketsQuery, TicketsQueryVariables>(TicketsDocument)
    return useInfiniteQuery<TicketsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['tickets.infinite'] : ['tickets.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTicketsQuery.getKey = (variables?: TicketsQueryVariables) => variables === undefined ? ['tickets.infinite'] : ['tickets.infinite', variables];

export const VariantPreviewDocument = `
    query variantPreview($variantId: ID!) {
  variant(id: $variantId) {
    financial {
      retailPrice {
        amountVatIncludedInCents
        currency
      }
    }
    id
    images {
      url
    }
    gtin
    product {
      __typename
      ... on ProductDigital {
        financial {
          frenchTaxRate
          readableCategory
        }
        id
        name
        options {
          id
          name
          type
          values {
            id
            value
          }
        }
        visibility {
          isAvailableForSale
        }
        visuals {
          images {
            url
          }
        }
      }
      ... on ProductPhysical {
        financial {
          frenchTaxRate
          readableCategory
        }
        id
        name
        options {
          id
          name
          type
          values {
            id
            value
          }
        }
        visibility {
          isAvailableForSale
        }
        visuals {
          images {
            url
          }
        }
      }
    }
    productId
    sku
    title
    visibility {
      isAvailableForSale
    }
  }
}
    `;

export const useVariantPreviewQuery = <
      TData = VariantPreviewQuery,
      TError = unknown
    >(
      variables: VariantPreviewQueryVariables,
      options?: Omit<UseQueryOptions<VariantPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<VariantPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<VariantPreviewQuery, TError, TData>(
      {
    queryKey: ['variantPreview', variables],
    queryFn: useFetchData<VariantPreviewQuery, VariantPreviewQueryVariables>(VariantPreviewDocument).bind(null, variables),
    ...options
  }
    )};

useVariantPreviewQuery.getKey = (variables: VariantPreviewQueryVariables) => ['variantPreview', variables];

export const useInfiniteVariantPreviewQuery = <
      TData = InfiniteData<VariantPreviewQuery>,
      TError = unknown
    >(
      variables: VariantPreviewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<VariantPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<VariantPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<VariantPreviewQuery, VariantPreviewQueryVariables>(VariantPreviewDocument)
    return useInfiniteQuery<VariantPreviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['variantPreview.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteVariantPreviewQuery.getKey = (variables: VariantPreviewQueryVariables) => ['variantPreview.infinite', variables];

export const ViewDocument = `
    query view($viewId: ID!) {
  supportView(viewId: $viewId) {
    createdBy {
      ...Agent
    }
    displayedProperties {
      assignedTo
      channel
      contact
      hasPendingScheduleActions
      isDraft
      orderFlow
      previewText
      saleName
      statusUpdatedAt
      subStatus
      title
    }
    filters {
      assignedToId {
        in
        notIn
      }
      channel {
        in
        notIn
      }
      contactId {
        in
        notIn
      }
      createdAt {
        gt
        gte
        lt
        lte
      }
      contextDerived {
        orderId {
          in
          notIn
        }
        sale {
          salesTeamName {
            in
            notIn
          }
          type {
            in
            notIn
          }
        }
        saleId {
          in
          notIn
        }
        storeId {
          in
          notIn
        }
        supplierId {
          in
          notIn
        }
      }
      hasPendingScheduleActions {
        equals
        not
      }
      initialRequest {
        flow {
          in
          notIn
        }
      }
      isDraft {
        equals
        not
      }
      orderFlowId {
        in
        notIn
      }
      subStatus {
        in
        notIn
      }
    }
    groupBy
    icon
    iconColor
    id
    sortBy {
      direction
      field
    }
    title
  }
}
    ${AgentFragmentDoc}`;

export const useViewQuery = <
      TData = ViewQuery,
      TError = unknown
    >(
      variables: ViewQueryVariables,
      options?: Omit<UseQueryOptions<ViewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ViewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ViewQuery, TError, TData>(
      {
    queryKey: ['view', variables],
    queryFn: useFetchData<ViewQuery, ViewQueryVariables>(ViewDocument).bind(null, variables),
    ...options
  }
    )};

useViewQuery.getKey = (variables: ViewQueryVariables) => ['view', variables];

export const useInfiniteViewQuery = <
      TData = InfiniteData<ViewQuery>,
      TError = unknown
    >(
      variables: ViewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ViewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ViewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ViewQuery, ViewQueryVariables>(ViewDocument)
    return useInfiniteQuery<ViewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['view.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteViewQuery.getKey = (variables: ViewQueryVariables) => ['view.infinite', variables];

export const ViewsDocument = `
    query views($input: SearchSupportViewsInput!) {
  supportViews(input: $input) {
    edges {
      node {
        createdBy {
          ...Agent
        }
        icon
        iconColor
        id
        title
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${AgentFragmentDoc}`;

export const useViewsQuery = <
      TData = ViewsQuery,
      TError = unknown
    >(
      variables: ViewsQueryVariables,
      options?: Omit<UseQueryOptions<ViewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ViewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ViewsQuery, TError, TData>(
      {
    queryKey: ['views', variables],
    queryFn: useFetchData<ViewsQuery, ViewsQueryVariables>(ViewsDocument).bind(null, variables),
    ...options
  }
    )};

useViewsQuery.getKey = (variables: ViewsQueryVariables) => ['views', variables];

export const useInfiniteViewsQuery = <
      TData = InfiniteData<ViewsQuery>,
      TError = unknown
    >(
      variables: ViewsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ViewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ViewsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ViewsQuery, ViewsQueryVariables>(ViewsDocument)
    return useInfiniteQuery<ViewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['views.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteViewsQuery.getKey = (variables: ViewsQueryVariables) => ['views.infinite', variables];

export const NotificationCreatedDocument = `
    subscription notificationCreated {
  supportNotificationCreated {
    __typename
    ... on SupportNotificationMention {
      id
      sender {
        ...Agent
        ...Contact
      }
      ticket {
        id
        title
      }
    }
    ... on SupportNotificationReaction {
      id
      reactionType
      sender {
        ...Agent
        ...Contact
      }
      ticket {
        id
        title
      }
    }
  }
}
    ${AgentFragmentDoc}
${ContactFragmentDoc}`;
export const SnippetCreatedDocument = `
    subscription snippetCreated {
  supportSnippetCreated {
    ...PartialSnippet
  }
}
    ${PartialSnippetFragmentDoc}`;
export const SnippetUpdatedDocument = `
    subscription snippetUpdated {
  supportSnippetUpdated {
    ...PartialSnippet
  }
}
    ${PartialSnippetFragmentDoc}`;
export const SnippetTagCreatedDocument = `
    subscription snippetTagCreated {
  supportSnippetTagCreated {
    ...PartialSnippetTag
  }
}
    ${PartialSnippetTagFragmentDoc}`;
export const SnippetTagUpdatedDocument = `
    subscription snippetTagUpdated {
  supportSnippetTagUpdated {
    ...PartialSnippetTag
  }
}
    ${PartialSnippetTagFragmentDoc}`;
export const TicketCreatedDocument = `
    subscription ticketCreated {
  supportTicketCreated {
    ...PartialTicket
  }
}
    ${PartialTicketFragmentDoc}`;
export const TicketUpdatedDocument = `
    subscription ticketUpdated {
  supportTicketUpdated {
    ...PartialTicket
  }
}
    ${PartialTicketFragmentDoc}`;
export const TicketDeletedDocument = `
    subscription ticketDeleted {
  supportTicketDeleted
}
    `;